window.SC = window.SC || {};
SC.renderManifest = {
  'KBAS15B-A0122-FR':'KBAS15B-A0122-FR-Barton-Loveseat-Wildwood Duck Egg.png',
  'KBAS15B-A012X-FR':'KBAS15B-A012X-FR-Barton-Loveseat-Wildwood Duck Egg.png',
  'KBAS15B-A012X-SI':'KBAS15B-A012X-SI-Barton-Loveseat-Wildwood Duck Egg.png',
  'KBAS15B-A0222-FR':'KBAS15B-A0222-FR-Barton-Loveseat-Wildwood Ivory.png',
  'KBAS15B-A022X-FR':'KBAS15B-A022X-FR-Barton-Loveseat-Wildwood Ivory.png',
  'KBAS15B-A022X-SI':'KBAS15B-A022X-SI-Barton-Loveseat-Wildwood Ivory.png',
  'KBAS15B-A0322-FR':'KBAS15B-A0322-FR-Barton-Loveseat-Wildwood Twig.png',
  'KBAS15B-A0422-FR':'KBAS15B-A0422-FR-Barton-Loveseat-Peony Summer Sky.png',
  'KBAS15B-A0422-SI':'KBAS15B-A0422-SI-Barton-Loveseat-Peony Summer Sky.jpg',
  'KBAS15B-A0522-FR':'KBAS15B-A0522-FR-Barton-Loveseat-Midsummer Sky.png',
  'KBAS15B-A0522-SI':'KBAS15B-A0522-SI-Barton-Loveseat-Midsummer Sky.jpg',
  'KBAS15B-A0622-FR':'KBAS15B-A0622-FR-Barton-Loveseat-Midsummer Stone.png',
  'KBAS15B-A0722-RE':'KBAS15B-A0722-RE-Barton-Loveseat-Midsummer Faded Blue.jpg',
  'KBAS15B-A0822-FR':'KBAS15B-A0822-FR-Barton-Loveseat-Otter Denim.png',
  'KBAS15B-A1022-FR':'KBAS15B-A1022-FR-Barton-Loveseat-Pelham Moss.png',
  'KBAS15B-A1022-SI':'KBAS15B-A1022-SI-Barton-Loveseat-Pelham Moss.jpg',
  'KBAS15B-A102X-FR':'KBAS15B-A102X-FR-Barton-Loveseat-Pelham Moss.png',
  'KBAS15B-A102X-SI':'KBAS15B-A102X-SI-Barton-Loveseat-Pelham Moss.png',
  'KBAS15B-A1122-FR':'KBAS15B-A1122-FR-Barton-Loveseat-Pelham Denim.png',
  'KBAS15B-A1122-SI':'KBAS15B-A1122-SI-Barton-Loveseat-Pelham Denim.jpg',
  'KBAS15B-A1322-FR':'KBAS15B-A1322-FR-Barton-Loveseat-Las Salinas Las Salinas 4.png',
  'KBAS15B-B0122-FR':'KBAS15B-B0122-FR-Barton-Loveseat-Beatrice Barley.png',
  'KBAS15B-B0122-SI':'KBAS15B-B0122-SI-Barton-Loveseat-Beatrice Barley.jpg',
  'KBAS15B-B0322-FR':'KBAS15B-B0322-FR-Barton-Loveseat-Beatrice Midnight.png',
  'KBAS15B-B0622-FR':'KBAS15B-B0622-FR-Barton-Loveseat-Froisse Cerulean.png',
  'KBAS15B-B0622-SI':'KBAS15B-B0622-SI-Barton-Loveseat-Froisse Cerulean.jpg',
  'KBAS15B-B0722-FR':'KBAS15B-B0722-FR-Barton-Loveseat-Froisse Chalk.png',
  'KBAS15B-B0822-FR':'KBAS15B-B0822-FR-Barton-Loveseat-Froisse Hemp.png',
  'KBAS15B-B1222-FR':'KBAS15B-B1222-FR-Barton-Loveseat-Froisse Putty.png',
  'KBAS15B-B122X-FR':'KBAS15B-B122X-FR-Barton-Loveseat-Froisse Putty.png',
  'KBAS15B-B122X-SI':'KBAS15B-B122X-SI-Barton-Loveseat-Froisse Putty.png',
  'KBAS15B-D0122-FR':'KBAS15B-D0122-FR-Barton-Loveseat-Varese Fuchsia.png',
  'KBAS15B-D0522-FR':'KBAS15B-D0522-FR-Barton-Loveseat-Varese Grass.png',
  'KBAS15B-D0522-SI':'KBAS15B-D0522-SI-Barton-Loveseat-Varese Grass.jpg',
  'KBAS15B-D0622-FR':'KBAS15B-D0622-FR-Barton-Loveseat-Brera Lino Cerise.png',
  'KBAS15B-D0622-SI':'KBAS15B-D0622-SI-Barton-Loveseat-Brera Lino Cerise.jpg',
  'KBAS15B-D082X-FR':'KBAS15B-D082X-FR-Barton-Loveseat-Brera Lino Putty.png',
  'KBAS15B-D082X-SI':'KBAS15B-D082X-SI-Barton-Loveseat-Brera Lino Putty.png',
  'KBAS15B-G0122-FR':'KBAS15B-G0122-FR-Barton-Loveseat-Nympheus Teal green.png',
  'KBAS15B-G0122-SI':'KBAS15B-G0122-SI-Barton-Loveseat-Nympheus Teal green.jpg',
  'KBAS15B-G0222-FR':'KBAS15B-G0222-FR-Barton-Loveseat-Nympheus Stone pistachio.png',
  'KBAS15B-G0322-FR':'KBAS15B-G0322-FR-Barton-Loveseat-Nympheus Aqua teal.png',
  'KBAS15B-G0422-FR':'KBAS15B-G0422-FR-Barton-Loveseat-Magnolia Cream Blue.png',
  'KBAS15B-G0422-SI':'KBAS15B-G0422-SI-Barton-Loveseat-Magnolia Cream Blue.jpg',
  'KBAS15B-G042X-FR':'KBAS15B-G042X-FR-Barton-Loveseat-Magnolia Cream Blue.png',
  'KBAS15B-G042X-SI':'KBAS15B-G042X-SI-Barton-Loveseat-Magnolia Cream Blue.png',
  'KBAS15B-G0522-FR':'KBAS15B-G0522-FR-Barton-Loveseat-Little Magnolia Pink orange.png',
  'KBAS15B-G0622-FR':'KBAS15B-G0622-FR-Barton-Loveseat-Little Magnolia Espresso.png',
  'KBAS15B-G0622-SI':'KBAS15B-G0622-SI-Barton-Loveseat-Little Magnolia Espresso.jpg',
  'KBAS15B-G0722-FR':'KBAS15B-G0722-FR-Barton-Loveseat-Little Magnolia Emerald.png',
  'KBAS15B-J0122-FR':'KBAS15B-J0122-FR-Barton-Loveseat-Boho Cloud.png',
  'KBAS15B-J0122-SI':'KBAS15B-J0122-SI-Barton-Loveseat-Boho Cloud.jpg',
  'KBAS15B-J0322-FR':'KBAS15B-J0322-FR-Barton-Loveseat-Boho Parchment.png',
  'KBAS15B-L0122-FR':'KBAS15B-L0122-FR-Barton-Loveseat-English Garden - Kitty Spring Green.png',
  'KBAS15B-L0122-SI':'KBAS15B-L0122-SI-Barton-Loveseat-English Garden - Kitty Spring Green.jpg',
  'KBAS15B-L0222-FR':'KBAS15B-L0222-FR-Barton-Loveseat-English Garden - Kitty Blue Green.png',
  'KBAS15B-L0322-FR':'KBAS15B-L0322-FR-Barton-Loveseat-English Garden - Kitty Indian Summer.png',
  'KBAS15B-L0422-FR':'KBAS15B-L0422-FR-Barton-Loveseat-English Garden - Albertine Grey Skies.png',
  'KBAS15B-L042X-FR':'KBAS15B-L042X-FR-Barton-Loveseat-English Garden - Albertine Grey Skies.png',
  'KBAS15B-L042X-SI':'KBAS15B-L042X-SI-Barton-Loveseat-English Garden - Albertine Grey Skies.png',
  'KBAS15B-L0522-FR':'KBAS15B-L0522-FR-Barton-Loveseat-English Garden - Albertine Classic Rose.png',
  'KBAS15B-L0622-FR':'KBAS15B-L0622-FR-Barton-Loveseat-English Garden - Albertine Coral Orange.png',
  'KBAS15B-L0622-SI':'KBAS15B-L0622-SI-Barton-Loveseat-English Garden - Albertine Coral Orange.jpg',
  'KBAS15B-L0722-FR':'KBAS15B-L0722-FR-Barton-Loveseat-Belleville - Miji Juniper.png',
  'KBAS15B-L1122-FR':'KBAS15B-L1122-FR-Barton-Loveseat-Omega Lagoon.png',
  'KBAS15B-L1122-SI':'KBAS15B-L1122-SI-Barton-Loveseat-Omega Lagoon.jpg',
  'KBAS15B-L1422-FR':'KBAS15B-L1422-FR-Barton-Loveseat-Omega Pine.png',
  'KBAS15B-O0122-FR':'KBAS15B-O0122-FR-Barton-Loveseat-Bespoke Coastal Blue.png',
  'KBAS15B-O0122-SI':'KBAS15B-O0122-SI-Barton-Loveseat-Bespoke Coastal Blue.jpg',
  'KBAS15B-O022X-FR':'KBAS15B-O022X-FR-Barton-Loveseat-Tasman Petunia.png',
  'KBAS15B-O022X-SI':'KBAS15B-O022X-SI-Barton-Loveseat-Tasman Petunia.png',
  'KBAS15B-O0322-FR':'KBAS15B-O0322-FR-Barton-Loveseat-Bespoke Woodland.png',
  'KBAS15B-O0322-SI':'KBAS15B-O0322-SI-Barton-Loveseat-Bespoke Woodland.jpg',
  'KBAS15B-O0522-FR':'KBAS15B-O0522-FR-Barton-Loveseat-Tasman Sea Holly.png',
  'KBAS15B-O0522-SI':'KBAS15B-O0522-SI-Barton-Loveseat-Tasman Sea Holly.jpg',
  'KBAS15B-O0622-FR':'KBAS15B-O0622-FR-Barton-Loveseat-Tasman Garden Grey.png',
  'KBAS15B-O062X-FR':'KBAS15B-O062X-FR-Barton-Loveseat-Tasman Garden Grey.png',
  'KBAS15B-O062X-SI':'KBAS15B-O062X-SI-Barton-Loveseat-Tasman Garden Grey.png',
  'KBAS15B-O0722-FR':'KBAS15B-O0722-FR-Barton-Loveseat-Tasman Dandelion.png',
  'KBAS15B-O072X-FR':'KBAS15B-O072X-FR-Barton-Loveseat-Tasman Dandelion.png',
  'KBAS15B-O072X-SI':'KBAS15B-O072X-SI-Barton-Loveseat-Tasman Dandelion.png',
  'KBAS15B-O0922-FR':'KBAS15B-O0922-FR-Barton-Loveseat-Tasman Cornish Blue.png',
  'KBAS15B-O1022-FR':'KBAS15B-O1022-FR-Barton-Loveseat-Antarctic Narrow Chocolate.png',
  'KBAS15B-O102X-FR':'KBAS15B-O102X-FR-Barton-Loveseat-Antarctic Narrow Chocolate.png',
  'KBAS15B-O102X-SI':'KBAS15B-O102X-SI-Barton-Loveseat-Antarctic Narrow Chocolate.png',
  'KBAS15B-O112X-FR':'KBAS15B-O112X-FR-Barton-Loveseat-Tasman Chocolate.png',
  'KBAS15B-O112X-SI':'KBAS15B-O112X-SI-Barton-Loveseat-Tasman Chocolate.png',
  'KBAS15B-O1322-FR':'KBAS15B-O1322-FR-Barton-Loveseat-Capelo Cool Coconut.png',
  'KBAS15B-O1422-FR':'KBAS15B-O1422-FR-Barton-Loveseat-Capelo Snow Drop.png',
  'KBAS15B-O142X-FR':'KBAS15B-O142X-FR-Barton-Loveseat-Capelo Snow Drop.png',
  'KBAS15B-O142X-SI':'KBAS15B-O142X-SI-Barton-Loveseat-Capelo Snow Drop.png',
  'KBAS15B-O1522-FR':'KBAS15B-O1522-FR-Barton-Loveseat-Capelo Sea Salt.png',
  'KBAS15B-O1522-SI':'KBAS15B-O1522-SI-Barton-Loveseat-Capelo Sea Salt.jpg',
  'KBAS15B-O1722-FR':'KBAS15B-O1722-FR-Barton-Loveseat-Capelo Inkspot.png',
  'KBAS15B-O1922-FR':'KBAS15B-O1922-FR-Barton-Loveseat-Columbus Marigold.png',
  'KBAS15B-O1922-SI':'KBAS15B-O1922-SI-Barton-Loveseat-Columbus Marigold.jpg',
  'KBAS15B-O2022-FR':'KBAS15B-O2022-FR-Barton-Loveseat-Columbus Potting Moss.png',
  'KBAS15B-O2222-FR':'KBAS15B-O2222-FR-Barton-Loveseat-Columbus Sunflower.png',
  'KBAS20B-A012X-FR':'KBAS20B-A012X-FR-Barton-2 Seater-Wildwood Duck Egg.png',
  'KBAS20B-A012X-SI':'KBAS20B-A012X-SI-Barton-2 Seater-Wildwood Duck Egg.png',
  'KBAS20B-A022X-FR':'KBAS20B-A022X-FR-Barton-2 Seater-Wildwood Ivory.png',
  'KBAS20B-A022X-SI':'KBAS20B-A022X-SI-Barton-2 Seater-Wildwood Ivory.png',
  'KBAS20B-A0322-FR':'KBAS20B-A0322-FR-Barton-2 Seater-Wildwood Twig.png',
  'KBAS20B-A0522-FR':'KBAS20B-A0522-FR-Barton-2 Seater-Midsummer Sky.png',
  'KBAS20B-A0622-FR':'KBAS20B-A0622-FR-Barton-2 Seater-Midsummer Stone.png',
  'KBAS20B-A0722-RE':'KBAS20B-A0722-RE-Barton-2 Seater-Midsummer Faded Blue.jpg',
  'KBAS20B-A0822-FR':'KBAS20B-A0822-FR-Barton-2 Seater-Otter Denim.png',
  'KBAS20B-A1022-FR':'KBAS20B-A1022-FR-Barton-2 Seater-Pelham Moss.png',
  'KBAS20B-A1122-FR':'KBAS20B-A1122-FR-Barton-2 Seater-Pelham Denim.png',
  'KBAS20B-A1322-FR':'KBAS20B-A1322-FR-Barton-2 Seater-Las Salinas Las Salinas 4.png',
  'KBAS20B-B0122-FR':'KBAS20B-B0122-FR-Barton-2 Seater-Beatrice Barley.png',
  'KBAS20B-B0222-FR':'KBAS20B-B0222-FR-Barton-2 Seater-Beatrice Camelia.png',
  'KBAS20B-B0322-FR':'KBAS20B-B0322-FR-Barton-2 Seater-Beatrice Midnight.png',
  'KBAS20B-B1222-FR':'KBAS20B-B1222-FR-Barton-2 Seater-Froisse Putty.png',
  'KBAS20B-B122X-FR':'KBAS20B-B122X-FR-Barton-2 Seater-Froisse Putty.png',
  'KBAS20B-B122X-SI':'KBAS20B-B122X-SI-Barton-2 Seater-Froisse Putty.png',
  'KBAS20B-D0622-FR':'KBAS20B-D0622-FR-Barton-2 Seater-Brera Lino Cerise.png',
  'KBAS20B-D0722-FR':'KBAS20B-D0722-FR-Barton-2 Seater-Brera Lino Chalk.png',
  'KBAS20B-D082X-FR':'KBAS20B-D082X-FR-Barton-2 Seater-Brera Lino Putty.png',
  'KBAS20B-D082X-SI':'KBAS20B-D082X-SI-Barton-2 Seater-Brera Lino Putty.png',
  'KBAS20B-G0122-FR':'KBAS20B-G0122-FR-Barton-2 Seater-Nympheus Teal green.png',
  'KBAS20B-G0222-FR':'KBAS20B-G0222-FR-Barton-2 Seater-Nympheus Stone pistachio.png',
  'KBAS20B-G0322-FR':'KBAS20B-G0322-FR-Barton-2 Seater-Nympheus Aqua teal.png',
  'KBAS20B-G0422-FR':'KBAS20B-G0422-FR-Barton-2 Seater-Magnolia Cream Blue.png',
  'KBAS20B-G0522-FR':'KBAS20B-G0522-FR-Barton-2 Seater-Little Magnolia Pink orange.png',
  'KBAS20B-G0622-FR':'KBAS20B-G0622-FR-Barton-2 Seater-Little Magnolia Espresso.png',
  'KBAS20B-G0722-FR':'KBAS20B-G0722-FR-Barton-2 Seater-Little Magnolia Emerald.png',
  'KBAS20B-J0122-FR':'KBAS20B-J0122-FR-Barton-2 Seater-Boho Cloud.png',
  'KBAS20B-J0322-FR':'KBAS20B-J0322-FR-Barton-2 Seater-Boho Parchment.png',
  'KBAS20B-L0122-FR':'KBAS20B-L0122-FR-Barton-2 Seater-English Garden - Kitty Spring Green.png',
  'KBAS20B-L0222-FR':'KBAS20B-L0222-FR-Barton-2 Seater-English Garden - Kitty Blue Green.png',
  'KBAS20B-L022X-FR':'KBAS20B-L022X-FR-Barton-2 Seater-English Garden - Kitty Blue Green.png',
  'KBAS20B-L022X-SI':'KBAS20B-L022X-SI-Barton-2 Seater-English Garden - Kitty Blue Green.png',
  'KBAS20B-L0322-FR':'KBAS20B-L0322-FR-Barton-2 Seater-English Garden - Kitty Indian Summer.png',
  'KBAS20B-L0422-FR':'KBAS20B-L0422-FR-Barton-2 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS20B-L042X-FR':'KBAS20B-L042X-FR-Barton-2 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS20B-L042X-SI':'KBAS20B-L042X-SI-Barton-2 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS20B-L0522-FR':'KBAS20B-L0522-FR-Barton-2 Seater-English Garden - Albertine Classic Rose.png',
  'KBAS20B-L0622-FR':'KBAS20B-L0622-FR-Barton-2 Seater-English Garden - Albertine Coral Orange.png',
  'KBAS20B-L0922-FR':'KBAS20B-L0922-FR-Barton-2 Seater-Omega Carnelian.png',
  'KBAS20B-L1822-FR':'KBAS20B-L1822-FR-Barton-2 Seater-Elba Cerulean.png',
  'KBAS20B-L2022-FR':'KBAS20B-L2022-FR-Barton-2 Seater-Elba Midnight.png',
  'KBAS20B-O0122-FR':'KBAS20B-O0122-FR-Barton-2 Seater-Bespoke Coastal Blue.png',
  'KBAS20B-O022X-FR':'KBAS20B-O022X-FR-Barton-2 Seater-Tasman Petunia.png',
  'KBAS20B-O022X-SI':'KBAS20B-O022X-SI-Barton-2 Seater-Tasman Petunia.png',
  'KBAS20B-O0322-FR':'KBAS20B-O0322-FR-Barton-2 Seater-Bespoke Woodland.png',
  'KBAS20B-O0522-FR':'KBAS20B-O0522-FR-Barton-2 Seater-Tasman Sea Holly.png',
  'KBAS20B-O0722-FR':'KBAS20B-O0722-FR-Barton-2 Seater-Tasman Dandelion.png',
  'KBAS20B-O072X-FR':'KBAS20B-O072X-FR-Barton-2 Seater-Tasman Dandelion.png',
  'KBAS20B-O072X-SI':'KBAS20B-O072X-SI-Barton-2 Seater-Tasman Dandelion.png',
  'KBAS20B-O0922-FR':'KBAS20B-O0922-FR-Barton-2 Seater-Tasman Cornish Blue.png',
  'KBAS20B-O1022-FR':'KBAS20B-O1022-FR-Barton-2 Seater-Antarctic Narrow Chocolate.png',
  'KBAS20B-O102X-FR':'KBAS20B-O102X-FR-Barton-2 Seater-Antarctic Narrow Chocolate.png',
  'KBAS20B-O102X-SI':'KBAS20B-O102X-SI-Barton-2 Seater-Antarctic Narrow Chocolate.png',
  'KBAS20B-O112X-FR':'KBAS20B-O112X-FR-Barton-2 Seater-Tasman Chocolate.png',
  'KBAS20B-O112X-SI':'KBAS20B-O112X-SI-Barton-2 Seater-Tasman Chocolate.png',
  'KBAS20B-O1322-FR':'KBAS20B-O1322-FR-Barton-2 Seater-Capelo Cool Coconut.png',
  'KBAS20B-O1422-FR':'KBAS20B-O1422-FR-Barton-2 Seater-Capelo Snow Drop.png',
  'KBAS20B-O142X-FR':'KBAS20B-O142X-FR-Barton-2 Seater-Capelo Snow Drop.png',
  'KBAS20B-O142X-SI':'KBAS20B-O142X-SI-Barton-2 Seater-Capelo Snow Drop.png',
  'KBAS20B-O1822-FR':'KBAS20B-O1822-FR-Barton-2 Seater-Columbus Evergreen.png',
  'KBAS20B-O1922-FR':'KBAS20B-O1922-FR-Barton-2 Seater-Columbus Marigold.png',
  'KBAS20B-O202X-FR':'KBAS20B-O202X-FR-Barton-2 Seater-Columbus Potting Moss.png',
  'KBAS20B-O202X-SI':'KBAS20B-O202X-SI-Barton-2 Seater-Columbus Potting Moss.png',
  'KBAS20B-O2122-FR':'KBAS20B-O2122-FR-Barton-2 Seater-Columbus Roselette.png',
  'KBAS20B-O2222-FR':'KBAS20B-O2222-FR-Barton-2 Seater-Columbus Sunflower.png',
  'KBAS20S-A0122-FR':'KBAS20S-A0122-FR-Barton-2 Seater-Wildwood Duck Egg.png',
  'KBAS20S-A0122-SI':'KBAS20S-A0122-SI-Barton-2 Seater-Wildwood Duck Egg.png',
  'KBAS20S-A0222-FR':'KBAS20S-A0222-FR-Barton-2 Seater-Wildwood Ivory.png',
  'KBAS20S-A0222-SI':'KBAS20S-A0222-SI-Barton-2 Seater-Wildwood Ivory.png',
  'KBAS20S-A0322-FR':'KBAS20S-A0322-FR-Barton-2 Seater-Wildwood Twig.png',
  'KBAS20S-A0322-SI':'KBAS20S-A0322-SI-Barton-2 Seater-Wildwood Twig.png',
  'KBAS20S-A0422-FR':'KBAS20S-A0422-FR-Barton-2 Seater-Peony Summer Sky.png',
  'KBAS20S-A0422-SI':'KBAS20S-A0422-SI-Barton-2 Seater-Peony Summer Sky.png',
  'KBAS20S-A0522-FR':'KBAS20S-A0522-FR-Barton-2 Seater-Midsummer Sky.png',
  'KBAS20S-A0522-SI':'KBAS20S-A0522-SI-Barton-2 Seater-Midsummer Sky.png',
  'KBAS20S-A0622-FR':'KBAS20S-A0622-FR-Barton-2 Seater-Midsummer Stone.png',
  'KBAS20S-A0622-SI':'KBAS20S-A0622-SI-Barton-2 Seater-Midsummer Stone.png',
  'KBAS20S-A0822-FR':'KBAS20S-A0822-FR-Barton-2 Seater-Otter Denim.png',
  'KBAS20S-A0822-SI':'KBAS20S-A0822-SI-Barton-2 Seater-Otter Denim.png',
  'KBAS20S-A1322-FR':'KBAS20S-A1322-FR-Barton-2 Seater-Las Salinas Las Salinas 4.png',
  'KBAS20S-A1322-SI':'KBAS20S-A1322-SI-Barton-2 Seater-Las Salinas Las Salinas 4.png',
  'KBAS20S-B0122-FR':'KBAS20S-B0122-FR-Barton-2 Seater-Beatrice Barley.png',
  'KBAS20S-B0122-SI':'KBAS20S-B0122-SI-Barton-2 Seater-Beatrice Barley.png',
  'KBAS20S-B0222-FR':'KBAS20S-B0222-FR-Barton-2 Seater-Beatrice Camelia.png',
  'KBAS20S-B0222-SI':'KBAS20S-B0222-SI-Barton-2 Seater-Beatrice Camelia.png',
  'KBAS20S-B0322-FR':'KBAS20S-B0322-FR-Barton-2 Seater-Beatrice Midnight.png',
  'KBAS20S-B0322-SI':'KBAS20S-B0322-SI-Barton-2 Seater-Beatrice Midnight.png',
  'KBAS20S-B0522-FR':'KBAS20S-B0522-FR-Barton-2 Seater-Beatrice Olive.png',
  'KBAS20S-B0522-SI':'KBAS20S-B0522-SI-Barton-2 Seater-Beatrice Olive.png',
  'KBAS20S-B1222-FR':'KBAS20S-B1222-FR-Barton-2 Seater-Froisse Putty.png',
  'KBAS20S-B1222-SI':'KBAS20S-B1222-SI-Barton-2 Seater-Froisse Putty.png',
  'KBAS20S-D0622-FR':'KBAS20S-D0622-FR-Barton-2 Seater-Brera Lino Cerise.png',
  'KBAS20S-D0622-SI':'KBAS20S-D0622-SI-Barton-2 Seater-Brera Lino Cerise.png',
  'KBAS20S-G0122-FR':'KBAS20S-G0122-FR-Barton-2 Seater-Nympheus Teal green.png',
  'KBAS20S-G0122-SI':'KBAS20S-G0122-SI-Barton-2 Seater-Nympheus Teal green.png',
  'KBAS20S-G0222-FR':'KBAS20S-G0222-FR-Barton-2 Seater-Nympheus Stone pistachio.png',
  'KBAS20S-G0222-SI':'KBAS20S-G0222-SI-Barton-2 Seater-Nympheus Stone pistachio.png',
  'KBAS20S-G0322-FR':'KBAS20S-G0322-FR-Barton-2 Seater-Nympheus Aqua teal.png',
  'KBAS20S-G0322-SI':'KBAS20S-G0322-SI-Barton-2 Seater-Nympheus Aqua teal.png',
  'KBAS20S-G0422-FR':'KBAS20S-G0422-FR-Barton-2 Seater-Magnolia Cream Blue.png',
  'KBAS20S-G0422-SI':'KBAS20S-G0422-SI-Barton-2 Seater-Magnolia Cream Blue.png',
  'KBAS20S-G0522-FR':'KBAS20S-G0522-FR-Barton-2 Seater-Little Magnolia Pink orange.png',
  'KBAS20S-G0522-SI':'KBAS20S-G0522-SI-Barton-2 Seater-Little Magnolia Pink orange.png',
  'KBAS20S-G0622-FR':'KBAS20S-G0622-FR-Barton-2 Seater-Little Magnolia Espresso.png',
  'KBAS20S-G0622-SI':'KBAS20S-G0622-SI-Barton-2 Seater-Little Magnolia Espresso.png',
  'KBAS20S-G0722-FR':'KBAS20S-G0722-FR-Barton-2 Seater-Little Magnolia Emerald.png',
  'KBAS20S-G0722-SI':'KBAS20S-G0722-SI-Barton-2 Seater-Little Magnolia Emerald.png',
  'KBAS20S-J0122-FR':'KBAS20S-J0122-FR-Barton-2 Seater-Boho Cloud.png',
  'KBAS20S-J0122-SI':'KBAS20S-J0122-SI-Barton-2 Seater-Boho Cloud.png',
  'KBAS20S-L0122-FR':'KBAS20S-L0122-FR-Barton-2 Seater-English Garden - Kitty Spring Green.png',
  'KBAS20S-L0322-FR':'KBAS20S-L0322-FR-Barton-2 Seater-English Garden - Kitty Indian Summer.png',
  'KBAS20S-L0322-SI':'KBAS20S-L0322-SI-Barton-2 Seater-English Garden - Kitty Indian Summer.png',
  'KBAS20S-L0422-SI':'KBAS20S-L0422-SI-Barton-2 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS20S-L0522-FR':'KBAS20S-L0522-FR-Barton-2 Seater-English Garden - Albertine Classic Rose.png',
  'KBAS20S-L0522-SI':'KBAS20S-L0522-SI-Barton-2 Seater-English Garden - Albertine Classic Rose.png',
  'KBAS20S-L0622-FR':'KBAS20S-L0622-FR-Barton-2 Seater-English Garden - Albertine Coral Orange.png',
  'KBAS20S-L0622-SI':'KBAS20S-L0622-SI-Barton-2 Seater-English Garden - Albertine Coral Orange.png',
  'KBAS20S-L0722-FR':'KBAS20S-L0722-FR-Barton-2 Seater-Belleville - Miji Juniper.png',
  'KBAS20S-L0722-SI':'KBAS20S-L0722-SI-Barton-2 Seater-Belleville - Miji Juniper.png',
  'KBAS20S-L1822-FR':'KBAS20S-L1822-FR-Barton-2 Seater-Elba Cerulean.png',
  'KBAS20S-L1822-SI':'KBAS20S-L1822-SI-Barton-2 Seater-Elba Cerulean.png',
  'KBAS20S-L1922-FR':'KBAS20S-L1922-FR-Barton-2 Seater-Elba Hemp.png',
  'KBAS20S-L1922-SI':'KBAS20S-L1922-SI-Barton-2 Seater-Elba Hemp.png',
  'KBAS20S-L2022-FR':'KBAS20S-L2022-FR-Barton-2 Seater-Elba Midnight.png',
  'KBAS20S-L2022-SI':'KBAS20S-L2022-SI-Barton-2 Seater-Elba Midnight.png',
  'KBAS20S-L2122-FR':'KBAS20S-L2122-FR-Barton-2 Seater-Elba Sage.png',
  'KBAS20S-L2122-SI':'KBAS20S-L2122-SI-Barton-2 Seater-Elba Sage.png',
  'KBAS20S-O0122-FR':'KBAS20S-O0122-FR-Barton-2 Seater-Bespoke Coastal Blue.png',
  'KBAS20S-O0122-SI':'KBAS20S-O0122-SI-Barton-2 Seater-Bespoke Coastal Blue.png',
  'KBAS20S-O0222-FR':'KBAS20S-O0222-FR-Barton-2 Seater-Tasman Petunia.png',
  'KBAS20S-O0222-SI':'KBAS20S-O0222-SI-Barton-2 Seater-Tasman Petunia.png',
  'KBAS20S-O0322-FR':'KBAS20S-O0322-FR-Barton-2 Seater-Bespoke Woodland.png',
  'KBAS20S-O0322-SI':'KBAS20S-O0322-SI-Barton-2 Seater-Bespoke Woodland.png',
  'KBAS20S-O0522-FR':'KBAS20S-O0522-FR-Barton-2 Seater-Tasman Sea Holly.png',
  'KBAS20S-O0522-SI':'KBAS20S-O0522-SI-Barton-2 Seater-Tasman Sea Holly.png',
  'KBAS20S-O0622-FR':'KBAS20S-O0622-FR-Barton-2 Seater-Tasman Garden Grey.png',
  'KBAS20S-O0622-SI':'KBAS20S-O0622-SI-Barton-2 Seater-Tasman Garden Grey.png',
  'KBAS20S-O0722-FR':'KBAS20S-O0722-FR-Barton-2 Seater-Tasman Dandelion.png',
  'KBAS20S-O0722-SI':'KBAS20S-O0722-SI-Barton-2 Seater-Tasman Dandelion.png',
  'KBAS20S-O0822-FR':'KBAS20S-O0822-FR-Barton-2 Seater-Tasman Spring Green.png',
  'KBAS20S-O0822-SI':'KBAS20S-O0822-SI-Barton-2 Seater-Tasman Spring Green.png',
  'KBAS20S-O0922-FR':'KBAS20S-O0922-FR-Barton-2 Seater-Tasman Cornish Blue.png',
  'KBAS20S-O0922-SI':'KBAS20S-O0922-SI-Barton-2 Seater-Tasman Cornish Blue.png',
  'KBAS20S-O1122-FR':'KBAS20S-O1122-FR-Barton-2 Seater-Tasman Chocolate.png',
  'KBAS20S-O1122-SI':'KBAS20S-O1122-SI-Barton-2 Seater-Tasman Chocolate.png',
  'KBAS20S-O1322-FR':'KBAS20S-O1322-FR-Barton-2 Seater-Capelo Cool Coconut.png',
  'KBAS20S-O1322-SI':'KBAS20S-O1322-SI-Barton-2 Seater-Capelo Cool Coconut.png',
  'KBAS20S-O1422-FR':'KBAS20S-O1422-FR-Barton-2 Seater-Capelo Snow Drop.png',
  'KBAS20S-O1422-SI':'KBAS20S-O1422-SI-Barton-2 Seater-Capelo Snow Drop.png',
  'KBAS20S-O1522-FR':'KBAS20S-O1522-FR-Barton-2 Seater-Capelo Sea Salt.png',
  'KBAS20S-O1522-SI':'KBAS20S-O1522-SI-Barton-2 Seater-Capelo Sea Salt.png',
  'KBAS20S-O1622-FR':'KBAS20S-O1622-FR-Barton-2 Seater-Capelo Rosedale.png',
  'KBAS20S-O1622-SI':'KBAS20S-O1622-SI-Barton-2 Seater-Capelo Rosedale.png',
  'KBAS20S-O1722-FR':'KBAS20S-O1722-FR-Barton-2 Seater-Capelo Inkspot.png',
  'KBAS20S-O1722-SI':'KBAS20S-O1722-SI-Barton-2 Seater-Capelo Inkspot.png',
  'KBAS20S-O1822-FR':'KBAS20S-O1822-FR-Barton-2 Seater-Columbus Evergreen.png',
  'KBAS20S-O1822-SI':'KBAS20S-O1822-SI-Barton-2 Seater-Columbus Evergreen.png',
  'KBAS20S-O1922-FR':'KBAS20S-O1922-FR-Barton-2 Seater-Columbus Marigold.png',
  'KBAS20S-O1922-SI':'KBAS20S-O1922-SI-Barton-2 Seater-Columbus Marigold.png',
  'KBAS20S-O2122-FR':'KBAS20S-O2122-FR-Barton-2 Seater-Columbus Roselette.png',
  'KBAS20S-O2122-SI':'KBAS20S-O2122-SI-Barton-2 Seater-Columbus Roselette.png',
  'KBAS20S-O2222-FR':'KBAS20S-O2222-FR-Barton-2 Seater-Columbus Sunflower.png',
  'KBAS20S-O2222-SI':'KBAS20S-O2222-SI-Barton-2 Seater-Columbus Sunflower.png',
  'KBAS20X-L182X-FR':'KBAS20X-L182X-FR-Barton-2 seater-Elba Ochre.png',
  'KBAS20X-L182X-SI':'KBAS20X-L182X-SI-Barton-2 seater-Elba Ochre.png',
  'KBAS30B-A012X-FR':'KBAS30B-A012X-FR-Barton-3 Seater-Wildwood Duck Egg.png',
  'KBAS30B-A012X-SI':'KBAS30B-A012X-SI-Barton-3 Seater-Wildwood Duck Egg.png',
  'KBAS30B-A022X-FR':'KBAS30B-A022X-FR-Barton-3 Seater-Wildwood Ivory.png',
  'KBAS30B-A022X-SI':'KBAS30B-A022X-SI-Barton-3 Seater-Wildwood Ivory.png',
  'KBAS30B-A0322-FR':'KBAS30B-A0322-FR-Barton-3 Seater-Wildwood Twig.png',
  'KBAS30B-A0522-FR':'KBAS30B-A0522-FR-Barton-3 Seater-Midsummer Sky.png',
  'KBAS30B-A0722-RE':'KBAS30B-A0722-RE-Barton-3 Seater-Midsummer Faded Blue.jpg',
  'KBAS30B-A0822-FR':'KBAS30B-A0822-FR-Barton-3 Seater-Otter Denim.png',
  'KBAS30B-A0922-FR':'KBAS30B-A0922-FR-Barton-3 Seater-Pelham Clementine.png',
  'KBAS30B-A1022-FR':'KBAS30B-A1022-FR-Barton-3 Seater-Pelham Moss.png',
  'KBAS30B-A102X-FR':'KBAS30B-A102X-FR-Barton-3 Seater-Pelham Moss.png',
  'KBAS30B-A102X-SI':'KBAS30B-A102X-SI-Barton-3 Seater-Pelham Moss.png',
  'KBAS30B-A1122-FR':'KBAS30B-A1122-FR-Barton-3 Seater-Pelham Denim.png',
  'KBAS30B-B0322-FR':'KBAS30B-B0322-FR-Barton-3 Seater-Beatrice Midnight.png',
  'KBAS30B-B0622-FR':'KBAS30B-B0622-FR-Barton-3 Seater-Froisse Cerulean.png',
  'KBAS30B-B0722-FR':'KBAS30B-B0722-FR-Barton-3 Seater-Froisse Chalk.png',
  'KBAS30B-B0822-FR':'KBAS30B-B0822-FR-Barton-3 Seater-Froisse Hemp.png',
  'KBAS30B-B122X-FR':'KBAS30B-B122X-FR-Barton-3 Seater-Froisse Putty.png',
  'KBAS30B-B122X-SI':'KBAS30B-B122X-SI-Barton-3 Seater-Froisse Putty.png',
  'KBAS30B-D0622-FR':'KBAS30B-D0622-FR-Barton-3 Seater-Brera Lino Cerise.png',
  'KBAS30B-D082X-FR':'KBAS30B-D082X-FR-Barton-3 Seater-Brera Lino Putty.png',
  'KBAS30B-D082X-SI':'KBAS30B-D082X-SI-Barton-3 Seater-Brera Lino Putty.png',
  'KBAS30B-G0222-FR':'KBAS30B-G0222-FR-Barton-3 Seater-Nympheus Stone pistachio.png',
  'KBAS30B-G0322-FR':'KBAS30B-G0322-FR-Barton-3 Seater-Nympheus Aqua teal.png',
  'KBAS30B-G0422-FR':'KBAS30B-G0422-FR-Barton-3 Seater-Magnolia Cream Blue.png',
  'KBAS30B-G042X-FR':'KBAS30B-G042X-FR-Barton-3 Seater-Magnolia Cream Blue.png',
  'KBAS30B-G042X-SI':'KBAS30B-G042X-SI-Barton-3 Seater-Magnolia Cream Blue.png',
  'KBAS30B-G0622-FR':'KBAS30B-G0622-FR-Barton-3 Seater-Little Magnolia Espresso.png',
  'KBAS30B-J0122-FR':'KBAS30B-J0122-FR-Barton-3 Seater-Boho Cloud.png',
  'KBAS30B-L0122-FR':'KBAS30B-L0122-FR-Barton-3 Seater-English Garden - Kitty Spring Green.png',
  'KBAS30B-L0222-FR':'KBAS30B-L0222-FR-Barton-3 Seater-English Garden - Kitty Blue Green.png',
  'KBAS30B-L0322-FR':'KBAS30B-L0322-FR-Barton-3 Seater-English Garden - Kitty Indian Summer.png',
  'KBAS30B-L0422-FR':'KBAS30B-L0422-FR-Barton-3 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS30B-L042X-FR':'KBAS30B-L042X-FR-Barton-3 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS30B-L042X-SI':'KBAS30B-L042X-SI-Barton-3 Seater-English Garden - Albertine Grey Skies.png',
  'KBAS30B-L0522-FR':'KBAS30B-L0522-FR-Barton-3 Seater-English Garden - Albertine Classic Rose.png',
  'KBAS30B-L0622-FR':'KBAS30B-L0622-FR-Barton-3 Seater-English Garden - Albertine Coral Orange.png',
  'KBAS30B-L2022-FR':'KBAS30B-L2022-FR-Barton-3 Seater-Elba Midnight.png',
  'KBAS30B-O0122-FR':'KBAS30B-O0122-FR-Barton-3 Seater-Bespoke Coastal Blue.png',
  'KBAS30B-O022X-FR':'KBAS30B-O022X-FR-Barton-3 Seater-Tasman Petunia.png',
  'KBAS30B-O022X-SI':'KBAS30B-O022X-SI-Barton-3 Seater-Tasman Petunia.png',
  'KBAS30B-O0322-FR':'KBAS30B-O0322-FR-Barton-3 Seater-Bespoke Woodland.png',
  'KBAS30B-O0522-FR':'KBAS30B-O0522-FR-Barton-3 Seater-Tasman Sea Holly.png',
  'KBAS30B-O062X-FR':'KBAS30B-O062X-FR-Barton-3 Seater-Tasman Garden Grey.png',
  'KBAS30B-O062X-SI':'KBAS30B-O062X-SI-Barton-3 Seater-Tasman Garden Grey.png',
  'KBAS30B-O0722-FR':'KBAS30B-O0722-FR-Barton-3 Seater-Tasman Dandelion.png',
  'KBAS30B-O072X-FR':'KBAS30B-O072X-FR-Barton-3 Seater-Tasman Dandelion.png',
  'KBAS30B-O072X-SI':'KBAS30B-O072X-SI-Barton-3 Seater-Tasman Dandelion.png',
  'KBAS30B-O102X-FR':'KBAS30B-O102X-FR-Barton-3 Seater-Antarctic Narrow Chocolate.png',
  'KBAS30B-O102X-SI':'KBAS30B-O102X-SI-Barton-3 Seater-Antarctic Narrow Chocolate.png',
  'KBAS30B-O112X-FR':'KBAS30B-O112X-FR-Barton-3 Seater-Tasman Chocolate.png',
  'KBAS30B-O112X-SI':'KBAS30B-O112X-SI-Barton-3 Seater-Tasman Chocolate.png',
  'KBAS30B-O1322-FR':'KBAS30B-O1322-FR-Barton-3 Seater-Capelo Cool Coconut.png',
  'KBAS30B-O1422-FR':'KBAS30B-O1422-FR-Barton-3 Seater-Capelo Snow Drop.png',
  'KBAS30B-O142X-FR':'KBAS30B-O142X-FR-Barton-3 Seater-Capelo Snow Drop.png',
  'KBAS30B-O142X-SI':'KBAS30B-O142X-SI-Barton-3 Seater-Capelo Snow Drop.png',
  'KBAS30B-O1722-FR':'KBAS30B-O1722-FR-Barton-3 Seater-Capelo Inkspot.png',
  'KBAS30B-O1922-FR':'KBAS30B-O1922-FR-Barton-3 Seater-Columbus Marigold.png',
  'KBAS30B-O2122-FR':'KBAS30B-O2122-FR-Barton-3 Seater-Columbus Roselette.png',
  'KCBFFSK-J0421-FR':'KCBFFSK-J0421-FR-Cocobella-Footstool-Bruges Navy.png',
  'KCBFFSK-J0521-FR':'KCBFFSK-J0521-FR-Cocobella-Footstool-Bruges Sage.png',
  'KCBFFSK-J0621-FR':'KCBFFSK-J0621-FR-Cocobella-Footstool-Bruges Sand.png',
  'KCBFFSK-J0721-FR':'KCBFFSK-J0721-FR-Cocobella-Footstool-Suzy Olive.png',
  'KCBFFSK-J0821-FR':'KCBFFSK-J0821-FR-Cocobella-Footstool-Suzy Denim.png',
  'KCBFFSK-J0921-FR':'KCBFFSK-J0921-FR-Cocobella-Footstool-Suzy Natural.png',
  'KCBFFSK-J1021-FR':'KCBFFSK-J1021-FR-Cocobella-Footstool-Beauville Spring Green.png',
  'KCBFFSK-J1121-FR':'KCBFFSK-J1121-FR-Cocobella-Footstool-Beauville Cornish Blue.png',
  'KCBFFSK-O2321-FR':'KCBFFSK-O2321-FR-Cocobella-Footstool-Pinstripe Natural.png',
  'KCBFFSK-O2421-FR':'KCBFFSK-O2421-FR-Cocobella-Footstool-Pinstripe Petunia.png',
  'KCBFFSK-O2521-FR':'KCBFFSK-O2521-FR-Cocobella-Footstool-Pinstripe Nutmeg.png',
  'KCBFFSK-O2621-FR':'KCBFFSK-O2621-FR-Cocobella-Footstool-Tasman Natural.png',
  'KCBM33K-B0121-SI':'KCBM33K-B0121-SI-Cocobella-3x3 Sectional-Beatrice Barley.png',
  'KCBM33K-B0221-SI':'KCBM33K-B0221-SI-Cocobella-3x3 Sectional-Beatrice Camelia.png',
  'KCBM33K-B0321-SI':'KCBM33K-B0321-SI-Cocobella-3x3 Sectional-Beatrice Midnight.png',
  'KCBM33K-J0421-SI':'KCBM33K-J0421-SI-Cocobella-3x3 Sectional-Bruges Navy.png',
  'KCBM33K-J0521-SI':'KCBM33K-J0521-SI-Cocobella-3x3 Sectional-Bruges Sage.png',
  'KCBM33K-J0621-SI':'KCBM33K-J0621-SI-Cocobella-3x3 Sectional-Bruges Sand.png',
  'KCBM33K-J0721-SI':'KCBM33K-J0721-SI-Cocobella-3x3 Sectional-Suzy Olive.png',
  'KCBM33K-J0821-SI':'KCBM33K-J0821-SI-Cocobella-3x3 Sectional-Suzy Denim.png',
  'KCBM33K-J0921-SI':'KCBM33K-J0921-SI-Cocobella-3x3 Sectional-Suzy Natural.png',
  'KCBM33K-J1021-SI':'KCBM33K-J1021-SI-Cocobella-3x3 Sectional-Beauville Spring Green.png',
  'KCBM33K-J1121-SI':'KCBM33K-J1121-SI-Cocobella-3x3 Sectional-Beauville Cornish Blue.png',
  'KCBM33K-O2321-SI':'KCBM33K-O2321-SI-Cocobella-3x3 Sectional-Pinstripe Natural.png',
  'KCBM33K-O2421-SI':'KCBM33K-O2421-SI-Cocobella-3x3 Sectional-Pinstripe Petunia.png',
  'KCBM33K-O2521-SI':'KCBM33K-O2521-SI-Cocobella-3x3 Sectional-Pinstripe Nutmeg.png',
  'KCBM33K-O2621-SI':'KCBM33K-O2621-SI-Cocobella-3x3 Sectional-Tasman Natural.png',
  'KCBMLAK-B0121-SI':'KCBMLAK-B0121-SI-Cocobella-2x3 Sectional-Beatrice Barley.png',
  'KCBMLAK-B0221-SI':'KCBMLAK-B0221-SI-Cocobella-2x3 Sectional-Beatrice Camelia.png',
  'KCBMLAK-B0321-SI':'KCBMLAK-B0321-SI-Cocobella-2x3 Sectional-Beatrice Midnight.png',
  'KCBMLAK-B0421-SI':'KCBMLAK-B0421-SI-Cocobella-2x3 Sectional-Beatrice Nutmeg.png',
  'KCBMLAK-B0521-SI':'KCBMLAK-B0521-SI-Cocobella-2x3 Sectional-Beatrice Olive.png',
  'KCBMLAK-J0121-SI':'KCBMLAK-J0121-SI-Cocobella-2x3 Sectional-Boho Cloud.png',
  'KCBMLAK-J0221-SI':'KCBMLAK-J0221-SI-Cocobella-2x3 Sectional-Boho Denim.png',
  'KCBMLAK-J0321-SI':'KCBMLAK-J0321-SI-Cocobella-2x3 Sectional-Boho Parchment.png',
  'KCBMLAK-J0421-LHF':'KCBMLAK-J0421-LHF-Cocobella-2x3 Sectional-Bruges Navy.png',
  'KCBMLAK-J0421-RHF':'KCBMLAK-J0421-RHF-Cocobella-2x3 Sectional-Bruges Navy.png',
  'KCBMLAK-J0421-SI':'KCBMLAK-J0421-SI-Cocobella-2x3 Sectional-Bruges Navy.png',
  'KCBMLAK-J0521-LHF':'KCBMLAK-J0521-LHF-Cocobella-2x3 Sectional-Bruges Sage.png',
  'KCBMLAK-J0521-RHF':'KCBMLAK-J0521-RHF-Cocobella-2x3 Sectional-Bruges Sage.png',
  'KCBMLAK-J0521-SI':'KCBMLAK-J0521-SI-Cocobella-2x3 Sectional-Bruges Sage.png',
  'KCBMLAK-J0621-LHF':'KCBMLAK-J0621-LHF-Cocobella-2x3 Sectional-Bruges Sand.png',
  'KCBMLAK-J0621-RHF':'KCBMLAK-J0621-RHF-Cocobella-2x3 Sectional-Bruges Sand.png',
  'KCBMLAK-J0621-SI':'KCBMLAK-J0621-SI-Cocobella-2x3 Sectional-Bruges Sand.png',
  'KCBMLAK-J0721-LHF':'KCBMLAK-J0721-LHF-Cocobella-2x3 Sectional-Suzy Olive.png',
  'KCBMLAK-J0721-RHF':'KCBMLAK-J0721-RHF-Cocobella-2x3 Sectional-Suzy Olive.png',
  'KCBMLAK-J0821-LHF':'KCBMLAK-J0821-LHF-Cocobella-2x3 Sectional-Suzy Denim.png',
  'KCBMLAK-J0821-RHF':'KCBMLAK-J0821-RHF-Cocobella-2x3 Sectional-Suzy Denim.png',
  'KCBMLAK-J0921-LHF':'KCBMLAK-J0921-LHF-Cocobella-2x3 Sectional-Suzy Natural.png',
  'KCBMLAK-J0921-RHF':'KCBMLAK-J0921-RHF-Cocobella-2x3 Sectional-Suzy Natural.png',
  'KCBMLAK-J0921-SI':'KCBMLAK-J0921-SI-Cocobella-2x3 Sectional-Suzy Natural.png',
  'KCBMLAK-J1021-LHF':'KCBMLAK-J1021-LHF-Cocobella-2x3 Sectional-Beauville Spring Green.png',
  'KCBMLAK-J1021-RHF':'KCBMLAK-J1021-RHF-Cocobella-2x3 Sectional-Beauville Spring Green.png',
  'KCBMLAK-J1021-SI':'KCBMLAK-J1021-SI-Cocobella-2x3 Sectional-Beauville Spring Green.png',
  'KCBMLAK-J1121-LHF':'KCBMLAK-J1121-LHF-Cocobella-2x3 Sectional-Beauville Cornish Blue.png',
  'KCBMLAK-J1121-RHF':'KCBMLAK-J1121-RHF-Cocobella-2x3 Sectional-Beauville Cornish Blue.png',
  'KCBMLAK-J1121-SI':'KCBMLAK-J1121-SI-Cocobella-2x3 Sectional-Beauville Cornish Blue.png',
  'KCBMLAK-O0121-SI':'KCBMLAK-O0121-SI-Cocobella-2x3 Sectional-Bespoke Coastal Blue.png',
  'KCBMLAK-O0221-SI':'KCBMLAK-O0221-SI-Cocobella-2x3 Sectional-Tasman Petunia.png',
  'KCBMLAK-O0821-SI':'KCBMLAK-O0821-SI-Cocobella-2x3 Sectional-Tasman Spring Green.png',
  'KCBMLAK-O0921-SI':'KCBMLAK-O0921-SI-Cocobella-2x3 Sectional-Tasman Cornish Blue.png',
  'KCBMLAK-O2321-LHF':'KCBMLAK-O2321-LHF-Cocobella-2x3 Sectional-Pinstripe Natural.png',
  'KCBMLAK-O2321-RHF':'KCBMLAK-O2321-RHF-Cocobella-2x3 Sectional-Pinstripe Natural.png',
  'KCBMLAK-O2321-SI':'KCBMLAK-O2321-SI-Cocobella-2x3 Sectional-Pinstripe Natural.png',
  'KCBMLAK-O2421-LHF':'KCBMLAK-O2421-LHF-Cocobella-2x3 Sectional-Pinstripe Petunia.png',
  'KCBMLAK-O2421-RHF':'KCBMLAK-O2421-RHF-Cocobella-2x3 Sectional-Pinstripe Petunia.png',
  'KCBMLAK-O2421-SI':'KCBMLAK-O2421-SI-Cocobella-2x3 Sectional-Pinstripe Petunia.png',
  'KCBMLAK-O2521-LHF':'KCBMLAK-O2521-LHF-Cocobella-2x3 Sectional-Pinstripe Nutmeg.png',
  'KCBMLAK-O2521-RHF':'KCBMLAK-O2521-RHF-Cocobella-2x3 Sectional-Pinstripe Nutmeg.png',
  'KCBMLAK-O2521-SI':'KCBMLAK-O2521-SI-Cocobella-2x3 Sectional-Pinstripe Nutmeg.png',
  'KCBMLAK-O2621-LHF':'KCBMLAK-O2621-LHF-Cocobella-2x3 Sectional-Tasman Natural.png',
  'KCBMLAK-O2621-RHF':'KCBMLAK-O2621-RHF-Cocobella-2x3 Sectional-Tasman Natural.png',
  'KCBS10K-B0121-FR':'KCBS10K-B0121-FR-Cocobella-Armchair-Beatrice Barley.png',
  'KCBS10K-B0121-SI':'KCBS10K-B0121-SI-Cocobella-Armchair-Beatrice Barley.png',
  'KCBS10K-B0221-FR':'KCBS10K-B0221-FR-Cocobella-Armchair-Beatrice Camelia.png',
  'KCBS10K-B0221-SI':'KCBS10K-B0221-SI-Cocobella-Armchair-Beatrice Camelia.png',
  'KCBS10K-B0321-FR':'KCBS10K-B0321-FR-Cocobella-Armchair-Beatrice Midnight.png',
  'KCBS10K-B0321-SI':'KCBS10K-B0321-SI-Cocobella-Armchair-Beatrice Midnight.png',
  'KCBS10K-B0421-FR':'KCBS10K-B0421-FR-Cocobella-Armchair-Beatrice Nutmeg.png',
  'KCBS10K-B0421-SI':'KCBS10K-B0421-SI-Cocobella-Armchair-Beatrice Nutmeg.png',
  'KCBS10K-B0521-FR':'KCBS10K-B0521-FR-Cocobella-Armchair-Beatrice Olive.png',
  'KCBS10K-B0521-SI':'KCBS10K-B0521-SI-Cocobella-Armchair-Beatrice Olive.png',
  'KCBS10K-J0121-FR':'KCBS10K-J0121-FR-Cocobella-Armchair-Boho Cloud.png',
  'KCBS10K-J0121-SI':'KCBS10K-J0121-SI-Cocobella-Armchair-Boho Cloud.png',
  'KCBS10K-J0221-FR':'KCBS10K-J0221-FR-Cocobella-Armchair-Boho Denim.png',
  'KCBS10K-J0221-SI':'KCBS10K-J0221-SI-Cocobella-Armchair-Boho Denim.png',
  'KCBS10K-J0321-FR':'KCBS10K-J0321-FR-Cocobella-Armchair-Boho Parchment.png',
  'KCBS10K-J0321-SI':'KCBS10K-J0321-SI-Cocobella-Armchair-Boho Parchment.png',
  'KCBS10K-J0421-FR':'KCBS10K-J0421-FR-Cocobella-Armchair-Bruges Navy.jpg',
  'KCBS10K-J0421-SI':'KCBS10K-J0421-SI-Cocobella-Armchair-Bruges Navy.jpg',
  'KCBS10K-J0521-FR':'KCBS10K-J0521-FR-Cocobella-Armchair-Bruges Sage.png',
  'KCBS10K-J0521-SI':'KCBS10K-J0521-SI-Cocobella-Armchair-Bruges Sage.jpg',
  'KCBS10K-J0621-FR':'KCBS10K-J0621-FR-Cocobella-Armchair-Bruges Sand.png',
  'KCBS10K-J0621-SI':'KCBS10K-J0621-SI-Cocobella-Armchair-Bruges Sand.jpg',
  'KCBS10K-J0721-FR':'KCBS10K-J0721-FR-Cocobella-Armchair-Suzy Olive.png',
  'KCBS10K-J0721-SI':'KCBS10K-J0721-SI-Cocobella-Armchair-Suzy Olive.png',
  'KCBS10K-J0821-FR':'KCBS10K-J0821-FR-Cocobella-Armchair-Suzy Denim.png',
  'KCBS10K-J0821-SI':'KCBS10K-J0821-SI-Cocobella-Armchair-Suzy Denim.jpg',
  'KCBS10K-J0921-FR':'KCBS10K-J0921-FR-Cocobella-Armchair-Suzy Natural.jpg',
  'KCBS10K-J0921-SI':'KCBS10K-J0921-SI-Cocobella-Armchair-Suzy Natural.png',
  'KCBS10K-J1021-FR':'KCBS10K-J1021-FR-Cocobella-Armchair-Beauville Spring Green.png',
  'KCBS10K-J1021-SI':'KCBS10K-J1021-SI-Cocobella-Armchair-Beauville Spring Green.jpg',
  'KCBS10K-J1121-FR':'KCBS10K-J1121-FR-Cocobella-Armchair-Beauville Cornish Blue.jpg',
  'KCBS10K-J1121-SI':'KCBS10K-J1121-SI-Cocobella-Armchair-Beauville Cornish Blue.jpg',
  'KCBS10K-O0121-FR':'KCBS10K-O0121-FR-Cocobella-Armchair-Bespoke Coastal Blue.png',
  'KCBS10K-O0121-SI':'KCBS10K-O0121-SI-Cocobella-Armchair-Bespoke Coastal Blue.png',
  'KCBS10K-O0221-FR':'KCBS10K-O0221-FR-Cocobella-Armchair-Tasman Petunia.png',
  'KCBS10K-O0221-SI':'KCBS10K-O0221-SI-Cocobella-Armchair-Tasman Petunia.png',
  'KCBS10K-O0821-FR':'KCBS10K-O0821-FR-Cocobella-Armchair-Tasman Spring Green.png',
  'KCBS10K-O0821-SI':'KCBS10K-O0821-SI-Cocobella-Armchair-Tasman Spring Green.png',
  'KCBS10K-O0921-FR':'KCBS10K-O0921-FR-Cocobella-Armchair-Tasman Cornish Blue.png',
  'KCBS10K-O0921-SI':'KCBS10K-O0921-SI-Cocobella-Armchair-Tasman Cornish Blue.png',
  'KCBS10K-O2321-FR':'KCBS10K-O2321-FR-Cocobella-Armchair-Pinstripe Natural.jpg',
  'KCBS10K-O2321-SI':'KCBS10K-O2321-SI-Cocobella-Armchair-Pinstripe Natural.jpg',
  'KCBS10K-O2421-FR':'KCBS10K-O2421-FR-Cocobella-Armchair-Pinstripe Petunia.jpg',
  'KCBS10K-O2421-SI':'KCBS10K-O2421-SI-Cocobella-Armchair-Pinstripe Petunia.jpg',
  'KCBS10K-O2521-FR':'KCBS10K-O2521-FR-Cocobella-Armchair-Pinstripe Nutmeg.jpg',
  'KCBS10K-O2521-SI':'KCBS10K-O2521-SI-Cocobella-Armchair-Pinstripe Nutmeg.jpg',
  'KCBS10K-O2621-FR':'KCBS10K-O2621-FR-Cocobella-Armchair-Tasman Natural.jpg',
  'KCBS10K-O2621-SI':'KCBS10K-O2621-SI-Cocobella-Armchair-Tasman Natural.jpg',
  'KCBS15K-B0121-FR':'KCBS15K-B0121-FR-Cocobella-Loveseat-Beatrice Barley.png',
  'KCBS15K-B0121-SI':'KCBS15K-B0121-SI-Cocobella-Loveseat-Beatrice Barley.png',
  'KCBS15K-B0221-FR':'KCBS15K-B0221-FR-Cocobella-Loveseat-Beatrice Camelia.png',
  'KCBS15K-B0221-SI':'KCBS15K-B0221-SI-Cocobella-Loveseat-Beatrice Camelia.png',
  'KCBS15K-B0321-FR':'KCBS15K-B0321-FR-Cocobella-Loveseat-Beatrice Midnight.png',
  'KCBS15K-B0321-SI':'KCBS15K-B0321-SI-Cocobella-Loveseat-Beatrice Midnight.png',
  'KCBS15K-B0421-FR':'KCBS15K-B0421-FR-Cocobella-Loveseat-Beatrice Nutmeg.png',
  'KCBS15K-B0421-SI':'KCBS15K-B0421-SI-Cocobella-Loveseat-Beatrice Nutmeg.png',
  'KCBS15K-B0521-FR':'KCBS15K-B0521-FR-Cocobella-Loveseat-Beatrice Olive.png',
  'KCBS15K-B0521-SI':'KCBS15K-B0521-SI-Cocobella-Loveseat-Beatrice Olive.png',
  'KCBS15K-J0121-FR':'KCBS15K-J0121-FR-Cocobella-Loveseat-Boho Cloud.png',
  'KCBS15K-J0121-SI':'KCBS15K-J0121-SI-Cocobella-Loveseat-Boho Cloud.png',
  'KCBS15K-J0221-FR':'KCBS15K-J0221-FR-Cocobella-Loveseat-Boho Denim.png',
  'KCBS15K-J0221-SI':'KCBS15K-J0221-SI-Cocobella-Loveseat-Boho Denim.png',
  'KCBS15K-J0321-FR':'KCBS15K-J0321-FR-Cocobella-Loveseat-Boho Parchment.png',
  'KCBS15K-J0321-SI':'KCBS15K-J0321-SI-Cocobella-Loveseat-Boho Parchment.png',
  'KCBS15K-J0421-FR':'KCBS15K-J0421-FR-Cocobella-Loveseat-Bruges Navy.jpg',
  'KCBS15K-J0421-SI':'KCBS15K-J0421-SI-Cocobella-Loveseat-Bruges Navy.jpg',
  'KCBS15K-J0521-FR':'KCBS15K-J0521-FR-Cocobella-Loveseat-Bruges Sage.jpg',
  'KCBS15K-J0521-SI':'KCBS15K-J0521-SI-Cocobella-Loveseat-Bruges Sage.jpg',
  'KCBS15K-J0621-FR':'KCBS15K-J0621-FR-Cocobella-Loveseat-Bruges Sand.jpg',
  'KCBS15K-J0621-SI':'KCBS15K-J0621-SI-Cocobella-Loveseat-Bruges Sand.jpg',
  'KCBS15K-J0721-FR':'KCBS15K-J0721-FR-Cocobella-Loveseat-Suzy Olive.png',
  'KCBS15K-J0721-SI':'KCBS15K-J0721-SI-Cocobella-Loveseat-Suzy Olive.jpg',
  'KCBS15K-J0821-FR':'KCBS15K-J0821-FR-Cocobella-Loveseat-Suzy Denim.png',
  'KCBS15K-J0821-SI':'KCBS15K-J0821-SI-Cocobella-Loveseat-Suzy Denim.jpg',
  'KCBS15K-J0921-FR':'KCBS15K-J0921-FR-Cocobella-Loveseat-Suzy Natural.jpg',
  'KCBS15K-J0921-SI':'KCBS15K-J0921-SI-Cocobella-Loveseat-Suzy Natural.jpg',
  'KCBS15K-J1021-FR':'KCBS15K-J1021-FR-Cocobella-Loveseat-Beauville Spring Green.jpg',
  'KCBS15K-J1021-SI':'KCBS15K-J1021-SI-Cocobella-Loveseat-Beauville Spring Green.jpg',
  'KCBS15K-J1121-FR':'KCBS15K-J1121-FR-Cocobella-Loveseat-Beauville Cornish Blue.jpg',
  'KCBS15K-J1121-SI':'KCBS15K-J1121-SI-Cocobella-Loveseat-Beauville Cornish Blue.jpg',
  'KCBS15K-O0121-FR':'KCBS15K-O0121-FR-Cocobella-Loveseat-Bespoke Coastal Blue.png',
  'KCBS15K-O0121-SI':'KCBS15K-O0121-SI-Cocobella-Loveseat-Bespoke Coastal Blue.png',
  'KCBS15K-O0221-FR':'KCBS15K-O0221-FR-Cocobella-Loveseat-Tasman Petunia.png',
  'KCBS15K-O0221-SI':'KCBS15K-O0221-SI-Cocobella-Loveseat-Tasman Petunia.png',
  'KCBS15K-O0821-FR':'KCBS15K-O0821-FR-Cocobella-Loveseat-Tasman Spring Green.png',
  'KCBS15K-O0821-SI':'KCBS15K-O0821-SI-Cocobella-Loveseat-Tasman Spring Green.jpg',
  'KCBS15K-O0921-FR':'KCBS15K-O0921-FR-Cocobella-Loveseat-Tasman Cornish Blue.png',
  'KCBS15K-O0921-SI':'KCBS15K-O0921-SI-Cocobella-Loveseat-Tasman Cornish Blue.png',
  'KCBS15K-O2321-FR':'KCBS15K-O2321-FR-Cocobella-Loveseat-Pinstripe Natural.png',
  'KCBS15K-O2321-SI':'KCBS15K-O2321-SI-Cocobella-Loveseat-Pinstripe Natural.jpg',
  'KCBS15K-O2421-FR':'KCBS15K-O2421-FR-Cocobella-Loveseat-Pinstripe Petunia.png',
  'KCBS15K-O2421-SI':'KCBS15K-O2421-SI-Cocobella-Loveseat-Pinstripe Petunia.jpg',
  'KCBS15K-O2521-FR':'KCBS15K-O2521-FR-Cocobella-Loveseat-Pinstripe Nutmeg.jpg',
  'KCBS15K-O2521-SI':'KCBS15K-O2521-SI-Cocobella-Loveseat-Pinstripe Nutmeg.jpg',
  'KCBS15K-O2621-FR':'KCBS15K-O2621-FR-Cocobella-Loveseat-Tasman Natural.jpg',
  'KCBS15K-O2621-SI':'KCBS15K-O2621-SI-Cocobella-Loveseat-Tasman Natural.jpg',
  'KCBS20K-B0121-FR':'KCBS20K-B0121-FR-Cocobella-2 Seater-Beatrice Barley.png',
  'KCBS20K-B0121-SI':'KCBS20K-B0121-SI-Cocobella-2 Seater-Beatrice Barley.png',
  'KCBS20K-B0221-FR':'KCBS20K-B0221-FR-Cocobella-2 Seater-Beatrice Camelia.png',
  'KCBS20K-B0221-SI':'KCBS20K-B0221-SI-Cocobella-2 Seater-Beatrice Camelia.png',
  'KCBS20K-B0321-FR':'KCBS20K-B0321-FR-Cocobella-2 Seater-Beatrice Midnight.png',
  'KCBS20K-B0321-SI':'KCBS20K-B0321-SI-Cocobella-2 Seater-Beatrice Midnight.png',
  'KCBS20K-B0421-FR':'KCBS20K-B0421-FR-Cocobella-2 Seater-Beatrice Nutmeg.png',
  'KCBS20K-B0421-SI':'KCBS20K-B0421-SI-Cocobella-2 Seater-Beatrice Nutmeg.png',
  'KCBS20K-B0521-FR':'KCBS20K-B0521-FR-Cocobella-2 Seater-Beatrice Olive.png',
  'KCBS20K-B0521-SI':'KCBS20K-B0521-SI-Cocobella-2 Seater-Beatrice Olive.png',
  'KCBS20K-J0121-FR':'KCBS20K-J0121-FR-Cocobella-2 Seater-Boho Cloud.png',
  'KCBS20K-J0121-SI':'KCBS20K-J0121-SI-Cocobella-2 Seater-Boho Cloud.png',
  'KCBS20K-J0221-FR':'KCBS20K-J0221-FR-Cocobella-2 Seater-Boho Denim.png',
  'KCBS20K-J0221-SI':'KCBS20K-J0221-SI-Cocobella-2 Seater-Boho Denim.png',
  'KCBS20K-J0321-FR':'KCBS20K-J0321-FR-Cocobella-2 Seater-Boho Parchment.png',
  'KCBS20K-J0321-SI':'KCBS20K-J0321-SI-Cocobella-2 Seater-Boho Parchment.png',
  'KCBS20K-J0421-FR':'KCBS20K-J0421-FR-Cocobella-2 Seater-Bruges Navy.jpg',
  'KCBS20K-J0421-SI':'KCBS20K-J0421-SI-Cocobella-2 Seater-Bruges Navy.jpg',
  'KCBS20K-J0521-FR':'KCBS20K-J0521-FR-Cocobella-2 Seater-Bruges Sage.jpg',
  'KCBS20K-J0521-SI':'KCBS20K-J0521-SI-Cocobella-2 Seater-Bruges Sage.jpg',
  'KCBS20K-J0621-FR':'KCBS20K-J0621-FR-Cocobella-2 Seater-Bruges Sand.jpg',
  'KCBS20K-J0621-SI':'KCBS20K-J0621-SI-Cocobella-2 Seater-Bruges Sand.jpg',
  'KCBS20K-J0721-FR':'KCBS20K-J0721-FR-Cocobella-2 Seater-Suzy Olive.png',
  'KCBS20K-J0721-SI':'KCBS20K-J0721-SI-Cocobella-2 Seater-Suzy Olive.jpg',
  'KCBS20K-J0821-FR':'KCBS20K-J0821-FR-Cocobella-2 Seater-Suzy Denim.png',
  'KCBS20K-J0821-SI':'KCBS20K-J0821-SI-Cocobella-2 Seater-Suzy Denim.jpg',
  'KCBS20K-J0921-FR':'KCBS20K-J0921-FR-Cocobella-2 Seater-Suzy Natural.png',
  'KCBS20K-J0921-SI':'KCBS20K-J0921-SI-Cocobella-2 Seater-Suzy Natural.jpg',
  'KCBS20K-J1021-FR':'KCBS20K-J1021-FR-Cocobella-2 Seater-Beauville Spring Green.png',
  'KCBS20K-J1021-SI':'KCBS20K-J1021-SI-Cocobella-2 Seater-Beauville Spring Green.jpg',
  'KCBS20K-J1121-FR':'KCBS20K-J1121-FR-Cocobella-2 Seater-Beauville Cornish Blue.jpg',
  'KCBS20K-J1121-SI':'KCBS20K-J1121-SI-Cocobella-2 Seater-Beauville Cornish Blue.jpg',
  'KCBS20K-O0121-FR':'KCBS20K-O0121-FR-Cocobella-2 Seater-Bespoke Coastal Blue.png',
  'KCBS20K-O0121-SI':'KCBS20K-O0121-SI-Cocobella-2 Seater-Bespoke Coastal Blue.png',
  'KCBS20K-O0221-FR':'KCBS20K-O0221-FR-Cocobella-2 Seater-Tasman Petunia.png',
  'KCBS20K-O0221-SI':'KCBS20K-O0221-SI-Cocobella-2 Seater-Tasman Petunia.png',
  'KCBS20K-O0821-FR':'KCBS20K-O0821-FR-Cocobella-2 Seater-Tasman Spring Green.png',
  'KCBS20K-O0821-SI':'KCBS20K-O0821-SI-Cocobella-2 Seater-Tasman Spring Green.png',
  'KCBS20K-O0921-FR':'KCBS20K-O0921-FR-Cocobella-2 Seater-Tasman Cornish Blue.png',
  'KCBS20K-O0921-SI':'KCBS20K-O0921-SI-Cocobella-2 Seater-Tasman Cornish Blue.png',
  'KCBS20K-O2321-FR':'KCBS20K-O2321-FR-Cocobella-2 Seater-Pinstripe Natural.jpg',
  'KCBS20K-O2321-SI':'KCBS20K-O2321-SI-Cocobella-2 Seater-Pinstripe Natural.jpg',
  'KCBS20K-O2421-FR':'KCBS20K-O2421-FR-Cocobella-2 Seater-Pinstripe Petunia.jpg',
  'KCBS20K-O2421-SI':'KCBS20K-O2421-SI-Cocobella-2 Seater-Pinstripe Petunia.jpg',
  'KCBS20K-O2521-FR':'KCBS20K-O2521-FR-Cocobella-2 Seater-Pinstripe Nutmeg.jpg',
  'KCBS20K-O2521-SI':'KCBS20K-O2521-SI-Cocobella-2 Seater-Pinstripe Nutmeg.jpg',
  'KCBS20K-O2621-FR':'KCBS20K-O2621-FR-Cocobella-2 Seater-Tasman Natural.jpg',
  'KCBS20K-O2621-SI':'KCBS20K-O2621-SI-Cocobella-2 Seater-Tasman Natural.jpg',
  'KCBS25K-B0121-FR':'KCBS25K-B0121-FR-Cocobella-2.5 Seater-Beatrice Barley.png',
  'KCBS25K-B0121-SI':'KCBS25K-B0121-SI-Cocobella-2.5 Seater-Beatrice Barley.png',
  'KCBS25K-B0221-FR':'KCBS25K-B0221-FR-Cocobella-2.5 Seater-Beatrice Camelia.png',
  'KCBS25K-B0221-SI':'KCBS25K-B0221-SI-Cocobella-2.5 Seater-Beatrice Camelia.png',
  'KCBS25K-B0321-FR':'KCBS25K-B0321-FR-Cocobella-2.5 Seater-Beatrice Midnight.png',
  'KCBS25K-B0321-SI':'KCBS25K-B0321-SI-Cocobella-2.5 Seater-Beatrice Midnight.png',
  'KCBS25K-B0421-FR':'KCBS25K-B0421-FR-Cocobella-2.5 Seater-Beatrice Nutmeg.png',
  'KCBS25K-B0421-SI':'KCBS25K-B0421-SI-Cocobella-2.5 Seater-Beatrice Nutmeg.png',
  'KCBS25K-B0521-FR':'KCBS25K-B0521-FR-Cocobella-2.5 Seater-Beatrice Olive.png',
  'KCBS25K-B0521-SI':'KCBS25K-B0521-SI-Cocobella-2.5 Seater-Beatrice Olive.png',
  'KCBS25K-J0121-FR':'KCBS25K-J0121-FR-Cocobella-2.5 Seater-Boho Cloud.png',
  'KCBS25K-J0121-SI':'KCBS25K-J0121-SI-Cocobella-2.5 Seater-Boho Cloud.png',
  'KCBS25K-J0221-FR':'KCBS25K-J0221-FR-Cocobella-2.5 Seater-Boho Denim.png',
  'KCBS25K-J0221-SI':'KCBS25K-J0221-SI-Cocobella-2.5 Seater-Boho Denim.png',
  'KCBS25K-J0321-FR':'KCBS25K-J0321-FR-Cocobella-2.5 Seater-Boho Parchment.png',
  'KCBS25K-J0321-SI':'KCBS25K-J0321-SI-Cocobella-2.5 Seater-Boho Parchment.png',
  'KCBS25K-J0421-FR':'KCBS25K-J0421-FR-Cocobella-2.5 Seater-Bruges Navy.jpg',
  'KCBS25K-J0421-SI':'KCBS25K-J0421-SI-Cocobella-2.5 Seater-Bruges Navy.jpg',
  'KCBS25K-J0521-FR':'KCBS25K-J0521-FR-Cocobella-2.5 Seater-Bruges Sage.jpg',
  'KCBS25K-J0521-SI':'KCBS25K-J0521-SI-Cocobella-2.5 Seater-Bruges Sage.jpg',
  'KCBS25K-J0621-FR':'KCBS25K-J0621-FR-Cocobella-2.5 Seater-Bruges Sand.jpg',
  'KCBS25K-J0621-SI':'KCBS25K-J0621-SI-Cocobella-2.5 Seater-Bruges Sand.jpg',
  'KCBS25K-J0721-SI':'KCBS25K-J0721-SI-Cocobella-2.5 Seater-Suzy Olive.jpg',
  'KCBS25K-J0821-FR':'KCBS25K-J0821-FR-Cocobella-2.5 Seater-Suzy Denim.jpg',
  'KCBS25K-J0821-SI':'KCBS25K-J0821-SI-Cocobella-2.5 Seater-Suzy Denim.jpg',
  'KCBS25K-J0921-FR':'KCBS25K-J0921-FR-Cocobella-2.5 Seater-Suzy Natural.png',
  'KCBS25K-J0921-SI':'KCBS25K-J0921-SI-Cocobella-2.5 Seater-Suzy Natural.jpg',
  'KCBS25K-J1021-FR':'KCBS25K-J1021-FR-Cocobella-2.5 Seater-Beauville Spring Green.jpg',
  'KCBS25K-J1021-SI':'KCBS25K-J1021-SI-Cocobella-2.5 Seater-Beauville Spring Green.jpg',
  'KCBS25K-J1121-FR':'KCBS25K-J1121-FR-Cocobella-2.5 Seater-Beauville Cornish Blue.jpg',
  'KCBS25K-J1121-SI':'KCBS25K-J1121-SI-Cocobella-2.5 Seater-Beauville Cornish Blue.jpg',
  'KCBS25K-O0121-FR':'KCBS25K-O0121-FR-Cocobella-2.5 Seater-Bespoke Coastal Blue.png',
  'KCBS25K-O0121-SI':'KCBS25K-O0121-SI-Cocobella-2.5 Seater-Bespoke Coastal Blue.png',
  'KCBS25K-O0221-FR':'KCBS25K-O0221-FR-Cocobella-2.5 Seater-Tasman Petunia.png',
  'KCBS25K-O0221-SI':'KCBS25K-O0221-SI-Cocobella-2.5 Seater-Tasman Petunia.png',
  'KCBS25K-O0821-FR':'KCBS25K-O0821-FR-Cocobella-2.5 Seater-Tasman Spring Green.png',
  'KCBS25K-O0821-SI':'KCBS25K-O0821-SI-Cocobella-2.5 Seater-Tasman Spring Green.png',
  'KCBS25K-O0921-FR':'KCBS25K-O0921-FR-Cocobella-2.5 Seater-Tasman Cornish Blue.png',
  'KCBS25K-O0921-SI':'KCBS25K-O0921-SI-Cocobella-2.5 Seater-Tasman Cornish Blue.png',
  'KCBS25K-O2321-FR':'KCBS25K-O2321-FR-Cocobella-2.5 Seater-Pinstripe Natural.jpg',
  'KCBS25K-O2321-SI':'KCBS25K-O2321-SI-Cocobella-2.5 Seater-Pinstripe Natural.jpg',
  'KCBS25K-O2421-FR':'KCBS25K-O2421-FR-Cocobella-2.5 Seater-Pinstripe Petunia.jpg',
  'KCBS25K-O2421-SI':'KCBS25K-O2421-SI-Cocobella-2.5 Seater-Pinstripe Petunia.jpg',
  'KCBS25K-O2521-FR':'KCBS25K-O2521-FR-Cocobella-2.5 Seater-Pinstripe Nutmeg.jpg',
  'KCBS25K-O2521-SI':'KCBS25K-O2521-SI-Cocobella-2.5 Seater-Pinstripe Nutmeg.jpg',
  'KCBS25K-O2621-FR':'KCBS25K-O2621-FR-Cocobella-2.5 Seater-Tasman Natural.jpg',
  'KCBS25K-O2621-SI':'KCBS25K-O2621-SI-Cocobella-2.5 Seater-Tasman Natural.jpg',
  'KCBS30K-B0121-FR':'KCBS30K-B0121-FR-Cocobella-3 Seater-Beatrice Barley.png',
  'KCBS30K-B0121-SI':'KCBS30K-B0121-SI-Cocobella-3 Seater-Beatrice Barley.png',
  'KCBS30K-B0221-FR':'KCBS30K-B0221-FR-Cocobella-3 Seater-Beatrice Camelia.png',
  'KCBS30K-B0221-SI':'KCBS30K-B0221-SI-Cocobella-3 Seater-Beatrice Camelia.png',
  'KCBS30K-B0321-FR':'KCBS30K-B0321-FR-Cocobella-3 Seater-Beatrice Midnight.png',
  'KCBS30K-B0321-SI':'KCBS30K-B0321-SI-Cocobella-3 Seater-Beatrice Midnight.png',
  'KCBS30K-B0421-FR':'KCBS30K-B0421-FR-Cocobella-3 Seater-Beatrice Nutmeg.png',
  'KCBS30K-B0421-SI':'KCBS30K-B0421-SI-Cocobella-3 Seater-Beatrice Nutmeg.png',
  'KCBS30K-B0521-FR':'KCBS30K-B0521-FR-Cocobella-3 Seater-Beatrice Olive.png',
  'KCBS30K-B0521-SI':'KCBS30K-B0521-SI-Cocobella-3 Seater-Beatrice Olive.png',
  'KCBS30K-J0121-FR':'KCBS30K-J0121-FR-Cocobella-3 Seater-Boho Cloud.png',
  'KCBS30K-J0121-SI':'KCBS30K-J0121-SI-Cocobella-3 Seater-Boho Cloud.png',
  'KCBS30K-J0221-FR':'KCBS30K-J0221-FR-Cocobella-3 Seater-Boho Denim.png',
  'KCBS30K-J0221-SI':'KCBS30K-J0221-SI-Cocobella-3 Seater-Boho Denim.png',
  'KCBS30K-J0321-FR':'KCBS30K-J0321-FR-Cocobella-3 Seater-Boho Parchment.png',
  'KCBS30K-J0321-SI':'KCBS30K-J0321-SI-Cocobella-3 Seater-Boho Parchment.png',
  'KCBS30K-J0421-FR':'KCBS30K-J0421-FR-Cocobella-3 Seater-Bruges Navy.jpg',
  'KCBS30K-J0421-SI':'KCBS30K-J0421-SI-Cocobella-3 Seater-Bruges Navy.jpg',
  'KCBS30K-J0521-FR':'KCBS30K-J0521-FR-Cocobella-3 Seater-Bruges Sage.jpg',
  'KCBS30K-J0521-SI':'KCBS30K-J0521-SI-Cocobella-3 Seater-Bruges Sage.jpg',
  'KCBS30K-J0621-FR':'KCBS30K-J0621-FR-Cocobella-3 Seater-Bruges Sand.jpg',
  'KCBS30K-J0621-SI':'KCBS30K-J0621-SI-Cocobella-3 Seater-Bruges Sand.jpg',
  'KCBS30K-J0721-FR':'KCBS30K-J0721-FR-Cocobella-3 Seater-Suzy Olive.jpg',
  'KCBS30K-J0721-SI':'KCBS30K-J0721-SI-Cocobella-3 Seater-Suzy Olive.jpg',
  'KCBS30K-J0821-SI':'KCBS30K-J0821-SI-Cocobella-3 Seater-Suzy Denim.jpg',
  'KCBS30K-J0921-FR':'KCBS30K-J0921-FR-Cocobella-3 Seater-Suzy Natural.png',
  'KCBS30K-J0921-SI':'KCBS30K-J0921-SI-Cocobella-3 Seater-Suzy Natural.jpg',
  'KCBS30K-J1021-FR':'KCBS30K-J1021-FR-Cocobella-3 Seater-Beauville Spring Green.jpg',
  'KCBS30K-J1021-SI':'KCBS30K-J1021-SI-Cocobella-3 Seater-Beauville Spring Green.jpg',
  'KCBS30K-J1121-FR':'KCBS30K-J1121-FR-Cocobella-3 Seater-Beauville Cornish Blue.jpg',
  'KCBS30K-J1121-SI':'KCBS30K-J1121-SI-Cocobella-3 Seater-Beauville Cornish Blue.jpg',
  'KCBS30K-O0121-FR':'KCBS30K-O0121-FR-Cocobella-3 Seater-Bespoke Coastal Blue.png',
  'KCBS30K-O0121-SI':'KCBS30K-O0121-SI-Cocobella-3 Seater-Bespoke Coastal Blue.png',
  'KCBS30K-O0221-FR':'KCBS30K-O0221-FR-Cocobella-3 Seater-Tasman Petunia.png',
  'KCBS30K-O0221-SI':'KCBS30K-O0221-SI-Cocobella-3 Seater-Tasman Petunia.png',
  'KCBS30K-O0821-FR':'KCBS30K-O0821-FR-Cocobella-3 Seater-Tasman Spring Green.png',
  'KCBS30K-O0821-SI':'KCBS30K-O0821-SI-Cocobella-3 Seater-Tasman Spring Green.png',
  'KCBS30K-O0921-FR':'KCBS30K-O0921-FR-Cocobella-3 Seater-Tasman Cornish Blue.png',
  'KCBS30K-O0921-SI':'KCBS30K-O0921-SI-Cocobella-3 Seater-Tasman Cornish Blue.png',
  'KCBS30K-O2321-FR':'KCBS30K-O2321-FR-Cocobella-3 Seater-Pinstripe Natural.jpg',
  'KCBS30K-O2321-SI':'KCBS30K-O2321-SI-Cocobella-3 Seater-Pinstripe Natural.jpg',
  'KCBS30K-O2421-FR':'KCBS30K-O2421-FR-Cocobella-3 Seater-Pinstripe Petunia.jpg',
  'KCBS30K-O2421-SI':'KCBS30K-O2421-SI-Cocobella-3 Seater-Pinstripe Petunia.jpg',
  'KCBS30K-O2521-FR':'KCBS30K-O2521-FR-Cocobella-3 Seater-Pinstripe Nutmeg.jpg',
  'KCBS30K-O2521-SI':'KCBS30K-O2521-SI-Cocobella-3 Seater-Pinstripe Nutmeg.jpg',
  'KCBS30K-O2621-FR':'KCBS30K-O2621-FR-Cocobella-3 Seater-Tasman Natural.jpg',
  'KCBS30K-O2621-SI':'KCBS30K-O2621-SI-Cocobella-3 Seater-Tasman Natural.jpg',
  'KCBS35K-B0121-FR':'KCBS35K-B0121-FR-Cocobella-3.5 Seater-Beatrice Barley.png',
  'KCBS35K-B0121-SI':'KCBS35K-B0121-SI-Cocobella-3.5 Seater-Beatrice Barley.png',
  'KCBS35K-B0221-FR':'KCBS35K-B0221-FR-Cocobella-3.5 Seater-Beatrice Camelia.png',
  'KCBS35K-B0221-SI':'KCBS35K-B0221-SI-Cocobella-3.5 Seater-Beatrice Camelia.png',
  'KCBS35K-B0321-FR':'KCBS35K-B0321-FR-Cocobella-3.5 Seater-Beatrice Midnight.png',
  'KCBS35K-B0321-SI':'KCBS35K-B0321-SI-Cocobella-3.5 Seater-Beatrice Midnight.png',
  'KCBS35K-B0421-FR':'KCBS35K-B0421-FR-Cocobella-3.5 Seater-Beatrice Nutmeg.png',
  'KCBS35K-B0421-SI':'KCBS35K-B0421-SI-Cocobella-3.5 Seater-Beatrice Nutmeg.png',
  'KCBS35K-B0521-FR':'KCBS35K-B0521-FR-Cocobella-3.5 Seater-Beatrice Olive.png',
  'KCBS35K-B0521-SI':'KCBS35K-B0521-SI-Cocobella-3.5 Seater-Beatrice Olive.png',
  'KCBS35K-J0121-FR':'KCBS35K-J0121-FR-Cocobella-3.5 Seater-Boho Cloud.png',
  'KCBS35K-J0121-SI':'KCBS35K-J0121-SI-Cocobella-3.5 Seater-Boho Cloud.png',
  'KCBS35K-J0221-FR':'KCBS35K-J0221-FR-Cocobella-3.5 Seater-Boho Denim.png',
  'KCBS35K-J0221-SI':'KCBS35K-J0221-SI-Cocobella-3.5 Seater-Boho Denim.png',
  'KCBS35K-J0321-FR':'KCBS35K-J0321-FR-Cocobella-3.5 Seater-Boho Parchment.png',
  'KCBS35K-J0321-SI':'KCBS35K-J0321-SI-Cocobella-3.5 Seater-Boho Parchment.png',
  'KCBS35K-J0421-FR':'KCBS35K-J0421-FR-Cocobella-3.5 Seater-Bruges Navy.png',
  'KCBS35K-J0421-SI':'KCBS35K-J0421-SI-Cocobella-3.5 Seater-Bruges Navy.jpg',
  'KCBS35K-J0521-FR':'KCBS35K-J0521-FR-Cocobella-3.5 Seater-Bruges Sage.jpg',
  'KCBS35K-J0521-SI':'KCBS35K-J0521-SI-Cocobella-3.5 Seater-Bruges Sage.jpg',
  'KCBS35K-J0621-FR':'KCBS35K-J0621-FR-Cocobella-3.5 Seater-Bruges Sand.jpg',
  'KCBS35K-J0621-SI':'KCBS35K-J0621-SI-Cocobella-3.5 Seater-Bruges Sand.jpg',
  'KCBS35K-J0721-FR':'KCBS35K-J0721-FR-Cocobella-3.5 Seater-Suzy Olive.jpg',
  'KCBS35K-J0721-SI':'KCBS35K-J0721-SI-Cocobella-3.5 Seater-Suzy Olive.jpg',
  'KCBS35K-J0821-FR':'KCBS35K-J0821-FR-Cocobella-3.5 Seater-Suzy Denim.jpg',
  'KCBS35K-J0821-SI':'KCBS35K-J0821-SI-Cocobella-3.5 Seater-Suzy Denim.jpg',
  'KCBS35K-J0921-FR':'KCBS35K-J0921-FR-Cocobella-3.5 Seater-Suzy Natural.jpg',
  'KCBS35K-J0921-SI':'KCBS35K-J0921-SI-Cocobella-3.5 Seater-Suzy Natural.jpg',
  'KCBS35K-J1021-FR':'KCBS35K-J1021-FR-Cocobella-3.5 Seater-Beauville Spring Green.jpg',
  'KCBS35K-J1021-SI':'KCBS35K-J1021-SI-Cocobella-3.5 Seater-Beauville Spring Green.jpg',
  'KCBS35K-J1121-FR':'KCBS35K-J1121-FR-Cocobella-3.5 Seater-Beauville Cornish Blue.jpg',
  'KCBS35K-J1121-SI':'KCBS35K-J1121-SI-Cocobella-3.5 Seater-Beauville Cornish Blue.jpg',
  'KCBS35K-O0121-FR':'KCBS35K-O0121-FR-Cocobella-3.5 Seater-Bespoke Coastal Blue.png',
  'KCBS35K-O0121-SI':'KCBS35K-O0121-SI-Cocobella-3.5 Seater-Bespoke Coastal Blue.png',
  'KCBS35K-O0221-FR':'KCBS35K-O0221-FR-Cocobella-3.5 Seater-Tasman Petunia.png',
  'KCBS35K-O0221-SI':'KCBS35K-O0221-SI-Cocobella-3.5 Seater-Tasman Petunia.png',
  'KCBS35K-O0821-FR':'KCBS35K-O0821-FR-Cocobella-3.5 Seater-Tasman Spring Green.png',
  'KCBS35K-O0821-SI':'KCBS35K-O0821-SI-Cocobella-3.5 Seater-Tasman Spring Green.png',
  'KCBS35K-O0921-FR':'KCBS35K-O0921-FR-Cocobella-3.5 Seater-Tasman Cornish Blue.png',
  'KCBS35K-O0921-SI':'KCBS35K-O0921-SI-Cocobella-3.5 Seater-Tasman Cornish Blue.png',
  'KCBS35K-O2321-FR':'KCBS35K-O2321-FR-Cocobella-3.5 Seater-Pinstripe Natural.jpg',
  'KCBS35K-O2321-SI':'KCBS35K-O2321-SI-Cocobella-3.5 Seater-Pinstripe Natural.jpg',
  'KCBS35K-O2421-FR':'KCBS35K-O2421-FR-Cocobella-3.5 Seater-Pinstripe Petunia.jpg',
  'KCBS35K-O2421-SI':'KCBS35K-O2421-SI-Cocobella-3.5 Seater-Pinstripe Petunia.jpg',
  'KCBS35K-O2521-FR':'KCBS35K-O2521-FR-Cocobella-3.5 Seater-Pinstripe Nutmeg.jpg',
  'KCBS35K-O2521-SI':'KCBS35K-O2521-SI-Cocobella-3.5 Seater-Pinstripe Nutmeg.jpg',
  'KCBS35K-O2621-FR':'KCBS35K-O2621-FR-Cocobella-3.5 Seater-Tasman Natural.jpg',
  'KCBS35K-O2621-SI':'KCBS35K-O2621-SI-Cocobella-3.5 Seater-Tasman Natural.png',
  'KCOFFSK-A0225-FR':'KCOFFSK-A0225-FR-Coco-Footstool-Wildwood Ivory.jpg',
  'KCOFFSK-A0725-FR':'KCOFFSK-A0725-FR-Coco-Footstool-Midsummer Faded Blue.jpg',
  'KCOFFSK-O1425-FR':'KCOFFSK-O1425-FR-Coco-Footstool-Capelo Snow Drop.jpg',
  'KCOM33K-A0223-FR':'KCOM33K-A0223-FR-Coco-3x3 Sectional-Wildwood Ivory.jpeg',
  'KCOM33K-A0225-FR':'KCOM33K-A0225-FR-Coco-3x3 Sectional-Wildwood Ivory.jpg',
  'KCOM33K-A0725-FR':'KCOM33K-A0725-FR-Coco-3x3 Sectional-Midsummer Faded Blue.jpg',
  'KCOM33K-O1425-FR':'KCOM33K-O1425-FR-Coco-3x3 Sectional-Capelo Snow Drop.jpg',
  'KCOMLAK-A0225-FR':'KCOMLAK-A0225-FR-Coco-2x3 Sectional-Wildwood Ivory.jpg',
  'KCOMLAK-A0725-FR':'KCOMLAK-A0725-FR-Coco-2x3 Sectional-Midsummer Faded Blue.jpg',
  'KCOMLAK-O1425-FR':'KCOMLAK-O1425-FR-Coco-2x3 Sectional-Capelo Snow Drop.jpg',
  'KCOS10B-A0113-FR':'KCOS10B-A0113-FR-Coco-Armchair-Wildwood Duck Egg.jpg',
  'KCOS10B-A0121-FR':'KCOS10B-A0121-FR-Coco-Armchair-Wildwood Duck Egg.jpg',
  'KCOS10B-A0213-FR':'KCOS10B-A0213-FR-Coco-Armchair-Wildwood Ivory.jpg',
  'KCOS10B-A0221-FR':'KCOS10B-A0221-FR-Coco-Armchair-Wildwood Ivory.jpg',
  'KCOS10B-A0223-FR':'KCOS10B-A0223-FR-Coco-Armchair-Wildwood Ivory.jpg',
  'KCOS10B-A0313-FR':'KCOS10B-A0313-FR-Coco-Armchair-Wildwood Twig.jpg',
  'KCOS10B-A0323-FR':'KCOS10B-A0323-FR-Coco-Armchair-Wildwood Twig.jpg',
  'KCOS10B-A0411-FR':'KCOS10B-A0411-FR-Coco-Armchair-Peony Summer Sky.jpg',
  'KCOS10B-A0511-FR':'KCOS10B-A0511-FR-Coco-Armchair-Midsummer Sky.jpg',
  'KCOS10B-A0521-FR':'KCOS10B-A0521-FR-Coco-Armchair-Midsummer Sky.jpg',
  'KCOS10B-A0611-FR':'KCOS10B-A0611-FR-Coco-Armchair-Midsummer Stone.jpg',
  'KCOS10B-A07X1-FR':'KCOS10B-A07X1-FR-Coco-Armchair-Midsummer Faded Blue.jpg',
  'KCOS10B-A0811-FR':'KCOS10B-A0811-FR-Coco-Armchair-Otter Denim.jpg',
  'KCOS10B-A0911-FR':'KCOS10B-A0911-FR-Coco-Armchair-Pelham Clementine.jpg',
  'KCOS10B-A1011-FR':'KCOS10B-A1011-FR-Coco-Armchair-Pelham Moss.jpg',
  'KCOS10B-A1111-FR':'KCOS10B-A1111-FR-Coco-Armchair-Pelham Denim.jpg',
  'KCOS10B-A1211-FR':'KCOS10B-A1211-FR-Coco-Armchair-Pelham Peacock.jpg',
  'KCOS10B-A1311-FR':'KCOS10B-A1311-FR-Coco-Armchair-Las Salinas Las Salinas 4.jpg',
  'KCOS10B-B0111-FR':'KCOS10B-B0111-FR-Coco-Armchair-Beatrice Barley.jpg',
  'KCOS10B-B0211-FR':'KCOS10B-B0211-FR-Coco-Armchair-Beatrice Camelia.jpg',
  'KCOS10B-B0311-FR':'KCOS10B-B0311-FR-Coco-Armchair-Beatrice Midnight.jpg',
  'KCOS10B-B0411-FR':'KCOS10B-B0411-FR-Coco-Armchair-Beatrice Nutmeg.jpg',
  'KCOS10B-B0511-FR':'KCOS10B-B0511-FR-Coco-Armchair-Beatrice Olive.jpg',
  'KCOS10B-C0111-FR':'KCOS10B-C0111-FR-Coco-Armchair-Berrington.jpg',
  'KCOS10B-D0111-FR':'KCOS10B-D0111-FR-Coco-Armchair-Varese Fuchsia.jpg',
  'KCOS10B-D0311-FR':'KCOS10B-D0311-FR-Coco-Armchair-Varese Alchemilla.jpg',
  'KCOS10B-D0511-FR':'KCOS10B-D0511-FR-Coco-Armchair-Varese Grass.jpg',
  'KCOS10B-D0611-FR':'KCOS10B-D0611-FR-Coco-Armchair-Brera Lino Cerise.jpg',
  'KCOS10B-D0711-FR':'KCOS10B-D0711-FR-Coco-Armchair-Brera Lino Chalk.jpg',
  'KCOS10B-G0111-FR':'KCOS10B-G0111-FR-Coco-Armchair-Nympheus Teal green.jpg',
  'KCOS10B-G0211-FR':'KCOS10B-G0211-FR-Coco-Armchair-Nympheus Stone pistachio.jpg',
  'KCOS10B-G0311-FR':'KCOS10B-G0311-FR-Coco-Armchair-Nympheus Aqua teal.jpg',
  'KCOS10B-G0321-FR':'KCOS10B-G0321-FR-Coco-Armchair-Nympheus Aqua teal.jpg',
  'KCOS10B-G0513-FR':'KCOS10B-G0513-FR-Coco-Armchair-Little Magnolia Pink orange.jpg',
  'KCOS10B-G0611-FR':'KCOS10B-G0611-FR-Coco-Armchair-Little Magnolia Espresso.jpg',
  'KCOS10B-G0711-FR':'KCOS10B-G0711-FR-Coco-Armchair-Little Magnolia Emerald.jpg',
  'KCOS10B-L0113-FR':'KCOS10B-L0113-FR-Coco-Armchair-English Garden - Kitty Spring Green.jpg',
  'KCOS10B-L0213-FR':'KCOS10B-L0213-FR-Coco-Armchair-English Garden - Kitty Blue Green.jpg',
  'KCOS10B-L0313-FR':'KCOS10B-L0313-FR-Coco-Armchair-English Garden - Kitty Indian Summer.jpg',
  'KCOS10B-L0413-FR':'KCOS10B-L0413-FR-Coco-Armchair-English Garden - Albertine Grey Skies.jpg',
  'KCOS10B-L0513-FR':'KCOS10B-L0513-FR-Coco-Armchair-English Garden - Albertine Classic Rose.jpg',
  'KCOS10B-L0613-FR':'KCOS10B-L0613-FR-Coco-Armchair-English Garden - Albertine Coral Orange.jpg',
  'KCOS10B-L0713-FR':'KCOS10B-L0713-FR-Coco-Armchair-Belleville - Miji Juniper.jpg',
  'KCOS10B-L0911-FR':'KCOS10B-L0911-FR-Coco-Armchair-Omega Carnelian.jpg',
  'KCOS10B-L1011-FR':'KCOS10B-L1011-FR-Coco-Armchair-Omega Pastel Blue.jpg',
  'KCOS10B-L1111-FR':'KCOS10B-L1111-FR-Coco-Armchair-Omega Lagoon.jpg',
  'KCOS10B-L1211-FR':'KCOS10B-L1211-FR-Coco-Armchair-Omega Rosewood.jpg',
  'KCOS10B-L1411-FR':'KCOS10B-L1411-FR-Coco-Armchair-Omega Pine.jpg',
  'KCOS10B-L1711-FR':'KCOS10B-L1711-FR-Coco-Armchair-Omega Parakeet.jpg',
  'KCOS10B-L1811-FR':'KCOS10B-L1811-FR-Coco-Armchair-Elba Cerulean.jpg',
  'KCOS10B-L1911-FR':'KCOS10B-L1911-FR-Coco-Armchair-Elba Hemp.jpg',
  'KCOS10B-L2011-FR':'KCOS10B-L2011-FR-Coco-Armchair-Elba Midnight.jpg',
  'KCOS10B-L2111-FR':'KCOS10B-L2111-FR-Coco-Armchair-Elba Sage.jpg',
  'KCOS10B-O0111-FR':'KCOS10B-O0111-FR-Coco-Armchair-Bespoke Coastal Blue.jpg',
  'KCOS10B-O0211-FR':'KCOS10B-O0211-FR-Coco-Armchair-Tasman Petunia.jpg',
  'KCOS10B-O0221-FR':'KCOS10B-O0221-FR-Coco-Armchair-Tasman Petunia.jpg',
  'KCOS10B-O0321-FR':'KCOS10B-O0321-FR-Coco-Armchair-Bespoke Woodland.jpg',
  'KCOS10B-O0511-FR':'KCOS10B-O0511-FR-Coco-Armchair-Tasman Sea Holly.jpg',
  'KCOS10B-O0621-FR':'KCOS10B-O0621-FR-Coco-Armchair-Tasman Garden Grey.jpg',
  'KCOS10B-O0711-FR':'KCOS10B-O0711-FR-Coco-Armchair-Tasman Dandelion.jpg',
  'KCOS10B-O0721-FR':'KCOS10B-O0721-FR-Coco-Armchair-Tasman Dandelion.jpg',
  'KCOS10B-O0811-FR':'KCOS10B-O0811-FR-Coco-Armchair-Tasman Spring Green.jpg',
  'KCOS10B-O0911-FR':'KCOS10B-O0911-FR-Coco-Armchair-Tasman Cornish Blue.jpg',
  'KCOS10B-O1021-FR':'KCOS10B-O1021-FR-Coco-Armchair-Antarctic Narrow Chocolate.jpg',
  'KCOS10B-O1121-FR':'KCOS10B-O1121-FR-Coco-Armchair-Tasman Chocolate.jpg',
  'KCOS10B-O1311-FR':'KCOS10B-O1311-FR-Coco-Armchair-Capelo Cool Coconut.png',
  'KCOS10B-O1411-FR':'KCOS10B-O1411-FR-Coco-Armchair-Capelo Snow Drop.jpg',
  'KCOS10B-O1421-FR':'KCOS10B-O1421-FR-Coco-Armchair-Capelo Snow Drop.png',
  'KCOS10B-O1511-FR':'KCOS10B-O1511-FR-Coco-Armchair-Capelo Sea Salt.jpg',
  'KCOS10B-O1611-FR':'KCOS10B-O1611-FR-Coco-Armchair-Capelo Rosedale.jpg',
  'KCOS10B-O1711-FR':'KCOS10B-O1711-FR-Coco-Armchair-Capelo Inkspot.jpg',
  'KCOS10B-O1811-FR':'KCOS10B-O1811-FR-Coco-Armchair-Columbus Evergreen.jpg',
  'KCOS10B-O1911-FR':'KCOS10B-O1911-FR-Coco-Armchair-Columbus Marigold.jpg',
  'KCOS10B-O2011-FR':'KCOS10B-O2011-FR-Coco-Armchair-Columbus Potting Moss.jpg',
  'KCOS10B-O2111-FR':'KCOS10B-O2111-FR-Coco-Armchair-Columbus Roselette.jpg',
  'KCOS10B-O2121-FR':'KCOS10B-O2121-FR-Coco-Armchair-Columbus Roselette.jpg',
  'KCOS10B-O2211-FR':'KCOS10B-O2211-FR-Coco-Armchair-Columbus Sunflower.jpg',
  'KCOS10K-A0123-FR':'KCOS10K-A0123-FR-Coco-Armchair-Wildwood Duck Egg.png',
  'KCOS10K-A0123-SI':'KCOS10K-A0123-SI-Coco-Armchair-Wildwood Duck Egg.png',
  'KCOS10K-A0223-FR':'KCOS10K-A0223-FR-Coco-Armchair-Wildwood Ivory.png',
  'KCOS10K-A0223-SI':'KCOS10K-A0223-SI-Coco-Armchair-Wildwood Ivory.png',
  'KCOS10K-A0225-FR':'KCOS10K-A0225-FR-Coco-Armchair-Wildwood Ivory.jpg',
  'KCOS10K-A0725-FR':'KCOS10K-A0725-FR-Coco-Armchair-Midsummer Faded Blue.jpg',
  'KCOS10K-A07X1-FR':'KCOS10K-A07X1-FR-Coco-Armchair-Midsummer Faded Blue.jpg',
  'KCOS10K-A1021-FR':'KCOS10K-A1021-FR-Coco-Armchair-Pelham Moss.png',
  'KCOS10K-A1021-SI':'KCOS10K-A1021-SI-Coco-Armchair-Pelham Moss.png',
  'KCOS10K-B0521-FR':'KCOS10K-B0521-FR-Coco-Armchair-Beatrice Olive.png',
  'KCOS10K-B0521-SI':'KCOS10K-B0521-SI-Coco-Armchair-Beatrice Olive.png',
  'KCOS10K-G0423-FR':'KCOS10K-G0423-FR-Coco-Armchair-Magnolia Cream Blue.png',
  'KCOS10K-G0423-SI':'KCOS10K-G0423-SI-Coco-Armchair-Magnolia Cream Blue.png',
  'KCOS10K-O0121-FR':'KCOS10K-O0121-FR-Coco-Armchair-Bespoke Coastal Blue.png',
  'KCOS10K-O0121-SI':'KCOS10K-O0121-SI-Coco-Armchair-Bespoke Coastal Blue.png',
  'KCOS10K-O0221-FR':'KCOS10K-O0221-FR-Coco-Armchair-Tasman Petunia.png',
  'KCOS10K-O0221-SI':'KCOS10K-O0221-SI-Coco-Armchair-Tasman Petunia.png',
  'KCOS10K-O0521-FR':'KCOS10K-O0521-FR-Coco-Armchair-Tasman Sea Holly.jpg',
  'KCOS10K-O0621-FR':'KCOS10K-O0621-FR-Coco-Armchair-Tasman Garden Grey.png',
  'KCOS10K-O0621-SI':'KCOS10K-O0621-SI-Coco-Armchair-Tasman Garden Grey.png',
  'KCOS10K-O0721-FR':'KCOS10K-O0721-FR-Coco-Armchair-Tasman Dandelion.png',
  'KCOS10K-O0721-SI':'KCOS10K-O0721-SI-Coco-Armchair-Tasman Dandelion.png',
  'KCOS10K-O0821-FR':'KCOS10K-O0821-FR-Coco-Armchair-Tasman Spring Green.png',
  'KCOS10K-O0821-SI':'KCOS10K-O0821-SI-Coco-Armchair-Tasman Spring Green.png',
  'KCOS10K-O0921-FR':'KCOS10K-O0921-FR-Coco-Armchair-Tasman Cornish Blue.jpg',
  'KCOS10K-O1021-FR':'KCOS10K-O1021-FR-Coco-Armchair-Antarctic Narrow Chocolate.png',
  'KCOS10K-O1021-SI':'KCOS10K-O1021-SI-Coco-Armchair-Antarctic Narrow Chocolate.png',
  'KCOS10K-O1121-FR':'KCOS10K-O1121-FR-Coco-Armchair-Tasman Chocolate.png',
  'KCOS10K-O1121-SI':'KCOS10K-O1121-SI-Coco-Armchair-Tasman Chocolate.png',
  'KCOS10K-O1321-FR':'KCOS10K-O1321-FR-Coco-Armchair-Capelo Cool Coconut.png',
  'KCOS10K-O1321-SI':'KCOS10K-O1321-SI-Coco-Armchair-Capelo Cool Coconut.png',
  'KCOS10K-O1411-FR':'KCOS10K-O1411-FR-Coco-Armchair-Capelo Snow Drop.jpg',
  'KCOS10K-O1421-FR':'KCOS10K-O1421-FR-Coco-Armchair-Capelo Snow Drop.png',
  'KCOS10K-O1421-SI':'KCOS10K-O1421-SI-Coco-Armchair-Capelo Snow Drop.png',
  'KCOS10K-O1425-FR':'KCOS10K-O1425-FR-Coco-Armchair-Capelo Snow Drop.jpg',
  'KCOS15B-A0121-FR':'KCOS15B-A0121-FR-Coco-Loveseat-Wildwood Duck Egg.jpg',
  'KCOS15B-A0123-FR':'KCOS15B-A0123-FR-Coco-Loveseat-Wildwood Duck Egg.jpg',
  'KCOS15B-A0222-FR':'KCOS15B-A0222-FR-Coco-Loveseat-Wildwood Ivory.jpg',
  'KCOS15B-A0223-FR':'KCOS15B-A0223-FR-Coco-Loveseat-Wildwood Ivory.jpg',
  'KCOS15B-A0313-FR':'KCOS15B-A0313-FR-Coco-Loveseat-Wildwood Twig.jpg',
  'KCOS15B-A0323-FR':'KCOS15B-A0323-FR-Coco-Loveseat-Wildwood Twig.jpg',
  'KCOS15B-A0411-FR':'KCOS15B-A0411-FR-Coco-Loveseat-Peony Summer Sky.jpg',
  'KCOS15B-A0421-FR':'KCOS15B-A0421-FR-Coco-Loveseat-Peony Summer Sky.jpg',
  'KCOS15B-A0511-FR':'KCOS15B-A0511-FR-Coco-Loveseat-Midsummer Sky.jpg',
  'KCOS15B-A0521-FR':'KCOS15B-A0521-FR-Coco-Loveseat-Midsummer Sky.jpg',
  'KCOS15B-A0611-FR':'KCOS15B-A0611-FR-Coco-Loveseat-Midsummer Stone.jpg',
  'KCOS15B-A0621-FR':'KCOS15B-A0621-FR-Coco-Loveseat-Midsummer Stone.jpg',
  'KCOS15B-A0721-FR':'KCOS15B-A0721-FR-Coco-Loveseat-Midsummer Faded Blue.jpg',
  'KCOS15B-A07X1-FR':'KCOS15B-A07X1-FR-Coco-Loveseat-Midsummer Faded Blue.jpg',
  'KCOS15B-A0811-FR':'KCOS15B-A0811-FR-Coco-Loveseat-Otter Denim.jpg',
  'KCOS15B-A0821-FR':'KCOS15B-A0821-FR-Coco-Loveseat-Otter Denim.jpg',
  'KCOS15B-A0911-FR':'KCOS15B-A0911-FR-Coco-Loveseat-Pelham Clementine.jpg',
  'KCOS15B-A0921-FR':'KCOS15B-A0921-FR-Coco-Loveseat-Pelham Clementine.jpg',
  'KCOS15B-A1011-FR':'KCOS15B-A1011-FR-Coco-Loveseat-Pelham Moss.jpg',
  'KCOS15B-A1021-FR':'KCOS15B-A1021-FR-Coco-Loveseat-Pelham Moss.jpg',
  'KCOS15B-A1111-FR':'KCOS15B-A1111-FR-Coco-Loveseat-Pelham Denim.jpg',
  'KCOS15B-A1121-FR':'KCOS15B-A1121-FR-Coco-Loveseat-Pelham Denim.jpg',
  'KCOS15B-A1211-FR':'KCOS15B-A1211-FR-Coco-Loveseat-Pelham Peacock.jpg',
  'KCOS15B-A1221-FR':'KCOS15B-A1221-FR-Coco-Loveseat-Pelham Peacock.jpg',
  'KCOS15B-A1311-FR':'KCOS15B-A1311-FR-Coco-Loveseat-Las Salinas Las Salinas 4.jpg',
  'KCOS15B-B0111-FR':'KCOS15B-B0111-FR-Coco-Loveseat-Beatrice Barley.jpg',
  'KCOS15B-B0121-FR':'KCOS15B-B0121-FR-Coco-Loveseat-Beatrice Barley.jpg',
  'KCOS15B-B0211-FR':'KCOS15B-B0211-FR-Coco-Loveseat-Beatrice Camelia.jpg',
  'KCOS15B-B0221-FR':'KCOS15B-B0221-FR-Coco-Loveseat-Beatrice Camelia.jpg',
  'KCOS15B-B0311-FR':'KCOS15B-B0311-FR-Coco-Loveseat-Beatrice Midnight.jpg',
  'KCOS15B-B0321-FR':'KCOS15B-B0321-FR-Coco-Loveseat-Beatrice Midnight.jpg',
  'KCOS15B-B0411-FR':'KCOS15B-B0411-FR-Coco-Loveseat-Beatrice Nutmeg.jpg',
  'KCOS15B-B0421-FR':'KCOS15B-B0421-FR-Coco-Loveseat-Beatrice Nutmeg.jpg',
  'KCOS15B-B0511-FR':'KCOS15B-B0511-FR-Coco-Loveseat-Beatrice Olive.jpg',
  'KCOS15B-B0521-FR':'KCOS15B-B0521-FR-Coco-Loveseat-Beatrice Olive.jpg',
  'KCOS15B-B0621-FR':'KCOS15B-B0621-FR-Coco-Loveseat-Froisse Cerulean.jpg',
  'KCOS15B-B0721-FR':'KCOS15B-B0721-FR-Coco-Loveseat-Froisse Chalk.jpg',
  'KCOS15B-B0821-FR':'KCOS15B-B0821-FR-Coco-Loveseat-Froisse Hemp.jpg',
  'KCOS15B-B0921-FR':'KCOS15B-B0921-FR-Coco-Loveseat-Froisse Khaki.jpg',
  'KCOS15B-B1021-FR':'KCOS15B-B1021-FR-Coco-Loveseat-Froisse Mole.jpg',
  'KCOS15B-B1121-FR':'KCOS15B-B1121-FR-Coco-Loveseat-Froisse Pebble.jpg',
  'KCOS15B-B1221-FR':'KCOS15B-B1221-FR-Coco-Loveseat-Froisse Putty.jpg',
  'KCOS15B-B1321-FR':'KCOS15B-B1321-FR-Coco-Loveseat-Froisse Sisal.jpg',
  'KCOS15B-C0111-FR':'KCOS15B-C0111-FR-Coco-Loveseat-Berrington.jpg',
  'KCOS15B-C0121-FR':'KCOS15B-C0121-FR-Coco-Loveseat-Berrington.jpg',
  'KCOS15B-D0111-FR':'KCOS15B-D0111-FR-Coco-Loveseat-Varese Fuchsia.jpg',
  'KCOS15B-D0121-FR':'KCOS15B-D0121-FR-Coco-Loveseat-Varese Fuchsia.jpg',
  'KCOS15B-D0311-FR':'KCOS15B-D0311-FR-Coco-Loveseat-Varese Alchemilla.jpg',
  'KCOS15B-D0321-FR':'KCOS15B-D0321-FR-Coco-Loveseat-Varese Alchemilla.jpg',
  'KCOS15B-D0511-FR':'KCOS15B-D0511-FR-Coco-Loveseat-Varese Grass.jpg',
  'KCOS15B-D0521-FR':'KCOS15B-D0521-FR-Coco-Loveseat-Varese Grass.jpg',
  'KCOS15B-D0611-FR':'KCOS15B-D0611-FR-Coco-Loveseat-Brera Lino Cerise.jpg',
  'KCOS15B-D0621-FR':'KCOS15B-D0621-FR-Coco-Loveseat-Brera Lino Cerise.jpg',
  'KCOS15B-D0711-FR':'KCOS15B-D0711-FR-Coco-Loveseat-Brera Lino Chalk.jpg',
  'KCOS15B-D0721-FR':'KCOS15B-D0721-FR-Coco-Loveseat-Brera Lino Chalk.jpg',
  'KCOS15B-D0821-FR':'KCOS15B-D0821-FR-Coco-Loveseat-Brera Lino Putty.jpg',
  'KCOS15B-G0111-FR':'KCOS15B-G0111-FR-Coco-Loveseat-Nympheus Teal green.jpg',
  'KCOS15B-G0121-FR':'KCOS15B-G0121-FR-Coco-Loveseat-Nympheus Teal green.jpg',
  'KCOS15B-G0211-FR':'KCOS15B-G0211-FR-Coco-Loveseat-Nympheus Stone pistachio.jpg',
  'KCOS15B-G0221-FR':'KCOS15B-G0221-FR-Coco-Loveseat-Nympheus Stone pistachio.jpg',
  'KCOS15B-G0311-FR':'KCOS15B-G0311-FR-Coco-Loveseat-Nympheus Aqua teal.jpg',
  'KCOS15B-G0321-FR':'KCOS15B-G0321-FR-Coco-Loveseat-Nympheus Aqua teal.jpg',
  'KCOS15B-G0423-FR':'KCOS15B-G0423-FR-Coco-Loveseat-Magnolia Cream Blue.jpg',
  'KCOS15B-G0513-FR':'KCOS15B-G0513-FR-Coco-Loveseat-Little Magnolia Pink orange.jpg',
  'KCOS15B-G0523-FR':'KCOS15B-G0523-FR-Coco-Loveseat-Little Magnolia Pink orange.jpg',
  'KCOS15B-G0611-FR':'KCOS15B-G0611-FR-Coco-Loveseat-Little Magnolia Espresso.jpg',
  'KCOS15B-G0621-FR':'KCOS15B-G0621-FR-Coco-Loveseat-Little Magnolia Espresso.jpg',
  'KCOS15B-G0711-FR':'KCOS15B-G0711-FR-Coco-Loveseat-Little Magnolia Emerald.jpg',
  'KCOS15B-G0721-FR':'KCOS15B-G0721-FR-Coco-Loveseat-Little Magnolia Emerald.jpg',
  'KCOS15B-J0121-FR':'KCOS15B-J0121-FR-Coco-Loveseat-Boho Cloud.jpg',
  'KCOS15B-J0221-FR':'KCOS15B-J0221-FR-Coco-Loveseat-Boho Denim.jpg',
  'KCOS15B-J0321-FR':'KCOS15B-J0321-FR-Coco-Loveseat-Boho Parchment.jpg',
  'KCOS15B-L0113-FR':'KCOS15B-L0113-FR-Coco-Loveseat-English Garden - Kitty Spring Green.jpg',
  'KCOS15B-L0123-FR':'KCOS15B-L0123-FR-Coco-Loveseat-English Garden - Kitty Spring Green.jpg',
  'KCOS15B-L0213-FR':'KCOS15B-L0213-FR-Coco-Loveseat-English Garden - Kitty Blue Green.jpg',
  'KCOS15B-L0223-FR':'KCOS15B-L0223-FR-Coco-Loveseat-English Garden - Kitty Blue Green.jpg',
  'KCOS15B-L0313-FR':'KCOS15B-L0313-FR-Coco-Loveseat-English Garden - Kitty Indian Summer.jpg',
  'KCOS15B-L0323-FR':'KCOS15B-L0323-FR-Coco-Loveseat-English Garden - Kitty Indian Summer.jpg',
  'KCOS15B-L0413-FR':'KCOS15B-L0413-FR-Coco-Loveseat-English Garden - Albertine Grey Skies.jpg',
  'KCOS15B-L0423-FR':'KCOS15B-L0423-FR-Coco-Loveseat-English Garden - Albertine Grey Skies.jpg',
  'KCOS15B-L0513-FR':'KCOS15B-L0513-FR-Coco-Loveseat-English Garden - Albertine Classic Rose.jpg',
  'KCOS15B-L0523-FR':'KCOS15B-L0523-FR-Coco-Loveseat-English Garden - Albertine Classic Rose.jpg',
  'KCOS15B-L0613-FR':'KCOS15B-L0613-FR-Coco-Loveseat-English Garden - Albertine Coral Orange.jpg',
  'KCOS15B-L0623-FR':'KCOS15B-L0623-FR-Coco-Loveseat-English Garden - Albertine Coral Orange.jpg',
  'KCOS15B-L0713-FR':'KCOS15B-L0713-FR-Coco-Loveseat-Belleville - Miji Juniper.jpg',
  'KCOS15B-L0723-FR':'KCOS15B-L0723-FR-Coco-Loveseat-Belleville - Miji Juniper.jpg',
  'KCOS15B-L0911-FR':'KCOS15B-L0911-FR-Coco-Loveseat-Omega Carnelian.jpg',
  'KCOS15B-L0921-FR':'KCOS15B-L0921-FR-Coco-Loveseat-Omega Carnelian.jpg',
  'KCOS15B-L1011-FR':'KCOS15B-L1011-FR-Coco-Loveseat-Omega Pastel Blue.jpg',
  'KCOS15B-L1021-FR':'KCOS15B-L1021-FR-Coco-Loveseat-Omega Pastel Blue.jpg',
  'KCOS15B-L1111-FR':'KCOS15B-L1111-FR-Coco-Loveseat-Omega Lagoon.jpg',
  'KCOS15B-L1121-FR':'KCOS15B-L1121-FR-Coco-Loveseat-Omega Lagoon.jpg',
  'KCOS15B-L1211-FR':'KCOS15B-L1211-FR-Coco-Loveseat-Omega Rosewood.jpg',
  'KCOS15B-L1221-FR':'KCOS15B-L1221-FR-Coco-Loveseat-Omega Rosewood.jpg',
  'KCOS15B-L1321-FR':'KCOS15B-L1321-FR-Coco-Loveseat-Omega Winter Moss.jpg',
  'KCOS15B-L1411-FR':'KCOS15B-L1411-FR-Coco-Loveseat-Omega Pine.jpg',
  'KCOS15B-L1421-FR':'KCOS15B-L1421-FR-Coco-Loveseat-Omega Pine.jpg',
  'KCOS15B-L1621-FR':'KCOS15B-L1621-FR-Coco-Loveseat-Omega Pillar Box.jpg',
  'KCOS15B-L1711-FR':'KCOS15B-L1711-FR-Coco-Loveseat-Omega Parakeet.jpg',
  'KCOS15B-L1721-FR':'KCOS15B-L1721-FR-Coco-Loveseat-Omega Parakeet.jpg',
  'KCOS15B-L1811-FR':'KCOS15B-L1811-FR-Coco-Loveseat-Elba Cerulean.jpg',
  'KCOS15B-L1821-FR':'KCOS15B-L1821-FR-Coco-Loveseat-Elba Cerulean.jpg',
  'KCOS15B-L1911-FR':'KCOS15B-L1911-FR-Coco-Loveseat-Elba Hemp.jpg',
  'KCOS15B-L1921-FR':'KCOS15B-L1921-FR-Coco-Loveseat-Elba Hemp.jpg',
  'KCOS15B-L2011-FR':'KCOS15B-L2011-FR-Coco-Loveseat-Elba Midnight.jpg',
  'KCOS15B-L2021-FR':'KCOS15B-L2021-FR-Coco-Loveseat-Elba Midnight.jpg',
  'KCOS15B-L2111-FR':'KCOS15B-L2111-FR-Coco-Loveseat-Elba Sage.jpg',
  'KCOS15B-L2121-FR':'KCOS15B-L2121-FR-Coco-Loveseat-Elba Sage.jpg',
  'KCOS15B-O0111-FR':'KCOS15B-O0111-FR-Coco-Loveseat-Bespoke Coastal Blue.jpg',
  'KCOS15B-O0121-FR':'KCOS15B-O0121-FR-Coco-Loveseat-Bespoke Coastal Blue.jpg',
  'KCOS15B-O0211-FR':'KCOS15B-O0211-FR-Coco-Loveseat-Tasman Petunia.jpg',
  'KCOS15B-O0221-FR':'KCOS15B-O0221-FR-Coco-Loveseat-Tasman Petunia.jpg',
  'KCOS15B-O0311-FR':'KCOS15B-O0311-FR-Coco-Loveseat-Bespoke Woodland.jpg',
  'KCOS15B-O0321-FR':'KCOS15B-O0321-FR-Coco-Loveseat-Bespoke Woodland.jpg',
  'KCOS15B-O0411-FR':'KCOS15B-O0411-FR-Coco-Loveseat-Bespoke Caramel.jpg',
  'KCOS15B-O0511-FR':'KCOS15B-O0511-FR-Coco-Loveseat-Tasman Sea Holly.jpg',
  'KCOS15B-O0621-FR':'KCOS15B-O0621-FR-Coco-Loveseat-Tasman Garden Grey.jpg',
  'KCOS15B-O0711-FR':'KCOS15B-O0711-FR-Coco-Loveseat-Tasman Dandelion.jpg',
  'KCOS15B-O0721-FR':'KCOS15B-O0721-FR-Coco-Loveseat-Tasman Dandelion.jpg',
  'KCOS15B-O0811-FR':'KCOS15B-O0811-FR-Coco-Loveseat-Tasman Spring Green.jpg',
  'KCOS15B-O0821-FR':'KCOS15B-O0821-FR-Coco-Loveseat-Tasman Spring Green.jpg',
  'KCOS15B-O0911-FR':'KCOS15B-O0911-FR-Coco-Loveseat-Tasman Cornish Blue.jpg',
  'KCOS15B-O0921-FR':'KCOS15B-O0921-FR-Coco-Loveseat-Tasman Cornish Blue.jpg',
  'KCOS15B-O1021-FR':'KCOS15B-O1021-FR-Coco-Loveseat-Antarctic Narrow Chocolate.jpg',
  'KCOS15B-O1121-FR':'KCOS15B-O1121-FR-Coco-Loveseat-Tasman Chocolate.jpg',
  'KCOS15B-O1311-FR':'KCOS15B-O1311-FR-Coco-Loveseat-Capelo Cool Coconut.jpg',
  'KCOS15B-O1321-FR':'KCOS15B-O1321-FR-Coco-Loveseat-Capelo Cool Coconut.jpg',
  'KCOS15B-O1411-FR':'KCOS15B-O1411-FR-Coco-Loveseat-Capelo Snow Drop.jpg',
  'KCOS15B-O1421-FR':'KCOS15B-O1421-FR-Coco-Loveseat-Capelo Snow Drop.jpg',
  'KCOS15B-O1511-FR':'KCOS15B-O1511-FR-Coco-Loveseat-Capelo Sea Salt.jpg',
  'KCOS15B-O1521-FR':'KCOS15B-O1521-FR-Coco-Loveseat-Capelo Sea Salt.jpg',
  'KCOS15B-O1611-FR':'KCOS15B-O1611-FR-Coco-Loveseat-Capelo Rosedale.jpg',
  'KCOS15B-O1621-FR':'KCOS15B-O1621-FR-Coco-Loveseat-Capelo Rosedale.jpg',
  'KCOS15B-O1711-FR':'KCOS15B-O1711-FR-Coco-Loveseat-Capelo Inkspot.jpg',
  'KCOS15B-O1721-FR':'KCOS15B-O1721-FR-Coco-Loveseat-Capelo Inkspot.jpg',
  'KCOS15B-O1811-FR':'KCOS15B-O1811-FR-Coco-Loveseat-Columbus Evergreen.jpg',
  'KCOS15B-O1821-FR':'KCOS15B-O1821-FR-Coco-Loveseat-Columbus Evergreen.jpg',
  'KCOS15B-O1911-FR':'KCOS15B-O1911-FR-Coco-Loveseat-Columbus Marigold.jpg',
  'KCOS15B-O1921-FR':'KCOS15B-O1921-FR-Coco-Loveseat-Columbus Marigold.jpg',
  'KCOS15B-O2011-FR':'KCOS15B-O2011-FR-Coco-Loveseat-Columbus Potting Moss.jpg',
  'KCOS15B-O2021-FR':'KCOS15B-O2021-FR-Coco-Loveseat-Columbus Potting Moss.jpg',
  'KCOS15B-O2111-FR':'KCOS15B-O2111-FR-Coco-Loveseat-Columbus Roselette.jpg',
  'KCOS15B-O2121-FR':'KCOS15B-O2121-FR-Coco-Loveseat-Columbus Roselette.jpg',
  'KCOS15B-O2211-FR':'KCOS15B-O2211-FR-Coco-Loveseat-Columbus Sunflower.jpg',
  'KCOS15B-O2221-FR':'KCOS15B-O2221-FR-Coco-Loveseat-Columbus Sunflower.jpg',
  'KCOS15K-A0225-FR':'KCOS15K-A0225-FR-Coco-Loveseat-Wildwood Ivory.jpg',
  'KCOS15K-A0725-FR':'KCOS15K-A0725-FR-Coco-Loveseat-Midsummer Faded Blue.jpg',
  'KCOS15K-A07X1-FR':'KCOS15K-A07X1-FR-Coco-Loveseat-Midsummer Faded Blue.jpg',
  'KCOS15K-A1021-FR':'KCOS15K-A1021-FR-Coco-Loveseat-Pelham Moss.png',
  'KCOS15K-A1021-SI':'KCOS15K-A1021-SI-Coco-Loveseat-Pelham Moss.png',
  'KCOS15K-B0521-FR':'KCOS15K-B0521-FR-Coco-Loveseat-Beatrice Olive.png',
  'KCOS15K-B0521-SI':'KCOS15K-B0521-SI-Coco-Loveseat-Beatrice Olive.png',
  'KCOS15K-G0423-FR':'KCOS15K-G0423-FR-Coco-Loveseat-Magnolia Cream Blue.png',
  'KCOS15K-G0423-SI':'KCOS15K-G0423-SI-Coco-Loveseat-Magnolia Cream Blue.png',
  'KCOS15K-O0121-FR':'KCOS15K-O0121-FR-Coco-Loveseat-Bespoke Coastal Blue.jpg',
  'KCOS15K-O0221-FR':'KCOS15K-O0221-FR-Coco-Loveseat-Tasman Petunia.png',
  'KCOS15K-O0221-SI':'KCOS15K-O0221-SI-Coco-Loveseat-Tasman Petunia.png',
  'KCOS15K-O0521-FR':'KCOS15K-O0521-FR-Coco-Loveseat-Tasman Sea Holly.jpg',
  'KCOS15K-O0521-SI':'KCOS15K-O0521-SI-Coco-Loveseat-Tasman Sea Holly.jpg',
  'KCOS15K-O0621-FR':'KCOS15K-O0621-FR-Coco-Loveseat-Tasman Garden Grey.png',
  'KCOS15K-O0621-SI':'KCOS15K-O0621-SI-Coco-Loveseat-Tasman Garden Grey.png',
  'KCOS15K-O0721-FR':'KCOS15K-O0721-FR-Coco-Loveseat-Tasman Dandelion.png',
  'KCOS15K-O0721-SI':'KCOS15K-O0721-SI-Coco-Loveseat-Tasman Dandelion.png',
  'KCOS15K-O0821-FR':'KCOS15K-O0821-FR-Coco-Loveseat-Tasman Spring Green.png',
  'KCOS15K-O0821-SI':'KCOS15K-O0821-SI-Coco-Loveseat-Tasman Spring Green.png',
  'KCOS15K-O0921-FR':'KCOS15K-O0921-FR-Coco-Loveseat-Tasman Cornish Blue.jpg',
  'KCOS15K-O1021-FR':'KCOS15K-O1021-FR-Coco-Loveseat-Antarctic Narrow Chocolate.png',
  'KCOS15K-O1021-SI':'KCOS15K-O1021-SI-Coco-Loveseat-Antarctic Narrow Chocolate.png',
  'KCOS15K-O1121-FR':'KCOS15K-O1121-FR-Coco-Loveseat-Tasman Chocolate.png',
  'KCOS15K-O1121-SI':'KCOS15K-O1121-SI-Coco-Loveseat-Tasman Chocolate.png',
  'KCOS15K-O1321-FR':'KCOS15K-O1321-FR-Coco-Loveseat-Capelo Cool Coconut.png',
  'KCOS15K-O1321-SI':'KCOS15K-O1321-SI-Coco-Loveseat-Capelo Cool Coconut.png',
  'KCOS15K-O1416-FR':'KCOS15K-O1416-FR-Coco-Loveseat-Capelo Snow Drop.jpg',
  'KCOS15K-O1421-FR':'KCOS15K-O1421-FR-Coco-Loveseat-Capelo Snow Drop.png',
  'KCOS15K-O1421-SI':'KCOS15K-O1421-SI-Coco-Loveseat-Capelo Snow Drop.png',
  'KCOS15K-O1425-FR':'KCOS15K-O1425-FR-Coco-Loveseat-Capelo Snow Drop.jpg',
  'KCOS20B-A0113-FR':'KCOS20B-A0113-FR-Coco-2 Seater-Wildwood Duck Egg.png',
  'KCOS20B-A0113-SI':'KCOS20B-A0113-SI-Coco-2 Seater-Wildwood Duck Egg.png',
  'KCOS20B-A0123-FR':'KCOS20B-A0123-FR-Coco-2 Seater-Wildwood Duck Egg.jpg',
  'KCOS20B-A0213-FR':'KCOS20B-A0213-FR-Coco-2 Seater-Wildwood Ivory.png',
  'KCOS20B-A0213-SI':'KCOS20B-A0213-SI-Coco-2 Seater-Wildwood Ivory.png',
  'KCOS20B-A0223-FR':'KCOS20B-A0223-FR-Coco-2 Seater-Wildwood Ivory.jpg',
  'KCOS20B-A0313-FR':'KCOS20B-A0313-FR-Coco-2 Seater-Wildwood Twig.png',
  'KCOS20B-A0313-SI':'KCOS20B-A0313-SI-Coco-2 Seater-Wildwood Twig.png',
  'KCOS20B-A0323-FR':'KCOS20B-A0323-FR-Coco-2 Seater-Wildwood Twig.jpg',
  'KCOS20B-A0411-FR':'KCOS20B-A0411-FR-Coco-2 Seater-Peony Summer Sky.png',
  'KCOS20B-A0411-SI':'KCOS20B-A0411-SI-Coco-2 Seater-Peony Summer Sky.png',
  'KCOS20B-A0421-FR':'KCOS20B-A0421-FR-Coco-2 Seater-Peony Summer Sky.jpg',
  'KCOS20B-A0511-FR':'KCOS20B-A0511-FR-Coco-2 Seater-Midsummer Sky.png',
  'KCOS20B-A0511-SI':'KCOS20B-A0511-SI-Coco-2 Seater-Midsummer Sky.png',
  'KCOS20B-A0521-FR':'KCOS20B-A0521-FR-Coco-2 Seater-Midsummer Sky.jpg',
  'KCOS20B-A0611-FR':'KCOS20B-A0611-FR-Coco-2 Seater-Midsummer Stone.png',
  'KCOS20B-A0611-SI':'KCOS20B-A0611-SI-Coco-2 Seater-Midsummer Stone.png',
  'KCOS20B-A0621-FR':'KCOS20B-A0621-FR-Coco-2 Seater-Midsummer Stone.jpg',
  'KCOS20B-A0711-FR':'KCOS20B-A0711-FR-Coco-2 Seater-Midsummer Faded Blue.png',
  'KCOS20B-A0711-SI':'KCOS20B-A0711-SI-Coco-2 Seater-Midsummer Faded Blue.png',
  'KCOS20B-A0721-FR':'KCOS20B-A0721-FR-Coco-2 Seater-Midsummer Faded Blue.jpg',
  'KCOS20B-A07X1-FR':'KCOS20B-A07X1-FR-Coco-2 Seater-Midsummer Faded Blue.jpg',
  'KCOS20B-A0811-FR':'KCOS20B-A0811-FR-Coco-2 Seater-Otter Denim.png',
  'KCOS20B-A0811-SI':'KCOS20B-A0811-SI-Coco-2 Seater-Otter Denim.png',
  'KCOS20B-A0821-FR':'KCOS20B-A0821-FR-Coco-2 Seater-Otter Denim.jpg',
  'KCOS20B-A0911-FR':'KCOS20B-A0911-FR-Coco-2 Seater-Pelham Clementine.png',
  'KCOS20B-A0911-SI':'KCOS20B-A0911-SI-Coco-2 Seater-Pelham Clementine.png',
  'KCOS20B-A0921-FR':'KCOS20B-A0921-FR-Coco-2 Seater-Pelham Clementine.jpg',
  'KCOS20B-A1011-FR':'KCOS20B-A1011-FR-Coco-2 Seater-Pelham Moss.jpg',
  'KCOS20B-A1021-FR':'KCOS20B-A1021-FR-Coco-2 Seater-Pelham Moss.jpg',
  'KCOS20B-A1111-FR':'KCOS20B-A1111-FR-Coco-2 Seater-Pelham Denim.png',
  'KCOS20B-A1111-SI':'KCOS20B-A1111-SI-Coco-2 Seater-Pelham Denim.png',
  'KCOS20B-A1121-FR':'KCOS20B-A1121-FR-Coco-2 Seater-Pelham Denim.jpg',
  'KCOS20B-A1211-FR':'KCOS20B-A1211-FR-Coco-2 Seater-Pelham Peacock.jpg',
  'KCOS20B-A1211-SI':'KCOS20B-A1211-SI-Coco-2 Seater-Pelham Peacock.png',
  'KCOS20B-A1221-FR':'KCOS20B-A1221-FR-Coco-2 Seater-Pelham Peacock.jpg',
  'KCOS20B-A1311-FR':'KCOS20B-A1311-FR-Coco-2 Seater-Las Salinas Las Salinas 4.png',
  'KCOS20B-A1311-SI':'KCOS20B-A1311-SI-Coco-2 Seater-Las Salinas Las Salinas 4.png',
  'KCOS20B-B0111-FR':'KCOS20B-B0111-FR-Coco-2 Seater-Beatrice Barley.jpg',
  'KCOS20B-B0111-PR':'KCOS20B-B0111-PR-Coco-2 Seater-Beatrice Barley.jpg',
  'KCOS20B-B0121-FR':'KCOS20B-B0121-FR-Coco-2 Seater-Beatrice Barley.jpg',
  'KCOS20B-B0211-FR':'KCOS20B-B0211-FR-Coco-2 Seater-Beatrice Camelia.png',
  'KCOS20B-B0211-PR':'KCOS20B-B0211-PR-Coco-2 Seater-Beatrice Camelia.png',
  'KCOS20B-B0221-FR':'KCOS20B-B0221-FR-Coco-2 Seater-Beatrice Camelia.jpg',
  'KCOS20B-B0311-FR':'KCOS20B-B0311-FR-Coco-2 Seater-Beatrice Midnight.jpg',
  'KCOS20B-B0321-FR':'KCOS20B-B0321-FR-Coco-2 Seater-Beatrice Midnight.jpg',
  'KCOS20B-B0411-FR':'KCOS20B-B0411-FR-Coco-2 Seater-Beatrice Nutmeg.jpg',
  'KCOS20B-B0411-PR':'KCOS20B-B0411-PR-Coco-2 Seater-Beatrice Nutmeg.jpg',
  'KCOS20B-B0421-FR':'KCOS20B-B0421-FR-Coco-2 Seater-Beatrice Nutmeg.jpg',
  'KCOS20B-B0511-FR':'KCOS20B-B0511-FR-Coco-2 Seater-Beatrice Olive.jpg',
  'KCOS20B-B0511-PR':'KCOS20B-B0511-PR-Coco-2 Seater-Beatrice Olive.jpg',
  'KCOS20B-B0521-FR':'KCOS20B-B0521-FR-Coco-2 Seater-Beatrice Olive.jpg',
  'KCOS20B-B0621-FR':'KCOS20B-B0621-FR-Coco-2 Seater-Froisse Cerulean.jpg',
  'KCOS20B-B0721-FR':'KCOS20B-B0721-FR-Coco-2 Seater-Froisse Chalk.jpg',
  'KCOS20B-B0821-FR':'KCOS20B-B0821-FR-Coco-2 Seater-Froisse Hemp.jpg',
  'KCOS20B-B0921-FR':'KCOS20B-B0921-FR-Coco-2 Seater-Froisse Khaki.jpg',
  'KCOS20B-B1021-FR':'KCOS20B-B1021-FR-Coco-2 Seater-Froisse Mole.jpg',
  'KCOS20B-B1121-FR':'KCOS20B-B1121-FR-Coco-2 Seater-Froisse Pebble.jpg',
  'KCOS20B-B1221-FR':'KCOS20B-B1221-FR-Coco-2 Seater-Froisse Putty.jpg',
  'KCOS20B-B1321-FR':'KCOS20B-B1321-FR-Coco-2 Seater-Froisse Sisal.jpg',
  'KCOS20B-C0111-FR':'KCOS20B-C0111-FR-Coco-2 Seater-Berrington.jpg',
  'KCOS20B-C0111-PR':'KCOS20B-C0111-PR-Coco-2 Seater-Berrington.jpg',
  'KCOS20B-C0121-FR':'KCOS20B-C0121-FR-Coco-2 Seater-Berrington.jpg',
  'KCOS20B-D0111-FR':'KCOS20B-D0111-FR-Coco-2 Seater-Varese Fuchsia.jpg',
  'KCOS20B-D0111-PR':'KCOS20B-D0111-PR-Coco-2 Seater-Varese Fuchsia.jpg',
  'KCOS20B-D0121-FR':'KCOS20B-D0121-FR-Coco-2 Seater-Varese Fuchsia.jpg',
  'KCOS20B-D0311-FR':'KCOS20B-D0311-FR-Coco-2 Seater-Varese Alchemilla.jpg',
  'KCOS20B-D0311-PR':'KCOS20B-D0311-PR-Coco-2 Seater-Varese Alchemilla.jpg',
  'KCOS20B-D0321-FR':'KCOS20B-D0321-FR-Coco-2 Seater-Varese Alchemilla.jpg',
  'KCOS20B-D0511-FR':'KCOS20B-D0511-FR-Coco-2 Seater-Varese Grass.jpg',
  'KCOS20B-D0511-PR':'KCOS20B-D0511-PR-Coco-2 Seater-Varese Grass.jpg',
  'KCOS20B-D0521-FR':'KCOS20B-D0521-FR-Coco-2 Seater-Varese Grass.jpg',
  'KCOS20B-D0611-FR':'KCOS20B-D0611-FR-Coco-2 Seater-Brera Lino Cerise.jpg',
  'KCOS20B-D0611-PR':'KCOS20B-D0611-PR-Coco-2 Seater-Brera Lino Cerise.jpg',
  'KCOS20B-D0621-FR':'KCOS20B-D0621-FR-Coco-2 Seater-Brera Lino Cerise.jpg',
  'KCOS20B-D0711-FR':'KCOS20B-D0711-FR-Coco-2 Seater-Brera Lino Chalk.jpg',
  'KCOS20B-D0711-PR':'KCOS20B-D0711-PR-Coco-2 Seater-Brera Lino Chalk.jpg',
  'KCOS20B-D0721-FR':'KCOS20B-D0721-FR-Coco-2 Seater-Brera Lino Chalk.jpg',
  'KCOS20B-D0821-FR':'KCOS20B-D0821-FR-Coco-2 Seater-Brera Lino Putty.jpg',
  'KCOS20B-G0111-FR':'KCOS20B-G0111-FR-Coco-2 Seater-Nympheus Teal green.jpg',
  'KCOS20B-G0111-PR':'KCOS20B-G0111-PR-Coco-2 Seater-Nympheus Teal green.jpg',
  'KCOS20B-G0121-FR':'KCOS20B-G0121-FR-Coco-2 Seater-Nympheus Teal green.jpg',
  'KCOS20B-G0211-FR':'KCOS20B-G0211-FR-Coco-2 Seater-Nympheus Stone pistachio.jpg',
  'KCOS20B-G0211-PR':'KCOS20B-G0211-PR-Coco-2 Seater-Nympheus Stone pistachio.jpg',
  'KCOS20B-G0221-FR':'KCOS20B-G0221-FR-Coco-2 Seater-Nympheus Stone pistachio.jpg',
  'KCOS20B-G0311-FR':'KCOS20B-G0311-FR-Coco-2 Seater-Nympheus Aqua teal.jpg',
  'KCOS20B-G0311-PR':'KCOS20B-G0311-PR-Coco-2 Seater-Nympheus Aqua teal.jpg',
  'KCOS20B-G0321-FR':'KCOS20B-G0321-FR-Coco-2 Seater-Nympheus Aqua teal.jpg',
  'KCOS20B-G0423-FR':'KCOS20B-G0423-FR-Coco-2 Seater-Magnolia Cream Blue.jpg',
  'KCOS20B-G0513-FR':'KCOS20B-G0513-FR-Coco-2 Seater-Little Magnolia Pink orange.jpg',
  'KCOS20B-G0513-PR':'KCOS20B-G0513-PR-Coco-2 Seater-Little Magnolia Pink orange.jpg',
  'KCOS20B-G0523-FR':'KCOS20B-G0523-FR-Coco-2 Seater-Little Magnolia Pink orange.jpg',
  'KCOS20B-G0611-FR':'KCOS20B-G0611-FR-Coco-2 Seater-Little Magnolia Espresso.jpg',
  'KCOS20B-G0611-PR':'KCOS20B-G0611-PR-Coco-2 Seater-Little Magnolia Espresso.jpg',
  'KCOS20B-G0621-FR':'KCOS20B-G0621-FR-Coco-2 Seater-Little Magnolia Espresso.jpg',
  'KCOS20B-G0711-FR':'KCOS20B-G0711-FR-Coco-2 Seater-Little Magnolia Emerald.jpg',
  'KCOS20B-G0711-PR':'KCOS20B-G0711-PR-Coco-2 Seater-Little Magnolia Emerald.jpg',
  'KCOS20B-G0721-FR':'KCOS20B-G0721-FR-Coco-2 Seater-Little Magnolia Emerald.jpg',
  'KCOS20B-J0121-FR':'KCOS20B-J0121-FR-Coco-2 Seater-Boho Cloud.jpg',
  'KCOS20B-J0221-FR':'KCOS20B-J0221-FR-Coco-2 Seater-Boho Denim.jpg',
  'KCOS20B-J0321-FR':'KCOS20B-J0321-FR-Coco-2 Seater-Boho Parchment.jpg',
  'KCOS20B-L0113-FR':'KCOS20B-L0113-FR-Coco-2 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS20B-L0113-PR':'KCOS20B-L0113-PR-Coco-2 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS20B-L0113-SI':'KCOS20B-L0113-SI-Coco-2 Seater-English Garden - Kitty Spring Green.png',
  'KCOS20B-L0123-FR':'KCOS20B-L0123-FR-Coco-2 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS20B-L0213-FR':'KCOS20B-L0213-FR-Coco-2 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS20B-L0213-PR':'KCOS20B-L0213-PR-Coco-2 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS20B-L0223-FR':'KCOS20B-L0223-FR-Coco-2 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS20B-L0313-FR':'KCOS20B-L0313-FR-Coco-2 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS20B-L0313-PR':'KCOS20B-L0313-PR-Coco-2 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS20B-L0323-FR':'KCOS20B-L0323-FR-Coco-2 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS20B-L0413-FR':'KCOS20B-L0413-FR-Coco-2 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS20B-L0413-PR':'KCOS20B-L0413-PR-Coco-2 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS20B-L0423-FR':'KCOS20B-L0423-FR-Coco-2 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS20B-L0513-FR':'KCOS20B-L0513-FR-Coco-2 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS20B-L0513-PR':'KCOS20B-L0513-PR-Coco-2 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS20B-L0523-FR':'KCOS20B-L0523-FR-Coco-2 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS20B-L0613-FR':'KCOS20B-L0613-FR-Coco-2 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS20B-L0613-PR':'KCOS20B-L0613-PR-Coco-2 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS20B-L0623-FR':'KCOS20B-L0623-FR-Coco-2 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS20B-L0713-FR':'KCOS20B-L0713-FR-Coco-2 Seater-Belleville - Miji Juniper.jpg',
  'KCOS20B-L0713-PR':'KCOS20B-L0713-PR-Coco-2 Seater-Belleville - Miji Juniper.jpg',
  'KCOS20B-L0723-FR':'KCOS20B-L0723-FR-Coco-2 Seater-Belleville - Miji Juniper.jpg',
  'KCOS20B-L0911-FR':'KCOS20B-L0911-FR-Coco-2 Seater-Omega Carnelian.jpg',
  'KCOS20B-L0921-FR':'KCOS20B-L0921-FR-Coco-2 Seater-Omega Carnelian.jpg',
  'KCOS20B-L1011-FR':'KCOS20B-L1011-FR-Coco-2 Seater-Omega Pastel Blue.jpg',
  'KCOS20B-L1021-FR':'KCOS20B-L1021-FR-Coco-2 Seater-Omega Pastel Blue.jpg',
  'KCOS20B-L1111-FR':'KCOS20B-L1111-FR-Coco-2 Seater-Omega Lagoon.jpg',
  'KCOS20B-L1111-PR':'KCOS20B-L1111-PR-Coco-2 Seater-Omega Lagoon.jpg',
  'KCOS20B-L1121-FR':'KCOS20B-L1121-FR-Coco-2 Seater-Omega Lagoon.jpg',
  'KCOS20B-L1211-FR':'KCOS20B-L1211-FR-Coco-2 Seater-Omega Rosewood.jpg',
  'KCOS20B-L1211-PR':'KCOS20B-L1211-PR-Coco-2 Seater-Omega Rosewood.jpg',
  'KCOS20B-L1221-FR':'KCOS20B-L1221-FR-Coco-2 Seater-Omega Rosewood.jpg',
  'KCOS20B-L1321-FR':'KCOS20B-L1321-FR-Coco-2 Seater-Omega Winter Moss.jpg',
  'KCOS20B-L1411-FR':'KCOS20B-L1411-FR-Coco-2 Seater-Omega Pine.jpg',
  'KCOS20B-L1411-PR':'KCOS20B-L1411-PR-Coco-2 Seater-Omega Pine.jpg',
  'KCOS20B-L1421-FR':'KCOS20B-L1421-FR-Coco-2 Seater-Omega Pine.jpg',
  'KCOS20B-L1621-FR':'KCOS20B-L1621-FR-Coco-2 Seater-Omega Pillar Box.jpg',
  'KCOS20B-L1711-FR':'KCOS20B-L1711-FR-Coco-2 Seater-Omega Parakeet.jpg',
  'KCOS20B-L1711-PR':'KCOS20B-L1711-PR-Coco-2 Seater-Omega Parakeet.jpg',
  'KCOS20B-L1721-FR':'KCOS20B-L1721-FR-Coco-2 Seater-Omega Parakeet.jpg',
  'KCOS20B-L1811-FR':'KCOS20B-L1811-FR-Coco-2 Seater-Elba Cerulean.jpg',
  'KCOS20B-L1811-PR':'KCOS20B-L1811-PR-Coco-2 Seater-Elba Cerulean.jpg',
  'KCOS20B-L1821-FR':'KCOS20B-L1821-FR-Coco-2 Seater-Elba Cerulean.jpg',
  'KCOS20B-L1911-FR':'KCOS20B-L1911-FR-Coco-2 Seater-Elba Hemp.jpg',
  'KCOS20B-L1911-PR':'KCOS20B-L1911-PR-Coco-2 Seater-Elba Hemp.jpg',
  'KCOS20B-L1921-FR':'KCOS20B-L1921-FR-Coco-2 Seater-Elba Hemp.jpg',
  'KCOS20B-L2011-FR':'KCOS20B-L2011-FR-Coco-2 Seater-Elba Midnight.jpg',
  'KCOS20B-L2011-PR':'KCOS20B-L2011-PR-Coco-2 Seater-Elba Midnight.jpg',
  'KCOS20B-L2021-FR':'KCOS20B-L2021-FR-Coco-2 Seater-Elba Midnight.jpg',
  'KCOS20B-L2111-FR':'KCOS20B-L2111-FR-Coco-2 Seater-Elba Sage.jpg',
  'KCOS20B-L2111-PR':'KCOS20B-L2111-PR-Coco-2 Seater-Elba Sage.jpg',
  'KCOS20B-L2121-FR':'KCOS20B-L2121-FR-Coco-2 Seater-Elba Sage.jpg',
  'KCOS20B-O0111-FR':'KCOS20B-O0111-FR-Coco-2 Seater-Bespoke Coastal Blue.png',
  'KCOS20B-O0111-SI':'KCOS20B-O0111-SI-Coco-2 Seater-Bespoke Coastal Blue.png',
  'KCOS20B-O0211-FR':'KCOS20B-O0211-FR-Coco-2 Seater-Tasman Petunia.jpg',
  'KCOS20B-O0211-SI':'KCOS20B-O0211-SI-Coco-2 Seater-Tasman Petunia.png',
  'KCOS20B-O0311-FR':'KCOS20B-O0311-FR-Coco-2 Seater-Bespoke Woodland.png',
  'KCOS20B-O0311-SI':'KCOS20B-O0311-SI-Coco-2 Seater-Bespoke Woodland.png',
  'KCOS20B-O0411-FR':'KCOS20B-O0411-FR-Coco-2 Seater-Bespoke Caramel.png',
  'KCOS20B-O0411-SI':'KCOS20B-O0411-SI-Coco-2 Seater-Bespoke Caramel.png',
  'KCOS20B-O0511-FR':'KCOS20B-O0511-FR-Coco-2 Seater-Tasman Sea Holly.png',
  'KCOS20B-O0511-SI':'KCOS20B-O0511-SI-Coco-2 Seater-Tasman Sea Holly.png',
  'KCOS20B-O0611-FR':'KCOS20B-O0611-FR-Coco-2 Seater-Tasman Garden Grey.png',
  'KCOS20B-O0611-SI':'KCOS20B-O0611-SI-Coco-2 Seater-Tasman Garden Grey.png',
  'KCOS20B-O0711-FR':'KCOS20B-O0711-FR-Coco-2 Seater-Tasman Dandelion.png',
  'KCOS20B-O0711-SI':'KCOS20B-O0711-SI-Coco-2 Seater-Tasman Dandelion.png',
  'KCOS20B-O0911-FR':'KCOS20B-O0911-FR-Coco-2 Seater-Tasman Cornish Blue.png',
  'KCOS20B-O0911-SI':'KCOS20B-O0911-SI-Coco-2 Seater-Tasman Cornish Blue.png',
  'KCOS20B-O1011-FR':'KCOS20B-O1011-FR-Coco-2 Seater-Antarctic Narrow Chocolate.png',
  'KCOS20B-O1011-SI':'KCOS20B-O1011-SI-Coco-2 Seater-Antarctic Narrow Chocolate.png',
  'KCOS20B-O1111-FR':'KCOS20B-O1111-FR-Coco-2 Seater-Tasman Chocolate.png',
  'KCOS20B-O1111-SI':'KCOS20B-O1111-SI-Coco-2 Seater-Tasman Chocolate.png',
  'KCOS20B-O1311-FR':'KCOS20B-O1311-FR-Coco-2 Seater-Capelo Cool Coconut.jpg',
  'KCOS20B-O1321-FR':'KCOS20B-O1321-FR-Coco-2 Seater-Capelo Cool Coconut.jpg',
  'KCOS20B-O1411-FR':'KCOS20B-O1411-FR-Coco-2 Seater-Capelo Snow Drop.jpg',
  'KCOS20B-O1411-SI':'KCOS20B-O1411-SI-Coco-2 Seater-Capelo Snow Drop.png',
  'KCOS20B-O1421-FR':'KCOS20B-O1421-FR-Coco-2 Seater-Capelo Snow Drop.png',
  'KCOS20B-O1511-FR':'KCOS20B-O1511-FR-Coco-2 Seater-Capelo Sea Salt.png',
  'KCOS20B-O1511-SI':'KCOS20B-O1511-SI-Coco-2 Seater-Capelo Sea Salt.png',
  'KCOS20B-O1521-FR':'KCOS20B-O1521-FR-Coco-2 Seater-Capelo Sea Salt.jpg',
  'KCOS20B-O1611-FR':'KCOS20B-O1611-FR-Coco-2 Seater-Capelo Rosedale.png',
  'KCOS20B-O1611-SI':'KCOS20B-O1611-SI-Coco-2 Seater-Capelo Rosedale.png',
  'KCOS20B-O1621-FR':'KCOS20B-O1621-FR-Coco-2 Seater-Capelo Rosedale.jpg',
  'KCOS20B-O1711-FR':'KCOS20B-O1711-FR-Coco-2 Seater-Capelo Inkspot.png',
  'KCOS20B-O1711-SI':'KCOS20B-O1711-SI-Coco-2 Seater-Capelo Inkspot.png',
  'KCOS20B-O1721-FR':'KCOS20B-O1721-FR-Coco-2 Seater-Capelo Inkspot.jpg',
  'KCOS20B-O1811-FR':'KCOS20B-O1811-FR-Coco-2 Seater-Columbus Evergreen.png',
  'KCOS20B-O1811-SI':'KCOS20B-O1811-SI-Coco-2 Seater-Columbus Evergreen.png',
  'KCOS20B-O1821-FR':'KCOS20B-O1821-FR-Coco-2 Seater-Columbus Evergreen.jpg',
  'KCOS20B-O1911-FR':'KCOS20B-O1911-FR-Coco-2 Seater-Columbus Marigold.png',
  'KCOS20B-O1911-SI':'KCOS20B-O1911-SI-Coco-2 Seater-Columbus Marigold.png',
  'KCOS20B-O1921-FR':'KCOS20B-O1921-FR-Coco-2 Seater-Columbus Marigold.jpg',
  'KCOS20B-O2011-FR':'KCOS20B-O2011-FR-Coco-2 Seater-Columbus Potting Moss.png',
  'KCOS20B-O2011-SI':'KCOS20B-O2011-SI-Coco-2 Seater-Columbus Potting Moss.png',
  'KCOS20B-O2021-FR':'KCOS20B-O2021-FR-Coco-2 Seater-Columbus Potting Moss.jpg',
  'KCOS20B-O2111-FR':'KCOS20B-O2111-FR-Coco-2 Seater-Columbus Roselette.png',
  'KCOS20B-O2111-SI':'KCOS20B-O2111-SI-Coco-2 Seater-Columbus Roselette.png',
  'KCOS20B-O2121-FR':'KCOS20B-O2121-FR-Coco-2 Seater-Columbus Roselette.jpg',
  'KCOS20B-O2211-FR':'KCOS20B-O2211-FR-Coco-2 Seater-Columbus Sunflower.png',
  'KCOS20B-O2211-SI':'KCOS20B-O2211-SI-Coco-2 Seater-Columbus Sunflower.png',
  'KCOS20B-O2221-FR':'KCOS20B-O2221-FR-Coco-2 Seater-Columbus Sunflower.jpg',
  'KCOS20K-A0123-FR':'KCOS20K-A0123-FR-Coco-2 Seater-Wildwood Duck Egg.png',
  'KCOS20K-A0123-SI':'KCOS20K-A0123-SI-Coco-2 Seater-Wildwood Duck Egg.png',
  'KCOS20K-A0223-FR':'KCOS20K-A0223-FR-Coco-2 Seater-Wildwood Ivory.png',
  'KCOS20K-A0223-SI':'KCOS20K-A0223-SI-Coco-2 Seater-Wildwood Ivory.png',
  'KCOS20K-A0225-FR':'KCOS20K-A0225-FR-Coco-2 Seater-Wildwood Ivory.jpg',
  'KCOS20K-A0725-FR':'KCOS20K-A0725-FR-Coco-2 Seater-Midsummer Faded Blue.jpg',
  'KCOS20K-A07X1-FR':'KCOS20K-A07X1-FR-Coco-2 Seater-Midsummer Faded Blue.jpg',
  'KCOS20K-A0821-FR':'KCOS20K-A0821-FR-Coco-2 Seater-Otter Denim.jpg',
  'KCOS20K-A0921-FR':'KCOS20K-A0921-FR-Coco-2 Seater-Pelham Clementine.jpg',
  'KCOS20K-A1021-FR':'KCOS20K-A1021-FR-Coco-2 Seater-Pelham Moss.png',
  'KCOS20K-A1021-SI':'KCOS20K-A1021-SI-Coco-2 Seater-Pelham Moss.png',
  'KCOS20K-A1121-FR':'KCOS20K-A1121-FR-Coco-2 Seater-Pelham Denim.jpg',
  'KCOS20K-A1221-FR':'KCOS20K-A1221-FR-Coco-2 Seater-Pelham Peacock.jpg',
  'KCOS20K-A1321-FR':'KCOS20K-A1321-FR-Coco-2 Seater-Las Salinas Las Salinas 4.jpg',
  'KCOS20K-B0121-FR':'KCOS20K-B0121-FR-Coco-2 Seater-Beatrice Barley.jpg',
  'KCOS20K-B0221-FR':'KCOS20K-B0221-FR-Coco-2 Seater-Beatrice Camelia.png',
  'KCOS20K-B0321-FR':'KCOS20K-B0321-FR-Coco-2 Seater-Beatrice Midnight.jpg',
  'KCOS20K-B0421-FR':'KCOS20K-B0421-FR-Coco-2 Seater-Beatrice Nutmeg.jpg',
  'KCOS20K-B0521-FR':'KCOS20K-B0521-FR-Coco-2 Seater-Beatrice Olive.png',
  'KCOS20K-B0521-SI':'KCOS20K-B0521-SI-Coco-2 Seater-Beatrice Olive.png',
  'KCOS20K-D0121-FR':'KCOS20K-D0121-FR-Coco-2 Seater-Varese Fuchsia.jpg',
  'KCOS20K-D0321-FR':'KCOS20K-D0321-FR-Coco-2 Seater-Varese Alchemilla.jpg',
  'KCOS20K-D0521-FR':'KCOS20K-D0521-FR-Coco-2 Seater-Varese Grass.jpg',
  'KCOS20K-D0621-FR':'KCOS20K-D0621-FR-Coco-2 Seater-Brera Lino Cerise.jpg',
  'KCOS20K-D0721-FR':'KCOS20K-D0721-FR-Coco-2 Seater-Brera Lino Chalk.jpg',
  'KCOS20K-G0423-FR':'KCOS20K-G0423-FR-Coco-2 Seater-Magnolia Cream Blue.png',
  'KCOS20K-G0423-SI':'KCOS20K-G0423-SI-Coco-2 Seater-Magnolia Cream Blue.png',
  'KCOS20K-G0523-FR':'KCOS20K-G0523-FR-Coco-2 Seater-Little Magnolia Pink orange.jpg',
  'KCOS20K-G0621-FR':'KCOS20K-G0621-FR-Coco-2 Seater-Little Magnolia Espresso.jpg',
  'KCOS20K-G0721-FR':'KCOS20K-G0721-FR-Coco-2 Seater-Little Magnolia Emerald.jpg',
  'KCOS20K-L0123-FR':'KCOS20K-L0123-FR-Coco-2 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS20K-L0223-FR':'KCOS20K-L0223-FR-Coco-2 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS20K-L0323-FR':'KCOS20K-L0323-FR-Coco-2 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS20K-L0423-FR':'KCOS20K-L0423-FR-Coco-2 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS20K-L0523-FR':'KCOS20K-L0523-FR-Coco-2 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS20K-L0623-FR':'KCOS20K-L0623-FR-Coco-2 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS20K-L0921-FR':'KCOS20K-L0921-FR-Coco-2 Seater-Omega Carnelian.jpg',
  'KCOS20K-L1121-FR':'KCOS20K-L1121-FR-Coco-2 Seater-Omega Lagoon.jpg',
  'KCOS20K-L1221-FR':'KCOS20K-L1221-FR-Coco-2 Seater-Omega Rosewood.jpg',
  'KCOS20K-L1421-FR':'KCOS20K-L1421-FR-Coco-2 Seater-Omega Pine.jpg',
  'KCOS20K-L1721-FR':'KCOS20K-L1721-FR-Coco-2 Seater-Omega Parakeet.jpg',
  'KCOS20K-L1821-FR':'KCOS20K-L1821-FR-Coco-2 Seater-Elba Cerulean.jpg',
  'KCOS20K-L1921-FR':'KCOS20K-L1921-FR-Coco-2 Seater-Elba Hemp.jpg',
  'KCOS20K-L2021-FR':'KCOS20K-L2021-FR-Coco-2 Seater-Elba Midnight.jpg',
  'KCOS20K-L2121-FR':'KCOS20K-L2121-FR-Coco-2 Seater-Elba Sage.jpg',
  'KCOS20K-O0121-FR':'KCOS20K-O0121-FR-Coco-2 Seater-Bespoke Coastal Blue.png',
  'KCOS20K-O0121-SI':'KCOS20K-O0121-SI-Coco-2 Seater-Bespoke Coastal Blue.png',
  'KCOS20K-O0221-FR':'KCOS20K-O0221-FR-Coco-2 Seater-Tasman Petunia.png',
  'KCOS20K-O0221-SI':'KCOS20K-O0221-SI-Coco-2 Seater-Tasman Petunia.png',
  'KCOS20K-O0321-FR':'KCOS20K-O0321-FR-Coco-2 Seater-Bespoke Woodland.jpg',
  'KCOS20K-O0621-FR':'KCOS20K-O0621-FR-Coco-2 Seater-Tasman Garden Grey.png',
  'KCOS20K-O0621-SI':'KCOS20K-O0621-SI-Coco-2 Seater-Tasman Garden Grey.png',
  'KCOS20K-O0721-FR':'KCOS20K-O0721-FR-Coco-2 Seater-Tasman Dandelion.png',
  'KCOS20K-O0721-SI':'KCOS20K-O0721-SI-Coco-2 Seater-Tasman Dandelion.png',
  'KCOS20K-O0821-FR':'KCOS20K-O0821-FR-Coco-2 Seater-Tasman Spring Green.png',
  'KCOS20K-O0821-SI':'KCOS20K-O0821-SI-Coco-2 Seater-Tasman Spring Green.png',
  'KCOS20K-O1021-FR':'KCOS20K-O1021-FR-Coco-2 Seater-Antarctic Narrow Chocolate.png',
  'KCOS20K-O1021-SI':'KCOS20K-O1021-SI-Coco-2 Seater-Antarctic Narrow Chocolate.png',
  'KCOS20K-O1121-FR':'KCOS20K-O1121-FR-Coco-2 Seater-Tasman Chocolate.png',
  'KCOS20K-O1121-SI':'KCOS20K-O1121-SI-Coco-2 Seater-Tasman Chocolate.png',
  'KCOS20K-O1321-FR':'KCOS20K-O1321-FR-Coco-2 Seater-Capelo Cool Coconut.png',
  'KCOS20K-O1321-SI':'KCOS20K-O1321-SI-Coco-2 Seater-Capelo Cool Coconut.png',
  'KCOS20K-O1411-FR':'KCOS20K-O1411-FR-Coco-2 Seater-Capelo Snow Drop.jpg',
  'KCOS20K-O1421-FR':'KCOS20K-O1421-FR-Coco-2 Seater-Capelo Snow Drop.png',
  'KCOS20K-O1421-SI':'KCOS20K-O1421-SI-Coco-2 Seater-Capelo Snow Drop.png',
  'KCOS20K-O1425-FR':'KCOS20K-O1425-FR-Coco-2 Seater-Capelo Snow Drop.jpg',
  'KCOS20K-O1521-FR':'KCOS20K-O1521-FR-Coco-2 Seater-Capelo Sea Salt.jpg',
  'KCOS20K-O1621-FR':'KCOS20K-O1621-FR-Coco-2 Seater-Capelo Rosedale.jpg',
  'KCOS20K-O1721-FR':'KCOS20K-O1721-FR-Coco-2 Seater-Capelo Inkspot.jpg',
  'KCOS20K-O1821-FR':'KCOS20K-O1821-FR-Coco-2 Seater-Columbus Evergreen.jpg',
  'KCOS20K-O1921-FR':'KCOS20K-O1921-FR-Coco-2 Seater-Columbus Marigold.jpg',
  'KCOS20K-O2021-FR':'KCOS20K-O2021-FR-Coco-2 Seater-Columbus Potting Moss.jpg',
  'KCOS20K-O2121-FR':'KCOS20K-O2121-FR-Coco-2 Seater-Columbus Roselette.jpg',
  'KCOS20K-O2221-FR':'KCOS20K-O2221-FR-Coco-2 Seater-Columbus Sunflower.jpg',
  'KCOS25B-A0113-FR':'KCOS25B-A0113-FR-Coco-2.5 Seater-Wildwood Duck Egg.jpg',
  'KCOS25B-A0113-SI':'KCOS25B-A0113-SI-Coco-2.5 Seater-Wildwood Duck Egg.png',
  'KCOS25B-A0121-FR':'KCOS25B-A0121-FR-Coco-2.5 Seater-Wildwood Duck Egg.jpg',
  'KCOS25B-A0123-FR':'KCOS25B-A0123-FR-Coco-2.5 Seater-Wildwood Duck Egg.jpg',
  'KCOS25B-A0213-FR':'KCOS25B-A0213-FR-Coco-2.5 Seater-Wildwood Ivory.jpg',
  'KCOS25B-A0213-SI':'KCOS25B-A0213-SI-Coco-2.5 Seater-Wildwood Ivory.png',
  'KCOS25B-A0222-FR':'KCOS25B-A0222-FR-Coco-2.5 Seater-Wildwood Ivory.jpg',
  'KCOS25B-A0223-FR':'KCOS25B-A0223-FR-Coco-2.5 Seater-Wildwood Ivory.jpg',
  'KCOS25B-A0313-FR':'KCOS25B-A0313-FR-Coco-2.5 Seater-Wildwood Twig.png',
  'KCOS25B-A0313-SI':'KCOS25B-A0313-SI-Coco-2.5 Seater-Wildwood Twig.png',
  'KCOS25B-A0323-FR':'KCOS25B-A0323-FR-Coco-2.5 Seater-Wildwood Twig.jpg',
  'KCOS25B-A0411-FR':'KCOS25B-A0411-FR-Coco-2.5 Seater-Peony Summer Sky.png',
  'KCOS25B-A0411-SI':'KCOS25B-A0411-SI-Coco-2.5 Seater-Peony Summer Sky.png',
  'KCOS25B-A0421-FR':'KCOS25B-A0421-FR-Coco-2.5 Seater-Peony Summer Sky.jpg',
  'KCOS25B-A0511-FR':'KCOS25B-A0511-FR-Coco-2.5 Seater-Midsummer Sky.png',
  'KCOS25B-A0511-SI':'KCOS25B-A0511-SI-Coco-2.5 Seater-Midsummer Sky.png',
  'KCOS25B-A0521-FR':'KCOS25B-A0521-FR-Coco-2.5 Seater-Midsummer Sky.jpg',
  'KCOS25B-A0611-FR':'KCOS25B-A0611-FR-Coco-2.5 Seater-Midsummer Stone.png',
  'KCOS25B-A0611-SI':'KCOS25B-A0611-SI-Coco-2.5 Seater-Midsummer Stone.png',
  'KCOS25B-A0621-FR':'KCOS25B-A0621-FR-Coco-2.5 Seater-Midsummer Stone.jpg',
  'KCOS25B-A0711-FR':'KCOS25B-A0711-FR-Coco-2.5 Seater-Midsummer Faded Blue.png',
  'KCOS25B-A0711-SI':'KCOS25B-A0711-SI-Coco-2.5 Seater-Midsummer Faded Blue.png',
  'KCOS25B-A0721-FR':'KCOS25B-A0721-FR-Coco-2.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS25B-A07X1-FR':'KCOS25B-A07X1-FR-Coco-2.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS25B-A0811-FR':'KCOS25B-A0811-FR-Coco-2.5 Seater-Otter Denim.png',
  'KCOS25B-A0811-SI':'KCOS25B-A0811-SI-Coco-2.5 Seater-Otter Denim.png',
  'KCOS25B-A0821-FR':'KCOS25B-A0821-FR-Coco-2.5 Seater-Otter Denim.jpg',
  'KCOS25B-A0911-FR':'KCOS25B-A0911-FR-Coco-2.5 Seater-Pelham Clementine.jpg',
  'KCOS25B-A0911-SI':'KCOS25B-A0911-SI-Coco-2.5 Seater-Pelham Clementine.png',
  'KCOS25B-A0921-FR':'KCOS25B-A0921-FR-Coco-2.5 Seater-Pelham Clementine.jpg',
  'KCOS25B-A1011-FR':'KCOS25B-A1011-FR-Coco-2.5 Seater-Pelham Moss.jpg',
  'KCOS25B-A1011-SI':'KCOS25B-A1011-SI-Coco-2.5 Seater-Pelham Moss.png',
  'KCOS25B-A1021-FR':'KCOS25B-A1021-FR-Coco-2.5 Seater-Pelham Moss.jpg',
  'KCOS25B-A1111-FR':'KCOS25B-A1111-FR-Coco-2.5 Seater-Pelham Denim.jpg',
  'KCOS25B-A1111-SI':'KCOS25B-A1111-SI-Coco-2.5 Seater-Pelham Denim.png',
  'KCOS25B-A1121-FR':'KCOS25B-A1121-FR-Coco-2.5 Seater-Pelham Denim.jpg',
  'KCOS25B-A1211-FR':'KCOS25B-A1211-FR-Coco-2.5 Seater-Pelham Peacock.jpg',
  'KCOS25B-A1211-SI':'KCOS25B-A1211-SI-Coco-2.5 Seater-Pelham Peacock.png',
  'KCOS25B-A1221-FR':'KCOS25B-A1221-FR-Coco-2.5 Seater-Pelham Peacock.jpg',
  'KCOS25B-A1311-FR':'KCOS25B-A1311-FR-Coco-2.5 Seater-Las Salinas Las Salinas 4.png',
  'KCOS25B-A1311-SI':'KCOS25B-A1311-SI-Coco-2.5 Seater-Las Salinas Las Salinas 4.png',
  'KCOS25B-B0111-FR':'KCOS25B-B0111-FR-Coco-2.5 Seater-Beatrice Barley.jpg',
  'KCOS25B-B0121-FR':'KCOS25B-B0121-FR-Coco-2.5 Seater-Beatrice Barley.jpg',
  'KCOS25B-B0211-FR':'KCOS25B-B0211-FR-Coco-2.5 Seater-Beatrice Camelia.png',
  'KCOS25B-B0221-FR':'KCOS25B-B0221-FR-Coco-2.5 Seater-Beatrice Camelia.jpg',
  'KCOS25B-B0311-FR':'KCOS25B-B0311-FR-Coco-2.5 Seater-Beatrice Midnight.jpg',
  'KCOS25B-B0321-FR':'KCOS25B-B0321-FR-Coco-2.5 Seater-Beatrice Midnight.jpg',
  'KCOS25B-B0411-FR':'KCOS25B-B0411-FR-Coco-2.5 Seater-Beatrice Nutmeg.jpg',
  'KCOS25B-B0421-FR':'KCOS25B-B0421-FR-Coco-2.5 Seater-Beatrice Nutmeg.jpg',
  'KCOS25B-B0511-FR':'KCOS25B-B0511-FR-Coco-2.5 Seater-Beatrice Olive.jpg',
  'KCOS25B-B0521-FR':'KCOS25B-B0521-FR-Coco-2.5 Seater-Beatrice Olive.jpg',
  'KCOS25B-B0621-FR':'KCOS25B-B0621-FR-Coco-2.5 Seater-Froisse Cerulean.jpg',
  'KCOS25B-B0721-FR':'KCOS25B-B0721-FR-Coco-2.5 Seater-Froisse Chalk.jpg',
  'KCOS25B-B0821-FR':'KCOS25B-B0821-FR-Coco-2.5 Seater-Froisse Hemp.jpg',
  'KCOS25B-B0921-FR':'KCOS25B-B0921-FR-Coco-2.5 Seater-Froisse Khaki.jpg',
  'KCOS25B-B1021-FR':'KCOS25B-B1021-FR-Coco-2.5 Seater-Froisse Mole.jpg',
  'KCOS25B-B1121-FR':'KCOS25B-B1121-FR-Coco-2.5 Seater-Froisse Pebble.jpg',
  'KCOS25B-B1221-FR':'KCOS25B-B1221-FR-Coco-2.5 Seater-Froisse Putty.jpg',
  'KCOS25B-B1321-FR':'KCOS25B-B1321-FR-Coco-2.5 Seater-Froisse Sisal.jpg',
  'KCOS25B-C0111-FR':'KCOS25B-C0111-FR-Coco-2.5 Seater-Berrington.jpg',
  'KCOS25B-C0121-FR':'KCOS25B-C0121-FR-Coco-2.5 Seater-Berrington.jpg',
  'KCOS25B-D0111-FR':'KCOS25B-D0111-FR-Coco-2.5 Seater-Varese Fuchsia.jpg',
  'KCOS25B-D0121-FR':'KCOS25B-D0121-FR-Coco-2.5 Seater-Varese Fuchsia.jpg',
  'KCOS25B-D0311-FR':'KCOS25B-D0311-FR-Coco-2.5 Seater-Varese Alchemilla.jpg',
  'KCOS25B-D0321-FR':'KCOS25B-D0321-FR-Coco-2.5 Seater-Varese Alchemilla.jpg',
  'KCOS25B-D0511-FR':'KCOS25B-D0511-FR-Coco-2.5 Seater-Varese Grass.jpg',
  'KCOS25B-D0521-FR':'KCOS25B-D0521-FR-Coco-2.5 Seater-Varese Grass.jpg',
  'KCOS25B-D0611-FR':'KCOS25B-D0611-FR-Coco-2.5 Seater-Brera Lino Cerise.jpg',
  'KCOS25B-D0621-FR':'KCOS25B-D0621-FR-Coco-2.5 Seater-Brera Lino Cerise.jpg',
  'KCOS25B-D0711-FR':'KCOS25B-D0711-FR-Coco-2.5 Seater-Brera Lino Chalk.jpg',
  'KCOS25B-D0721-FR':'KCOS25B-D0721-FR-Coco-2.5 Seater-Brera Lino Chalk.jpg',
  'KCOS25B-D0821-FR':'KCOS25B-D0821-FR-Coco-2.5 Seater-Brera Lino Putty.jpg',
  'KCOS25B-G0111-FR':'KCOS25B-G0111-FR-Coco-2.5 Seater-Nympheus Teal green.jpg',
  'KCOS25B-G0121-FR':'KCOS25B-G0121-FR-Coco-2.5 Seater-Nympheus Teal green.jpg',
  'KCOS25B-G0211-FR':'KCOS25B-G0211-FR-Coco-2.5 Seater-Nympheus Stone pistachio.jpg',
  'KCOS25B-G0221-FR':'KCOS25B-G0221-FR-Coco-2.5 Seater-Nympheus Stone pistachio.jpg',
  'KCOS25B-G0311-FR':'KCOS25B-G0311-FR-Coco-2.5 Seater-Nympheus Aqua teal.jpg',
  'KCOS25B-G0321-FR':'KCOS25B-G0321-FR-Coco-2.5 Seater-Nympheus Aqua teal.jpg',
  'KCOS25B-G0423-FR':'KCOS25B-G0423-FR-Coco-2.5 Seater-Magnolia Cream Blue.jpg',
  'KCOS25B-G0513-FR':'KCOS25B-G0513-FR-Coco-2.5 Seater-Little Magnolia Pink orange.jpg',
  'KCOS25B-G0523-FR':'KCOS25B-G0523-FR-Coco-2.5 Seater-Little Magnolia Pink orange.jpg',
  'KCOS25B-G0611-FR':'KCOS25B-G0611-FR-Coco-2.5 Seater-Little Magnolia Espresso.jpg',
  'KCOS25B-G0621-FR':'KCOS25B-G0621-FR-Coco-2.5 Seater-Little Magnolia Espresso.jpg',
  'KCOS25B-G0711-FR':'KCOS25B-G0711-FR-Coco-2.5 Seater-Little Magnolia Emerald.jpg',
  'KCOS25B-G0721-FR':'KCOS25B-G0721-FR-Coco-2.5 Seater-Little Magnolia Emerald.jpg',
  'KCOS25B-J0121-FR':'KCOS25B-J0121-FR-Coco-2.5 Seater-Boho Cloud.jpg',
  'KCOS25B-J0221-FR':'KCOS25B-J0221-FR-Coco-2.5 Seater-Boho Denim.jpg',
  'KCOS25B-J0321-FR':'KCOS25B-J0321-FR-Coco-2.5 Seater-Boho Parchment.jpg',
  'KCOS25B-L0113-FR':'KCOS25B-L0113-FR-Coco-2.5 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS25B-L0113-SI':'KCOS25B-L0113-SI-Coco-2.5 Seater-English Garden - Kitty Spring Green.png',
  'KCOS25B-L0123-FR':'KCOS25B-L0123-FR-Coco-2.5 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS25B-L0213-FR':'KCOS25B-L0213-FR-Coco-2.5 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS25B-L0223-FR':'KCOS25B-L0223-FR-Coco-2.5 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS25B-L0313-FR':'KCOS25B-L0313-FR-Coco-2.5 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS25B-L0323-FR':'KCOS25B-L0323-FR-Coco-2.5 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS25B-L0413-FR':'KCOS25B-L0413-FR-Coco-2.5 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS25B-L0423-FR':'KCOS25B-L0423-FR-Coco-2.5 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS25B-L0513-FR':'KCOS25B-L0513-FR-Coco-2.5 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS25B-L0523-FR':'KCOS25B-L0523-FR-Coco-2.5 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS25B-L0613-FR':'KCOS25B-L0613-FR-Coco-2.5 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS25B-L0623-FR':'KCOS25B-L0623-FR-Coco-2.5 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS25B-L0713-FR':'KCOS25B-L0713-FR-Coco-2.5 Seater-Belleville - Miji Juniper.jpg',
  'KCOS25B-L0723-FR':'KCOS25B-L0723-FR-Coco-2.5 Seater-Belleville - Miji Juniper.jpg',
  'KCOS25B-L0911-FR':'KCOS25B-L0911-FR-Coco-2.5 Seater-Omega Carnelian.jpg',
  'KCOS25B-L0921-FR':'KCOS25B-L0921-FR-Coco-2.5 Seater-Omega Carnelian.jpg',
  'KCOS25B-L1011-FR':'KCOS25B-L1011-FR-Coco-2.5 Seater-Omega Pastel Blue.jpg',
  'KCOS25B-L1021-FR':'KCOS25B-L1021-FR-Coco-2.5 Seater-Omega Pastel Blue.jpg',
  'KCOS25B-L1121-FR':'KCOS25B-L1121-FR-Coco-2.5 Seater-Omega Lagoon.jpg',
  'KCOS25B-L1221-FR':'KCOS25B-L1221-FR-Coco-2.5 Seater-Omega Rosewood.jpg',
  'KCOS25B-L1321-FR':'KCOS25B-L1321-FR-Coco-2.5 Seater-Omega Winter Moss.jpg',
  'KCOS25B-L1411-FR':'KCOS25B-L1411-FR-Coco-2.5 Seater-Omega Pine.jpg',
  'KCOS25B-L1421-FR':'KCOS25B-L1421-FR-Coco-2.5 Seater-Omega Pine.jpg',
  'KCOS25B-L1621-FR':'KCOS25B-L1621-FR-Coco-2.5 Seater-Omega Pillar Box.jpg',
  'KCOS25B-L1711-FR':'KCOS25B-L1711-FR-Coco-2.5 Seater-Omega Parakeet.jpg',
  'KCOS25B-L1721-FR':'KCOS25B-L1721-FR-Coco-2.5 Seater-Omega Parakeet.jpg',
  'KCOS25B-L1811-FR':'KCOS25B-L1811-FR-Coco-2.5 Seater-Elba Cerulean.jpg',
  'KCOS25B-L1821-FR':'KCOS25B-L1821-FR-Coco-2.5 Seater-Elba Cerulean.jpg',
  'KCOS25B-L1911-FR':'KCOS25B-L1911-FR-Coco-2.5 Seater-Elba Hemp.jpg',
  'KCOS25B-L1921-FR':'KCOS25B-L1921-FR-Coco-2.5 Seater-Elba Hemp.jpg',
  'KCOS25B-L2011-FR':'KCOS25B-L2011-FR-Coco-2.5 Seater-Elba Midnight.jpg',
  'KCOS25B-L2021-FR':'KCOS25B-L2021-FR-Coco-2.5 Seater-Elba Midnight.jpg',
  'KCOS25B-L2111-FR':'KCOS25B-L2111-FR-Coco-2.5 Seater-Elba Sage.jpg',
  'KCOS25B-L2121-FR':'KCOS25B-L2121-FR-Coco-2.5 Seater-Elba Sage.jpg',
  'KCOS25B-O0111-FR':'KCOS25B-O0111-FR-Coco-2.5 Seater-Bespoke Coastal Blue.png',
  'KCOS25B-O0111-SI':'KCOS25B-O0111-SI-Coco-2.5 Seater-Bespoke Coastal Blue.png',
  'KCOS25B-O0211-FR':'KCOS25B-O0211-FR-Coco-2.5 Seater-Tasman Petunia.jpg',
  'KCOS25B-O0221-FR':'KCOS25B-O0221-FR-Coco-2.5 Seater-Tasman Petunia.png',
  'KCOS25B-O0311-FR':'KCOS25B-O0311-FR-Coco-2.5 Seater-Bespoke Woodland.png',
  'KCOS25B-O0311-SI':'KCOS25B-O0311-SI-Coco-2.5 Seater-Bespoke Woodland.png',
  'KCOS25B-O0321-FR':'KCOS25B-O0321-FR-Coco-2.5 Seater-Bespoke Woodland.jpg',
  'KCOS25B-O0411-FR':'KCOS25B-O0411-FR-Coco-2.5 Seater-Bespoke Caramel.png',
  'KCOS25B-O0411-SI':'KCOS25B-O0411-SI-Coco-2.5 Seater-Bespoke Caramel.png',
  'KCOS25B-O0511-FR':'KCOS25B-O0511-FR-Coco-2.5 Seater-Tasman Sea Holly.png',
  'KCOS25B-O0511-SI':'KCOS25B-O0511-SI-Coco-2.5 Seater-Tasman Sea Holly.png',
  'KCOS25B-O0611-FR':'KCOS25B-O0611-FR-Coco-2.5 Seater-Tasman Garden Grey.png',
  'KCOS25B-O0611-SI':'KCOS25B-O0611-SI-Coco-2.5 Seater-Tasman Garden Grey.png',
  'KCOS25B-O0621-FR':'KCOS25B-O0621-FR-Coco-2.5 Seater-Tasman Garden Grey.png',
  'KCOS25B-O0711-FR':'KCOS25B-O0711-FR-Coco-2.5 Seater-Tasman Dandelion.jpg',
  'KCOS25B-O0711-SI':'KCOS25B-O0711-SI-Coco-2.5 Seater-Tasman Dandelion.png',
  'KCOS25B-O0721-FR':'KCOS25B-O0721-FR-Coco-2.5 Seater-Tasman Dandelion.jpg',
  'KCOS25B-O0911-FR':'KCOS25B-O0911-FR-Coco-2.5 Seater-Tasman Cornish Blue.png',
  'KCOS25B-O0911-SI':'KCOS25B-O0911-SI-Coco-2.5 Seater-Tasman Cornish Blue.png',
  'KCOS25B-O1011-FR':'KCOS25B-O1011-FR-Coco-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS25B-O1011-SI':'KCOS25B-O1011-SI-Coco-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS25B-O1021-FR':'KCOS25B-O1021-FR-Coco-2.5 Seater-Antarctic Narrow Chocolate.jpg',
  'KCOS25B-O1111-FR':'KCOS25B-O1111-FR-Coco-2.5 Seater-Tasman Chocolate.png',
  'KCOS25B-O1111-SI':'KCOS25B-O1111-SI-Coco-2.5 Seater-Tasman Chocolate.png',
  'KCOS25B-O1121-FR':'KCOS25B-O1121-FR-Coco-2.5 Seater-Tasman Chocolate.jpg',
  'KCOS25B-O1311-FR':'KCOS25B-O1311-FR-Coco-2.5 Seater-Capelo Cool Coconut.jpg',
  'KCOS25B-O1321-FR':'KCOS25B-O1321-FR-Coco-2.5 Seater-Capelo Cool Coconut.jpg',
  'KCOS25B-O1411-FR':'KCOS25B-O1411-FR-Coco-2.5 Seater-Capelo Snow Drop.jpg',
  'KCOS25B-O1411-SI':'KCOS25B-O1411-SI-Coco-2.5 Seater-Capelo Snow Drop.png',
  'KCOS25B-O1421-FR':'KCOS25B-O1421-FR-Coco-2.5 Seater-Capelo Snow Drop.png',
  'KCOS25B-O1511-FR':'KCOS25B-O1511-FR-Coco-2.5 Seater-Capelo Sea Salt.jpg',
  'KCOS25B-O1511-SI':'KCOS25B-O1511-SI-Coco-2.5 Seater-Capelo Sea Salt.png',
  'KCOS25B-O1521-FR':'KCOS25B-O1521-FR-Coco-2.5 Seater-Capelo Sea Salt.jpg',
  'KCOS25B-O1611-FR':'KCOS25B-O1611-FR-Coco-2.5 Seater-Capelo Rosedale.jpg',
  'KCOS25B-O1611-SI':'KCOS25B-O1611-SI-Coco-2.5 Seater-Capelo Rosedale.png',
  'KCOS25B-O1621-FR':'KCOS25B-O1621-FR-Coco-2.5 Seater-Capelo Rosedale.jpg',
  'KCOS25B-O1711-FR':'KCOS25B-O1711-FR-Coco-2.5 Seater-Capelo Inkspot.jpg',
  'KCOS25B-O1711-SI':'KCOS25B-O1711-SI-Coco-2.5 Seater-Capelo Inkspot.png',
  'KCOS25B-O1721-FR':'KCOS25B-O1721-FR-Coco-2.5 Seater-Capelo Inkspot.jpg',
  'KCOS25B-O1811-FR':'KCOS25B-O1811-FR-Coco-2.5 Seater-Columbus Evergreen.jpg',
  'KCOS25B-O1811-SI':'KCOS25B-O1811-SI-Coco-2.5 Seater-Columbus Evergreen.png',
  'KCOS25B-O1821-FR':'KCOS25B-O1821-FR-Coco-2.5 Seater-Columbus Evergreen.jpg',
  'KCOS25B-O1911-FR':'KCOS25B-O1911-FR-Coco-2.5 Seater-Columbus Marigold.jpg',
  'KCOS25B-O1911-SI':'KCOS25B-O1911-SI-Coco-2.5 Seater-Columbus Marigold.png',
  'KCOS25B-O1921-FR':'KCOS25B-O1921-FR-Coco-2.5 Seater-Columbus Marigold.jpg',
  'KCOS25B-O2021-FR':'KCOS25B-O2021-FR-Coco-2.5 Seater-Columbus Potting Moss.jpg',
  'KCOS25B-O2111-FR':'KCOS25B-O2111-FR-Coco-2.5 Seater-Columbus Roselette.jpg',
  'KCOS25B-O2111-SI':'KCOS25B-O2111-SI-Coco-2.5 Seater-Columbus Roselette.png',
  'KCOS25B-O2121-FR':'KCOS25B-O2121-FR-Coco-2.5 Seater-Columbus Roselette.jpg',
  'KCOS25B-O2211-FR':'KCOS25B-O2211-FR-Coco-2.5 Seater-Columbus Sunflower.jpg',
  'KCOS25B-O2211-SI':'KCOS25B-O2211-SI-Coco-2.5 Seater-Columbus Sunflower.png',
  'KCOS25B-O2221-FR':'KCOS25B-O2221-FR-Coco-2.5 Seater-Columbus Sunflower.jpg',
  'KCOS25K-A0123-FR':'KCOS25K-A0123-FR-Coco-2.5 Seater-Wildwood Duck Egg.png',
  'KCOS25K-A0123-SI':'KCOS25K-A0123-SI-Coco-2.5 Seater-Wildwood Duck Egg.png',
  'KCOS25K-A0223-FR':'KCOS25K-A0223-FR-Coco-2.5 Seater-Wildwood Ivory.png',
  'KCOS25K-A0223-SI':'KCOS25K-A0223-SI-Coco-2.5 Seater-Wildwood Ivory.png',
  'KCOS25K-A0225-FR':'KCOS25K-A0225-FR-Coco-2.5 Seater-Wildwood Ivory.jpg',
  'KCOS25K-A0323-FR':'KCOS25K-A0323-FR-Coco-2.5 Seater-Wildwood Twig.png',
  'KCOS25K-A0421-FR':'KCOS25K-A0421-FR-Coco-2.5 Seater-Peony Summer Sky.png',
  'KCOS25K-A0521-FR':'KCOS25K-A0521-FR-Coco-2.5 Seater-Midsummer Sky.png',
  'KCOS25K-A0621-FR':'KCOS25K-A0621-FR-Coco-2.5 Seater-Midsummer Stone.png',
  'KCOS25K-A0725-FR':'KCOS25K-A0725-FR-Coco-2.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS25K-A07X1-FR':'KCOS25K-A07X1-FR-Coco-2.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS25K-A0821-FR':'KCOS25K-A0821-FR-Coco-2.5 Seater-Otter Denim.png',
  'KCOS25K-A0921-FR':'KCOS25K-A0921-FR-Coco-2.5 Seater-Pelham Clementine.png',
  'KCOS25K-A1021-FR':'KCOS25K-A1021-FR-Coco-2.5 Seater-Pelham Moss.png',
  'KCOS25K-A1021-SI':'KCOS25K-A1021-SI-Coco-2.5 Seater-Pelham Moss.png',
  'KCOS25K-A1121-FR':'KCOS25K-A1121-FR-Coco-2.5 Seater-Pelham Denim.png',
  'KCOS25K-A1221-FR':'KCOS25K-A1221-FR-Coco-2.5 Seater-Pelham Peacock.png',
  'KCOS25K-A1321-FR':'KCOS25K-A1321-FR-Coco-2.5 Seater-Las Salinas Las Salinas 4.png',
  'KCOS25K-B0521-FR':'KCOS25K-B0521-FR-Coco-2.5 Seater-Beatrice Olive.png',
  'KCOS25K-B0521-SI':'KCOS25K-B0521-SI-Coco-2.5 Seater-Beatrice Olive.png',
  'KCOS25K-C0121-FR':'KCOS25K-C0121-FR-Coco-2.5 Seater-Berrington.jpg',
  'KCOS25K-D0121-FR':'KCOS25K-D0121-FR-Coco-2.5 Seater-Varese Fuchsia.jpg',
  'KCOS25K-D0321-FR':'KCOS25K-D0321-FR-Coco-2.5 Seater-Varese Alchemilla.jpg',
  'KCOS25K-D0521-FR':'KCOS25K-D0521-FR-Coco-2.5 Seater-Varese Grass.jpg',
  'KCOS25K-D0621-FR':'KCOS25K-D0621-FR-Coco-2.5 Seater-Brera Lino Cerise.jpg',
  'KCOS25K-D0721-FR':'KCOS25K-D0721-FR-Coco-2.5 Seater-Brera Lino Chalk.jpg',
  'KCOS25K-G0423-FR':'KCOS25K-G0423-FR-Coco-2.5 Seater-Magnolia Cream Blue.png',
  'KCOS25K-G0423-SI':'KCOS25K-G0423-SI-Coco-2.5 Seater-Magnolia Cream Blue.png',
  'KCOS25K-G0523-FR':'KCOS25K-G0523-FR-Coco-2.5 Seater-Little Magnolia Pink orange.jpg',
  'KCOS25K-G0621-FR':'KCOS25K-G0621-FR-Coco-2.5 Seater-Little Magnolia Espresso.jpg',
  'KCOS25K-G072-FR':'KCOS25K-G072-FR-Coco-2.5 seater-Little Magnolia Emerald.jpg',
  'KCOS25K-L0123-FR':'KCOS25K-L0123-FR-Coco-2.5 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS25K-L0223-FR':'KCOS25K-L0223-FR-Coco-2.5 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS25K-L0323-FR':'KCOS25K-L0323-FR-Coco-2.5 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS25K-L042-FR':'KCOS25K-L042-FR-Coco-2.5 seater-English Garden - Albertine - Grey Skies.jpg',
  'KCOS25K-L0523-FR':'KCOS25K-L0523-FR-Coco-2.5 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS25K-L0623-FR':'KCOS25K-L0623-FR-Coco-2.5 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS25K-L0723-FR':'KCOS25K-L0723-FR-Coco-2.5 Seater-Belleville - Miji Juniper.jpg',
  'KCOS25K-L0921-FR':'KCOS25K-L0921-FR-Coco-2.5 Seater-Omega Carnelian.jpg',
  'KCOS25K-L1121-FR':'KCOS25K-L1121-FR-Coco-2.5 Seater-Omega Lagoon.jpg',
  'KCOS25K-L1221-FR':'KCOS25K-L1221-FR-Coco-2.5 Seater-Omega Rosewood.jpg',
  'KCOS25K-L1421-FR':'KCOS25K-L1421-FR-Coco-2.5 Seater-Omega Pine.jpg',
  'KCOS25K-L1721-FR':'KCOS25K-L1721-FR-Coco-2.5 Seater-Omega Parakeet.jpg',
  'KCOS25K-L1821-FR':'KCOS25K-L1821-FR-Coco-2.5 Seater-Elba Cerulean.jpg',
  'KCOS25K-L1921-FR':'KCOS25K-L1921-FR-Coco-2.5 Seater-Elba Hemp.jpg',
  'KCOS25K-L2021-FR':'KCOS25K-L2021-FR-Coco-2.5 Seater-Elba Midnight.jpg',
  'KCOS25K-L2121-FR':'KCOS25K-L2121-FR-Coco-2.5 Seater-Elba Sage.jpg',
  'KCOS25K-O0121-FR':'KCOS25K-O0121-FR-Coco-2.5 Seater-Bespoke Coastal Blue.png',
  'KCOS25K-O0121-SI':'KCOS25K-O0121-SI-Coco-2.5 Seater-Bespoke Coastal Blue.png',
  'KCOS25K-O0221-FR':'KCOS25K-O0221-FR-Coco-2.5 Seater-Tasman Petunia.png',
  'KCOS25K-O0221-SI':'KCOS25K-O0221-SI-Coco-2.5 Seater-Tasman Petunia.png',
  'KCOS25K-O0421-FR':'KCOS25K-O0421-FR-Coco-2.5 Seater-Bespoke Caramel.jpg',
  'KCOS25K-O0521-FR':'KCOS25K-O0521-FR-Coco-2.5 Seater-Tasman Sea Holly.jpg',
  'KCOS25K-O0621-FR':'KCOS25K-O0621-FR-Coco-2.5 Seater-Tasman Garden Grey.png',
  'KCOS25K-O0621-SI':'KCOS25K-O0621-SI-Coco-2.5 Seater-Tasman Garden Grey.png',
  'KCOS25K-O0721-FR':'KCOS25K-O0721-FR-Coco-2.5 Seater-Tasman Dandelion.png',
  'KCOS25K-O0721-SI':'KCOS25K-O0721-SI-Coco-2.5 Seater-Tasman Dandelion.png',
  'KCOS25K-O0821-FR':'KCOS25K-O0821-FR-Coco-2.5 Seater-Tasman Spring Green.png',
  'KCOS25K-O0821-SI':'KCOS25K-O0821-SI-Coco-2.5 Seater-Tasman Spring Green.png',
  'KCOS25K-O0921-FR':'KCOS25K-O0921-FR-Coco-2.5 Seater-Tasman Cornish Blue.jpg',
  'KCOS25K-O1021-FR':'KCOS25K-O1021-FR-Coco-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS25K-O1021-SI':'KCOS25K-O1021-SI-Coco-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS25K-O1121-FR':'KCOS25K-O1121-FR-Coco-2.5 Seater-Tasman Chocolate.png',
  'KCOS25K-O1121-SI':'KCOS25K-O1121-SI-Coco-2.5 Seater-Tasman Chocolate.png',
  'KCOS25K-O1321-FR':'KCOS25K-O1321-FR-Coco-2.5 Seater-Capelo Cool Coconut.png',
  'KCOS25K-O1321-SI':'KCOS25K-O1321-SI-Coco-2.5 Seater-Capelo Cool Coconut.png',
  'KCOS25K-O1416-FR':'KCOS25K-O1416-FR-Coco-2.5 Seater-Capelo Snow Drop.jpg',
  'KCOS25K-O1421-FR':'KCOS25K-O1421-FR-Coco-2.5 Seater-Capelo Snow Drop.png',
  'KCOS25K-O1421-SI':'KCOS25K-O1421-SI-Coco-2.5 Seater-Capelo Snow Drop.png',
  'KCOS25K-O1425-FR':'KCOS25K-O1425-FR-Coco-2.5 Seater-Capelo Snow Drop.jpg',
  'KCOS25K-O1521-FR':'KCOS25K-O1521-FR-Coco-2.5 Seater-Capelo Sea Salt.jpg',
  'KCOS25K-O1621-FR':'KCOS25K-O1621-FR-Coco-2.5 Seater-Capelo Rosedale.jpg',
  'KCOS25K-O1721-FR':'KCOS25K-O1721-FR-Coco-2.5 Seater-Capelo Inkspot.jpg',
  'KCOS25K-O1821-FR':'KCOS25K-O1821-FR-Coco-2.5 Seater-Columbus Evergreen.jpg',
  'KCOS25K-O1921-FR':'KCOS25K-O1921-FR-Coco-2.5 Seater-Columbus Marigold.jpg',
  'KCOS25K-O2021-FR':'KCOS25K-O2021-FR-Coco-2.5 Seater-Columbus Potting Moss.jpg',
  'KCOS25K-O2121-FR':'KCOS25K-O2121-FR-Coco-2.5 Seater-Columbus Roselette.jpg',
  'KCOS25K-O2221-FR':'KCOS25K-O2221-FR-Coco-2.5 Seater-Columbus Sunflower.jpg',
  'KCOS30B-A0113-FR':'KCOS30B-A0113-FR-Coco-3 Seater-Wildwood Duck Egg.jpg',
  'KCOS30B-A0113-SI':'KCOS30B-A0113-SI-Coco-3 Seater-Wildwood Duck Egg.png',
  'KCOS30B-A0123-FR':'KCOS30B-A0123-FR-Coco-3 Seater-Wildwood Duck Egg.jpg',
  'KCOS30B-A0213-FR':'KCOS30B-A0213-FR-Coco-3 Seater-Wildwood Ivory.jpg',
  'KCOS30B-A0213-SI':'KCOS30B-A0213-SI-Coco-3 Seater-Wildwood Ivory.png',
  'KCOS30B-A0223-FR':'KCOS30B-A0223-FR-Coco-3 Seater-Wildwood Ivory.jpg',
  'KCOS30B-A0313-FR':'KCOS30B-A0313-FR-Coco-3 Seater-Wildwood Twig.png',
  'KCOS30B-A0313-SI':'KCOS30B-A0313-SI-Coco-3 Seater-Wildwood Twig.png',
  'KCOS30B-A0323-FR':'KCOS30B-A0323-FR-Coco-3 Seater-Wildwood Twig.jpg',
  'KCOS30B-A0411-FR':'KCOS30B-A0411-FR-Coco-3 Seater-Peony Summer Sky.png',
  'KCOS30B-A0411-SI':'KCOS30B-A0411-SI-Coco-3 Seater-Peony Summer Sky.png',
  'KCOS30B-A0421-FR':'KCOS30B-A0421-FR-Coco-3 Seater-Peony Summer Sky.jpg',
  'KCOS30B-A0511-FR':'KCOS30B-A0511-FR-Coco-3 Seater-Midsummer Sky.png',
  'KCOS30B-A0511-SI':'KCOS30B-A0511-SI-Coco-3 Seater-Midsummer Sky.png',
  'KCOS30B-A0521-FR':'KCOS30B-A0521-FR-Coco-3 Seater-Midsummer Sky.jpg',
  'KCOS30B-A0611-FR':'KCOS30B-A0611-FR-Coco-3 Seater-Midsummer Stone.png',
  'KCOS30B-A0611-SI':'KCOS30B-A0611-SI-Coco-3 Seater-Midsummer Stone.png',
  'KCOS30B-A0621-FR':'KCOS30B-A0621-FR-Coco-3 Seater-Midsummer Stone.jpg',
  'KCOS30B-A0711-FR':'KCOS30B-A0711-FR-Coco-3 Seater-Midsummer Faded Blue.png',
  'KCOS30B-A0711-SI':'KCOS30B-A0711-SI-Coco-3 Seater-Midsummer Faded Blue.png',
  'KCOS30B-A0721-FR':'KCOS30B-A0721-FR-Coco-3 Seater-Midsummer Faded Blue.jpg',
  'KCOS30B-A07X1-FR':'KCOS30B-A07X1-FR-Coco-3 Seater-Midsummer Faded Blue.jpg',
  'KCOS30B-A0811-FR':'KCOS30B-A0811-FR-Coco-3 Seater-Otter Denim.png',
  'KCOS30B-A0811-SI':'KCOS30B-A0811-SI-Coco-3 Seater-Otter Denim.png',
  'KCOS30B-A0821-FR':'KCOS30B-A0821-FR-Coco-3 Seater-Otter Denim.jpg',
  'KCOS30B-A0921-FR':'KCOS30B-A0921-FR-Coco-3 Seater-Pelham Clementine.jpg',
  'KCOS30B-A1011-FR':'KCOS30B-A1011-FR-Coco-3 Seater-Pelham Moss.jpg',
  'KCOS30B-A1011-SI':'KCOS30B-A1011-SI-Coco-3 Seater-Pelham Moss.png',
  'KCOS30B-A1021-FR':'KCOS30B-A1021-FR-Coco-3 Seater-Pelham Moss.jpg',
  'KCOS30B-A1111-FR':'KCOS30B-A1111-FR-Coco-3 Seater-Pelham Denim.png',
  'KCOS30B-A1111-SI':'KCOS30B-A1111-SI-Coco-3 Seater-Pelham Denim.png',
  'KCOS30B-A1121-FR':'KCOS30B-A1121-FR-Coco-3 Seater-Pelham Denim.jpg',
  'KCOS30B-A1211-FR':'KCOS30B-A1211-FR-Coco-3 Seater-Pelham Peacock.jpg',
  'KCOS30B-A1211-SI':'KCOS30B-A1211-SI-Coco-3 Seater-Pelham Peacock.png',
  'KCOS30B-A1221-FR':'KCOS30B-A1221-FR-Coco-3 Seater-Pelham Peacock.jpg',
  'KCOS30B-A1311-FR':'KCOS30B-A1311-FR-Coco-3 Seater-Las Salinas Las Salinas 4.png',
  'KCOS30B-A1311-SI':'KCOS30B-A1311-SI-Coco-3 Seater-Las Salinas Las Salinas 4.png',
  'KCOS30B-B0111-FR':'KCOS30B-B0111-FR-Coco-3 Seater-Beatrice Barley.jpg',
  'KCOS30B-B0121-FR':'KCOS30B-B0121-FR-Coco-3 Seater-Beatrice Barley.jpg',
  'KCOS30B-B0211-FR':'KCOS30B-B0211-FR-Coco-3 Seater-Beatrice Camelia.jpg',
  'KCOS30B-B0221-FR':'KCOS30B-B0221-FR-Coco-3 Seater-Beatrice Camelia.jpg',
  'KCOS30B-B0311-FR':'KCOS30B-B0311-FR-Coco-3 Seater-Beatrice Midnight.jpg',
  'KCOS30B-B0321-FR':'KCOS30B-B0321-FR-Coco-3 Seater-Beatrice Midnight.jpg',
  'KCOS30B-B0411-FR':'KCOS30B-B0411-FR-Coco-3 Seater-Beatrice Nutmeg.jpg',
  'KCOS30B-B0421-FR':'KCOS30B-B0421-FR-Coco-3 Seater-Beatrice Nutmeg.jpg',
  'KCOS30B-B0511-FR':'KCOS30B-B0511-FR-Coco-3 Seater-Beatrice Olive.jpg',
  'KCOS30B-B0521-FR':'KCOS30B-B0521-FR-Coco-3 Seater-Beatrice Olive.jpg',
  'KCOS30B-B0621-FR':'KCOS30B-B0621-FR-Coco-3 Seater-Froisse Cerulean.jpg',
  'KCOS30B-B0721-FR':'KCOS30B-B0721-FR-Coco-3 Seater-Froisse Chalk.jpg',
  'KCOS30B-B0821-FR':'KCOS30B-B0821-FR-Coco-3 Seater-Froisse Hemp.jpg',
  'KCOS30B-B0921-FR':'KCOS30B-B0921-FR-Coco-3 Seater-Froisse Khaki.jpg',
  'KCOS30B-B1021-FR':'KCOS30B-B1021-FR-Coco-3 Seater-Froisse Mole.jpg',
  'KCOS30B-B1121-FR':'KCOS30B-B1121-FR-Coco-3 Seater-Froisse Pebble.jpg',
  'KCOS30B-B1221-FR':'KCOS30B-B1221-FR-Coco-3 Seater-Froisse Putty.jpg',
  'KCOS30B-B1321-FR':'KCOS30B-B1321-FR-Coco-3 Seater-Froisse Sisal.jpg',
  'KCOS30B-C0111-FR':'KCOS30B-C0111-FR-Coco-3 Seater-Berrington.jpg',
  'KCOS30B-C0121-FR':'KCOS30B-C0121-FR-Coco-3 Seater-Berrington.jpg',
  'KCOS30B-D0111-FR':'KCOS30B-D0111-FR-Coco-3 Seater-Varese Fuchsia.jpg',
  'KCOS30B-D0121-FR':'KCOS30B-D0121-FR-Coco-3 Seater-Varese Fuchsia.jpg',
  'KCOS30B-D0311-FR':'KCOS30B-D0311-FR-Coco-3 Seater-Varese Alchemilla.jpg',
  'KCOS30B-D0321-FR':'KCOS30B-D0321-FR-Coco-3 Seater-Varese Alchemilla.jpg',
  'KCOS30B-D0511-FR':'KCOS30B-D0511-FR-Coco-3 Seater-Varese Grass.jpg',
  'KCOS30B-D0521-FR':'KCOS30B-D0521-FR-Coco-3 Seater-Varese Grass.jpg',
  'KCOS30B-D0611-FR':'KCOS30B-D0611-FR-Coco-3 Seater-Brera Lino Cerise.jpg',
  'KCOS30B-D0621-FR':'KCOS30B-D0621-FR-Coco-3 Seater-Brera Lino Cerise.jpg',
  'KCOS30B-D0711-FR':'KCOS30B-D0711-FR-Coco-3 Seater-Brera Lino Chalk.jpg',
  'KCOS30B-D0721-FR':'KCOS30B-D0721-FR-Coco-3 Seater-Brera Lino Chalk.jpg',
  'KCOS30B-D0821-FR':'KCOS30B-D0821-FR-Coco-3 Seater-Brera Lino Putty.jpg',
  'KCOS30B-G0111-FR':'KCOS30B-G0111-FR-Coco-3 Seater-Nympheus Teal green.jpg',
  'KCOS30B-G0121-FR':'KCOS30B-G0121-FR-Coco-3 Seater-Nympheus Teal green.jpg',
  'KCOS30B-G0211-FR':'KCOS30B-G0211-FR-Coco-3 Seater-Nympheus Stone pistachio.jpg',
  'KCOS30B-G0221-FR':'KCOS30B-G0221-FR-Coco-3 Seater-Nympheus Stone pistachio.jpg',
  'KCOS30B-G0311-FR':'KCOS30B-G0311-FR-Coco-3 Seater-Nympheus Aqua teal.jpg',
  'KCOS30B-G0321-FR':'KCOS30B-G0321-FR-Coco-3 Seater-Nympheus Aqua teal.jpg',
  'KCOS30B-G0423-FR':'KCOS30B-G0423-FR-Coco-3 Seater-Magnolia Cream Blue.jpg',
  'KCOS30B-G0513-FR':'KCOS30B-G0513-FR-Coco-3 Seater-Little Magnolia Pink orange.jpg',
  'KCOS30B-G0523-FR':'KCOS30B-G0523-FR-Coco-3 Seater-Little Magnolia Pink orange.jpg',
  'KCOS30B-G0611-FR':'KCOS30B-G0611-FR-Coco-3 Seater-Little Magnolia Espresso.jpg',
  'KCOS30B-G0621-FR':'KCOS30B-G0621-FR-Coco-3 Seater-Little Magnolia Espresso.jpg',
  'KCOS30B-G0711-FR':'KCOS30B-G0711-FR-Coco-3 Seater-Little Magnolia Emerald.jpg',
  'KCOS30B-G0721-FR':'KCOS30B-G0721-FR-Coco-3 Seater-Little Magnolia Emerald.jpg',
  'KCOS30B-J0121-FR':'KCOS30B-J0121-FR-Coco-3 Seater-Boho Cloud.jpg',
  'KCOS30B-J0221-FR':'KCOS30B-J0221-FR-Coco-3 Seater-Boho Denim.jpg',
  'KCOS30B-J0321-FR':'KCOS30B-J0321-FR-Coco-3 Seater-Boho Parchment.jpg',
  'KCOS30B-L0113-FR':'KCOS30B-L0113-FR-Coco-3 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS30B-L0113-SI':'KCOS30B-L0113-SI-Coco-3 Seater-English Garden - Kitty Spring Green.png',
  'KCOS30B-L0123-FR':'KCOS30B-L0123-FR-Coco-3 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS30B-L0213-FR':'KCOS30B-L0213-FR-Coco-3 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS30B-L0223-FR':'KCOS30B-L0223-FR-Coco-3 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS30B-L0313-FR':'KCOS30B-L0313-FR-Coco-3 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS30B-L0323-FR':'KCOS30B-L0323-FR-Coco-3 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS30B-L0413-FR':'KCOS30B-L0413-FR-Coco-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS30B-L0423-FR':'KCOS30B-L0423-FR-Coco-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS30B-L0513-FR':'KCOS30B-L0513-FR-Coco-3 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS30B-L0523-FR':'KCOS30B-L0523-FR-Coco-3 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS30B-L0613-FR':'KCOS30B-L0613-FR-Coco-3 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS30B-L0623-FR':'KCOS30B-L0623-FR-Coco-3 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS30B-L0713-FR':'KCOS30B-L0713-FR-Coco-3 Seater-Belleville - Miji Juniper.jpg',
  'KCOS30B-L0723-FR':'KCOS30B-L0723-FR-Coco-3 Seater-Belleville - Miji Juniper.jpg',
  'KCOS30B-L0911-FR':'KCOS30B-L0911-FR-Coco-3 Seater-Omega Carnelian.jpg',
  'KCOS30B-L0921-FR':'KCOS30B-L0921-FR-Coco-3 Seater-Omega Carnelian.jpg',
  'KCOS30B-L1011-FR':'KCOS30B-L1011-FR-Coco-3 Seater-Omega Pastel Blue.jpg',
  'KCOS30B-L1021-FR':'KCOS30B-L1021-FR-Coco-3 Seater-Omega Pastel Blue.jpg',
  'KCOS30B-L1111-FR':'KCOS30B-L1111-FR-Coco-3 Seater-Omega Lagoon.jpg',
  'KCOS30B-L1121-FR':'KCOS30B-L1121-FR-Coco-3 Seater-Omega Lagoon.jpg',
  'KCOS30B-L1211-FR':'KCOS30B-L1211-FR-Coco-3 Seater-Omega Rosewood.jpg',
  'KCOS30B-L1221-FR':'KCOS30B-L1221-FR-Coco-3 Seater-Omega Rosewood.jpg',
  'KCOS30B-L1321-FR':'KCOS30B-L1321-FR-Coco-3 Seater-Omega Winter Moss.jpg',
  'KCOS30B-L1411-FR':'KCOS30B-L1411-FR-Coco-3 Seater-Omega Pine.jpg',
  'KCOS30B-L1421-FR':'KCOS30B-L1421-FR-Coco-3 Seater-Omega Pine.jpg',
  'KCOS30B-L1621-FR':'KCOS30B-L1621-FR-Coco-3 Seater-Omega Pillar Box.jpg',
  'KCOS30B-L1711-FR':'KCOS30B-L1711-FR-Coco-3 Seater-Omega Parakeet.jpg',
  'KCOS30B-L1721-FR':'KCOS30B-L1721-FR-Coco-3 Seater-Omega Parakeet.jpg',
  'KCOS30B-L1811-FR':'KCOS30B-L1811-FR-Coco-3 Seater-Elba Cerulean.jpg',
  'KCOS30B-L1821-FR':'KCOS30B-L1821-FR-Coco-3 Seater-Elba Cerulean.jpg',
  'KCOS30B-L1911-FR':'KCOS30B-L1911-FR-Coco-3 Seater-Elba Hemp.jpg',
  'KCOS30B-L1921-FR':'KCOS30B-L1921-FR-Coco-3 Seater-Elba Hemp.jpg',
  'KCOS30B-L2011-FR':'KCOS30B-L2011-FR-Coco-3 Seater-Elba Midnight.jpg',
  'KCOS30B-L2021-FR':'KCOS30B-L2021-FR-Coco-3 Seater-Elba Midnight.jpg',
  'KCOS30B-L2111-FR':'KCOS30B-L2111-FR-Coco-3 Seater-Elba Sage.jpg',
  'KCOS30B-L2121-FR':'KCOS30B-L2121-FR-Coco-3 Seater-Elba Sage.jpg',
  'KCOS30B-O0111-FR':'KCOS30B-O0111-FR-Coco-3 Seater-Bespoke Coastal Blue.png',
  'KCOS30B-O0111-SI':'KCOS30B-O0111-SI-Coco-3 Seater-Bespoke Coastal Blue.png',
  'KCOS30B-O0211-FR':'KCOS30B-O0211-FR-Coco-3 Seater-Tasman Petunia.jpg',
  'KCOS30B-O0221-FR':'KCOS30B-O0221-FR-Coco-3 Seater-Tasman Petunia.png',
  'KCOS30B-O0311-FR':'KCOS30B-O0311-FR-Coco-3 Seater-Bespoke Woodland.png',
  'KCOS30B-O0311-SI':'KCOS30B-O0311-SI-Coco-3 Seater-Bespoke Woodland.png',
  'KCOS30B-O0321-FR':'KCOS30B-O0321-FR-Coco-3 Seater-Bespoke Woodland.jpg',
  'KCOS30B-O0411-FR':'KCOS30B-O0411-FR-Coco-3 Seater-Bespoke Caramel.png',
  'KCOS30B-O0411-SI':'KCOS30B-O0411-SI-Coco-3 Seater-Bespoke Caramel.png',
  'KCOS30B-O0511-FR':'KCOS30B-O0511-FR-Coco-3 Seater-Tasman Sea Holly.png',
  'KCOS30B-O0511-SI':'KCOS30B-O0511-SI-Coco-3 Seater-Tasman Sea Holly.png',
  'KCOS30B-O0611-FR':'KCOS30B-O0611-FR-Coco-3 Seater-Tasman Garden Grey.png',
  'KCOS30B-O0611-SI':'KCOS30B-O0611-SI-Coco-3 Seater-Tasman Garden Grey.png',
  'KCOS30B-O0621-FR':'KCOS30B-O0621-FR-Coco-3 Seater-Tasman Garden Grey.jpg',
  'KCOS30B-O0711-FR':'KCOS30B-O0711-FR-Coco-3 Seater-Tasman Dandelion.png',
  'KCOS30B-O0711-SI':'KCOS30B-O0711-SI-Coco-3 Seater-Tasman Dandelion.png',
  'KCOS30B-O0721-FR':'KCOS30B-O0721-FR-Coco-3 Seater-Tasman Dandelion.jpg',
  'KCOS30B-O0911-FR':'KCOS30B-O0911-FR-Coco-3 Seater-Tasman Cornish Blue.png',
  'KCOS30B-O0911-SI':'KCOS30B-O0911-SI-Coco-3 Seater-Tasman Cornish Blue.png',
  'KCOS30B-O1011-FR':'KCOS30B-O1011-FR-Coco-3 Seater-Antarctic Narrow Chocolate.png',
  'KCOS30B-O1011-SI':'KCOS30B-O1011-SI-Coco-3 Seater-Antarctic Narrow Chocolate.png',
  'KCOS30B-O1021-FR':'KCOS30B-O1021-FR-Coco-3 Seater-Antarctic Narrow Chocolate.jpg',
  'KCOS30B-O1111-FR':'KCOS30B-O1111-FR-Coco-3 Seater-Tasman Chocolate.jpg',
  'KCOS30B-O1111-SI':'KCOS30B-O1111-SI-Coco-3 Seater-Tasman Chocolate.png',
  'KCOS30B-O1311-FR':'KCOS30B-O1311-FR-Coco-3 Seater-Capelo Cool Coconut.jpg',
  'KCOS30B-O1321-FR':'KCOS30B-O1321-FR-Coco-3 Seater-Capelo Cool Coconut.jpg',
  'KCOS30B-O1411-FR':'KCOS30B-O1411-FR-Coco-3 Seater-Capelo Snow Drop.jpg',
  'KCOS30B-O1421-FR':'KCOS30B-O1421-FR-Coco-3 Seater-Capelo Snow Drop.png',
  'KCOS30B-O1511-FR':'KCOS30B-O1511-FR-Coco-3 Seater-Capelo Sea Salt.png',
  'KCOS30B-O1511-SI':'KCOS30B-O1511-SI-Coco-3 Seater-Capelo Sea Salt.png',
  'KCOS30B-O1521-FR':'KCOS30B-O1521-FR-Coco-3 Seater-Capelo Sea Salt.jpg',
  'KCOS30B-O1611-FR':'KCOS30B-O1611-FR-Coco-3 Seater-Capelo Rosedale.png',
  'KCOS30B-O1611-SI':'KCOS30B-O1611-SI-Coco-3 Seater-Capelo Rosedale.png',
  'KCOS30B-O1621-FR':'KCOS30B-O1621-FR-Coco-3 Seater-Capelo Rosedale.jpg',
  'KCOS30B-O1711-FR':'KCOS30B-O1711-FR-Coco-3 Seater-Capelo Inkspot.png',
  'KCOS30B-O1711-SI':'KCOS30B-O1711-SI-Coco-3 Seater-Capelo Inkspot.png',
  'KCOS30B-O1721-FR':'KCOS30B-O1721-FR-Coco-3 Seater-Capelo Inkspot.jpg',
  'KCOS30B-O1811-FR':'KCOS30B-O1811-FR-Coco-3 Seater-Columbus Evergreen.png',
  'KCOS30B-O1811-SI':'KCOS30B-O1811-SI-Coco-3 Seater-Columbus Evergreen.png',
  'KCOS30B-O1821-FR':'KCOS30B-O1821-FR-Coco-3 Seater-Columbus Evergreen.jpg',
  'KCOS30B-O1911-FR':'KCOS30B-O1911-FR-Coco-3 Seater-Columbus Marigold.png',
  'KCOS30B-O1911-SI':'KCOS30B-O1911-SI-Coco-3 Seater-Columbus Marigold.png',
  'KCOS30B-O1921-FR':'KCOS30B-O1921-FR-Coco-3 Seater-Columbus Marigold.jpg',
  'KCOS30B-O2011-FR':'KCOS30B-O2011-FR-Coco-3 Seater-Columbus Potting Moss.png',
  'KCOS30B-O2011-SI':'KCOS30B-O2011-SI-Coco-3 Seater-Columbus Potting Moss.png',
  'KCOS30B-O2021-FR':'KCOS30B-O2021-FR-Coco-3 Seater-Columbus Potting Moss.jpg',
  'KCOS30B-O2111-FR':'KCOS30B-O2111-FR-Coco-3 Seater-Columbus Roselette.png',
  'KCOS30B-O2111-SI':'KCOS30B-O2111-SI-Coco-3 Seater-Columbus Roselette.png',
  'KCOS30B-O2121-FR':'KCOS30B-O2121-FR-Coco-3 Seater-Columbus Roselette.jpg',
  'KCOS30B-O2211-FR':'KCOS30B-O2211-FR-Coco-3 Seater-Columbus Sunflower.png',
  'KCOS30B-O2211-SI':'KCOS30B-O2211-SI-Coco-3 Seater-Columbus Sunflower.png',
  'KCOS30B-O2221-FR':'KCOS30B-O2221-FR-Coco-3 Seater-Columbus Sunflower.jpg',
  'KCOS30K-A0123-FR':'KCOS30K-A0123-FR-Coco-3 Seater-Wildwood Duck Egg.png',
  'KCOS30K-A0123-SI':'KCOS30K-A0123-SI-Coco-3 Seater-Wildwood Duck Egg.png',
  'KCOS30K-A0223-FR':'KCOS30K-A0223-FR-Coco-3 Seater-Wildwood Ivory.png',
  'KCOS30K-A0223-SI':'KCOS30K-A0223-SI-Coco-3 Seater-Wildwood Ivory.png',
  'KCOS30K-A0225-FR':'KCOS30K-A0225-FR-Coco-3 Seater-Wildwood Ivory.jpg',
  'KCOS30K-A0323-FR':'KCOS30K-A0323-FR-Coco-3 Seater-Wildwood Twig.jpg',
  'KCOS30K-A0421-FR':'KCOS30K-A0421-FR-Coco-3 Seater-Peony Summer Sky.jpg',
  'KCOS30K-A0521-FR':'KCOS30K-A0521-FR-Coco-3 Seater-Midsummer Sky.jpg',
  'KCOS30K-A0621-FR':'KCOS30K-A0621-FR-Coco-3 Seater-Midsummer Stone.jpg',
  'KCOS30K-A0725-FR':'KCOS30K-A0725-FR-Coco-3 Seater-Midsummer Faded Blue.jpg',
  'KCOS30K-A07X1-FR':'KCOS30K-A07X1-FR-Coco-3 Seater-Midsummer Faded Blue.jpg',
  'KCOS30K-A0821-FR':'KCOS30K-A0821-FR-Coco-3 Seater-Otter Denim.jpg',
  'KCOS30K-A1021-FR':'KCOS30K-A1021-FR-Coco-3 Seater-Pelham Moss.png',
  'KCOS30K-A1021-SI':'KCOS30K-A1021-SI-Coco-3 Seater-Pelham Moss.png',
  'KCOS30K-A1321-FR':'KCOS30K-A1321-FR-Coco-3 Seater-Las Salinas Las Salinas 4.jpg',
  'KCOS30K-B0121-FR':'KCOS30K-B0121-FR-Coco-3 Seater-Beatrice Barley.jpg',
  'KCOS30K-B0221-FR':'KCOS30K-B0221-FR-Coco-3 Seater-Beatrice Camelia.jpg',
  'KCOS30K-B0321-FR':'KCOS30K-B0321-FR-Coco-3 Seater-Beatrice Midnight.jpg',
  'KCOS30K-B0421-FR':'KCOS30K-B0421-FR-Coco-3 Seater-Beatrice Nutmeg.jpg',
  'KCOS30K-B0521-FR':'KCOS30K-B0521-FR-Coco-3 Seater-Beatrice Olive.png',
  'KCOS30K-B0521-SI':'KCOS30K-B0521-SI-Coco-3 Seater-Beatrice Olive.png',
  'KCOS30K-C0121-FR':'KCOS30K-C0121-FR-Coco-3 Seater-Berrington.png',
  'KCOS30K-D0621-FR':'KCOS30K-D0621-FR-Coco-3 Seater-Brera Lino Cerise.jpg',
  'KCOS30K-D0721-FR':'KCOS30K-D0721-FR-Coco-3 Seater-Brera Lino Chalk.jpg',
  'KCOS30K-G0121-FR':'KCOS30K-G0121-FR-Coco-3 Seater-Nympheus Teal green.jpg',
  'KCOS30K-G0221-FR':'KCOS30K-G0221-FR-Coco-3 Seater-Nympheus Stone pistachio.jpg',
  'KCOS30K-G0321-FR':'KCOS30K-G0321-FR-Coco-3 Seater-Nympheus Aqua teal.jpg',
  'KCOS30K-G0423-FR':'KCOS30K-G0423-FR-Coco-3 Seater-Magnolia Cream Blue.png',
  'KCOS30K-G0423-SI':'KCOS30K-G0423-SI-Coco-3 Seater-Magnolia Cream Blue.png',
  'KCOS30K-G0523-FR':'KCOS30K-G0523-FR-Coco-3 Seater-Little Magnolia Pink orange.jpg',
  'KCOS30K-G0621-FR':'KCOS30K-G0621-FR-Coco-3 Seater-Little Magnolia Espresso.jpg',
  'KCOS30K-L0223-FR':'KCOS30K-L0223-FR-Coco-3 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS30K-L0323-FR':'KCOS30K-L0323-FR-Coco-3 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS30K-L0423-FR':'KCOS30K-L0423-FR-Coco-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS30K-L0523-FR':'KCOS30K-L0523-FR-Coco-3 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS30K-L0623-FR':'KCOS30K-L0623-FR-Coco-3 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS30K-L0723-FR':'KCOS30K-L0723-FR-Coco-3 Seater-Belleville - Miji Juniper.jpg',
  'KCOS30K-L1021-FR':'KCOS30K-L1021-FR-Coco-3 Seater-Omega Pastel Blue.jpg',
  'KCOS30K-L1821-FR':'KCOS30K-L1821-FR-Coco-3 Seater-Elba Cerulean.jpg',
  'KCOS30K-L1921-FR':'KCOS30K-L1921-FR-Coco-3 Seater-Elba Hemp.jpg',
  'KCOS30K-L2021-FR':'KCOS30K-L2021-FR-Coco-3 Seater-Elba Midnight.jpg',
  'KCOS30K-L2121-FR':'KCOS30K-L2121-FR-Coco-3 Seater-Elba Sage.jpg',
  'KCOS30K-O0121-FR':'KCOS30K-O0121-FR-Coco-3 Seater-Bespoke Coastal Blue.png',
  'KCOS30K-O0121-SI':'KCOS30K-O0121-SI-Coco-3 Seater-Bespoke Coastal Blue.png',
  'KCOS30K-O0221-FR':'KCOS30K-O0221-FR-Coco-3 Seater-Tasman Petunia.png',
  'KCOS30K-O0221-SI':'KCOS30K-O0221-SI-Coco-3 Seater-Tasman Petunia.png',
  'KCOS30K-O0521-FR':'KCOS30K-O0521-FR-Coco-3 Seater-Tasman Sea Holly.jpg',
  'KCOS30K-O0621-FR':'KCOS30K-O0621-FR-Coco-3 Seater-Tasman Garden Grey.png',
  'KCOS30K-O0621-SI':'KCOS30K-O0621-SI-Coco-3 Seater-Tasman Garden Grey.png',
  'KCOS30K-O0721-FR':'KCOS30K-O0721-FR-Coco-3 Seater-Tasman Dandelion.png',
  'KCOS30K-O0821-FR':'KCOS30K-O0821-FR-Coco-3 Seater-Tasman Spring Green.png',
  'KCOS30K-O0821-SI':'KCOS30K-O0821-SI-Coco-3 Seater-Tasman Spring Green.png',
  'KCOS30K-O0921-FR':'KCOS30K-O0921-FR-Coco-3 Seater-Tasman Cornish Blue.jpg',
  'KCOS30K-O1021-SI':'KCOS30K-O1021-SI-Coco-3 Seater-Antarctic Narrow Chocolate.png',
  'KCOS30K-O1121-FR':'KCOS30K-O1121-FR-Coco-3 Seater-Tasman Chocolate.png',
  'KCOS30K-O1121-SI':'KCOS30K-O1121-SI-Coco-3 Seater-Tasman Chocolate.png',
  'KCOS30K-O1321-FR':'KCOS30K-O1321-FR-Coco-3 Seater-Capelo Cool Coconut.png',
  'KCOS30K-O1321-SI':'KCOS30K-O1321-SI-Coco-3 Seater-Capelo Cool Coconut.png',
  'KCOS30K-O1411-FR':'KCOS30K-O1411-FR-Coco-3 Seater-Capelo Snow Drop.jpg',
  'KCOS30K-O1421-FR':'KCOS30K-O1421-FR-Coco-3 Seater-Capelo Snow Drop.png',
  'KCOS30K-O1421-SI':'KCOS30K-O1421-SI-Coco-3 Seater-Capelo Snow Drop.png',
  'KCOS30K-O1425-FR':'KCOS30K-O1425-FR-Coco-3 Seater-Capelo Snow Drop.jpg',
  'KCOS30K-O1521-FR':'KCOS30K-O1521-FR-Coco-3 Seater-Capelo Sea Salt.jpg',
  'KCOS30K-O1621-FR':'KCOS30K-O1621-FR-Coco-3 Seater-Capelo Rosedale.jpg',
  'KCOS30K-O1721-FR':'KCOS30K-O1721-FR-Coco-3 Seater-Capelo Inkspot.jpg',
  'KCOS30K-O1821-FR':'KCOS30K-O1821-FR-Coco-3 Seater-Columbus Evergreen.jpg',
  'KCOS30K-O1921-FR':'KCOS30K-O1921-FR-Coco-3 Seater-Columbus Marigold.jpg',
  'KCOS30K-O2021-FR':'KCOS30K-O2021-FR-Coco-3 Seater-Columbus Potting Moss.jpg',
  'KCOS30K-O2121-FR':'KCOS30K-O2121-FR-Coco-3 Seater-Columbus Roselette.jpg',
  'KCOS30K-O2221-FR':'KCOS30K-O2221-FR-Coco-3 Seater-Columbus Sunflower.jpg',
  'KCOS35B-A0113-FR':'KCOS35B-A0113-FR-Coco-3.5 Seater-Wildwood Duck Egg.jpg',
  'KCOS35B-A0113-SI':'KCOS35B-A0113-SI-Coco-3.5 Seater-Wildwood Duck Egg.png',
  'KCOS35B-A0122-FR':'KCOS35B-A0122-FR-Coco-3.5 Seater-Wildwood Duck Egg.jpg',
  'KCOS35B-A0123-FR':'KCOS35B-A0123-FR-Coco-3.5 Seater-Wildwood Duck Egg.jpg',
  'KCOS35B-A0213-FR':'KCOS35B-A0213-FR-Coco-3.5 Seater-Wildwood Ivory.jpg',
  'KCOS35B-A0213-SI':'KCOS35B-A0213-SI-Coco-3.5 Seater-Wildwood Ivory.png',
  'KCOS35B-A0222-FR':'KCOS35B-A0222-FR-Coco-3.5 Seater-Wildwood Ivory.jpg',
  'KCOS35B-A0223-FR':'KCOS35B-A0223-FR-Coco-3.5 Seater-Wildwood Ivory.jpg',
  'KCOS35B-A0313-FR':'KCOS35B-A0313-FR-Coco-3.5 Seater-Wildwood Twig.png',
  'KCOS35B-A0313-SI':'KCOS35B-A0313-SI-Coco-3.5 Seater-Wildwood Twig.png',
  'KCOS35B-A0323-FR':'KCOS35B-A0323-FR-Coco-3.5 Seater-Wildwood Twig.jpg',
  'KCOS35B-A0411-FR':'KCOS35B-A0411-FR-Coco-3.5 Seater-Peony Summer Sky.png',
  'KCOS35B-A0411-SI':'KCOS35B-A0411-SI-Coco-3.5 Seater-Peony Summer Sky.png',
  'KCOS35B-A0421-FR':'KCOS35B-A0421-FR-Coco-3.5 Seater-Peony Summer Sky.jpg',
  'KCOS35B-A0511-FR':'KCOS35B-A0511-FR-Coco-3.5 Seater-Midsummer Sky.jpg',
  'KCOS35B-A0511-SI':'KCOS35B-A0511-SI-Coco-3.5 Seater-Midsummer Sky.png',
  'KCOS35B-A0521-FR':'KCOS35B-A0521-FR-Coco-3.5 Seater-Midsummer Sky.jpg',
  'KCOS35B-A0611-FR':'KCOS35B-A0611-FR-Coco-3.5 Seater-Midsummer Stone.png',
  'KCOS35B-A0611-SI':'KCOS35B-A0611-SI-Coco-3.5 Seater-Midsummer Stone.png',
  'KCOS35B-A0621-FR':'KCOS35B-A0621-FR-Coco-3.5 Seater-Midsummer Stone.jpg',
  'KCOS35B-A0711-FR':'KCOS35B-A0711-FR-Coco-3.5 Seater-Midsummer Faded Blue.png',
  'KCOS35B-A0711-SI':'KCOS35B-A0711-SI-Coco-3.5 Seater-Midsummer Faded Blue.png',
  'KCOS35B-A0721-FR':'KCOS35B-A0721-FR-Coco-3.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS35B-A07X1-FR':'KCOS35B-A07X1-FR-Coco-3.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS35B-A0811-FR':'KCOS35B-A0811-FR-Coco-3.5 Seater-Otter Denim.png',
  'KCOS35B-A0811-SI':'KCOS35B-A0811-SI-Coco-3.5 Seater-Otter Denim.png',
  'KCOS35B-A0821-FR':'KCOS35B-A0821-FR-Coco-3.5 Seater-Otter Denim.jpg',
  'KCOS35B-A0921-FR':'KCOS35B-A0921-FR-Coco-3.5 Seater-Pelham Clementine.jpg',
  'KCOS35B-A1011-FR':'KCOS35B-A1011-FR-Coco-3.5 Seater-Pelham Moss.jpg',
  'KCOS35B-A1011-SI':'KCOS35B-A1011-SI-Coco-3.5 Seater-Pelham Moss.png',
  'KCOS35B-A1021-FR':'KCOS35B-A1021-FR-Coco-3.5 Seater-Pelham Moss.jpg',
  'KCOS35B-A1111-FR':'KCOS35B-A1111-FR-Coco-3.5 Seater-Pelham Denim.png',
  'KCOS35B-A1111-SI':'KCOS35B-A1111-SI-Coco-3.5 Seater-Pelham Denim.png',
  'KCOS35B-A1121-FR':'KCOS35B-A1121-FR-Coco-3.5 Seater-Pelham Denim.jpg',
  'KCOS35B-A1211-FR':'KCOS35B-A1211-FR-Coco-3.5 Seater-Pelham Peacock.jpg',
  'KCOS35B-A1211-SI':'KCOS35B-A1211-SI-Coco-3.5 Seater-Pelham Peacock.png',
  'KCOS35B-A1221-FR':'KCOS35B-A1221-FR-Coco-3.5 Seater-Pelham Peacock.jpg',
  'KCOS35B-A1311-FR':'KCOS35B-A1311-FR-Coco-3.5 Seater-Las Salinas Las Salinas 4.png',
  'KCOS35B-A1311-SI':'KCOS35B-A1311-SI-Coco-3.5 Seater-Las Salinas Las Salinas 4.png',
  'KCOS35B-B0111-FR':'KCOS35B-B0111-FR-Coco-3.5 Seater-Beatrice Barley.jpg',
  'KCOS35B-B0121-FR':'KCOS35B-B0121-FR-Coco-3.5 Seater-Beatrice Barley.jpg',
  'KCOS35B-B0211-FR':'KCOS35B-B0211-FR-Coco-3.5 Seater-Beatrice Camelia.png',
  'KCOS35B-B0221-FR':'KCOS35B-B0221-FR-Coco-3.5 Seater-Beatrice Camelia.jpg',
  'KCOS35B-B0311-FR':'KCOS35B-B0311-FR-Coco-3.5 Seater-Beatrice Midnight.jpg',
  'KCOS35B-B0321-FR':'KCOS35B-B0321-FR-Coco-3.5 Seater-Beatrice Midnight.jpg',
  'KCOS35B-B0411-FR':'KCOS35B-B0411-FR-Coco-3.5 Seater-Beatrice Nutmeg.jpg',
  'KCOS35B-B0421-FR':'KCOS35B-B0421-FR-Coco-3.5 Seater-Beatrice Nutmeg.jpg',
  'KCOS35B-B0511-FR':'KCOS35B-B0511-FR-Coco-3.5 Seater-Beatrice Olive.jpg',
  'KCOS35B-B0521-FR':'KCOS35B-B0521-FR-Coco-3.5 Seater-Beatrice Olive.jpg',
  'KCOS35B-B0621-FR':'KCOS35B-B0621-FR-Coco-3.5 Seater-Froisse Cerulean.jpg',
  'KCOS35B-B0721-FR':'KCOS35B-B0721-FR-Coco-3.5 Seater-Froisse Chalk.jpg',
  'KCOS35B-B0821-FR':'KCOS35B-B0821-FR-Coco-3.5 Seater-Froisse Hemp.jpg',
  'KCOS35B-B0921-FR':'KCOS35B-B0921-FR-Coco-3.5 Seater-Froisse Khaki.jpg',
  'KCOS35B-B1021-FR':'KCOS35B-B1021-FR-Coco-3.5 Seater-Froisse Mole.jpg',
  'KCOS35B-B1121-FR':'KCOS35B-B1121-FR-Coco-3.5 Seater-Froisse Pebble.jpg',
  'KCOS35B-B1221-FR':'KCOS35B-B1221-FR-Coco-3.5 Seater-Froisse Putty.jpg',
  'KCOS35B-B1321-FR':'KCOS35B-B1321-FR-Coco-3.5 Seater-Froisse Sisal.jpg',
  'KCOS35B-C0111-FR':'KCOS35B-C0111-FR-Coco-3.5 Seater-Berrington.jpg',
  'KCOS35B-C0121-FR':'KCOS35B-C0121-FR-Coco-3.5 Seater-Berrington.jpg',
  'KCOS35B-D0111-FR':'KCOS35B-D0111-FR-Coco-3.5 Seater-Varese Fuchsia.jpg',
  'KCOS35B-D0121-FR':'KCOS35B-D0121-FR-Coco-3.5 Seater-Varese Fuchsia.jpg',
  'KCOS35B-D0311-FR':'KCOS35B-D0311-FR-Coco-3.5 Seater-Varese Alchemilla.jpg',
  'KCOS35B-D0321-FR':'KCOS35B-D0321-FR-Coco-3.5 Seater-Varese Alchemilla.jpg',
  'KCOS35B-D0511-FR':'KCOS35B-D0511-FR-Coco-3.5 Seater-Varese Grass.jpg',
  'KCOS35B-D0521-FR':'KCOS35B-D0521-FR-Coco-3.5 Seater-Varese Grass.jpg',
  'KCOS35B-D0611-FR':'KCOS35B-D0611-FR-Coco-3.5 Seater-Brera Lino Cerise.jpg',
  'KCOS35B-D0621-FR':'KCOS35B-D0621-FR-Coco-3.5 Seater-Brera Lino Cerise.jpg',
  'KCOS35B-D0711-FR':'KCOS35B-D0711-FR-Coco-3.5 Seater-Brera Lino Chalk.jpg',
  'KCOS35B-D0721-FR':'KCOS35B-D0721-FR-Coco-3.5 Seater-Brera Lino Chalk.jpg',
  'KCOS35B-D0821-FR':'KCOS35B-D0821-FR-Coco-3.5 Seater-Brera Lino Putty.jpg',
  'KCOS35B-G0111-FR':'KCOS35B-G0111-FR-Coco-3.5 Seater-Nympheus Teal green.jpg',
  'KCOS35B-G0121-FR':'KCOS35B-G0121-FR-Coco-3.5 Seater-Nympheus Teal green.jpg',
  'KCOS35B-G0211-FR':'KCOS35B-G0211-FR-Coco-3.5 Seater-Nympheus Stone pistachio.jpg',
  'KCOS35B-G0221-FR':'KCOS35B-G0221-FR-Coco-3.5 Seater-Nympheus Stone pistachio.jpg',
  'KCOS35B-G0311-FR':'KCOS35B-G0311-FR-Coco-3.5 Seater-Nympheus Aqua teal.jpg',
  'KCOS35B-G0321-FR':'KCOS35B-G0321-FR-Coco-3.5 Seater-Nympheus Aqua teal.jpg',
  'KCOS35B-G0423-FR':'KCOS35B-G0423-FR-Coco-3.5 Seater-Magnolia Cream Blue.jpg',
  'KCOS35B-G0513-FR':'KCOS35B-G0513-FR-Coco-3.5 Seater-Little Magnolia Pink orange.jpg',
  'KCOS35B-G0523-FR':'KCOS35B-G0523-FR-Coco-3.5 Seater-Little Magnolia Pink orange.jpg',
  'KCOS35B-G0611-FR':'KCOS35B-G0611-FR-Coco-3.5 Seater-Little Magnolia Espresso.jpg',
  'KCOS35B-G0621-FR':'KCOS35B-G0621-FR-Coco-3.5 Seater-Little Magnolia Espresso.jpg',
  'KCOS35B-G0711-FR':'KCOS35B-G0711-FR-Coco-3.5 Seater-Little Magnolia Emerald.jpg',
  'KCOS35B-G0721-FR':'KCOS35B-G0721-FR-Coco-3.5 Seater-Little Magnolia Emerald.jpg',
  'KCOS35B-J0121-FR':'KCOS35B-J0121-FR-Coco-3.5 Seater-Boho Cloud.jpg',
  'KCOS35B-J0221-FR':'KCOS35B-J0221-FR-Coco-3.5 Seater-Boho Denim.jpg',
  'KCOS35B-J0321-FR':'KCOS35B-J0321-FR-Coco-3.5 Seater-Boho Parchment.jpg',
  'KCOS35B-L0113-FR':'KCOS35B-L0113-FR-Coco-3.5 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS35B-L0113-SI':'KCOS35B-L0113-SI-Coco-3.5 Seater-English Garden - Kitty Spring Green.png',
  'KCOS35B-L0123-FR':'KCOS35B-L0123-FR-Coco-3.5 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS35B-L0213-FR':'KCOS35B-L0213-FR-Coco-3.5 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS35B-L0223-FR':'KCOS35B-L0223-FR-Coco-3.5 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS35B-L0313-FR':'KCOS35B-L0313-FR-Coco-3.5 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS35B-L0323-FR':'KCOS35B-L0323-FR-Coco-3.5 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS35B-L0413-FR':'KCOS35B-L0413-FR-Coco-3.5 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS35B-L0423-FR':'KCOS35B-L0423-FR-Coco-3.5 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS35B-L0513-FR':'KCOS35B-L0513-FR-Coco-3.5 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS35B-L0523-FR':'KCOS35B-L0523-FR-Coco-3.5 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS35B-L0613-FR':'KCOS35B-L0613-FR-Coco-3.5 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS35B-L0623-FR':'KCOS35B-L0623-FR-Coco-3.5 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS35B-L0713-FR':'KCOS35B-L0713-FR-Coco-3.5 Seater-Belleville - Miji Juniper.jpg',
  'KCOS35B-L0723-FR':'KCOS35B-L0723-FR-Coco-3.5 Seater-Belleville - Miji Juniper.jpg',
  'KCOS35B-L0921-FR':'KCOS35B-L0921-FR-Coco-3.5 Seater-Omega Carnelian.jpg',
  'KCOS35B-L1021-FR':'KCOS35B-L1021-FR-Coco-3.5 Seater-Omega Pastel Blue.jpg',
  'KCOS35B-L1111-FR':'KCOS35B-L1111-FR-Coco-3.5 Seater-Omega Lagoon.jpg',
  'KCOS35B-L1121-FR':'KCOS35B-L1121-FR-Coco-3.5 Seater-Omega Lagoon.jpg',
  'KCOS35B-L1211-FR':'KCOS35B-L1211-FR-Coco-3.5 Seater-Omega Rosewood.jpg',
  'KCOS35B-L1221-FR':'KCOS35B-L1221-FR-Coco-3.5 Seater-Omega Rosewood.jpg',
  'KCOS35B-L1321-FR':'KCOS35B-L1321-FR-Coco-3.5 Seater-Omega Winter Moss.jpg',
  'KCOS35B-L1411-FR':'KCOS35B-L1411-FR-Coco-3.5 Seater-Omega Pine.jpg',
  'KCOS35B-L1421-FR':'KCOS35B-L1421-FR-Coco-3.5 Seater-Omega Pine.jpg',
  'KCOS35B-L1621-FR':'KCOS35B-L1621-FR-Coco-3.5 Seater-Omega Pillar Box.jpg',
  'KCOS35B-L1711-FR':'KCOS35B-L1711-FR-Coco-3.5 Seater-Omega Parakeet.jpg',
  'KCOS35B-L1721-FR':'KCOS35B-L1721-FR-Coco-3.5 Seater-Omega Parakeet.jpg',
  'KCOS35B-L1811-FR':'KCOS35B-L1811-FR-Coco-3.5 Seater-Elba Cerulean.jpg',
  'KCOS35B-L1821-FR':'KCOS35B-L1821-FR-Coco-3.5 Seater-Elba Cerulean.jpg',
  'KCOS35B-L1911-FR':'KCOS35B-L1911-FR-Coco-3.5 Seater-Elba Hemp.jpg',
  'KCOS35B-L1921-FR':'KCOS35B-L1921-FR-Coco-3.5 Seater-Elba Hemp.jpg',
  'KCOS35B-L2011-FR':'KCOS35B-L2011-FR-Coco-3.5 Seater-Elba Midnight.jpg',
  'KCOS35B-L2021-FR':'KCOS35B-L2021-FR-Coco-3.5 Seater-Elba Midnight.jpg',
  'KCOS35B-L2111-FR':'KCOS35B-L2111-FR-Coco-3.5 Seater-Elba Sage.jpg',
  'KCOS35B-L2121-FR':'KCOS35B-L2121-FR-Coco-3.5 Seater-Elba Sage.jpg',
  'KCOS35B-O0111-FR':'KCOS35B-O0111-FR-Coco-3.5 Seater-Bespoke Coastal Blue.png',
  'KCOS35B-O0111-SI':'KCOS35B-O0111-SI-Coco-3.5 Seater-Bespoke Coastal Blue.png',
  'KCOS35B-O0211-FR':'KCOS35B-O0211-FR-Coco-3.5 Seater-Tasman Petunia.jpg',
  'KCOS35B-O0211-SI':'KCOS35B-O0211-SI-Coco-3.5 Seater-Tasman Petunia.png',
  'KCOS35B-O0221-FR':'KCOS35B-O0221-FR-Coco-3.5 Seater-Tasman Petunia.jpg',
  'KCOS35B-O0311-FR':'KCOS35B-O0311-FR-Coco-3.5 Seater-Bespoke Woodland.jpg',
  'KCOS35B-O0311-SI':'KCOS35B-O0311-SI-Coco-3.5 Seater-Bespoke Woodland.png',
  'KCOS35B-O0321-FR':'KCOS35B-O0321-FR-Coco-3.5 Seater-Bespoke Woodland.jpg',
  'KCOS35B-O0411-FR':'KCOS35B-O0411-FR-Coco-3.5 Seater-Bespoke Caramel.png',
  'KCOS35B-O0411-SI':'KCOS35B-O0411-SI-Coco-3.5 Seater-Bespoke Caramel.png',
  'KCOS35B-O0511-FR':'KCOS35B-O0511-FR-Coco-3.5 Seater-Tasman Sea Holly.png',
  'KCOS35B-O0511-SI':'KCOS35B-O0511-SI-Coco-3.5 Seater-Tasman Sea Holly.png',
  'KCOS35B-O0611-FR':'KCOS35B-O0611-FR-Coco-3.5 Seater-Tasman Garden Grey.jpg',
  'KCOS35B-O0611-SI':'KCOS35B-O0611-SI-Coco-3.5 Seater-Tasman Garden Grey.png',
  'KCOS35B-O0621-FR':'KCOS35B-O0621-FR-Coco-3.5 Seater-Tasman Garden Grey.jpg',
  'KCOS35B-O0711-FR':'KCOS35B-O0711-FR-Coco-3.5 Seater-Tasman Dandelion.jpg',
  'KCOS35B-O0711-SI':'KCOS35B-O0711-SI-Coco-3.5 Seater-Tasman Dandelion.png',
  'KCOS35B-O0721-FR':'KCOS35B-O0721-FR-Coco-3.5 Seater-Tasman Dandelion.jpg',
  'KCOS35B-O0911-FR':'KCOS35B-O0911-FR-Coco-3.5 Seater-Tasman Cornish Blue.png',
  'KCOS35B-O0911-SI':'KCOS35B-O0911-SI-Coco-3.5 Seater-Tasman Cornish Blue.png',
  'KCOS35B-O1011-FR':'KCOS35B-O1011-FR-Coco-3.5 Seater-Antarctic Narrow Chocolate.jpg',
  'KCOS35B-O1011-SI':'KCOS35B-O1011-SI-Coco-3.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS35B-O1021-FR':'KCOS35B-O1021-FR-Coco-3.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS35B-O1111-FR':'KCOS35B-O1111-FR-Coco-3.5 Seater-Tasman Chocolate.jpg',
  'KCOS35B-O1111-SI':'KCOS35B-O1111-SI-Coco-3.5 Seater-Tasman Chocolate.png',
  'KCOS35B-O1121-FR':'KCOS35B-O1121-FR-Coco-3.5 Seater-Tasman Chocolate.png',
  'KCOS35B-O1311-FR':'KCOS35B-O1311-FR-Coco-3.5 Seater-Capelo Cool Coconut.jpg',
  'KCOS35B-O1321-FR':'KCOS35B-O1321-FR-Coco-3.5 Seater-Capelo Cool Coconut.png',
  'KCOS35B-O1411-FR':'KCOS35B-O1411-FR-Coco-3.5 Seater-Capelo Snow Drop.jpg',
  'KCOS35B-O1411-SI':'KCOS35B-O1411-SI-Coco-3.5 Seater-Capelo Snow Drop.png',
  'KCOS35B-O1421-FR':'KCOS35B-O1421-FR-Coco-3.5 Seater-Capelo Snow Drop.png',
  'KCOS35B-O1511-FR':'KCOS35B-O1511-FR-Coco-3.5 Seater-Capelo Sea Salt.png',
  'KCOS35B-O1511-SI':'KCOS35B-O1511-SI-Coco-3.5 Seater-Capelo Sea Salt.png',
  'KCOS35B-O1521-FR':'KCOS35B-O1521-FR-Coco-3.5 Seater-Capelo Sea Salt.jpg',
  'KCOS35B-O1611-FR':'KCOS35B-O1611-FR-Coco-3.5 Seater-Capelo Rosedale.png',
  'KCOS35B-O1611-SI':'KCOS35B-O1611-SI-Coco-3.5 Seater-Capelo Rosedale.png',
  'KCOS35B-O1621-FR':'KCOS35B-O1621-FR-Coco-3.5 Seater-Capelo Rosedale.jpg',
  'KCOS35B-O1711-FR':'KCOS35B-O1711-FR-Coco-3.5 Seater-Capelo Inkspot.jpg',
  'KCOS35B-O1711-SI':'KCOS35B-O1711-SI-Coco-3.5 Seater-Capelo Inkspot.png',
  'KCOS35B-O1721-FR':'KCOS35B-O1721-FR-Coco-3.5 Seater-Capelo Inkspot.jpg',
  'KCOS35B-O1811-FR':'KCOS35B-O1811-FR-Coco-3.5 Seater-Columbus Evergreen.png',
  'KCOS35B-O1811-SI':'KCOS35B-O1811-SI-Coco-3.5 Seater-Columbus Evergreen.png',
  'KCOS35B-O1821-FR':'KCOS35B-O1821-FR-Coco-3.5 Seater-Columbus Evergreen.jpg',
  'KCOS35B-O1911-FR':'KCOS35B-O1911-FR-Coco-3.5 Seater-Columbus Marigold.png',
  'KCOS35B-O1911-SI':'KCOS35B-O1911-SI-Coco-3.5 Seater-Columbus Marigold.png',
  'KCOS35B-O1921-FR':'KCOS35B-O1921-FR-Coco-3.5 Seater-Columbus Marigold.jpg',
  'KCOS35B-O2011-FR':'KCOS35B-O2011-FR-Coco-3.5 Seater-Columbus Potting Moss.png',
  'KCOS35B-O2011-SI':'KCOS35B-O2011-SI-Coco-3.5 Seater-Columbus Potting Moss.png',
  'KCOS35B-O2021-FR':'KCOS35B-O2021-FR-Coco-3.5 Seater-Columbus Potting Moss.png',
  'KCOS35B-O2111-FR':'KCOS35B-O2111-FR-Coco-3.5 Seater-Columbus Roselette.png',
  'KCOS35B-O2111-SI':'KCOS35B-O2111-SI-Coco-3.5 Seater-Columbus Roselette.png',
  'KCOS35B-O2121-FR':'KCOS35B-O2121-FR-Coco-3.5 Seater-Columbus Roselette.jpg',
  'KCOS35B-O2211-FR':'KCOS35B-O2211-FR-Coco-3.5 Seater-Columbus Sunflower.png',
  'KCOS35B-O2211-SI':'KCOS35B-O2211-SI-Coco-3.5 Seater-Columbus Sunflower.png',
  'KCOS35B-O2221-FR':'KCOS35B-O2221-FR-Coco-3.5 Seater-Columbus Sunflower.jpg',
  'KCOS35K-A0123-FR':'KCOS35K-A0123-FR-Coco-3.5 Seater-Wildwood Duck Egg.png',
  'KCOS35K-A0123-SI':'KCOS35K-A0123-SI-Coco-3.5 Seater-Wildwood Duck Egg.png',
  'KCOS35K-A0223-FR':'KCOS35K-A0223-FR-Coco-3.5 Seater-Wildwood Ivory.png',
  'KCOS35K-A0223-SI':'KCOS35K-A0223-SI-Coco-3.5 Seater-Wildwood Ivory.png',
  'KCOS35K-A0225-FR':'KCOS35K-A0225-FR-Coco-3.5 Seater-Wildwood Ivory.jpg',
  'KCOS35K-A0323-FR':'KCOS35K-A0323-FR-Coco-3.5 Seater-Wildwood Twig.jpg',
  'KCOS35K-A0421-FR':'KCOS35K-A0421-FR-Coco-3.5 Seater-Peony Summer Sky.jpg',
  'KCOS35K-A0521-FR':'KCOS35K-A0521-FR-Coco-3.5 Seater-Midsummer Sky.jpg',
  'KCOS35K-A0621-FR':'KCOS35K-A0621-FR-Coco-3.5 Seater-Midsummer Stone.jpg',
  'KCOS35K-A0725-FR':'KCOS35K-A0725-FR-Coco-3.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS35K-A07X1-FR':'KCOS35K-A07X1-FR-Coco-3.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS35K-A0821-FR':'KCOS35K-A0821-FR-Coco-3.5 Seater-Otter Denim.jpg',
  'KCOS35K-A0921-FR':'KCOS35K-A0921-FR-Coco-3.5 Seater-Pelham Clementine.jpg',
  'KCOS35K-A1021-FR':'KCOS35K-A1021-FR-Coco-3.5 Seater-Pelham Moss.png',
  'KCOS35K-A1021-SI':'KCOS35K-A1021-SI-Coco-3.5 Seater-Pelham Moss.png',
  'KCOS35K-A1121-FR':'KCOS35K-A1121-FR-Coco-3.5 Seater-Pelham Denim.jpg',
  'KCOS35K-A1221-FR':'KCOS35K-A1221-FR-Coco-3.5 Seater-Pelham Peacock.jpg',
  'KCOS35K-A1321-FR':'KCOS35K-A1321-FR-Coco-3.5 Seater-Las Salinas Las Salinas 4.jpg',
  'KCOS35K-B0121-FR':'KCOS35K-B0121-FR-Coco-3.5 Seater-Beatrice Barley.jpg',
  'KCOS35K-B0221-FR':'KCOS35K-B0221-FR-Coco-3.5 Seater-Beatrice Camelia.jpg',
  'KCOS35K-B0321-FR':'KCOS35K-B0321-FR-Coco-3.5 Seater-Beatrice Midnight.jpg',
  'KCOS35K-B0421-FR':'KCOS35K-B0421-FR-Coco-3.5 Seater-Beatrice Nutmeg.jpg',
  'KCOS35K-B0521-FR':'KCOS35K-B0521-FR-Coco-3.5 Seater-Beatrice Olive.png',
  'KCOS35K-B0521-SI':'KCOS35K-B0521-SI-Coco-3.5 Seater-Beatrice Olive.png',
  'KCOS35K-C0121-FR':'KCOS35K-C0121-FR-Coco-3.5 Seater-Berrington.jpg',
  'KCOS35K-D0121-FR':'KCOS35K-D0121-FR-Coco-3.5 Seater-Varese Fuchsia.jpg',
  'KCOS35K-D0321-FR':'KCOS35K-D0321-FR-Coco-3.5 Seater-Varese Alchemilla.jpg',
  'KCOS35K-D0521-FR':'KCOS35K-D0521-FR-Coco-3.5 Seater-Varese Grass.jpg',
  'KCOS35K-D0621-FR':'KCOS35K-D0621-FR-Coco-3.5 Seater-Brera Lino Cerise.jpg',
  'KCOS35K-D0721-FR':'KCOS35K-D0721-FR-Coco-3.5 Seater-Brera Lino Chalk.jpg',
  'KCOS35K-G0423-FR':'KCOS35K-G0423-FR-Coco-3.5 Seater-Magnolia Cream Blue.png',
  'KCOS35K-G0423-SI':'KCOS35K-G0423-SI-Coco-3.5 Seater-Magnolia Cream Blue.png',
  'KCOS35K-G0523-FR':'KCOS35K-G0523-FR-Coco-3.5 Seater-Little Magnolia Pink orange.jpg',
  'KCOS35K-G0621-FR':'KCOS35K-G0621-FR-Coco-3.5 Seater-Little Magnolia Espresso.jpg',
  'KCOS35K-G0721-FR':'KCOS35K-G0721-FR-Coco-3.5 Seater-Little Magnolia Emerald.jpg',
  'KCOS35K-L0123-FR':'KCOS35K-L0123-FR-Coco-3.5 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS35K-L0223-FR':'KCOS35K-L0223-FR-Coco-3.5 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS35K-L0323-FR':'KCOS35K-L0323-FR-Coco-3.5 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS35K-L0423-FR':'KCOS35K-L0423-FR-Coco-3.5 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS35K-L0523-FR':'KCOS35K-L0523-FR-Coco-3.5 Seater-English Garden - Albertine Classic Rose.png',
  'KCOS35K-L0623-FR':'KCOS35K-L0623-FR-Coco-3.5 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS35K-L0921-FR':'KCOS35K-L0921-FR-Coco-3.5 Seater-Omega Carnelian.jpg',
  'KCOS35K-L1121-FR':'KCOS35K-L1121-FR-Coco-3.5 Seater-Omega Lagoon.jpg',
  'KCOS35K-L1221-FR':'KCOS35K-L1221-FR-Coco-3.5 Seater-Omega Rosewood.jpg',
  'KCOS35K-L1421-FR':'KCOS35K-L1421-FR-Coco-3.5 Seater-Omega Pine.jpg',
  'KCOS35K-L1721-FR':'KCOS35K-L1721-FR-Coco-3.5 Seater-Omega Parakeet.jpg',
  'KCOS35K-L1821-FR':'KCOS35K-L1821-FR-Coco-3.5 Seater-Elba Cerulean.jpg',
  'KCOS35K-L1921-FR':'KCOS35K-L1921-FR-Coco-3.5 Seater-Elba Hemp.jpg',
  'KCOS35K-L2021-FR':'KCOS35K-L2021-FR-Coco-3.5 Seater-Elba Midnight.jpg',
  'KCOS35K-L2121-FR':'KCOS35K-L2121-FR-Coco-3.5 Seater-Elba Sage.jpg',
  'KCOS35K-O0121-FR':'KCOS35K-O0121-FR-Coco-3.5 Seater-Bespoke Coastal Blue.png',
  'KCOS35K-O0121-SI':'KCOS35K-O0121-SI-Coco-3.5 Seater-Bespoke Coastal Blue.png',
  'KCOS35K-O0221-FR':'KCOS35K-O0221-FR-Coco-3.5 Seater-Tasman Petunia.png',
  'KCOS35K-O0221-SI':'KCOS35K-O0221-SI-Coco-3.5 Seater-Tasman Petunia.png',
  'KCOS35K-O0421-FR':'KCOS35K-O0421-FR-Coco-3.5 Seater-Bespoke Caramel.jpg',
  'KCOS35K-O0521-FR':'KCOS35K-O0521-FR-Coco-3.5 Seater-Tasman Sea Holly.jpg',
  'KCOS35K-O0621-FR':'KCOS35K-O0621-FR-Coco-3.5 Seater-Tasman Garden Grey.png',
  'KCOS35K-O0621-SI':'KCOS35K-O0621-SI-Coco-3.5 Seater-Tasman Garden Grey.png',
  'KCOS35K-O0721-FR':'KCOS35K-O0721-FR-Coco-3.5 Seater-Tasman Dandelion.png',
  'KCOS35K-O0721-SI':'KCOS35K-O0721-SI-Coco-3.5 Seater-Tasman Dandelion.png',
  'KCOS35K-O0821-FR':'KCOS35K-O0821-FR-Coco-3.5 Seater-Tasman Spring Green.png',
  'KCOS35K-O0821-SI':'KCOS35K-O0821-SI-Coco-3.5 Seater-Tasman Spring Green.png',
  'KCOS35K-O0921-FR':'KCOS35K-O0921-FR-Coco-3.5 Seater-Tasman Cornish Blue.jpg',
  'KCOS35K-O1021-FR':'KCOS35K-O1021-FR-Coco-3.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS35K-O1021-SI':'KCOS35K-O1021-SI-Coco-3.5 Seater-Antarctic Narrow Chocolate.png',
  'KCOS35K-O1121-FR':'KCOS35K-O1121-FR-Coco-3.5 Seater-Tasman Chocolate.png',
  'KCOS35K-O1121-SI':'KCOS35K-O1121-SI-Coco-3.5 Seater-Tasman Chocolate.png',
  'KCOS35K-O1321-FR':'KCOS35K-O1321-FR-Coco-3.5 Seater-Capelo Cool Coconut.png',
  'KCOS35K-O1321-SI':'KCOS35K-O1321-SI-Coco-3.5 Seater-Capelo Cool Coconut.png',
  'KCOS35K-O1416-FR':'KCOS35K-O1416-FR-Coco-3.5 Seater-Capelo Snow Drop.jpg',
  'KCOS35K-O1421-FR':'KCOS35K-O1421-FR-Coco-3.5 Seater-Capelo Snow Drop.png',
  'KCOS35K-O1421-SI':'KCOS35K-O1421-SI-Coco-3.5 Seater-Capelo Snow Drop.png',
  'KCOS35K-O1425-FR':'KCOS35K-O1425-FR-Coco-3.5 Seater-Capelo Snow Drop.jpg',
  'KCOS35K-O1521-FR':'KCOS35K-O1521-FR-Coco-3.5 Seater-Capelo Sea Salt.jpg',
  'KCOS35K-O1621-FR':'KCOS35K-O1621-FR-Coco-3.5 Seater-Capelo Rosedale.jpg',
  'KCOS35K-O1721-FR':'KCOS35K-O1721-FR-Coco-3.5 Seater-Capelo Inkspot.jpg',
  'KCOS35K-O1821-FR':'KCOS35K-O1821-FR-Coco-3.5 Seater-Columbus Evergreen.jpg',
  'KCOS35K-O1921-FR':'KCOS35K-O1921-FR-Coco-3.5 Seater-Columbus Marigold.jpg',
  'KCOS35K-O2021-FR':'KCOS35K-O2021-FR-Coco-3.5 Seater-Columbus Potting Moss.jpg',
  'KCOS35K-O2121-FR':'KCOS35K-O2121-FR-Coco-3.5 Seater-Columbus Roselette.jpg',
  'KCOS35K-O2221-FR':'KCOS35K-O2221-FR-Coco-3.5 Seater-Columbus Sunflower.jpg',
  'KCOS40B-A0113-FR':'KCOS40B-A0113-FR-Coco-4 Seater-Wildwood Duck Egg.jpg',
  'KCOS40B-A0113-SI':'KCOS40B-A0113-SI-Coco-4 Seater-Wildwood Duck Egg.png',
  'KCOS40B-A0122-FR':'KCOS40B-A0122-FR-Coco-4 Seater-Wildwood Duck Egg.jpg',
  'KCOS40B-A0123-FR':'KCOS40B-A0123-FR-Coco-4 Seater-Wildwood Duck Egg.jpg',
  'KCOS40B-A0213-FR':'KCOS40B-A0213-FR-Coco-4 Seater-Wildwood Ivory.jpg',
  'KCOS40B-A0213-SI':'KCOS40B-A0213-SI-Coco-4 Seater-Wildwood Ivory.png',
  'KCOS40B-A0222-FR':'KCOS40B-A0222-FR-Coco-4 Seater-Wildwood Ivory.jpg',
  'KCOS40B-A0223-FR':'KCOS40B-A0223-FR-Coco-4 Seater-Wildwood Ivory.jpg',
  'KCOS40B-A0313-FR':'KCOS40B-A0313-FR-Coco-4 Seater-Wildwood Twig.png',
  'KCOS40B-A0313-SI':'KCOS40B-A0313-SI-Coco-4 Seater-Wildwood Twig.png',
  'KCOS40B-A0323-FR':'KCOS40B-A0323-FR-Coco-4 Seater-Wildwood Twig.jpg',
  'KCOS40B-A0411-FR':'KCOS40B-A0411-FR-Coco-4 Seater-Peony Summer Sky.png',
  'KCOS40B-A0411-SI':'KCOS40B-A0411-SI-Coco-4 Seater-Peony Summer Sky.png',
  'KCOS40B-A0421-FR':'KCOS40B-A0421-FR-Coco-4 Seater-Peony Summer Sky.jpg',
  'KCOS40B-A0511-FR':'KCOS40B-A0511-FR-Coco-4 Seater-Midsummer Sky.jpg',
  'KCOS40B-A0511-SI':'KCOS40B-A0511-SI-Coco-4 Seater-Midsummer Sky.png',
  'KCOS40B-A0521-FR':'KCOS40B-A0521-FR-Coco-4 Seater-Midsummer Sky.jpg',
  'KCOS40B-A0611-FR':'KCOS40B-A0611-FR-Coco-4 Seater-Midsummer Stone.png',
  'KCOS40B-A0611-SI':'KCOS40B-A0611-SI-Coco-4 Seater-Midsummer Stone.png',
  'KCOS40B-A0621-FR':'KCOS40B-A0621-FR-Coco-4 Seater-Midsummer Stone.jpg',
  'KCOS40B-A0711-FR':'KCOS40B-A0711-FR-Coco-4 Seater-Midsummer Faded Blue.png',
  'KCOS40B-A0711-SI':'KCOS40B-A0711-SI-Coco-4 Seater-Midsummer Faded Blue.png',
  'KCOS40B-A0721-FR':'KCOS40B-A0721-FR-Coco-4 Seater-Midsummer Faded Blue.jpg',
  'KCOS40B-A07X1-FR':'KCOS40B-A07X1-FR-Coco-4 Seater-Midsummer Faded Blue.jpg',
  'KCOS40B-A0811-FR':'KCOS40B-A0811-FR-Coco-4 Seater-Otter Denim.png',
  'KCOS40B-A0811-SI':'KCOS40B-A0811-SI-Coco-4 Seater-Otter Denim.png',
  'KCOS40B-A0821-FR':'KCOS40B-A0821-FR-Coco-4 Seater-Otter Denim.jpg',
  'KCOS40B-A0911-FR':'KCOS40B-A0911-FR-Coco-4 Seater-Pelham Clementine.png',
  'KCOS40B-A0911-SI':'KCOS40B-A0911-SI-Coco-4 Seater-Pelham Clementine.png',
  'KCOS40B-A0921-FR':'KCOS40B-A0921-FR-Coco-4 Seater-Pelham Clementine.jpg',
  'KCOS40B-A1011-FR':'KCOS40B-A1011-FR-Coco-4 Seater-Pelham Moss.jpg',
  'KCOS40B-A1021-FR':'KCOS40B-A1021-FR-Coco-4 Seater-Pelham Moss.jpg',
  'KCOS40B-A1111-FR':'KCOS40B-A1111-FR-Coco-4 Seater-Pelham Denim.png',
  'KCOS40B-A1111-SI':'KCOS40B-A1111-SI-Coco-4 Seater-Pelham Denim.png',
  'KCOS40B-A1121-FR':'KCOS40B-A1121-FR-Coco-4 Seater-Pelham Denim.jpg',
  'KCOS40B-A1211-FR':'KCOS40B-A1211-FR-Coco-4 Seater-Pelham Peacock.jpg',
  'KCOS40B-A1211-SI':'KCOS40B-A1211-SI-Coco-4 Seater-Pelham Peacock.png',
  'KCOS40B-A1221-FR':'KCOS40B-A1221-FR-Coco-4 Seater-Pelham Peacock.jpg',
  'KCOS40B-A1311-FR':'KCOS40B-A1311-FR-Coco-4 Seater-Las Salinas Las Salinas 4.png',
  'KCOS40B-A1311-SI':'KCOS40B-A1311-SI-Coco-4 Seater-Las Salinas Las Salinas 4.png',
  'KCOS40B-B0111-FR':'KCOS40B-B0111-FR-Coco-4 Seater-Beatrice Barley.jpg',
  'KCOS40B-B0121-FR':'KCOS40B-B0121-FR-Coco-4 Seater-Beatrice Barley.jpg',
  'KCOS40B-B0211-FR':'KCOS40B-B0211-FR-Coco-4 Seater-Beatrice Camelia.png',
  'KCOS40B-B0221-FR':'KCOS40B-B0221-FR-Coco-4 Seater-Beatrice Camelia.jpg',
  'KCOS40B-B0311-FR':'KCOS40B-B0311-FR-Coco-4 Seater-Beatrice Midnight.jpg',
  'KCOS40B-B0321-FR':'KCOS40B-B0321-FR-Coco-4 Seater-Beatrice Midnight.jpg',
  'KCOS40B-B0411-FR':'KCOS40B-B0411-FR-Coco-4 Seater-Beatrice Nutmeg.jpg',
  'KCOS40B-B0421-FR':'KCOS40B-B0421-FR-Coco-4 Seater-Beatrice Nutmeg.jpg',
  'KCOS40B-B0511-FR':'KCOS40B-B0511-FR-Coco-4 Seater-Beatrice Olive.jpg',
  'KCOS40B-B0521-FR':'KCOS40B-B0521-FR-Coco-4 Seater-Beatrice Olive.jpg',
  'KCOS40B-B0621-FR':'KCOS40B-B0621-FR-Coco-4 Seater-Froisse Cerulean.jpg',
  'KCOS40B-B0721-FR':'KCOS40B-B0721-FR-Coco-4 Seater-Froisse Chalk.jpg',
  'KCOS40B-B0821-FR':'KCOS40B-B0821-FR-Coco-4 Seater-Froisse Hemp.jpg',
  'KCOS40B-B0921-FR':'KCOS40B-B0921-FR-Coco-4 Seater-Froisse Khaki.jpg',
  'KCOS40B-B1021-FR':'KCOS40B-B1021-FR-Coco-4 Seater-Froisse Mole.jpg',
  'KCOS40B-B1121-FR':'KCOS40B-B1121-FR-Coco-4 Seater-Froisse Pebble.jpg',
  'KCOS40B-B1221-FR':'KCOS40B-B1221-FR-Coco-4 Seater-Froisse Putty.jpg',
  'KCOS40B-B1321-FR':'KCOS40B-B1321-FR-Coco-4 Seater-Froisse Sisal.jpg',
  'KCOS40B-C0111-FR':'KCOS40B-C0111-FR-Coco-4 Seater-Berrington.jpg',
  'KCOS40B-C0121-FR':'KCOS40B-C0121-FR-Coco-4 Seater-Berrington.jpg',
  'KCOS40B-D0111-FR':'KCOS40B-D0111-FR-Coco-4 Seater-Varese Fuchsia.jpg',
  'KCOS40B-D0121-FR':'KCOS40B-D0121-FR-Coco-4 Seater-Varese Fuchsia.jpg',
  'KCOS40B-D0311-FR':'KCOS40B-D0311-FR-Coco-4 Seater-Varese Alchemilla.jpg',
  'KCOS40B-D0321-FR':'KCOS40B-D0321-FR-Coco-4 Seater-Varese Alchemilla.jpg',
  'KCOS40B-D0511-FR':'KCOS40B-D0511-FR-Coco-4 Seater-Varese Grass.jpg',
  'KCOS40B-D0521-FR':'KCOS40B-D0521-FR-Coco-4 Seater-Varese Grass.jpg',
  'KCOS40B-D0611-FR':'KCOS40B-D0611-FR-Coco-4 Seater-Brera Lino Cerise.jpg',
  'KCOS40B-D0621-FR':'KCOS40B-D0621-FR-Coco-4 Seater-Brera Lino Cerise.jpg',
  'KCOS40B-D0711-FR':'KCOS40B-D0711-FR-Coco-4 Seater-Brera Lino Chalk.jpg',
  'KCOS40B-D0721-FR':'KCOS40B-D0721-FR-Coco-4 Seater-Brera Lino Chalk.jpg',
  'KCOS40B-D0821-FR':'KCOS40B-D0821-FR-Coco-4 Seater-Brera Lino Putty.jpg',
  'KCOS40B-G0111-FR':'KCOS40B-G0111-FR-Coco-4 Seater-Nympheus Teal green.jpg',
  'KCOS40B-G0121-FR':'KCOS40B-G0121-FR-Coco-4 Seater-Nympheus Teal green.jpg',
  'KCOS40B-G0211-FR':'KCOS40B-G0211-FR-Coco-4 Seater-Nympheus Stone pistachio.jpg',
  'KCOS40B-G0221-FR':'KCOS40B-G0221-FR-Coco-4 Seater-Nympheus Stone pistachio.jpg',
  'KCOS40B-G0311-FR':'KCOS40B-G0311-FR-Coco-4 Seater-Nympheus Aqua teal.jpg',
  'KCOS40B-G0321-FR':'KCOS40B-G0321-FR-Coco-4 Seater-Nympheus Aqua teal.jpg',
  'KCOS40B-G0423-FR':'KCOS40B-G0423-FR-Coco-4 Seater-Magnolia Cream Blue.jpg',
  'KCOS40B-G0513-FR':'KCOS40B-G0513-FR-Coco-4 Seater-Little Magnolia Pink orange.jpg',
  'KCOS40B-G0523-FR':'KCOS40B-G0523-FR-Coco-4 Seater-Little Magnolia Pink orange.jpg',
  'KCOS40B-G0611-FR':'KCOS40B-G0611-FR-Coco-4 Seater-Little Magnolia Espresso.jpg',
  'KCOS40B-G0621-FR':'KCOS40B-G0621-FR-Coco-4 Seater-Little Magnolia Espresso.jpg',
  'KCOS40B-G0711-FR':'KCOS40B-G0711-FR-Coco-4 Seater-Little Magnolia Emerald.jpg',
  'KCOS40B-G0721-FR':'KCOS40B-G0721-FR-Coco-4 Seater-Little Magnolia Emerald.jpg',
  'KCOS40B-J0121-FR':'KCOS40B-J0121-FR-Coco-4 Seater-Boho Cloud.jpg',
  'KCOS40B-J0221-FR':'KCOS40B-J0221-FR-Coco-4 Seater-Boho Denim.jpg',
  'KCOS40B-J0321-FR':'KCOS40B-J0321-FR-Coco-4 Seater-Boho Parchment.jpg',
  'KCOS40B-L0113-FR':'KCOS40B-L0113-FR-Coco-4 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS40B-L0113-SI':'KCOS40B-L0113-SI-Coco-4 Seater-English Garden - Kitty Spring Green.png',
  'KCOS40B-L0123-FR':'KCOS40B-L0123-FR-Coco-4 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS40B-L0213-FR':'KCOS40B-L0213-FR-Coco-4 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS40B-L0223-FR':'KCOS40B-L0223-FR-Coco-4 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS40B-L0313-FR':'KCOS40B-L0313-FR-Coco-4 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS40B-L0323-FR':'KCOS40B-L0323-FR-Coco-4 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS40B-L0413-FR':'KCOS40B-L0413-FR-Coco-4 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS40B-L0423-FR':'KCOS40B-L0423-FR-Coco-4 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS40B-L0513-FR':'KCOS40B-L0513-FR-Coco-4 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS40B-L0523-FR':'KCOS40B-L0523-FR-Coco-4 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS40B-L0613-FR':'KCOS40B-L0613-FR-Coco-4 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS40B-L0623-FR':'KCOS40B-L0623-FR-Coco-4 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS40B-L0713-FR':'KCOS40B-L0713-FR-Coco-4 Seater-Belleville - Miji Juniper.jpg',
  'KCOS40B-L0723-FR':'KCOS40B-L0723-FR-Coco-4 Seater-Belleville - Miji Juniper.jpg',
  'KCOS40B-L0911-FR':'KCOS40B-L0911-FR-Coco-4 Seater-Omega Carnelian.jpg',
  'KCOS40B-L0921-FR':'KCOS40B-L0921-FR-Coco-4 Seater-Omega Carnelian.jpg',
  'KCOS40B-L1011-FR':'KCOS40B-L1011-FR-Coco-4 Seater-Omega Pastel Blue.jpg',
  'KCOS40B-L1021-FR':'KCOS40B-L1021-FR-Coco-4 Seater-Omega Pastel Blue.jpg',
  'KCOS40B-L1111-FR':'KCOS40B-L1111-FR-Coco-4 Seater-Omega Lagoon.jpg',
  'KCOS40B-L1121-FR':'KCOS40B-L1121-FR-Coco-4 Seater-Omega Lagoon.jpg',
  'KCOS40B-L1211-FR':'KCOS40B-L1211-FR-Coco-4 Seater-Omega Rosewood.jpg',
  'KCOS40B-L1221-FR':'KCOS40B-L1221-FR-Coco-4 Seater-Omega Rosewood.jpg',
  'KCOS40B-L1321-FR':'KCOS40B-L1321-FR-Coco-4 Seater-Omega Winter Moss.jpg',
  'KCOS40B-L1411-FR':'KCOS40B-L1411-FR-Coco-4 Seater-Omega Pine.jpg',
  'KCOS40B-L1421-FR':'KCOS40B-L1421-FR-Coco-4 Seater-Omega Pine.jpg',
  'KCOS40B-L1621-FR':'KCOS40B-L1621-FR-Coco-4 Seater-Omega Pillar Box.jpg',
  'KCOS40B-L1711-FR':'KCOS40B-L1711-FR-Coco-4 Seater-Omega Parakeet.jpg',
  'KCOS40B-L1721-FR':'KCOS40B-L1721-FR-Coco-4 Seater-Omega Parakeet.jpg',
  'KCOS40B-L1811-FR':'KCOS40B-L1811-FR-Coco-4 Seater-Elba Cerulean.jpg',
  'KCOS40B-L1821-FR':'KCOS40B-L1821-FR-Coco-4 Seater-Elba Cerulean.jpg',
  'KCOS40B-L1911-FR':'KCOS40B-L1911-FR-Coco-4 Seater-Elba Hemp.jpg',
  'KCOS40B-L1921-FR':'KCOS40B-L1921-FR-Coco-4 Seater-Elba Hemp.jpg',
  'KCOS40B-L2011-FR':'KCOS40B-L2011-FR-Coco-4 Seater-Elba Midnight.jpg',
  'KCOS40B-L2021-FR':'KCOS40B-L2021-FR-Coco-4 Seater-Elba Midnight.jpg',
  'KCOS40B-L2111-FR':'KCOS40B-L2111-FR-Coco-4 Seater-Elba Sage.jpg',
  'KCOS40B-L2121-FR':'KCOS40B-L2121-FR-Coco-4 Seater-Elba Sage.jpg',
  'KCOS40B-O0111-FR':'KCOS40B-O0111-FR-Coco-4 Seater-Bespoke Coastal Blue.png',
  'KCOS40B-O0111-SI':'KCOS40B-O0111-SI-Coco-4 Seater-Bespoke Coastal Blue.png',
  'KCOS40B-O0211-FR':'KCOS40B-O0211-FR-Coco-4 Seater-Tasman Petunia.jpg',
  'KCOS40B-O0211-SI':'KCOS40B-O0211-SI-Coco-4 Seater-Tasman Petunia.png',
  'KCOS40B-O0221-FR':'KCOS40B-O0221-FR-Coco-4 Seater-Tasman Petunia.jpg',
  'KCOS40B-O0311-FR':'KCOS40B-O0311-FR-Coco-4 Seater-Bespoke Woodland.jpg',
  'KCOS40B-O0311-SI':'KCOS40B-O0311-SI-Coco-4 Seater-Bespoke Woodland.png',
  'KCOS40B-O0321-FR':'KCOS40B-O0321-FR-Coco-4 Seater-Bespoke Woodland.jpg',
  'KCOS40B-O0411-FR':'KCOS40B-O0411-FR-Coco-4 Seater-Bespoke Caramel.png',
  'KCOS40B-O0411-SI':'KCOS40B-O0411-SI-Coco-4 Seater-Bespoke Caramel.png',
  'KCOS40B-O0511-FR':'KCOS40B-O0511-FR-Coco-4 Seater-Tasman Sea Holly.png',
  'KCOS40B-O0511-SI':'KCOS40B-O0511-SI-Coco-4 Seater-Tasman Sea Holly.png',
  'KCOS40B-O0611-FR':'KCOS40B-O0611-FR-Coco-4 Seater-Tasman Garden Grey.jpg',
  'KCOS40B-O0611-SI':'KCOS40B-O0611-SI-Coco-4 Seater-Tasman Garden Grey.png',
  'KCOS40B-O0621-FR':'KCOS40B-O0621-FR-Coco-4 Seater-Tasman Garden Grey.jpg',
  'KCOS40B-O0711-FR':'KCOS40B-O0711-FR-Coco-4 Seater-Tasman Dandelion.jpg',
  'KCOS40B-O0711-SI':'KCOS40B-O0711-SI-Coco-4 Seater-Tasman Dandelion.png',
  'KCOS40B-O0721-FR':'KCOS40B-O0721-FR-Coco-4 Seater-Tasman Dandelion.jpg',
  'KCOS40B-O0911-FR':'KCOS40B-O0911-FR-Coco-4 Seater-Tasman Cornish Blue.png',
  'KCOS40B-O0911-SI':'KCOS40B-O0911-SI-Coco-4 Seater-Tasman Cornish Blue.png',
  'KCOS40B-O1011-FR':'KCOS40B-O1011-FR-Coco-4 Seater-Antarctic Narrow Chocolate.jpg',
  'KCOS40B-O1011-SI':'KCOS40B-O1011-SI-Coco-4 Seater-Antarctic Narrow Chocolate.png',
  'KCOS40B-O1021-FR':'KCOS40B-O1021-FR-Coco-4 Seater-Antarctic Narrow Chocolate.jpg',
  'KCOS40B-O1111-FR':'KCOS40B-O1111-FR-Coco-4 Seater-Tasman Chocolate.jpg',
  'KCOS40B-O1111-SI':'KCOS40B-O1111-SI-Coco-4 Seater-Tasman Chocolate.png',
  'KCOS40B-O1121-FR':'KCOS40B-O1121-FR-Coco-4 Seater-Tasman Chocolate.jpg',
  'KCOS40B-O1311-FR':'KCOS40B-O1311-FR-Coco-4 Seater-Capelo Cool Coconut.jpg',
  'KCOS40B-O1321-FR':'KCOS40B-O1321-FR-Coco-4 Seater-Capelo Cool Coconut.jpg',
  'KCOS40B-O1411-FR':'KCOS40B-O1411-FR-Coco-4 Seater-Capelo Snow Drop.jpg',
  'KCOS40B-O1411-SI':'KCOS40B-O1411-SI-Coco-4 Seater-Capelo Snow Drop.png',
  'KCOS40B-O1421-FR':'KCOS40B-O1421-FR-Coco-4 Seater-Capelo Snow Drop.jpg',
  'KCOS40B-O1511-FR':'KCOS40B-O1511-FR-Coco-4 Seater-Capelo Sea Salt.png',
  'KCOS40B-O1511-SI':'KCOS40B-O1511-SI-Coco-4 Seater-Capelo Sea Salt.png',
  'KCOS40B-O1521-FR':'KCOS40B-O1521-FR-Coco-4 Seater-Capelo Sea Salt.jpg',
  'KCOS40B-O1611-FR':'KCOS40B-O1611-FR-Coco-4 Seater-Capelo Rosedale.png',
  'KCOS40B-O1611-SI':'KCOS40B-O1611-SI-Coco-4 Seater-Capelo Rosedale.png',
  'KCOS40B-O1621-FR':'KCOS40B-O1621-FR-Coco-4 Seater-Capelo Rosedale.jpg',
  'KCOS40B-O1711-FR':'KCOS40B-O1711-FR-Coco-4 Seater-Capelo Inkspot.jpg',
  'KCOS40B-O1711-SI':'KCOS40B-O1711-SI-Coco-4 Seater-Capelo Inkspot.png',
  'KCOS40B-O1721-FR':'KCOS40B-O1721-FR-Coco-4 Seater-Capelo Inkspot.jpg',
  'KCOS40B-O1811-FR':'KCOS40B-O1811-FR-Coco-4 Seater-Columbus Evergreen.png',
  'KCOS40B-O1811-SI':'KCOS40B-O1811-SI-Coco-4 Seater-Columbus Evergreen.png',
  'KCOS40B-O1821-FR':'KCOS40B-O1821-FR-Coco-4 Seater-Columbus Evergreen.jpg',
  'KCOS40B-O1911-FR':'KCOS40B-O1911-FR-Coco-4 Seater-Columbus Marigold.png',
  'KCOS40B-O1911-SI':'KCOS40B-O1911-SI-Coco-4 Seater-Columbus Marigold.png',
  'KCOS40B-O1921-FR':'KCOS40B-O1921-FR-Coco-4 Seater-Columbus Marigold.jpg',
  'KCOS40B-O2011-FR':'KCOS40B-O2011-FR-Coco-4 Seater-Columbus Potting Moss.png',
  'KCOS40B-O2011-SI':'KCOS40B-O2011-SI-Coco-4 Seater-Columbus Potting Moss.png',
  'KCOS40B-O2021-FR':'KCOS40B-O2021-FR-Coco-4 Seater-Columbus Potting Moss.jpg',
  'KCOS40B-O2111-FR':'KCOS40B-O2111-FR-Coco-4 Seater-Columbus Roselette.png',
  'KCOS40B-O2111-SI':'KCOS40B-O2111-SI-Coco-4 Seater-Columbus Roselette.png',
  'KCOS40B-O2121-FR':'KCOS40B-O2121-FR-Coco-4 Seater-Columbus Roselette.jpg',
  'KCOS40B-O2211-FR':'KCOS40B-O2211-FR-Coco-4 Seater-Columbus Sunflower.png',
  'KCOS40B-O2211-SI':'KCOS40B-O2211-SI-Coco-4 Seater-Columbus Sunflower.png',
  'KCOS40B-O2221-FR':'KCOS40B-O2221-FR-Coco-4 Seater-Columbus Sunflower.jpg',
  'KCOS40K-A0123-FR':'KCOS40K-A0123-FR-Coco-4 Seater-Wildwood Duck Egg.png',
  'KCOS40K-A0123-SI':'KCOS40K-A0123-SI-Coco-4 Seater-Wildwood Duck Egg.png',
  'KCOS40K-A0223-FR':'KCOS40K-A0223-FR-Coco-4 Seater-Wildwood Ivory.png',
  'KCOS40K-A0223-SI':'KCOS40K-A0223-SI-Coco-4 Seater-Wildwood Ivory.png',
  'KCOS40K-A0225-FR':'KCOS40K-A0225-FR-Coco-4 Seater-Wildwood Ivory.jpg',
  'KCOS40K-A0323-FR':'KCOS40K-A0323-FR-Coco-4 Seater-Wildwood Twig.jpg',
  'KCOS40K-A0621-FR':'KCOS40K-A0621-FR-Coco-4 Seater-Midsummer Stone.jpg',
  'KCOS40K-A0725-FR':'KCOS40K-A0725-FR-Coco-4 Seater-Midsummer Faded Blue.jpg',
  'KCOS40K-A07X1-FR':'KCOS40K-A07X1-FR-Coco-4 Seater-Midsummer Faded Blue.jpg',
  'KCOS40K-A0821-FR':'KCOS40K-A0821-FR-Coco-4 Seater-Otter Denim.jpg',
  'KCOS40K-A0921-FR':'KCOS40K-A0921-FR-Coco-4 Seater-Pelham Clementine.jpg',
  'KCOS40K-A1021-FR':'KCOS40K-A1021-FR-Coco-4 Seater-Pelham Moss.png',
  'KCOS40K-A1021-SI':'KCOS40K-A1021-SI-Coco-4 Seater-Pelham Moss.png',
  'KCOS40K-A1121-FR':'KCOS40K-A1121-FR-Coco-4 Seater-Pelham Denim.jpg',
  'KCOS40K-A1221-FR':'KCOS40K-A1221-FR-Coco-4 Seater-Pelham Peacock.jpg',
  'KCOS40K-A1321-FR':'KCOS40K-A1321-FR-Coco-4 Seater-Las Salinas Las Salinas 4.jpg',
  'KCOS40K-B0121-FR':'KCOS40K-B0121-FR-Coco-4 Seater-Beatrice Barley.jpg',
  'KCOS40K-B0221-FR':'KCOS40K-B0221-FR-Coco-4 Seater-Beatrice Camelia.jpg',
  'KCOS40K-B0321-FR':'KCOS40K-B0321-FR-Coco-4 Seater-Beatrice Midnight.jpg',
  'KCOS40K-B0421-FR':'KCOS40K-B0421-FR-Coco-4 Seater-Beatrice Nutmeg.jpg',
  'KCOS40K-B0521-FR':'KCOS40K-B0521-FR-Coco-4 Seater-Beatrice Olive.png',
  'KCOS40K-B0521-SI':'KCOS40K-B0521-SI-Coco-4 Seater-Beatrice Olive.png',
  'KCOS40K-C0121-FR':'KCOS40K-C0121-FR-Coco-4 Seater-Berrington.jpg',
  'KCOS40K-D0121-FR':'KCOS40K-D0121-FR-Coco-4 Seater-Varese Fuchsia.jpg',
  'KCOS40K-D0321-FR':'KCOS40K-D0321-FR-Coco-4 Seater-Varese Alchemilla.jpg',
  'KCOS40K-D0521-FR':'KCOS40K-D0521-FR-Coco-4 Seater-Varese Grass.jpg',
  'KCOS40K-D0621-FR':'KCOS40K-D0621-FR-Coco-4 Seater-Brera Lino Cerise.jpg',
  'KCOS40K-D0721-FR':'KCOS40K-D0721-FR-Coco-4 Seater-Brera Lino Chalk.jpg',
  'KCOS40K-G0423-FR':'KCOS40K-G0423-FR-Coco-4 Seater-Magnolia Cream Blue.png',
  'KCOS40K-G0423-SI':'KCOS40K-G0423-SI-Coco-4 Seater-Magnolia Cream Blue.png',
  'KCOS40K-G0523-FR':'KCOS40K-G0523-FR-Coco-4 Seater-Little Magnolia Pink orange.jpg',
  'KCOS40K-G0621-FR':'KCOS40K-G0621-FR-Coco-4 Seater-Little Magnolia Espresso.jpg',
  'KCOS40K-G0721-FR':'KCOS40K-G0721-FR-Coco-4 Seater-Little Magnolia Emerald.jpg',
  'KCOS40K-L0123-FR':'KCOS40K-L0123-FR-Coco-4 Seater-English Garden - Kitty Spring Green.jpg',
  'KCOS40K-L0223-FR':'KCOS40K-L0223-FR-Coco-4 Seater-English Garden - Kitty Blue Green.jpg',
  'KCOS40K-L0323-FR':'KCOS40K-L0323-FR-Coco-4 Seater-English Garden - Kitty Indian Summer.jpg',
  'KCOS40K-L0423-FR':'KCOS40K-L0423-FR-Coco-4 Seater-English Garden - Albertine Grey Skies.jpg',
  'KCOS40K-L0523-FR':'KCOS40K-L0523-FR-Coco-4 Seater-English Garden - Albertine Classic Rose.jpg',
  'KCOS40K-L0623-FR':'KCOS40K-L0623-FR-Coco-4 Seater-English Garden - Albertine Coral Orange.jpg',
  'KCOS40K-L1121-FR':'KCOS40K-L1121-FR-Coco-4 Seater-Omega Lagoon.jpg',
  'KCOS40K-L1221-FR':'KCOS40K-L1221-FR-Coco-4 Seater-Omega Rosewood.jpg',
  'KCOS40K-L1821-FR':'KCOS40K-L1821-FR-Coco-4 Seater-Elba Cerulean.jpg',
  'KCOS40K-L2021-FR':'KCOS40K-L2021-FR-Coco-4 Seater-Elba Midnight.jpg',
  'KCOS40K-L2121-FR':'KCOS40K-L2121-FR-Coco-4 Seater-Elba Sage.jpg',
  'KCOS40K-O0121-FR':'KCOS40K-O0121-FR-Coco-4 Seater-Bespoke Coastal Blue.jpg',
  'KCOS40K-O0221-FR':'KCOS40K-O0221-FR-Coco-4 Seater-Tasman Petunia.png',
  'KCOS40K-O0221-SI':'KCOS40K-O0221-SI-Coco-4 Seater-Tasman Petunia.png',
  'KCOS40K-O0521-FR':'KCOS40K-O0521-FR-Coco-4 Seater-Tasman Sea Holly.jpg',
  'KCOS40K-O0621-FR':'KCOS40K-O0621-FR-Coco-4 Seater-Tasman Garden Grey.png',
  'KCOS40K-O0621-SI':'KCOS40K-O0621-SI-Coco-4 Seater-Tasman Garden Grey.png',
  'KCOS40K-O0721-FR':'KCOS40K-O0721-FR-Coco-4 Seater-Tasman Dandelion.png',
  'KCOS40K-O0721-SI':'KCOS40K-O0721-SI-Coco-4 Seater-Tasman Dandelion.png',
  'KCOS40K-O0821-FR':'KCOS40K-O0821-FR-Coco-4 Seater-Tasman Spring Green.png',
  'KCOS40K-O0821-SI':'KCOS40K-O0821-SI-Coco-4 Seater-Tasman Spring Green.png',
  'KCOS40K-O0921-FR':'KCOS40K-O0921-FR-Coco-4 Seater-Tasman Cornish Blue.jpg',
  'KCOS40K-O1021-FR':'KCOS40K-O1021-FR-Coco-4 Seater-Antarctic Narrow Chocolate.png',
  'KCOS40K-O1021-SI':'KCOS40K-O1021-SI-Coco-4 Seater-Antarctic Narrow Chocolate.png',
  'KCOS40K-O1121-FR':'KCOS40K-O1121-FR-Coco-4 Seater-Tasman Chocolate.png',
  'KCOS40K-O1121-SI':'KCOS40K-O1121-SI-Coco-4 Seater-Tasman Chocolate.png',
  'KCOS40K-O1321-FR':'KCOS40K-O1321-FR-Coco-4 Seater-Capelo Cool Coconut.png',
  'KCOS40K-O1321-SI':'KCOS40K-O1321-SI-Coco-4 Seater-Capelo Cool Coconut.png',
  'KCOS40K-O1416-FR':'KCOS40K-O1416-FR-Coco-4 Seater-Capelo Snow Drop.jpg',
  'KCOS40K-O1421-FR':'KCOS40K-O1421-FR-Coco-4 Seater-Capelo Snow Drop.png',
  'KCOS40K-O1421-SI':'KCOS40K-O1421-SI-Coco-4 Seater-Capelo Snow Drop.png',
  'KCOS40K-O1425-FR':'KCOS40K-O1425-FR-Coco-4 Seater-Capelo Snow Drop.jpg',
  'KCOS40K-O1521-FR':'KCOS40K-O1521-FR-Coco-4 Seater-Capelo Sea Salt.jpg',
  'KCOS40K-O1621-FR':'KCOS40K-O1621-FR-Coco-4 Seater-Capelo Rosedale.jpg',
  'KCOS40K-O1721-FR':'KCOS40K-O1721-FR-Coco-4 Seater-Capelo Inkspot.jpg',
  'KCOS40K-O1821-FR':'KCOS40K-O1821-FR-Coco-4 Seater-Columbus Evergreen.jpg',
  'KCOS40K-O1921-FR':'KCOS40K-O1921-FR-Coco-4 Seater-Columbus Marigold.jpg',
  'KCOS40K-O2021-FR':'KCOS40K-O2021-FR-Coco-4 Seater-Columbus Potting Moss.jpg',
  'KCOS40K-O2121-FR':'KCOS40K-O2121-FR-Coco-4 Seater-Columbus Roselette.jpg',
  'KCOS40K-O2221-FR':'KCOS40K-O2221-FR-Coco-4 Seater-Columbus Sunflower.jpg',
  'KCOS45B-O1411-FR':'KCOS45B-O1411-FR-Coco-4.5 Seater-Capelo Snow Drop.jpeg',
  'KCOS45B-O1421-FR':'KCOS45B-O1421-FR-Coco-4.5 Seater-Capelo Snow Drop.jpeg',
  'KCOS45K-A0225-FR':'KCOS45K-A0225-FR-Coco-4.5 Seater-Wildwood Ivory.jpg',
  'KCOS45K-A0725-FR':'KCOS45K-A0725-FR-Coco-4.5 Seater-Midsummer Faded Blue.jpg',
  'KCOS45K-O1416-FR':'KCOS45K-O1416-FR-Coco-4.5 Seater-Capelo Snow Drop.jpg',
  'KCOS45K-O1421-FR':'KCOS45K-O1421-FR-Coco-4.5 Seater-Capelo Snow Drop.jpeg',
  'KCOS45K-O1425-FR':'KCOS45K-O1425-FR-Coco-4.5 Seater-Capelo Snow Drop.jpg',
  'KFES10F-A0116-FR':'KFES10F-A0116-FR-Felix-Armchair-Wildwood Duck Egg.png',
  'KFES10F-A0116-SI':'KFES10F-A0116-SI-Felix-Armchair-Wildwood Duck Egg.png',
  'KFES10F-A0216-FR':'KFES10F-A0216-FR-Felix-Armchair-Wildwood Ivory.png',
  'KFES10F-A0216-SI':'KFES10F-A0216-SI-Felix-Armchair-Wildwood Ivory.png',
  'KFES10F-A0726-FR':'KFES10F-A0726-FR-Felix-Armchair-Midsummer Faded Blue.jpg',
  'KFES10F-A1016-FR':'KFES10F-A1016-FR-Felix-Armchair-Pelham Moss.png',
  'KFES10F-A1016-SI':'KFES10F-A1016-SI-Felix-Armchair-Pelham Moss.png',
  'KFES10F-B0326-FR':'KFES10F-B0326-FR-Felix-Armchair-Beatrice Midnight.png',
  'KFES10F-B1216-FR':'KFES10F-B1216-FR-Felix-Armchair-Froisse Putty.png',
  'KFES10F-B1216-SI':'KFES10F-B1216-SI-Felix-Armchair-Froisse Putty.png',
  'KFES10F-G0416-FR':'KFES10F-G0416-FR-Felix-Armchair-Magnolia Cream Blue.png',
  'KFES10F-G0416-SI':'KFES10F-G0416-SI-Felix-Armchair-Magnolia Cream Blue.png',
  'KFES10F-G0626-FR':'KFES10F-G0626-FR-Felix-Armchair-Little Magnolia Espresso.png',
  'KFES10F-G0726-FR':'KFES10F-G0726-FR-Felix-Armchair-Little Magnolia Emerald.png',
  'KFES10F-O0216-FR':'KFES10F-O0216-FR-Felix-Armchair-Tasman Petunia.png',
  'KFES10F-O0216-SI':'KFES10F-O0216-SI-Felix-Armchair-Tasman Petunia.png',
  'KFES10F-O0616-FR':'KFES10F-O0616-FR-Felix-Armchair-Tasman Garden Grey.png',
  'KFES10F-O0616-SI':'KFES10F-O0616-SI-Felix-Armchair-Tasman Garden Grey.png',
  'KFES10F-O0716-FR':'KFES10F-O0716-FR-Felix-Armchair-Tasman Dandelion.png',
  'KFES10F-O0716-SI':'KFES10F-O0716-SI-Felix-Armchair-Tasman Dandelion.png',
  'KFES10F-O1016-FR':'KFES10F-O1016-FR-Felix-Armchair-Antarctic Narrow Chocolate.png',
  'KFES10F-O1016-SI':'KFES10F-O1016-SI-Felix-Armchair-Antarctic Narrow Chocolate.png',
  'KFES10F-O1026-FR':'KFES10F-O1026-FR-Felix-Armchair-Antarctic Narrow Chocolate.png',
  'KFES10F-O1116-FR':'KFES10F-O1116-FR-Felix-Armchair-Tasman Chocolate.png',
  'KFES10F-O1116-SI':'KFES10F-O1116-SI-Felix-Armchair-Tasman Chocolate.png',
  'KFES10F-O1326-FR':'KFES10F-O1326-FR-Felix-Armchair-Capelo Cool Coconut.png',
  'KFES10F-O1416-FR':'KFES10F-O1416-FR-Felix-Armchair-Capelo Snow Drop.png',
  'KFES10F-O1416-SI':'KFES10F-O1416-SI-Felix-Armchair-Capelo Snow Drop.png',
  'KFES10F-O1426-FR':'KFES10F-O1426-FR-Felix-Armchair-Capelo Snow Drop.png',
  'KFES10F-O1726-FR':'KFES10F-O1726-FR-Felix-Armchair-Capelo Inkspot.png',
  'KFES10F-O1826-FR':'KFES10F-O1826-FR-Felix-Armchair-Columbus Evergreen.png',
  'KFES10F-O1926-FR':'KFES10F-O1926-FR-Felix-Armchair-Columbus Marigold.png',
  'KFES10F-O2026-FR':'KFES10F-O2026-FR-Felix-Armchair-Columbus Potting Moss.png',
  'KFES15F-A0116-FR':'KFES15F-A0116-FR-Felix-Loveseat-Wildwood Duck Egg.png',
  'KFES15F-A0116-SI':'KFES15F-A0116-SI-Felix-Loveseat-Wildwood Duck Egg.png',
  'KFES15F-A0216-FR':'KFES15F-A0216-FR-Felix-Loveseat-Wildwood Ivory.png',
  'KFES15F-A0216-SI':'KFES15F-A0216-SI-Felix-Loveseat-Wildwood Ivory.png',
  'KFES15F-A0726-FR':'KFES15F-A0726-FR-Felix-Loveseat-Midsummer Faded Blue.jpg',
  'KFES15F-A1016-FR':'KFES15F-A1016-FR-Felix-Loveseat-Pelham Moss.png',
  'KFES15F-A1016-SI':'KFES15F-A1016-SI-Felix-Loveseat-Pelham Moss.png',
  'KFES15F-B0326-FR':'KFES15F-B0326-FR-Felix-Loveseat-Beatrice Midnight.png',
  'KFES15F-B1216-FR':'KFES15F-B1216-FR-Felix-Loveseat-Froisse Putty.png',
  'KFES15F-B1216-SI':'KFES15F-B1216-SI-Felix-Loveseat-Froisse Putty.png',
  'KFES15F-G0416-FR':'KFES15F-G0416-FR-Felix-Loveseat-Magnolia Cream Blue.png',
  'KFES15F-G0416-SI':'KFES15F-G0416-SI-Felix-Loveseat-Magnolia Cream Blue.png',
  'KFES15F-G0626-FR':'KFES15F-G0626-FR-Felix-Loveseat-Little Magnolia Espresso.png',
  'KFES15F-G0726-FR':'KFES15F-G0726-FR-Felix-Loveseat-Little Magnolia Emerald.png',
  'KFES15F-L0116-FR':'KFES15F-L0116-FR-Felix-Loveseat-English Garden - Kitty Spring Green.jpg',
  'KFES15F-L0116-SI':'KFES15F-L0116-SI-Felix-Loveseat-English Garden - Kitty Spring Green.jpg',
  'KFES15F-O0216-FR':'KFES15F-O0216-FR-Felix-Loveseat-Tasman Petunia.png',
  'KFES15F-O0216-SI':'KFES15F-O0216-SI-Felix-Loveseat-Tasman Petunia.png',
  'KFES15F-O0316-FR':'KFES15F-O0316-FR-Felix-Loveseat-Bespoke Woodland.jpg',
  'KFES15F-O0316-SI':'KFES15F-O0316-SI-Felix-Loveseat-Bespoke Woodland.jpg',
  'KFES15F-O0426-FR':'KFES15F-O0426-FR-Felix-Loveseat-Bespoke Caramel.png',
  'KFES15F-O0616-FR':'KFES15F-O0616-FR-Felix-Loveseat-Tasman Garden Grey.png',
  'KFES15F-O0616-SI':'KFES15F-O0616-SI-Felix-Loveseat-Tasman Garden Grey.png',
  'KFES15F-O0716-FR':'KFES15F-O0716-FR-Felix-Loveseat-Tasman Dandelion.png',
  'KFES15F-O0716-SI':'KFES15F-O0716-SI-Felix-Loveseat-Tasman Dandelion.png',
  'KFES15F-O1016-FR':'KFES15F-O1016-FR-Felix-Loveseat-Antarctic Narrow Chocolate.png',
  'KFES15F-O1016-SI':'KFES15F-O1016-SI-Felix-Loveseat-Antarctic Narrow Chocolate.png',
  'KFES15F-O1026-FR':'KFES15F-O1026-FR-Felix-Loveseat-Antarctic Narrow Chocolate.png',
  'KFES15F-O1116-FR':'KFES15F-O1116-FR-Felix-Loveseat-Tasman Chocolate.png',
  'KFES15F-O1116-SI':'KFES15F-O1116-SI-Felix-Loveseat-Tasman Chocolate.png',
  'KFES15F-O1326-FR':'KFES15F-O1326-FR-Felix-Loveseat-Capelo Cool Coconut.png',
  'KFES15F-O1416-FR':'KFES15F-O1416-FR-Felix-Loveseat-Capelo Snow Drop.png',
  'KFES15F-O1416-SI':'KFES15F-O1416-SI-Felix-Loveseat-Capelo Snow Drop.png',
  'KFES15F-O1426-FR':'KFES15F-O1426-FR-Felix-Loveseat-Capelo Snow Drop.png',
  'KFES15F-O1726-FR':'KFES15F-O1726-FR-Felix-Loveseat-Capelo Inkspot.png',
  'KFES15F-O1826-FR':'KFES15F-O1826-FR-Felix-Loveseat-Columbus Evergreen.png',
  'KFES15F-O1926-FR':'KFES15F-O1926-FR-Felix-Loveseat-Columbus Marigold.png',
  'KFES15F-O2026-FR':'KFES15F-O2026-FR-Felix-Loveseat-Columbus Potting Moss.png',
  'KFES20F-A0116-FR':'KFES20F-A0116-FR-Felix-2 Seater-Wildwood Duck Egg.png',
  'KFES20F-A0116-SI':'KFES20F-A0116-SI-Felix-2 Seater-Wildwood Duck Egg.png',
  'KFES20F-A0216-FR':'KFES20F-A0216-FR-Felix-2 Seater-Wildwood Ivory.png',
  'KFES20F-A0216-SI':'KFES20F-A0216-SI-Felix-2 Seater-Wildwood Ivory.png',
  'KFES20F-A0316-FR':'KFES20F-A0316-FR-Felix-2 Seater-Wildwood Twig.png',
  'KFES20F-A0416-FR':'KFES20F-A0416-FR-Felix-2 Seater-Peony Summer Sky.png',
  'KFES20F-A0516-FR':'KFES20F-A0516-FR-Felix-2 Seater-Midsummer Sky.png',
  'KFES20F-A0616-FR':'KFES20F-A0616-FR-Felix-2 Seater-Midsummer Stone.png',
  'KFES20F-A0726-FR':'KFES20F-A0726-FR-Felix-2 Seater-Midsummer Faded Blue.jpg',
  'KFES20F-A0816-FR':'KFES20F-A0816-FR-Felix-2 Seater-Otter Denim.png',
  'KFES20F-A1016-FR':'KFES20F-A1016-FR-Felix-2 Seater-Pelham Moss.png',
  'KFES20F-A1016-SI':'KFES20F-A1016-SI-Felix-2 Seater-Pelham Moss.png',
  'KFES20F-A1116-FR':'KFES20F-A1116-FR-Felix-2 Seater-Pelham Denim.png',
  'KFES20F-A1316-SI':'KFES20F-A1316-SI-Felix-2 Seater-Las Salinas Las Salinas 4.png',
  'KFES20F-B0216-FR':'KFES20F-B0216-FR-Felix-2 Seater-Beatrice Camelia.png',
  'KFES20F-B0316-FR':'KFES20F-B0316-FR-Felix-2 Seater-Beatrice Midnight.png',
  'KFES20F-B0326-FR':'KFES20F-B0326-FR-Felix-2 Seater-Beatrice Midnight.png',
  'KFES20F-B0616-FR':'KFES20F-B0616-FR-Felix-2 Seater-Froisse Cerulean.png',
  'KFES20F-B0816-FR':'KFES20F-B0816-FR-Felix-2 Seater-Froisse Hemp.png',
  'KFES20F-B1216-FR':'KFES20F-B1216-FR-Felix-2 Seater-Froisse Putty.png',
  'KFES20F-B1216-SI':'KFES20F-B1216-SI-Felix-2 Seater-Froisse Putty.png',
  'KFES20F-D0616-FR':'KFES20F-D0616-FR-Felix-2 Seater-Brera Lino Cerise.png',
  'KFES20F-D0716-FR':'KFES20F-D0716-FR-Felix-2 Seater-Brera Lino Chalk.png',
  'KFES20F-G0416-SI':'KFES20F-G0416-SI-Felix-2 Seater-Magnolia Cream Blue.png',
  'KFES20F-G0516-FR':'KFES20F-G0516-FR-Felix-2 Seater-Little Magnolia Pink orange.png',
  'KFES20F-G0616-FR':'KFES20F-G0616-FR-Felix-2 Seater-Little Magnolia Espresso.png',
  'KFES20F-G0626-FR':'KFES20F-G0626-FR-Felix-2 Seater-Little Magnolia Espresso.png',
  'KFES20F-G0716-FR':'KFES20F-G0716-FR-Felix-2 Seater-Little Magnolia Emerald.png',
  'KFES20F-G0726-FR':'KFES20F-G0726-FR-Felix-2 Seater-Little Magnolia Emerald.png',
  'KFES20F-J0116-FR':'KFES20F-J0116-FR-Felix-2 Seater-Boho Cloud.png',
  'KFES20F-J0316-FR':'KFES20F-J0316-FR-Felix-2 Seater-Boho Parchment.png',
  'KFES20F-L0116-FR':'KFES20F-L0116-FR-Felix-2 Seater-English Garden - Kitty Spring Green.png',
  'KFES20F-L0216-FR':'KFES20F-L0216-FR-Felix-2 Seater-English Garden - Kitty Blue Green.png',
  'KFES20F-L0316-FR':'KFES20F-L0316-FR-Felix-2 Seater-English Garden - Kitty Indian Summer.png',
  'KFES20F-L0416-FR':'KFES20F-L0416-FR-Felix-2 Seater-English Garden - Albertine Grey Skies.png',
  'KFES20F-L0516-FR':'KFES20F-L0516-FR-Felix-2 Seater-English Garden - Albertine Classic Rose.png',
  'KFES20F-L0616-FR':'KFES20F-L0616-FR-Felix-2 Seater-English Garden - Albertine Coral Orange.png',
  'KFES20F-L0916-FR':'KFES20F-L0916-FR-Felix-2 Seater-Omega Carnelian.png',
  'KFES20F-L1216-FR':'KFES20F-L1216-FR-Felix-2 Seater-Omega Rosewood.png',
  'KFES20F-L1716-FR':'KFES20F-L1716-FR-Felix-2 Seater-Omega Parakeet.png',
  'KFES20F-L2116-FR':'KFES20F-L2116-FR-Felix-2 Seater-Elba Sage.png',
  'KFES20F-O0216-FR':'KFES20F-O0216-FR-Felix-2 Seater-Tasman Petunia.png',
  'KFES20F-O0216-SI':'KFES20F-O0216-SI-Felix-2 Seater-Tasman Petunia.png',
  'KFES20F-O0426-FR':'KFES20F-O0426-FR-Felix-2 Seater-Bespoke Caramel.png',
  'KFES20F-O0616-FR':'KFES20F-O0616-FR-Felix-2 Seater-Tasman Garden Grey.png',
  'KFES20F-O0616-SI':'KFES20F-O0616-SI-Felix-2 Seater-Tasman Garden Grey.png',
  'KFES20F-O0716-FR':'KFES20F-O0716-FR-Felix-2 Seater-Tasman Dandelion.png',
  'KFES20F-O0716-SI':'KFES20F-O0716-SI-Felix-2 Seater-Tasman Dandelion.png',
  'KFES20F-O1016-FR':'KFES20F-O1016-FR-Felix-2 Seater-Antarctic Narrow Chocolate.png',
  'KFES20F-O1016-SI':'KFES20F-O1016-SI-Felix-2 Seater-Antarctic Narrow Chocolate.png',
  'KFES20F-O1026-FR':'KFES20F-O1026-FR-Felix-2 Seater-Antarctic Narrow Chocolate.png',
  'KFES20F-O1116-FR':'KFES20F-O1116-FR-Felix-2 Seater-Tasman Chocolate.png',
  'KFES20F-O1116-SI':'KFES20F-O1116-SI-Felix-2 Seater-Tasman Chocolate.png',
  'KFES20F-O1316-FR':'KFES20F-O1316-FR-Felix-2 Seater-Capelo Cool Coconut.png',
  'KFES20F-O1326-FR':'KFES20F-O1326-FR-Felix-2 Seater-Capelo Cool Coconut.png',
  'KFES20F-O1416-FR':'KFES20F-O1416-FR-Felix-2 Seater-Capelo Snow Drop.png',
  'KFES20F-O1416-SI':'KFES20F-O1416-SI-Felix-2 Seater-Capelo Snow Drop.png',
  'KFES20F-O1426-FR':'KFES20F-O1426-FR-Felix-2 Seater-Capelo Snow Drop.png',
  'KFES20F-O1716-FR':'KFES20F-O1716-FR-Felix-2 Seater-Capelo Inkspot.png',
  'KFES20F-O1726-FR':'KFES20F-O1726-FR-Felix-2 Seater-Capelo Inkspot.png',
  'KFES20F-O1816-FR':'KFES20F-O1816-FR-Felix-2 Seater-Columbus Evergreen.png',
  'KFES20F-O1826-FR':'KFES20F-O1826-FR-Felix-2 Seater-Columbus Evergreen.png',
  'KFES20F-O1916-FR':'KFES20F-O1916-FR-Felix-2 Seater-Columbus Marigold.png',
  'KFES20F-O1926-FR':'KFES20F-O1926-FR-Felix-2 Seater-Columbus Marigold.png',
  'KFES20F-O2016-FR':'KFES20F-O2016-FR-Felix-2 Seater-Columbus Potting Moss.png',
  'KFES20F-O2026-FR':'KFES20F-O2026-FR-Felix-2 Seater-Columbus Potting Moss.png',
  'KFES25F-A0116-FR':'KFES25F-A0116-FR-Felix-2.5 Seater-Wildwood Duck Egg.png',
  'KFES25F-A0116-SI':'KFES25F-A0116-SI-Felix-2.5 Seater-Wildwood Duck Egg.png',
  'KFES25F-A0216-FR':'KFES25F-A0216-FR-Felix-2.5 Seater-Wildwood Ivory.png',
  'KFES25F-A0216-SI':'KFES25F-A0216-SI-Felix-2.5 Seater-Wildwood Ivory.png',
  'KFES25F-A0726-FR':'KFES25F-A0726-FR-Felix-2.5 Seater-Midsummer Faded Blue.jpg',
  'KFES25F-A1016-FR':'KFES25F-A1016-FR-Felix-2.5 Seater-Pelham Moss.png',
  'KFES25F-A1016-SI':'KFES25F-A1016-SI-Felix-2.5 Seater-Pelham Moss.png',
  'KFES25F-B0216-FR':'KFES25F-B0216-FR-Felix-2.5 Seater-Beatrice Camelia.png',
  'KFES25F-B0326-FR':'KFES25F-B0326-FR-Felix-2.5 Seater-Beatrice Midnight.png',
  'KFES25F-B1216-FR':'KFES25F-B1216-FR-Felix-2.5 Seater-Froisse Putty.png',
  'KFES25F-B1216-SI':'KFES25F-B1216-SI-Felix-2.5 Seater-Froisse Putty.png',
  'KFES25F-D0616-FR':'KFES25F-D0616-FR-Felix-2.5 Seater-Brera Lino Cerise.png',
  'KFES25F-G0416-SI':'KFES25F-G0416-SI-Felix-2.5 Seater-Magnolia Cream Blue.png',
  'KFES25F-G0626-FR':'KFES25F-G0626-FR-Felix-2.5 Seater-Little Magnolia Espresso.png',
  'KFES25F-G0726-FR':'KFES25F-G0726-FR-Felix-2.5 Seater-Little Magnolia Emerald.png',
  'KFES25F-L0216-FR':'KFES25F-L0216-FR-Felix-2.5 Seater-English Garden - Kitty Blue Green.png',
  'KFES25F-O0216-FR':'KFES25F-O0216-FR-Felix-2.5 Seater-Tasman Petunia.png',
  'KFES25F-O0216-SI':'KFES25F-O0216-SI-Felix-2.5 Seater-Tasman Petunia.png',
  'KFES25F-O0426-FR':'KFES25F-O0426-FR-Felix-2.5 Seater-Bespoke Caramel.png',
  'KFES25F-O0616-FR':'KFES25F-O0616-FR-Felix-2.5 Seater-Tasman Garden Grey.png',
  'KFES25F-O0616-SI':'KFES25F-O0616-SI-Felix-2.5 Seater-Tasman Garden Grey.png',
  'KFES25F-O0716-SI':'KFES25F-O0716-SI-Felix-2.5 Seater-Tasman Dandelion.png',
  'KFES25F-O1016-SI':'KFES25F-O1016-SI-Felix-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KFES25F-O1026-FR':'KFES25F-O1026-FR-Felix-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KFES25F-O1116-FR':'KFES25F-O1116-FR-Felix-2.5 Seater-Tasman Chocolate.png',
  'KFES25F-O1116-SI':'KFES25F-O1116-SI-Felix-2.5 Seater-Tasman Chocolate.png',
  'KFES25F-O1326-FR':'KFES25F-O1326-FR-Felix-2.5 Seater-Capelo Cool Coconut.png',
  'KFES25F-O1416-FR':'KFES25F-O1416-FR-Felix-2.5 Seater-Capelo Snow Drop.png',
  'KFES25F-O1416-SI':'KFES25F-O1416-SI-Felix-2.5 Seater-Capelo Snow Drop.png',
  'KFES25F-O1426-FR':'KFES25F-O1426-FR-Felix-2.5 Seater-Capelo Snow Drop.png',
  'KFES25F-O1726-FR':'KFES25F-O1726-FR-Felix-2.5 Seater-Capelo Inkspot.png',
  'KFES25F-O1826-FR':'KFES25F-O1826-FR-Felix-2.5 Seater-Columbus Evergreen.png',
  'KFES25F-O1926-FR':'KFES25F-O1926-FR-Felix-2.5 Seater-Columbus Marigold.png',
  'KFES25F-O2026-FR':'KFES25F-O2026-FR-Felix-2.5 Seater-Columbus Potting Moss.png',
  'KFES30F-A0116-FR':'KFES30F-A0116-FR-Felix-3 Seater-Wildwood Duck Egg.png',
  'KFES30F-A0116-SI':'KFES30F-A0116-SI-Felix-3 Seater-Wildwood Duck Egg.png',
  'KFES30F-A0216-FR':'KFES30F-A0216-FR-Felix-3 Seater-Wildwood Ivory.png',
  'KFES30F-A0216-SI':'KFES30F-A0216-SI-Felix-3 Seater-Wildwood Ivory.png',
  'KFES30F-A0726-FR':'KFES30F-A0726-FR-Felix-3 Seater-Midsummer Faded Blue.jpg',
  'KFES30F-A1016-FR':'KFES30F-A1016-FR-Felix-3 Seater-Pelham Moss.png',
  'KFES30F-A1016-SI':'KFES30F-A1016-SI-Felix-3 Seater-Pelham Moss.png',
  'KFES30F-B0316-FR':'KFES30F-B0316-FR-Felix-3 Seater-Beatrice Midnight.png',
  'KFES30F-B1216-FR':'KFES30F-B1216-FR-Felix-3 Seater-Froisse Putty.png',
  'KFES30F-B1216-SI':'KFES30F-B1216-SI-Felix-3 Seater-Froisse Putty.png',
  'KFES30F-G0416-FR':'KFES30F-G0416-FR-Felix-3 Seater-Magnolia Cream Blue.png',
  'KFES30F-G0416-SI':'KFES30F-G0416-SI-Felix-3 Seater-Magnolia Cream Blue.png',
  'KFES30F-G0626-FR':'KFES30F-G0626-FR-Felix-3 Seater-Little Magnolia Espresso.png',
  'KFES30F-G0726-FR':'KFES30F-G0726-FR-Felix-3 Seater-Little Magnolia Emerald.png',
  'KFES30F-L0116-FR':'KFES30F-L0116-FR-Felix-3 Seater-English Garden - Kitty Spring Green.jpg',
  'KFES30F-L0116-SI':'KFES30F-L0116-SI-Felix-3 Seater-English Garden - Kitty Spring Green.jpg',
  'KFES30F-O0216-FR':'KFES30F-O0216-FR-Felix-3 Seater-Tasman Petunia.png',
  'KFES30F-O0216-SI':'KFES30F-O0216-SI-Felix-3 Seater-Tasman Petunia.png',
  'KFES30F-O0316-FR':'KFES30F-O0316-FR-Felix-3 Seater-Bespoke Woodland.jpg',
  'KFES30F-O0316-SI':'KFES30F-O0316-SI-Felix-3 Seater-Bespoke Woodland.jpg',
  'KFES30F-O0426-FR':'KFES30F-O0426-FR-Felix-3 Seater-Bespoke Caramel.png',
  'KFES30F-O0616-FR':'KFES30F-O0616-FR-Felix-3 Seater-Tasman Garden Grey.png',
  'KFES30F-O0616-SI':'KFES30F-O0616-SI-Felix-3 Seater-Tasman Garden Grey.png',
  'KFES30F-O0716-FR':'KFES30F-O0716-FR-Felix-3 Seater-Tasman Dandelion.png',
  'KFES30F-O0716-SI':'KFES30F-O0716-SI-Felix-3 Seater-Tasman Dandelion.png',
  'KFES30F-O1016-FR':'KFES30F-O1016-FR-Felix-3 Seater-Antarctic Narrow Chocolate.png',
  'KFES30F-O1016-SI':'KFES30F-O1016-SI-Felix-3 Seater-Antarctic Narrow Chocolate.png',
  'KFES30F-O1026-FR':'KFES30F-O1026-FR-Felix-3 Seater-Antarctic Narrow Chocolate.png',
  'KFES30F-O1116-FR':'KFES30F-O1116-FR-Felix-3 Seater-Tasman Chocolate.png',
  'KFES30F-O1116-SI':'KFES30F-O1116-SI-Felix-3 Seater-Tasman Chocolate.png',
  'KFES30F-O1326-FR':'KFES30F-O1326-FR-Felix-3 Seater-Capelo Cool Coconut.png',
  'KFES30F-O1416-FR':'KFES30F-O1416-FR-Felix-3 Seater-Capelo Snow Drop.png',
  'KFES30F-O1416-SI':'KFES30F-O1416-SI-Felix-3 Seater-Capelo Snow Drop.png',
  'KFES30F-O1426-FR':'KFES30F-O1426-FR-Felix-3 Seater-Capelo Snow Drop.png',
  'KFES30F-O1726-FR':'KFES30F-O1726-FR-Felix-3 Seater-Capelo Inkspot.png',
  'KFES30F-O1826-FR':'KFES30F-O1826-FR-Felix-3 Seater-Columbus Evergreen.png',
  'KFES30F-O1926-FR':'KFES30F-O1926-FR-Felix-3 Seater-Columbus Marigold.png',
  'KFES30F-O2026-FR':'KFES30F-O2026-FR-Felix-3 Seater-Columbus Potting Moss.png',
  'KFES40F-A0116-FR':'KFES40F-A0116-FR-Felix-4 Seater-Wildwood Duck Egg.png',
  'KFES40F-A0116-SI':'KFES40F-A0116-SI-Felix-4 Seater-Wildwood Duck Egg.png',
  'KFES40F-A0216-FR':'KFES40F-A0216-FR-Felix-4 Seater-Wildwood Ivory.png',
  'KFES40F-A0216-SI':'KFES40F-A0216-SI-Felix-4 Seater-Wildwood Ivory.png',
  'KFES40F-A0726-FR':'KFES40F-A0726-FR-Felix-4 Seater-Midsummer Faded Blue.jpg',
  'KFES40F-A1016-FR':'KFES40F-A1016-FR-Felix-4 Seater-Pelham Moss.png',
  'KFES40F-A1016-SI':'KFES40F-A1016-SI-Felix-4 Seater-Pelham Moss.png',
  'KFES40F-B0326-FR':'KFES40F-B0326-FR-Felix-4 Seater-Beatrice Midnight.png',
  'KFES40F-B1216-FR':'KFES40F-B1216-FR-Felix-4 Seater-Froisse Putty.png',
  'KFES40F-B1216-SI':'KFES40F-B1216-SI-Felix-4 Seater-Froisse Putty.png',
  'KFES40F-G0416-FR':'KFES40F-G0416-FR-Felix-4 Seater-Magnolia Cream Blue.png',
  'KFES40F-G0416-SI':'KFES40F-G0416-SI-Felix-4 Seater-Magnolia Cream Blue.png',
  'KFES40F-G0626-FR':'KFES40F-G0626-FR-Felix-4 Seater-Little Magnolia Espresso.png',
  'KFES40F-G0726-FR':'KFES40F-G0726-FR-Felix-4 Seater-Little Magnolia Emerald.png',
  'KFES40F-L0116-FR':'KFES40F-L0116-FR-Felix-4 Seater-English Garden - Kitty Spring Green.jpg',
  'KFES40F-L0116-SI':'KFES40F-L0116-SI-Felix-4 Seater-English Garden - Kitty Spring Green.jpg',
  'KFES40F-O0216-FR':'KFES40F-O0216-FR-Felix-4 Seater-Tasman Petunia.png',
  'KFES40F-O0216-SI':'KFES40F-O0216-SI-Felix-4 Seater-Tasman Petunia.png',
  'KFES40F-O0316-FR':'KFES40F-O0316-FR-Felix-4 Seater-Bespoke Woodland.jpg',
  'KFES40F-O0316-SI':'KFES40F-O0316-SI-Felix-4 Seater-Bespoke Woodland.jpg',
  'KFES40F-O0426-FR':'KFES40F-O0426-FR-Felix-4 Seater-Bespoke Caramel.png',
  'KFES40F-O0616-FR':'KFES40F-O0616-FR-Felix-4 Seater-Tasman Garden Grey.png',
  'KFES40F-O0616-SI':'KFES40F-O0616-SI-Felix-4 Seater-Tasman Garden Grey.png',
  'KFES40F-O0716-FR':'KFES40F-O0716-FR-Felix-4 Seater-Tasman Dandelion.png',
  'KFES40F-O0716-SI':'KFES40F-O0716-SI-Felix-4 Seater-Tasman Dandelion.png',
  'KFES40F-O1016-FR':'KFES40F-O1016-FR-Felix-4 Seater-Antarctic Narrow Chocolate.png',
  'KFES40F-O1016-SI':'KFES40F-O1016-SI-Felix-4 Seater-Antarctic Narrow Chocolate.png',
  'KFES40F-O1116-FR':'KFES40F-O1116-FR-Felix-4 Seater-Tasman Chocolate.png',
  'KFES40F-O1116-SI':'KFES40F-O1116-SI-Felix-4 Seater-Tasman Chocolate.png',
  'KFES40F-O1326-FR':'KFES40F-O1326-FR-Felix-4 Seater-Capelo Cool Coconut.png',
  'KFES40F-O1416-FR':'KFES40F-O1416-FR-Felix-4 Seater-Capelo Snow Drop.png',
  'KFES40F-O1416-SI':'KFES40F-O1416-SI-Felix-4 Seater-Capelo Snow Drop.png',
  'KFES40F-O1426-FR':'KFES40F-O1426-FR-Felix-4 Seater-Capelo Snow Drop.png',
  'KFES40F-O1726-FR':'KFES40F-O1726-FR-Felix-4 Seater-Capelo Inkspot.png',
  'KFES40F-O1826-FR':'KFES40F-O1826-FR-Felix-4 Seater-Columbus Evergreen.png',
  'KFES40F-O1926-FR':'KFES40F-O1926-FR-Felix-4 Seater-Columbus Marigold.png',
  'KFES40F-O2026-FR':'KFES40F-O2026-FR-Felix-4 Seater-Columbus Potting Moss.png',
  'KFES42F-A0116-FR':'KFES42F-A0116-FR-Felix-4 Seater 2 Cushion-Wildwood Duck Egg.png',
  'KFES42F-A0116-SI':'KFES42F-A0116-SI-Felix-4 Seater 2 Cushion-Wildwood Duck Egg.png',
  'KFES42F-A0216-FR':'KFES42F-A0216-FR-Felix-4 Seater 2 Cushion-Wildwood Ivory.png',
  'KFES42F-A0216-SI':'KFES42F-A0216-SI-Felix-4 Seater 2 Cushion-Wildwood Ivory.png',
  'KFES42F-A1016-FR':'KFES42F-A1016-FR-Felix-4 Seater 2 Cushion-Pelham Moss.png',
  'KFES42F-A1016-SI':'KFES42F-A1016-SI-Felix-4 Seater 2 Cushion-Pelham Moss.png',
  'KFES42F-B1216-FR':'KFES42F-B1216-FR-Felix-4 Seater 2 Cushion-Froisse Putty.png',
  'KFES42F-B1216-SI':'KFES42F-B1216-SI-Felix-4 Seater 2 Cushion-Froisse Putty.png',
  'KFES42F-G0416-FR':'KFES42F-G0416-FR-Felix-4 Seater 2 Cushion-Magnolia Cream Blue.png',
  'KFES42F-G0416-SI':'KFES42F-G0416-SI-Felix-4 Seater 2 Cushion-Magnolia Cream Blue.png',
  'KFES42F-O0216-FR':'KFES42F-O0216-FR-Felix-4 Seater 2 Cushion-Tasman Petunia.png',
  'KFES42F-O0216-SI':'KFES42F-O0216-SI-Felix-4 Seater 2 Cushion-Tasman Petunia.png',
  'KFES42F-O0616-FR':'KFES42F-O0616-FR-Felix-4 Seater 2 Cushion-Tasman Garden Grey.png',
  'KFES42F-O0616-SI':'KFES42F-O0616-SI-Felix-4 Seater 2 Cushion-Tasman Garden Grey.png',
  'KFES42F-O0716-FR':'KFES42F-O0716-FR-Felix-4 Seater 2 Cushion-Tasman Dandelion.png',
  'KFES42F-O0716-SI':'KFES42F-O0716-SI-Felix-4 Seater 2 Cushion-Tasman Dandelion.png',
  'KFES42F-O1016-FR':'KFES42F-O1016-FR-Felix-4 Seater 2 Cushion-Antarctic Narrow Chocolate.png',
  'KFES42F-O1016-SI':'KFES42F-O1016-SI-Felix-4 Seater 2 Cushion-Antarctic Narrow Chocolate.png',
  'KFES42F-O1116-FR':'KFES42F-O1116-FR-Felix-4 Seater 2 Cushion-Tasman Chocolate.png',
  'KFES42F-O1116-SI':'KFES42F-O1116-SI-Felix-4 Seater 2 Cushion-Tasman Chocolate.png',
  'KFES42F-O1416-FR':'KFES42F-O1416-FR-Felix-4 Seater 2 Cushion-Capelo Snow Drop.png',
  'KFES42F-O1416-SI':'KFES42F-O1416-SI-Felix-4 Seater 2 Cushion-Capelo Snow Drop.png',
  'KFJS10F-B0122-FR':'KFJS10F-B0122-FR-Felix (JLP)-Armchair-Beatrice Barley.jpg',
  'KFJS10F-B0122-PR':'KFJS10F-B0122-PR-Felix (JLP)-Armchair-Beatrice Barley.jpg',
  'KFJS10F-B0122-RE':'KFJS10F-B0122-RE-Felix (JLP)-Armchair-Beatrice Barley.jpg',
  'KFJS10F-B0122-SI':'KFJS10F-B0122-SI-Felix (JLP)-Armchair-Beatrice Barley.jpg',
  'KFJS10F-B0222-FR':'KFJS10F-B0222-FR-Felix (JLP)-Armchair-Beatrice-Camelia.jpg',
  'KFJS10F-B0222-PR':'KFJS10F-B0222-PR-Felix (JLP)-Armchair-Beatrice-Camelia.jpg',
  'KFJS10F-B0222-RE':'KFJS10F-B0222-RE-Felix (JLP)-Armchair-Beatrice-Camelia.jpg',
  'KFJS10F-B0222-SI':'KFJS10F-B0222-SI-Felix (JLP)-Armchair-Beatrice-Camelia.jpg',
  'KFJS10F-B0322-FR':'KFJS10F-B0322-FR-Felix (JLP)-Armchair-Beatrice Midnight.jpg',
  'KFJS10F-B0322-PR':'KFJS10F-B0322-PR-Felix (JLP)-Armchair-Beatrice Midnight.jpg',
  'KFJS10F-B0322-RE':'KFJS10F-B0322-RE-Felix (JLP)-Armchair-Beatrice Midnight.jpg',
  'KFJS10F-B0322-SI':'KFJS10F-B0322-SI-Felix (JLP)-Armchair-Beatrice Midnight.jpg',
  'KFJS10F-B0422-FR':'KFJS10F-B0422-FR-Felix (JLP)-Armchair-Beatrice Nutmeg.jpg',
  'KFJS10F-B0422-PR':'KFJS10F-B0422-PR-Felix (JLP)-Armchair-Beatrice Nutmeg.jpg',
  'KFJS10F-B0422-RE':'KFJS10F-B0422-RE-Felix (JLP)-Armchair-Beatrice Nutmeg.jpg',
  'KFJS10F-B0422-SI':'KFJS10F-B0422-SI-Felix (JLP)-Armchair-Beatrice Nutmeg.jpg',
  'KFJS10F-B0522-FR':'KFJS10F-B0522-FR-Felix (JLP)-Armchair-Beatrice Olive.jpg',
  'KFJS10F-B0522-PR':'KFJS10F-B0522-PR-Felix (JLP)-Armchair-Beatrice Olive.jpg',
  'KFJS10F-B0522-RE':'KFJS10F-B0522-RE-Felix (JLP)-Armchair-Beatrice Olive.jpg',
  'KFJS10F-B0522-SI':'KFJS10F-B0522-SI-Felix (JLP)-Armchair-Beatrice Olive.jpg',
  'KFJS10F-J0122-FR':'KFJS10F-J0122-FR-Felix (JLP)-Armchair-Boho Cloud.jpg',
  'KFJS10F-J0122-PR':'KFJS10F-J0122-PR-Felix (JLP)-Armchair-Boho Cloud.jpg',
  'KFJS10F-J0122-RE':'KFJS10F-J0122-RE-Felix (JLP)-Armchair-Boho Cloud.jpg',
  'KFJS10F-J0122-SI':'KFJS10F-J0122-SI-Felix (JLP)-Armchair-Boho Cloud.jpg',
  'KFJS10F-J0222-FR':'KFJS10F-J0222-FR-Felix (JLP)-Armchair-Boho Denim.jpg',
  'KFJS10F-J0222-PR':'KFJS10F-J0222-PR-Felix (JLP)-Armchair-Boho Denim.jpg',
  'KFJS10F-J0222-RE':'KFJS10F-J0222-RE-Felix (JLP)-Armchair-Boho Denim.jpg',
  'KFJS10F-J0222-SI':'KFJS10F-J0222-SI-Felix (JLP)-Armchair-Boho Denim.jpg',
  'KFJS10F-J0322-FR':'KFJS10F-J0322-FR-Felix (JLP)-Armchair-Boho Parchment.jpg',
  'KFJS10F-J0322-PR':'KFJS10F-J0322-PR-Felix (JLP)-Armchair-Boho Parchment.jpg',
  'KFJS10F-J0322-RE':'KFJS10F-J0322-RE-Felix (JLP)-Armchair-Boho Parchment.jpg',
  'KFJS10F-J0322-SI':'KFJS10F-J0322-SI-Felix (JLP)-Armchair-Boho Parchment.jpg',
  'KFJS10F-J0422-FR':'KFJS10F-J0422-FR-Felix (JLP)-Armchair-Bruges Navy.jpg',
  'KFJS10F-J0422-PR':'KFJS10F-J0422-PR-Felix (JLP)-Armchair-Bruges Navy.jpg',
  'KFJS10F-J0422-RE':'KFJS10F-J0422-RE-Felix (JLP)-Armchair-Bruges Navy.jpg',
  'KFJS10F-J0422-SI':'KFJS10F-J0422-SI-Felix (JLP)-Armchair-Bruges Navy.jpg',
  'KFJS10F-J0522-FR':'KFJS10F-J0522-FR-Felix (JLP)-Armchair-Bruges Sage.jpg',
  'KFJS10F-J0522-PR':'KFJS10F-J0522-PR-Felix (JLP)-Armchair-Bruges Sage.jpg',
  'KFJS10F-J0522-RE':'KFJS10F-J0522-RE-Felix (JLP)-Armchair-Bruges Sage.jpg',
  'KFJS10F-J0522-SI':'KFJS10F-J0522-SI-Felix (JLP)-Armchair-Bruges Sage.jpg',
  'KFJS10F-J0622-FR':'KFJS10F-J0622-FR-Felix (JLP)-Armchair-Bruges Sand.jpg',
  'KFJS10F-J0622-PR':'KFJS10F-J0622-PR-Felix (JLP)-Armchair-Bruges Sand.jpg',
  'KFJS10F-J0622-RE':'KFJS10F-J0622-RE-Felix (JLP)-Armchair-Bruges Sand.jpg',
  'KFJS10F-J0622-SI':'KFJS10F-J0622-SI-Felix (JLP)-Armchair-Bruges Sand.jpg',
  'KFJS10F-J0722-FR':'KFJS10F-J0722-FR-Felix (JLP)-Armchair-Suzy Olive.jpg',
  'KFJS10F-J0722-PR':'KFJS10F-J0722-PR-Felix (JLP)-Armchair-Suzy Olive.jpg',
  'KFJS10F-J0722-RE':'KFJS10F-J0722-RE-Felix (JLP)-Armchair-Suzy Olive.jpg',
  'KFJS10F-J0722-SI':'KFJS10F-J0722-SI-Felix (JLP)-Armchair-Suzy Olive.jpg',
  'KFJS10F-J0822-FR':'KFJS10F-J0822-FR-Felix (JLP)-Armchair-Suzy Denim.jpg',
  'KFJS10F-J0822-PR':'KFJS10F-J0822-PR-Felix (JLP)-Armchair-Suzy Denim.jpg',
  'KFJS10F-J0822-RE':'KFJS10F-J0822-RE-Felix (JLP)-Armchair-Suzy Denim.jpg',
  'KFJS10F-J0822-SI':'KFJS10F-J0822-SI-Felix (JLP)-Armchair-Suzy Denim.jpg',
  'KFJS10F-J0922-FR':'KFJS10F-J0922-FR-Felix (JLP)-Armchair-Suzy Natural.jpg',
  'KFJS10F-J0922-PR':'KFJS10F-J0922-PR-Felix (JLP)-Armchair-Suzy Natural.jpg',
  'KFJS10F-J0922-RE':'KFJS10F-J0922-RE-Felix (JLP)-Armchair-Suzy Natural.jpg',
  'KFJS10F-J0922-SI':'KFJS10F-J0922-SI-Felix (JLP)-Armchair-Suzy Natural.jpg',
  'KFJS10F-J1022-FR':'KFJS10F-J1022-FR-Felix (JLP)-Armchair-Beauville Spring Green.jpg',
  'KFJS10F-J1022-PR':'KFJS10F-J1022-PR-Felix (JLP)-Armchair-Beauville Spring Green.jpg',
  'KFJS10F-J1022-RE':'KFJS10F-J1022-RE-Felix (JLP)-Armchair-Beauville Spring Green.jpg',
  'KFJS10F-J1022-SI':'KFJS10F-J1022-SI-Felix (JLP)-Armchair-Beauville Spring Green.jpg',
  'KFJS10F-J1122-FR':'KFJS10F-J1122-FR-Felix (JLP)-Armchair-Beauville Cornish Blue.jpg',
  'KFJS10F-J1122-PR':'KFJS10F-J1122-PR-Felix (JLP)-Armchair-Beauville Cornish Blue.jpg',
  'KFJS10F-J1122-RE':'KFJS10F-J1122-RE-Felix (JLP)-Armchair-Beauville Cornish Blue.jpg',
  'KFJS10F-J1122-SI':'KFJS10F-J1122-SI-Felix (JLP)-Armchair-Beauville Cornish Blue.jpg',
  'KFJS10F-O0122-FR':'KFJS10F-O0122-FR-Felix (JLP)-Armchair-Bespoke Coastal Blue.jpg',
  'KFJS10F-O0122-PR':'KFJS10F-O0122-PR-Felix (JLP)-Armchair-Bespoke Coastal Blue.jpg',
  'KFJS10F-O0122-RE':'KFJS10F-O0122-RE-Felix (JLP)-Armchair-Bespoke Coastal Blue.jpg',
  'KFJS10F-O0122-SI':'KFJS10F-O0122-SI-Felix (JLP)-Armchair-Bespoke Coastal Blue.jpg',
  'KFJS10F-O0222-FR':'KFJS10F-O0222-FR-Felix (JLP)-Armchair-Tasman Petunia.jpg',
  'KFJS10F-O0222-PR':'KFJS10F-O0222-PR-Felix (JLP)-Armchair-Tasman Petunia.jpg',
  'KFJS10F-O0222-RE':'KFJS10F-O0222-RE-Felix (JLP)-Armchair-Tasman Petunia.jpg',
  'KFJS10F-O0222-SI':'KFJS10F-O0222-SI-Felix (JLP)-Armchair-Tasman Petunia.jpg',
  'KFJS10F-O0822-FR':'KFJS10F-O0822-FR-Felix (JLP)-Armchair-Tasman Spring Green.jpg',
  'KFJS10F-O0822-PR':'KFJS10F-O0822-PR-Felix (JLP)-Armchair-Tasman Spring Green.jpg',
  'KFJS10F-O0822-RE':'KFJS10F-O0822-RE-Felix (JLP)-Armchair-Tasman Spring Green.jpg',
  'KFJS10F-O0822-SI':'KFJS10F-O0822-SI-Felix (JLP)-Armchair-Tasman Spring Green.jpg',
  'KFJS10F-O0922-FR':'KFJS10F-O0922-FR-Felix (JLP)-Armchair-Tasman Cornish Blue.jpg',
  'KFJS10F-O0922-PR':'KFJS10F-O0922-PR-Felix (JLP)-Armchair-Tasman Cornish Blue.jpg',
  'KFJS10F-O0922-RE':'KFJS10F-O0922-RE-Felix (JLP)-Armchair-Tasman Cornish Blue.jpg',
  'KFJS10F-O0922-SI':'KFJS10F-O0922-SI-Felix (JLP)-Armchair-Tasman Cornish Blue.jpg',
  'KFJS10F-O2322-FR':'KFJS10F-O2322-FR-Felix (JLP)-Armchair-Pinstripe Natural.jpg',
  'KFJS10F-O2322-PR':'KFJS10F-O2322-PR-Felix (JLP)-Armchair-Pinstripe Natural.jpg',
  'KFJS10F-O2322-RE':'KFJS10F-O2322-RE-Felix (JLP)-Armchair-Pinstripe Natural.jpg',
  'KFJS10F-O2322-SI':'KFJS10F-O2322-SI-Felix (JLP)-Armchair-Pinstripe Natural.jpg',
  'KFJS10F-O2422-FR':'KFJS10F-O2422-FR-Felix (JLP)-Armchair-Pinstripe Petunia.jpg',
  'KFJS10F-O2422-PR':'KFJS10F-O2422-PR-Felix (JLP)-Armchair-Pinstripe Petunia.jpg',
  'KFJS10F-O2422-RE':'KFJS10F-O2422-RE-Felix (JLP)-Armchair-Pinstripe Petunia.jpg',
  'KFJS10F-O2422-SI':'KFJS10F-O2422-SI-Felix (JLP)-Armchair-Pinstripe Petunia.jpg',
  'KFJS10F-O2522-FR':'KFJS10F-O2522-FR-Felix (JLP)-Armchair-Pinstripe Nutmeg.jpg',
  'KFJS10F-O2522-PR':'KFJS10F-O2522-PR-Felix (JLP)-Armchair-Pinstripe Nutmeg.jpg',
  'KFJS10F-O2522-RE':'KFJS10F-O2522-RE-Felix (JLP)-Armchair-Pinstripe Nutmeg.jpg',
  'KFJS10F-O2522-SI':'KFJS10F-O2522-SI-Felix (JLP)-Armchair-Pinstripe Nutmeg.jpg',
  'KFJS10F-O2622-FR':'KFJS10F-O2622-FR-Felix (JLP)-Armchair-Tasman Natural.jpg',
  'KFJS10F-O2622-PR':'KFJS10F-O2622-PR-Felix (JLP)-Armchair-Tasman Natural.jpg',
  'KFJS10F-O2622-RE':'KFJS10F-O2622-RE-Felix (JLP)-Armchair-Tasman Natural.jpg',
  'KFJS10F-O2622-SI':'KFJS10F-O2622-SI-Felix (JLP)-Armchair-Tasman Natural.jpg',
  'KFJS25F-B0122-FR':'KFJS25F-B0122-FR-Felix (JLP)-Medium-Beatrice Barley.jpg',
  'KFJS25F-B0122-PR':'KFJS25F-B0122-PR-Felix (JLP)-Medium-Beatrice Barley.jpg',
  'KFJS25F-B0122-RE':'KFJS25F-B0122-RE-Felix (JLP)-Medium-Beatrice Barley.jpg',
  'KFJS25F-B0122-SI':'KFJS25F-B0122-SI-Felix (JLP)-Medium-Beatrice Barley.jpg',
  'KFJS25F-B0222-FR':'KFJS25F-B0222-FR-Felix (JLP)-Medium-Beatrice Camelia.jpg',
  'KFJS25F-B0222-PR':'KFJS25F-B0222-PR-Felix (JLP)-Medium-Beatrice Camelia.jpg',
  'KFJS25F-B0222-RE':'KFJS25F-B0222-RE-Felix (JLP)-Medium-Beatrice Camelia.jpg',
  'KFJS25F-B0222-SI':'KFJS25F-B0222-SI-Felix (JLP)-Medium-Beatrice Camelia.jpg',
  'KFJS25F-B0322-FR':'KFJS25F-B0322-FR-Felix (JLP)-Medium-Beatrice Midnight.jpg',
  'KFJS25F-B0322-PR':'KFJS25F-B0322-PR-Felix (JLP)-Medium-Beatrice Midnight.jpg',
  'KFJS25F-B0322-RE':'KFJS25F-B0322-RE-Felix (JLP)-Medium-Beatrice Midnight.jpg',
  'KFJS25F-B0322-SI':'KFJS25F-B0322-SI-Felix (JLP)-Medium-Beatrice Midnight.jpg',
  'KFJS25F-B0422-FR':'KFJS25F-B0422-FR-Felix (JLP)-Medium-Beatrice Nutmeg.jpg',
  'KFJS25F-B0422-PR':'KFJS25F-B0422-PR-Felix (JLP)-Medium-Beatrice Nutmeg.jpg',
  'KFJS25F-B0422-RE':'KFJS25F-B0422-RE-Felix (JLP)-Medium-Beatrice Nutmeg.jpg',
  'KFJS25F-B0422-SI':'KFJS25F-B0422-SI-Felix (JLP)-Medium-Beatrice Nutmeg.jpg',
  'KFJS25F-B0522-FR':'KFJS25F-B0522-FR-Felix (JLP)-Medium-Beatrice Olive.jpg',
  'KFJS25F-B0522-PR':'KFJS25F-B0522-PR-Felix (JLP)-Medium-Beatrice Olive.jpg',
  'KFJS25F-B0522-RE':'KFJS25F-B0522-RE-Felix (JLP)-Medium-Beatrice Olive.jpg',
  'KFJS25F-B0522-SI':'KFJS25F-B0522-SI-Felix (JLP)-Medium-Beatrice Olive.jpg',
  'KFJS25F-J0122-FR':'KFJS25F-J0122-FR-Felix (JLP)-Medium-Boho Cloud.jpg',
  'KFJS25F-J0122-PR':'KFJS25F-J0122-PR-Felix (JLP)-Medium-Boho Cloud.jpg',
  'KFJS25F-J0122-RE':'KFJS25F-J0122-RE-Felix (JLP)-Medium-Boho Cloud.jpg',
  'KFJS25F-J0122-SI':'KFJS25F-J0122-SI-Felix (JLP)-Medium-Boho Cloud.jpg',
  'KFJS25F-J0222-FR':'KFJS25F-J0222-FR-Felix (JLP)-Medium-Boho Denim.jpg',
  'KFJS25F-J0222-PR':'KFJS25F-J0222-PR-Felix (JLP)-Medium-Boho Denim.jpg',
  'KFJS25F-J0222-RE':'KFJS25F-J0222-RE-Felix (JLP)-Medium-Boho Denim.jpg',
  'KFJS25F-J0222-SI':'KFJS25F-J0222-SI-Felix (JLP)-Medium-Boho Denim.jpg',
  'KFJS25F-J0322-FR':'KFJS25F-J0322-FR-Felix (JLP)-Medium-Boho Parchment.jpg',
  'KFJS25F-J0322-PR':'KFJS25F-J0322-PR-Felix (JLP)-Medium-Boho Parchment.jpg',
  'KFJS25F-J0322-RE':'KFJS25F-J0322-RE-Felix (JLP)-Medium-Boho Parchment.jpg',
  'KFJS25F-J0322-SI':'KFJS25F-J0322-SI-Felix (JLP)-Medium-Boho Parchment.jpg',
  'KFJS25F-J0422-FR':'KFJS25F-J0422-FR-Felix (JLP)-Medium-Bruges Navy.jpg',
  'KFJS25F-J0422-PR':'KFJS25F-J0422-PR-Felix (JLP)-Medium-Bruges Navy.jpg',
  'KFJS25F-J0422-RE':'KFJS25F-J0422-RE-Felix (JLP)-Medium-Bruges Navy.jpg',
  'KFJS25F-J0422-SI':'KFJS25F-J0422-SI-Felix (JLP)-Medium-Bruges Navy.jpg',
  'KFJS25F-J0522-FR':'KFJS25F-J0522-FR-Felix (JLP)-Medium-Bruges Sage.jpg',
  'KFJS25F-J0522-PR':'KFJS25F-J0522-PR-Felix (JLP)-Medium-Bruges Sage.jpg',
  'KFJS25F-J0522-RE':'KFJS25F-J0522-RE-Felix (JLP)-Medium-Bruges Sage.jpg',
  'KFJS25F-J0522-SI':'KFJS25F-J0522-SI-Felix (JLP)-Medium-Bruges Sage.jpg',
  'KFJS25F-J0622-FR':'KFJS25F-J0622-FR-Felix (JLP)-Medium-Bruges Sand.jpg',
  'KFJS25F-J0622-PR':'KFJS25F-J0622-PR-Felix (JLP)-Medium-Bruges Sand.jpg',
  'KFJS25F-J0622-RE':'KFJS25F-J0622-RE-Felix (JLP)-Medium-Bruges Sand.jpg',
  'KFJS25F-J0622-SI':'KFJS25F-J0622-SI-Felix (JLP)-Medium-Bruges Sand.jpg',
  'KFJS25F-J0722-FR':'KFJS25F-J0722-FR-Felix (JLP)-Medium-Suzy Olive.jpg',
  'KFJS25F-J0722-PR':'KFJS25F-J0722-PR-Felix (JLP)-Medium-Suzy Olive.jpg',
  'KFJS25F-J0722-RE':'KFJS25F-J0722-RE-Felix (JLP)-Medium-Suzy Olive.jpg',
  'KFJS25F-J0722-SI':'KFJS25F-J0722-SI-Felix (JLP)-Medium-Suzy Olive.jpg',
  'KFJS25F-J0822-FR':'KFJS25F-J0822-FR-Felix (JLP)-Medium-Suzy Denim.jpg',
  'KFJS25F-J0822-PR':'KFJS25F-J0822-PR-Felix (JLP)-Medium-Suzy Denim.jpg',
  'KFJS25F-J0822-RE':'KFJS25F-J0822-RE-Felix (JLP)-Medium-Suzy Denim.jpg',
  'KFJS25F-J0822-SI':'KFJS25F-J0822-SI-Felix (JLP)-Medium-Suzy Denim.jpg',
  'KFJS25F-J0922-FR':'KFJS25F-J0922-FR-Felix (JLP)-Medium-Suzy Natural.jpg',
  'KFJS25F-J0922-PR':'KFJS25F-J0922-PR-Felix (JLP)-Medium-Suzy Natural.jpg',
  'KFJS25F-J0922-RE':'KFJS25F-J0922-RE-Felix (JLP)-Medium-Suzy Natural.jpg',
  'KFJS25F-J0922-SI':'KFJS25F-J0922-SI-Felix (JLP)-Medium-Suzy Natural.jpg',
  'KFJS25F-J1022-FR':'KFJS25F-J1022-FR-Felix (JLP)-Medium-Beauville Spring Green.jpg',
  'KFJS25F-J1022-PR':'KFJS25F-J1022-PR-Felix (JLP)-Medium-Beauville Spring Green.jpg',
  'KFJS25F-J1022-RE':'KFJS25F-J1022-RE-Felix (JLP)-Medium-Beauville Spring Green.jpg',
  'KFJS25F-J1022-SI':'KFJS25F-J1022-SI-Felix (JLP)-Medium-Beauville Spring Green.jpg',
  'KFJS25F-J1122-FR':'KFJS25F-J1122-FR-Felix (JLP)-Medium-Beauville Cornish Blue.jpg',
  'KFJS25F-J1122-PR':'KFJS25F-J1122-PR-Felix (JLP)-Medium-Beauville Cornish Blue.jpg',
  'KFJS25F-J1122-RE':'KFJS25F-J1122-RE-Felix (JLP)-Medium-Beauville Cornish Blue.jpg',
  'KFJS25F-J1122-SI':'KFJS25F-J1122-SI-Felix (JLP)-Medium-Beauville Cornish Blue.jpg',
  'KFJS25F-O0122-FR':'KFJS25F-O0122-FR-Felix (JLP)-Medium-Bespoke Coastal Blue.jpg',
  'KFJS25F-O0122-PR':'KFJS25F-O0122-PR-Felix (JLP)-Medium-Bespoke Coastal Blue.jpg',
  'KFJS25F-O0122-RE':'KFJS25F-O0122-RE-Felix (JLP)-Medium-Bespoke Coastal Blue.jpg',
  'KFJS25F-O0122-SI':'KFJS25F-O0122-SI-Felix (JLP)-Medium-Bespoke Coastal Blue.jpg',
  'KFJS25F-O0222-FR':'KFJS25F-O0222-FR-Felix (JLP)-Medium-Tasman Petunia.jpg',
  'KFJS25F-O0222-PR':'KFJS25F-O0222-PR-Felix (JLP)-Medium-Tasman Petunia.jpg',
  'KFJS25F-O0222-RE':'KFJS25F-O0222-RE-Felix (JLP)-Medium-Tasman Petunia.jpg',
  'KFJS25F-O0222-SI':'KFJS25F-O0222-SI-Felix (JLP)-Medium-Tasman Petunia.jpg',
  'KFJS25F-O0822-FR':'KFJS25F-O0822-FR-Felix (JLP)-Medium-Tasman Spring Green.jpg',
  'KFJS25F-O0822-PR':'KFJS25F-O0822-PR-Felix (JLP)-Medium-Tasman Spring Green.jpg',
  'KFJS25F-O0822-RE':'KFJS25F-O0822-RE-Felix (JLP)-Medium-Tasman Spring Green.jpg',
  'KFJS25F-O0822-SI':'KFJS25F-O0822-SI-Felix (JLP)-Medium-Tasman Spring Green.jpg',
  'KFJS25F-O0922-FR':'KFJS25F-O0922-FR-Felix (JLP)-Medium-Tasman Cornish Blue.jpg',
  'KFJS25F-O0922-PR':'KFJS25F-O0922-PR-Felix (JLP)-Medium-Tasman Cornish Blue.jpg',
  'KFJS25F-O0922-RE':'KFJS25F-O0922-RE-Felix (JLP)-Medium-Tasman Cornish Blue.jpg',
  'KFJS25F-O0922-SI':'KFJS25F-O0922-SI-Felix (JLP)-Medium-Tasman Cornish Blue.jpg',
  'KFJS25F-O2322-FR':'KFJS25F-O2322-FR-Felix (JLP)-Medium-Pinstripe Natural.jpg',
  'KFJS25F-O2322-PR':'KFJS25F-O2322-PR-Felix (JLP)-Medium-Pinstripe Natural.jpg',
  'KFJS25F-O2322-RE':'KFJS25F-O2322-RE-Felix (JLP)-Medium-Pinstripe Natural.jpg',
  'KFJS25F-O2322-SI':'KFJS25F-O2322-SI-Felix (JLP)-Medium-Pinstripe Natural.jpg',
  'KFJS25F-O2422-FR':'KFJS25F-O2422-FR-Felix (JLP)-Medium-Pinstripe Petunia.jpg',
  'KFJS25F-O2422-PR':'KFJS25F-O2422-PR-Felix (JLP)-Medium-Pinstripe Petunia.jpg',
  'KFJS25F-O2422-RE':'KFJS25F-O2422-RE-Felix (JLP)-Medium-Pinstripe Petunia.jpg',
  'KFJS25F-O2422-SI':'KFJS25F-O2422-SI-Felix (JLP)-Medium-Pinstripe Petunia.jpg',
  'KFJS25F-O2522-FR':'KFJS25F-O2522-FR-Felix (JLP)-Medium-Pinstripe Nutmeg.jpg',
  'KFJS25F-O2522-PR':'KFJS25F-O2522-PR-Felix (JLP)-Medium-Pinstripe Nutmeg.jpg',
  'KFJS25F-O2522-RE':'KFJS25F-O2522-RE-Felix (JLP)-Medium-Pinstripe Nutmeg.jpg',
  'KFJS25F-O2522-SI':'KFJS25F-O2522-SI-Felix (JLP)-Medium-Pinstripe Nutmeg.jpg',
  'KFJS25F-O2622-FR':'KFJS25F-O2622-FR-Felix (JLP)-Medium-Tasman Natural.jpg',
  'KFJS25F-O2622-PR':'KFJS25F-O2622-PR-Felix (JLP)-Medium-Tasman Natural.jpg',
  'KFJS25F-O2622-RE':'KFJS25F-O2622-RE-Felix (JLP)-Medium-Tasman Natural.jpg',
  'KFJS25F-O2622-SI':'KFJS25F-O2622-SI-Felix (JLP)-Medium-Tasman Natural.jpg',
  'KFJS30F-B0122-FR':'KFJS30F-B0122-FR-Felix (JLP)-Large-Beatrice Barley.jpg',
  'KFJS30F-B0122-PR':'KFJS30F-B0122-PR-Felix (JLP)-Large-Beatrice Barley.jpg',
  'KFJS30F-B0122-RE':'KFJS30F-B0122-RE-Felix (JLP)-Large-Beatrice Barley.jpg',
  'KFJS30F-B0122-SI':'KFJS30F-B0122-SI-Felix (JLP)-Large-Beatrice Barley.jpg',
  'KFJS30F-B0222-FR':'KFJS30F-B0222-FR-Felix (JLP)-Large-Beatrice Camelia.jpg',
  'KFJS30F-B0222-PR':'KFJS30F-B0222-PR-Felix (JLP)-Large-Beatrice Camelia.jpg',
  'KFJS30F-B0222-RE':'KFJS30F-B0222-RE-Felix (JLP)-Large-Beatrice Camelia.jpg',
  'KFJS30F-B0222-SI':'KFJS30F-B0222-SI-Felix (JLP)-Large-Beatrice Camelia.jpg',
  'KFJS30F-B0322-FR':'KFJS30F-B0322-FR-Felix (JLP)-Large-Beatrice Midnight.jpg',
  'KFJS30F-B0322-PR':'KFJS30F-B0322-PR-Felix (JLP)-Large-Beatrice Midnight.jpg',
  'KFJS30F-B0322-RE':'KFJS30F-B0322-RE-Felix (JLP)-Large-Beatrice Midnight.jpg',
  'KFJS30F-B0322-SI':'KFJS30F-B0322-SI-Felix (JLP)-Large-Beatrice Midnight.jpg',
  'KFJS30F-B0422-FR':'KFJS30F-B0422-FR-Felix (JLP)-Large-Beatrice Nutmeg.jpg',
  'KFJS30F-B0422-PR':'KFJS30F-B0422-PR-Felix (JLP)-Large-Beatrice Nutmeg.jpg',
  'KFJS30F-B0422-RE':'KFJS30F-B0422-RE-Felix (JLP)-Large-Beatrice Nutmeg.jpg',
  'KFJS30F-B0422-SI':'KFJS30F-B0422-SI-Felix (JLP)-Large-Beatrice Nutmeg.jpg',
  'KFJS30F-B0522-FR':'KFJS30F-B0522-FR-Felix (JLP)-Large-Beatrice Olive.jpg',
  'KFJS30F-B0522-PR':'KFJS30F-B0522-PR-Felix (JLP)-Large-Beatrice Olive.jpg',
  'KFJS30F-B0522-RE':'KFJS30F-B0522-RE-Felix (JLP)-Large-Beatrice Olive.jpg',
  'KFJS30F-B0522-SI':'KFJS30F-B0522-SI-Felix (JLP)-Large-Beatrice Olive.jpg',
  'KFJS30F-J0122-FR':'KFJS30F-J0122-FR-Felix (JLP)-Large-Boho Cloud.jpg',
  'KFJS30F-J0122-PR':'KFJS30F-J0122-PR-Felix (JLP)-Large-Boho Cloud.jpg',
  'KFJS30F-J0122-RE':'KFJS30F-J0122-RE-Felix (JLP)-Large-Boho Cloud.jpg',
  'KFJS30F-J0122-SI':'KFJS30F-J0122-SI-Felix (JLP)-Large-Boho Cloud.jpg',
  'KFJS30F-J0222-FR':'KFJS30F-J0222-FR-Felix (JLP)-Large-Boho Denim.jpg',
  'KFJS30F-J0222-PR':'KFJS30F-J0222-PR-Felix (JLP)-Large-Boho Denim.jpg',
  'KFJS30F-J0222-RE':'KFJS30F-J0222-RE-Felix (JLP)-Large-Boho Denim.jpg',
  'KFJS30F-J0222-SI':'KFJS30F-J0222-SI-Felix (JLP)-Large-Boho Denim.jpg',
  'KFJS30F-J0322-FR':'KFJS30F-J0322-FR-Felix (JLP)-Large-Boho Parchment.jpg',
  'KFJS30F-J0322-PR':'KFJS30F-J0322-PR-Felix (JLP)-Large-Boho Parchment.jpg',
  'KFJS30F-J0322-RE':'KFJS30F-J0322-RE-Felix (JLP)-Large-Boho Parchment.jpg',
  'KFJS30F-J0322-SI':'KFJS30F-J0322-SI-Felix (JLP)-Large-Boho Parchment.jpg',
  'KFJS30F-J0422-FR':'KFJS30F-J0422-FR-Felix (JLP)-Large-Bruges Navy.jpg',
  'KFJS30F-J0422-PR':'KFJS30F-J0422-PR-Felix (JLP)-Large-Bruges Navy.jpg',
  'KFJS30F-J0422-RE':'KFJS30F-J0422-RE-Felix (JLP)-Large-Bruges Navy.jpg',
  'KFJS30F-J0422-SI':'KFJS30F-J0422-SI-Felix (JLP)-Large-Bruges Navy.jpg',
  'KFJS30F-J0522-FR':'KFJS30F-J0522-FR-Felix (JLP)-Large-Bruges Sage.jpg',
  'KFJS30F-J0522-PR':'KFJS30F-J0522-PR-Felix (JLP)-Large-Bruges Sage.jpg',
  'KFJS30F-J0522-RE':'KFJS30F-J0522-RE-Felix (JLP)-Large-Bruges Sage.jpg',
  'KFJS30F-J0522-SI':'KFJS30F-J0522-SI-Felix (JLP)-Large-Bruges Sage.jpg',
  'KFJS30F-J0622-FR':'KFJS30F-J0622-FR-Felix (JLP)-Large-Bruges Sand.jpg',
  'KFJS30F-J0622-PR':'KFJS30F-J0622-PR-Felix (JLP)-Large-Bruges Sand.jpg',
  'KFJS30F-J0622-RE':'KFJS30F-J0622-RE-Felix (JLP)-Large-Bruges Sand.jpg',
  'KFJS30F-J0622-SI':'KFJS30F-J0622-SI-Felix (JLP)-Large-Bruges Sand.jpg',
  'KFJS30F-J0722-FR':'KFJS30F-J0722-FR-Felix (JLP)-Large-Suzy Olive.jpg',
  'KFJS30F-J0722-PR':'KFJS30F-J0722-PR-Felix (JLP)-Large-Suzy Olive.jpg',
  'KFJS30F-J0722-RE':'KFJS30F-J0722-RE-Felix (JLP)-Large-Suzy Olive.jpg',
  'KFJS30F-J0722-SI':'KFJS30F-J0722-SI-Felix (JLP)-Large-Suzy Olive.jpg',
  'KFJS30F-J0822-FR':'KFJS30F-J0822-FR-Felix (JLP)-Large-Suzy Denim.jpg',
  'KFJS30F-J0822-PR':'KFJS30F-J0822-PR-Felix (JLP)-Large-Suzy Denim.jpg',
  'KFJS30F-J0822-RE':'KFJS30F-J0822-RE-Felix (JLP)-Large-Suzy Denim.jpg',
  'KFJS30F-J0822-SI':'KFJS30F-J0822-SI-Felix (JLP)-Large-Suzy Denim.jpg',
  'KFJS30F-J0922-FR':'KFJS30F-J0922-FR-Felix (JLP)-Large-Suzy Natural.jpg',
  'KFJS30F-J0922-PR':'KFJS30F-J0922-PR-Felix (JLP)-Large-Suzy Natural.jpg',
  'KFJS30F-J0922-RE':'KFJS30F-J0922-RE-Felix (JLP)-Large-Suzy Natural.jpg',
  'KFJS30F-J0922-SI':'KFJS30F-J0922-SI-Felix (JLP)-Large-Suzy Natural.jpg',
  'KFJS30F-J1022-FR':'KFJS30F-J1022-FR-Felix (JLP)-Large-Beauville Spring Green.jpg',
  'KFJS30F-J1022-PR':'KFJS30F-J1022-PR-Felix (JLP)-Large-Beauville Spring Green.jpg',
  'KFJS30F-J1022-RE':'KFJS30F-J1022-RE-Felix (JLP)-Large-Beauville Spring Green.jpg',
  'KFJS30F-J1022-SI':'KFJS30F-J1022-SI-Felix (JLP)-Large-Beauville Spring Green.jpg',
  'KFJS30F-J1122-FR':'KFJS30F-J1122-FR-Felix (JLP)-Large-Beauville Cornish Blue.jpg',
  'KFJS30F-J1122-PR':'KFJS30F-J1122-PR-Felix (JLP)-Large-Beauville Cornish Blue.jpg',
  'KFJS30F-J1122-RE':'KFJS30F-J1122-RE-Felix (JLP)-Large-Beauville Cornish Blue.jpg',
  'KFJS30F-J1122-SI':'KFJS30F-J1122-SI-Felix (JLP)-Large-Beauville Cornish Blue.jpg',
  'KFJS30F-O0122-FR':'KFJS30F-O0122-FR-Felix (JLP)-Large-Bespoke Coastal Blue.jpg',
  'KFJS30F-O0122-PR':'KFJS30F-O0122-PR-Felix (JLP)-Large-Bespoke Coastal Blue.jpg',
  'KFJS30F-O0122-RE':'KFJS30F-O0122-RE-Felix (JLP)-Large-Bespoke Coastal Blue.jpg',
  'KFJS30F-O0122-SI':'KFJS30F-O0122-SI-Felix (JLP)-Large-Bespoke Coastal Blue.jpg',
  'KFJS30F-O0222-FR':'KFJS30F-O0222-FR-Felix (JLP)-Large-Tasman Petunia.jpg',
  'KFJS30F-O0222-PR':'KFJS30F-O0222-PR-Felix (JLP)-Large-Tasman Petunia.jpg',
  'KFJS30F-O0222-RE':'KFJS30F-O0222-RE-Felix (JLP)-Large-Tasman Petunia.jpg',
  'KFJS30F-O0222-SI':'KFJS30F-O0222-SI-Felix (JLP)-Large-Tasman Petunia.jpg',
  'KFJS30F-O0822-FR':'KFJS30F-O0822-FR-Felix (JLP)-Large-Tasman Spring Green.jpg',
  'KFJS30F-O0822-PR':'KFJS30F-O0822-PR-Felix (JLP)-Large-Tasman Spring Green.jpg',
  'KFJS30F-O0822-RE':'KFJS30F-O0822-RE-Felix (JLP)-Large-Tasman Spring Green.jpg',
  'KFJS30F-O0822-SI':'KFJS30F-O0822-SI-Felix (JLP)-Large-Tasman Spring Green.jpg',
  'KFJS30F-O0922-FR':'KFJS30F-O0922-FR-Felix (JLP)-Large-Tasman Cornish Blue.jpg',
  'KFJS30F-O0922-PR':'KFJS30F-O0922-PR-Felix (JLP)-Large-Tasman Cornish Blue.jpg',
  'KFJS30F-O0922-RE':'KFJS30F-O0922-RE-Felix (JLP)-Large-Tasman Cornish Blue.jpg',
  'KFJS30F-O0922-SI':'KFJS30F-O0922-SI-Felix (JLP)-Large-Tasman Cornish Blue.jpg',
  'KFJS30F-O2322-FR':'KFJS30F-O2322-FR-Felix (JLP)-Large-Pinstripe Natural.jpg',
  'KFJS30F-O2322-PR':'KFJS30F-O2322-PR-Felix (JLP)-Large-Pinstripe Natural.jpg',
  'KFJS30F-O2322-RE':'KFJS30F-O2322-RE-Felix (JLP)-Large-Pinstripe Natural.jpg',
  'KFJS30F-O2322-SI':'KFJS30F-O2322-SI-Felix (JLP)-Large-Pinstripe Natural.jpg',
  'KFJS30F-O2422-FR':'KFJS30F-O2422-FR-Felix (JLP)-Large-Pinstripe Petunia.jpg',
  'KFJS30F-O2422-PR':'KFJS30F-O2422-PR-Felix (JLP)-Large-Pinstripe Petunia.jpg',
  'KFJS30F-O2422-RE':'KFJS30F-O2422-RE-Felix (JLP)-Large-Pinstripe Petunia.jpg',
  'KFJS30F-O2422-SI':'KFJS30F-O2422-SI-Felix (JLP)-Large-Pinstripe Petunia.jpg',
  'KFJS30F-O2522-FR':'KFJS30F-O2522-FR-Felix (JLP)-Large-Pinstripe Nutmeg.jpg',
  'KFJS30F-O2522-PR':'KFJS30F-O2522-PR-Felix (JLP)-Large-Pinstripe Nutmeg.jpg',
  'KFJS30F-O2522-RE':'KFJS30F-O2522-RE-Felix (JLP)-Large-Pinstripe Nutmeg.jpg',
  'KFJS30F-O2522-SI':'KFJS30F-O2522-SI-Felix (JLP)-Large-Pinstripe Nutmeg.jpg',
  'KFJS30F-O2622-FR':'KFJS30F-O2622-FR-Felix (JLP)-Large-Tasman Natural.jpg',
  'KFJS30F-O2622-PR':'KFJS30F-O2622-PR-Felix (JLP)-Large-Tasman Natural.jpg',
  'KFJS30F-O2622-RE':'KFJS30F-O2622-RE-Felix (JLP)-Large-Tasman Natural.jpg',
  'KFJS30F-O2622-SI':'KFJS30F-O2622-SI-Felix (JLP)-Large-Tasman Natural.jpg',
  'KHEFFSF-A0712-FR':'KHEFFSF-A0712-FR-Henrietta-Footstool-Midsummer Faded Blue.png',
  'KHEFFSF-B1212-FR':'KHEFFSF-B1212-FR-Henrietta-Footstool-Froisse Putty.jpg',
  'KHEFFSF-G0712-FR':'KHEFFSF-G0712-FR-Henrietta-Footstool-Little Magnolia Emerald.png',
  'KHEFFSF-O1412-FR':'KHEFFSF-O1412-FR-Henrietta-Footstool-Capelo Snow Drop.jpg',
  'KHES10F-A0114-FR':'KHES10F-A0114-FR-Henrietta-Armchair-Wildwood Duck Egg.png',
  'KHES10F-A0114-SI':'KHES10F-A0114-SI-Henrietta-Armchair-Wildwood Duck Egg.png',
  'KHES10F-A0214-FR':'KHES10F-A0214-FR-Henrietta-Armchair-Wildwood Ivory.png',
  'KHES10F-A0214-SI':'KHES10F-A0214-SI-Henrietta-Armchair-Wildwood Ivory.png',
  'KHES10F-A0712-FR':'KHES10F-A0712-FR-Henrietta-Armchair-Midsummer Faded Blue.jpg',
  'KHES10F-A0712-SI':'KHES10F-A0712-SI-Henrietta-Armchair-Midsummer Faded Blue.jpg',
  'KHES10F-B1212-FR':'KHES10F-B1212-FR-Henrietta-Armchair-Froisse Putty.png',
  'KHES10F-B1212-SI':'KHES10F-B1212-SI-Henrietta-Armchair-Froisse Putty.png',
  'KHES10F-L0612-FR':'KHES10F-L0612-FR-Henrietta-Armchair-English Garden - Albertine Coral Orange.png',
  'KHES10F-L0612-SI':'KHES10F-L0612-SI-Henrietta-Armchair-English Garden - Albertine Coral Orange.png',
  'KHES10F-L0912-FR':'KHES10F-L0912-FR-Henrietta-Armchair-Omega Carnelian.png',
  'KHES10F-L0912-SI':'KHES10F-L0912-SI-Henrietta-Armchair-Omega Carnelian.png',
  'KHES10F-L1112-FR':'KHES10F-L1112-FR-Henrietta-Armchair-Omega Lagoon.png',
  'KHES10F-L1112-SI':'KHES10F-L1112-SI-Henrietta-Armchair-Omega Lagoon.png',
  'KHES10F-O1412-FR':'KHES10F-O1412-FR-Henrietta-Armchair-Capelo Snow Drop.png',
  'KHES10F-O1412-SI':'KHES10F-O1412-SI-Henrietta-Armchair-Capelo Snow Drop.png',
  'KHES30F-A0112-FR':'KHES30F-A0112-FR-Henrietta-3 Seater-Wildwood Duck Egg.png',
  'KHES30F-A0112-SI':'KHES30F-A0112-SI-Henrietta-3 Seater-Wildwood Duck Egg.png',
  'KHES30F-A0212-FR':'KHES30F-A0212-FR-Henrietta-3 Seater-Wildwood Ivory.png',
  'KHES30F-A0212-SI':'KHES30F-A0212-SI-Henrietta-3 Seater-Wildwood Ivory.png',
  'KHES30F-A0712-FR':'KHES30F-A0712-FR-Henrietta-3 Seater-Midsummer Faded Blue.jpg',
  'KHES30F-B1212-FR':'KHES30F-B1212-FR-Henrietta-3 Seater-Froisse Putty.png',
  'KHES30F-B1212-SI':'KHES30F-B1212-SI-Henrietta-3 Seater-Froisse Putty.png',
  'KHES30F-L0412-FR':'KHES30F-L0412-FR-Henrietta-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KHES30F-L0412-SI':'KHES30F-L0412-SI-Henrietta-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KHES30F-L0414-FR':'KHES30F-L0414-FR-Henrietta-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KHES30F-L0414-SI':'KHES30F-L0414-SI-Henrietta-3 Seater-English Garden - Albertine Grey Skies.jpg',
  'KHES30F-L0612-FR':'KHES30F-L0612-FR-Henrietta-3 Seater-English Garden - Albertine Coral Orange.png',
  'KHES30F-L0612-SI':'KHES30F-L0612-SI-Henrietta-3 Seater-English Garden - Albertine Coral Orange.png',
  'KHES30F-L0912-FR':'KHES30F-L0912-FR-Henrietta-3 Seater-Omega Carnelian.png',
  'KHES30F-L0912-SI':'KHES30F-L0912-SI-Henrietta-3 Seater-Omega Carnelian.png',
  'KHES30F-L1112-FR':'KHES30F-L1112-FR-Henrietta-3 Seater-Omega Lagoon.png',
  'KHES30F-L1112-SI':'KHES30F-L1112-SI-Henrietta-3 Seater-Omega Lagoon.png',
  'KHES30F-O1412-FR':'KHES30F-O1412-FR-Henrietta-3 Seater-Capelo Snow Drop.png',
  'KHES30F-O1412-SI':'KHES30F-O1412-SI-Henrietta-3 Seater-Capelo Snow Drop.png',
  'KISS10B-A0116-FR':'KISS10B-A0116-FR-Isobel-Armchair-Wildwood Duck Egg.png',
  'KISS10B-A011-FR':'KISS10B-A011-FR-Isobel-Armchair-Wildwood Duck Egg.png',
  'KISS10B-A0216-FR':'KISS10B-A0216-FR-Isobel-Armchair-Wildwood Ivory.jpg',
  'KISS10B-A0716-RE':'KISS10B-A0716-RE-Isobel-Armchair-Midsummer Faded Blue.jpg',
  'KISS10B-A0916-FR':'KISS10B-A0916-FR-Isobel-Armchair-Pelham Clementine.png',
  'KISS10B-A1016-FR':'KISS10B-A1016-FR-Isobel-Armchair-Pelham Moss.png',
  'KISS10B-A101-FR':'KISS10B-A101-FR-Isobel-Armchair-Pelham Moss.png',
  'KISS10B-A1116-FR':'KISS10B-A1116-FR-Isobel-Armchair-Pelham Denim.png',
  'KISS10B-A1216-FR':'KISS10B-A1216-FR-Isobel-Armchair-Pelham Peacock.png',
  'KISS10B-B0316-FR':'KISS10B-B0316-FR-Isobel-Armchair-Beatrice Midnight.png',
  'KISS10B-B0326-FR':'KISS10B-B0326-FR-Isobel-Armchair-Beatrice Midnight.png',
  'KISS10B-G0416-FR':'KISS10B-G0416-FR-Isobel-Armchair-Magnolia Cream Blue.jpg',
  'KISS10B-G0616-FR':'KISS10B-G0616-FR-Isobel-Armchair-Little Magnolia Espresso.jpg',
  'KISS10B-G0626-FR':'KISS10B-G0626-FR-Isobel-Armchair-Little Magnolia Espresso.png',
  'KISS10B-G0726-FR':'KISS10B-G0726-FR-Isobel-Armchair-Little Magnolia Emerald.png',
  'KISS10B-L0916-FR':'KISS10B-L0916-FR-Isobel-Armchair-Omega Carnelian.png',
  'KISS10B-L1316-FR':'KISS10B-L1316-FR-Isobel-Armchair-Omega Winter Moss.png',
  'KISS10B-O0216-FR':'KISS10B-O0216-FR-Isobel-Armchair-Tasman Petunia.jpg',
  'KISS10B-O0426-FR':'KISS10B-O0426-FR-Isobel-Armchair-Bespoke Caramel.png',
  'KISS10B-O0616-FR':'KISS10B-O0616-FR-Isobel-Armchair-Tasman Garden Grey.png',
  'KISS10B-O061-FR':'KISS10B-O061-FR-Isobel-Armchair-Garden Grey.png',
  'KISS10B-O0716-FR':'KISS10B-O0716-FR-Isobel-Armchair-Tasman Dandelion.jpg',
  'KISS10B-O1026-FR':'KISS10B-O1026-FR-Isobel-Armchair-Antarctic Narrow Chocolate.png',
  'KISS10B-O1116-FR':'KISS10B-O1116-FR-Isobel-Armchair-Tasman Chocolate.jpg',
  'KISS10B-O1316-FR':'KISS10B-O1316-FR-Isobel-Armchair-Capelo Cool Coconut.png',
  'KISS10B-O1326-FR':'KISS10B-O1326-FR-Isobel-Armchair-Capelo Cool Coconut.png',
  'KISS10B-O1416-FR':'KISS10B-O1416-FR-Isobel-Armchair-Capelo Snow Drop.png',
  'KISS10B-O1426-FR':'KISS10B-O1426-FR-Isobel-Armchair-Capelo Snow Drop.png',
  'KISS10B-O1716-FR':'KISS10B-O1716-FR-Isobel-Armchair-Capelo Inkspot.png',
  'KISS10B-O1726-FR':'KISS10B-O1726-FR-Isobel-Armchair-Capelo Inkspot.png',
  'KISS10B-O1826-FR':'KISS10B-O1826-FR-Isobel-Armchair-Columbus Evergreen.png',
  'KISS10B-O1916-FR':'KISS10B-O1916-FR-Isobel-Armchair-Columbus Marigold.png',
  'KISS10B-O1926-FR':'KISS10B-O1926-FR-Isobel-Armchair-Columbus Marigold.png',
  'KISS10B-O2026-FR':'KISS10B-O2026-FR-Isobel-Armchair-Columbus Potting Moss.png',
  'KISS15B-A0116-FR':'KISS15B-A0116-FR-Isobel-Loveseat-Wildwood Duck Egg.png',
  'KISS15B-A0216-FR':'KISS15B-A0216-FR-Isobel-Loveseat-Wildwood Ivory.png',
  'KISS15B-A0716-RE':'KISS15B-A0716-RE-Isobel-Loveseat-Midsummer Faded Blue.jpg',
  'KISS15B-A0916-FR':'KISS15B-A0916-FR-Isobel-Loveseat-Pelham Clementine.png',
  'KISS15B-A1016-FR':'KISS15B-A1016-FR-Isobel-Loveseat-Pelham Moss.png',
  'KISS15B-A1116-FR':'KISS15B-A1116-FR-Isobel-Loveseat-Pelham Denim.png',
  'KISS15B-A1216-FR':'KISS15B-A1216-FR-Isobel-Loveseat-Pelham Peacock.png',
  'KISS15B-B0316-FR':'KISS15B-B0316-FR-Isobel-Loveseat-Beatrice Midnight.png',
  'KISS15B-B0326-FR':'KISS15B-B0326-FR-Isobel-Loveseat-Beatrice Midnight.png',
  'KISS15B-G0416-FR':'KISS15B-G0416-FR-Isobel-Loveseat-Magnolia Cream Blue.png',
  'KISS15B-G0616-FR':'KISS15B-G0616-FR-Isobel-Loveseat-Little Magnolia Espresso.png',
  'KISS15B-G0626-FR':'KISS15B-G0626-FR-Isobel-Loveseat-Little Magnolia Espresso.png',
  'KISS15B-G0726-FR':'KISS15B-G0726-FR-Isobel-Loveseat-Little Magnolia Emerald.png',
  'KISS15B-L0916-FR':'KISS15B-L0916-FR-Isobel-Loveseat-Omega Carnelian.png',
  'KISS15B-L1316-FR':'KISS15B-L1316-FR-Isobel-Loveseat-Omega Winter Moss.png',
  'KISS15B-O0216-FR':'KISS15B-O0216-FR-Isobel-Loveseat-Tasman Petunia.png',
  'KISS15B-O0426-FR':'KISS15B-O0426-FR-Isobel-Loveseat-Bespoke Caramel.png',
  'KISS15B-O0616-FR':'KISS15B-O0616-FR-Isobel-Loveseat-Tasman Garden Grey.png',
  'KISS15B-O0716-FR':'KISS15B-O0716-FR-Isobel-Loveseat-Tasman Dandelion.png',
  'KISS15B-O1016-FR':'KISS15B-O1016-FR-Isobel-Loveseat-Antarctic Narrow Chocolate.png',
  'KISS15B-O1026-FR':'KISS15B-O1026-FR-Isobel-Loveseat-Antarctic Narrow Chocolate.png',
  'KISS15B-O1116-FR':'KISS15B-O1116-FR-Isobel-Loveseat-Tasman Chocolate.png',
  'KISS15B-O1316-FR':'KISS15B-O1316-FR-Isobel-Loveseat-Capelo Cool Coconut.png',
  'KISS15B-O1326-FR':'KISS15B-O1326-FR-Isobel-Loveseat-Capelo Cool Coconut.png',
  'KISS15B-O1416-FR':'KISS15B-O1416-FR-Isobel-Loveseat-Capelo Snow Drop.png',
  'KISS15B-O1426-FR':'KISS15B-O1426-FR-Isobel-Loveseat-Capelo Snow Drop.png',
  'KISS15B-O1726-FR':'KISS15B-O1726-FR-Isobel-Loveseat-Capelo Inkspot.png',
  'KISS15B-O1826-FR':'KISS15B-O1826-FR-Isobel-Loveseat-Columbus Evergreen.png',
  'KISS15B-O1916-FR':'KISS15B-O1916-FR-Isobel-Loveseat-Columbus Marigold.png',
  'KISS15B-O1926-FR':'KISS15B-O1926-FR-Isobel-Loveseat-Columbus Marigold.png',
  'KISS15B-O2026-FR':'KISS15B-O2026-FR-Isobel-Loveseat-Columbus Potting Moss.png',
  'KISS20B-A0116-FR':'KISS20B-A0116-FR-Isobel-2 Seater-Wildwood Duck Egg.png',
  'KISS20B-A0216-FR':'KISS20B-A0216-FR-Isobel-2 Seater-Wildwood Ivory.png',
  'KISS20B-A0716-RE':'KISS20B-A0716-RE-Isobel-2 Seater-Midsummer Faded Blue.jpg',
  'KISS20B-A0916-FR':'KISS20B-A0916-FR-Isobel-2 Seater-Pelham Clementine.png',
  'KISS20B-A1016-FR':'KISS20B-A1016-FR-Isobel-2 Seater-Pelham Moss.png',
  'KISS20B-A1116-FR':'KISS20B-A1116-FR-Isobel-2 Seater-Pelham Denim.png',
  'KISS20B-A1216-FR':'KISS20B-A1216-FR-Isobel-2 Seater-Pelham Peacock.png',
  'KISS20B-B0316-FR':'KISS20B-B0316-FR-Isobel-2 Seater-Beatrice Midnight.png',
  'KISS20B-B0326-FR':'KISS20B-B0326-FR-Isobel-2 Seater-Beatrice Midnight.png',
  'KISS20B-G0416-FR':'KISS20B-G0416-FR-Isobel-2 Seater-Magnolia Cream Blue.png',
  'KISS20B-G0616-FR':'KISS20B-G0616-FR-Isobel-2 Seater-Little Magnolia Espresso.png',
  'KISS20B-G0626-FR':'KISS20B-G0626-FR-Isobel-2 Seater-Little Magnolia Espresso.png',
  'KISS20B-G0726-FR':'KISS20B-G0726-FR-Isobel-2 Seater-Little Magnolia Emerald.png',
  'KISS20B-L0916-FR':'KISS20B-L0916-FR-Isobel-2 Seater-Omega Carnelian.png',
  'KISS20B-L1316-FR':'KISS20B-L1316-FR-Isobel-2 Seater-Omega Winter Moss.png',
  'KISS20B-O0216-FR':'KISS20B-O0216-FR-Isobel-2 Seater-Tasman Petunia.png',
  'KISS20B-O0426-FR':'KISS20B-O0426-FR-Isobel-2 Seater-Bespoke Caramel.png',
  'KISS20B-O0616-FR':'KISS20B-O0616-FR-Isobel-2 Seater-Tasman Garden Grey.png',
  'KISS20B-O0716-FR':'KISS20B-O0716-FR-Isobel-2 Seater-Tasman Dandelion.png',
  'KISS20B-O1016-FR':'KISS20B-O1016-FR-Isobel-2 Seater-Antarctic Narrow Chocolate.png',
  'KISS20B-O1026-FR':'KISS20B-O1026-FR-Isobel-2 Seater-Antarctic Narrow Chocolate.png',
  'KISS20B-O1116-FR':'KISS20B-O1116-FR-Isobel-2 Seater-Tasman Chocolate.png',
  'KISS20B-O1316-FR':'KISS20B-O1316-FR-Isobel-2 Seater-Capelo Cool Coconut.png',
  'KISS20B-O1326-FR':'KISS20B-O1326-FR-Isobel-2 Seater-Capelo Cool Coconut.png',
  'KISS20B-O1416-FR':'KISS20B-O1416-FR-Isobel-2 Seater-Capelo Snow Drop.png',
  'KISS20B-O1426-FR':'KISS20B-O1426-FR-Isobel-2 Seater-Capelo Snow Drop.png',
  'KISS20B-O1716-FR':'KISS20B-O1716-FR-Isobel-2 Seater-Capelo Inkspot.png',
  'KISS20B-O1726-FR':'KISS20B-O1726-FR-Isobel-2 Seater-Capelo Inkspot.png',
  'KISS20B-O1826-FR':'KISS20B-O1826-FR-Isobel-2 Seater-Columbus Evergreen.png',
  'KISS20B-O1916-FR':'KISS20B-O1916-FR-Isobel-2 Seater-Columbus Marigold.png',
  'KISS20B-O1926-FR':'KISS20B-O1926-FR-Isobel-2 Seater-Columbus Marigold.png',
  'KISS20B-O2026-FR':'KISS20B-O2026-FR-Isobel-2 Seater-Columbus Potting Moss.png',
  'KISS25B-A0116-FR':'KISS25B-A0116-FR-Isobel-2.5 Seater-Wildwood Duck Egg.png',
  'KISS25B-A0216-FR':'KISS25B-A0216-FR-Isobel-2.5 Seater-Wildwood Ivory.png',
  'KISS25B-A0716-RE':'KISS25B-A0716-RE-Isobel-2.5 Seater-Midsummer Faded Blue.jpg',
  'KISS25B-A0916-FR':'KISS25B-A0916-FR-Isobel-2.5 Seater-Pelham Clementine.png',
  'KISS25B-A1016-FR':'KISS25B-A1016-FR-Isobel-2.5 Seater-Pelham Moss.png',
  'KISS25B-A1116-FR':'KISS25B-A1116-FR-Isobel-2.5 Seater-Pelham Denim.png',
  'KISS25B-A1216-FR':'KISS25B-A1216-FR-Isobel-2.5 Seater-Pelham Peacock.png',
  'KISS25B-B0316-FR':'KISS25B-B0316-FR-Isobel-2.5 Seater-Beatrice Midnight.png',
  'KISS25B-B0326-FR':'KISS25B-B0326-FR-Isobel-2.5 Seater-Beatrice Midnight.png',
  'KISS25B-G0416-FR':'KISS25B-G0416-FR-Isobel-2.5 Seater-Magnolia Cream Blue.png',
  'KISS25B-G0616-FR':'KISS25B-G0616-FR-Isobel-2.5 Seater-Little Magnolia Espresso.png',
  'KISS25B-G0626-FR':'KISS25B-G0626-FR-Isobel-2.5 Seater-Little Magnolia Espresso.png',
  'KISS25B-G0726-FR':'KISS25B-G0726-FR-Isobel-2.5 Seater-Little Magnolia Emerald.png',
  'KISS25B-L0916-FR':'KISS25B-L0916-FR-Isobel-2.5 Seater-Omega Carnelian.png',
  'KISS25B-L1316-FR':'KISS25B-L1316-FR-Isobel-2.5 Seater-Omega Winter Moss.png',
  'KISS25B-O0216-FR':'KISS25B-O0216-FR-Isobel-2.5 Seater-Tasman Petunia.png',
  'KISS25B-O0426-FR':'KISS25B-O0426-FR-Isobel-2.5 Seater-Bespoke Caramel.png',
  'KISS25B-O0616-FR':'KISS25B-O0616-FR-Isobel-2.5 Seater-Tasman Garden Grey.png',
  'KISS25B-O0716-FR':'KISS25B-O0716-FR-Isobel-2.5 Seater-Tasman Dandelion.png',
  'KISS25B-O1016-FR':'KISS25B-O1016-FR-Isobel-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KISS25B-O1026-FR':'KISS25B-O1026-FR-Isobel-2.5 Seater-Antarctic Narrow Chocolate.png',
  'KISS25B-O1116-FR':'KISS25B-O1116-FR-Isobel-2.5 Seater-Tasman Chocolate.png',
  'KISS25B-O1316-FR':'KISS25B-O1316-FR-Isobel-2.5 Seater-Capelo Cool Coconut.png',
  'KISS25B-O1326-FR':'KISS25B-O1326-FR-Isobel-2.5 Seater-Capelo Cool Coconut.png',
  'KISS25B-O1416-FR':'KISS25B-O1416-FR-Isobel-2.5 Seater-Capelo Snow Drop.png',
  'KISS25B-O1426-FR':'KISS25B-O1426-FR-Isobel-2.5 Seater-Capelo Snow Drop.png',
  'KISS25B-O1716-FR':'KISS25B-O1716-FR-Isobel-2.5 Seater-Capelo Inkspot.png',
  'KISS25B-O1726-FR':'KISS25B-O1726-FR-Isobel-2.5 Seater-Capelo Inkspot.png',
  'KISS25B-O1826-FR':'KISS25B-O1826-FR-Isobel-2.5 Seater-Columbus Evergreen.png',
  'KISS25B-O1916-FR':'KISS25B-O1916-FR-Isobel-2.5 Seater-Columbus Marigold.png',
  'KISS25B-O1926-FR':'KISS25B-O1926-FR-Isobel-2.5 Seater-Columbus Marigold.png',
  'KISS25B-O2026-FR':'KISS25B-O2026-FR-Isobel-2.5 Seater-Columbus Potting Moss.png',
  'KISS30B-A0116-FR':'KISS30B-A0116-FR-Isobel-3 Seater-Wildwood Duck Egg.png',
  'KISS30B-A0216-FR':'KISS30B-A0216-FR-Isobel-3 Seater-Wildwood Ivory.png',
  'KISS30B-A0716-RE':'KISS30B-A0716-RE-Isobel-3 Seater-Midsummer Faded Blue.jpg',
  'KISS30B-A0916-FR':'KISS30B-A0916-FR-Isobel-3 Seater-Pelham Clementine.png',
  'KISS30B-A1016-FR':'KISS30B-A1016-FR-Isobel-3 Seater-Pelham Moss.png',
  'KISS30B-A1116-FR':'KISS30B-A1116-FR-Isobel-3 Seater-Pelham Denim.png',
  'KISS30B-A1216-FR':'KISS30B-A1216-FR-Isobel-3 Seater-Pelham Peacock.png',
  'KISS30B-B0316-FR':'KISS30B-B0316-FR-Isobel-3 Seater-Beatrice Midnight.png',
  'KISS30B-G0416-FR':'KISS30B-G0416-FR-Isobel-3 Seater-Magnolia Cream Blue.png',
  'KISS30B-G0616-FR':'KISS30B-G0616-FR-Isobel-3 Seater-Little Magnolia Espresso.png',
  'KISS30B-G0626-FR':'KISS30B-G0626-FR-Isobel-3 Seater-Little Magnolia Espresso.png',
  'KISS30B-G0716-FR':'KISS30B-G0716-FR-Isobel-3 Seater-Little Magnolia Emerald.png',
  'KISS30B-G0716-RE':'KISS30B-G0716-RE-Isobel-3 Seater-Little Magnolia Emerald.jpg',
  'KISS30B-G0726-FR':'KISS30B-G0726-FR-Isobel-3 Seater-Little Magnolia Emerald.png',
  'KISS30B-L0916-FR':'KISS30B-L0916-FR-Isobel-3 Seater-Omega Carnelian.png',
  'KISS30B-L1316-FR':'KISS30B-L1316-FR-Isobel-3 Seater-Omega Winter Moss.png',
  'KISS30B-O0216-FR':'KISS30B-O0216-FR-Isobel-3 Seater-Tasman Petunia.png',
  'KISS30B-O0426-FR':'KISS30B-O0426-FR-Isobel-3 Seater-Bespoke Caramel.png',
  'KISS30B-O0616-FR':'KISS30B-O0616-FR-Isobel-3 Seater-Tasman Garden Grey.png',
  'KISS30B-O0716-FR':'KISS30B-O0716-FR-Isobel-3 Seater-Tasman Dandelion.png',
  'KISS30B-O1016-FR':'KISS30B-O1016-FR-Isobel-3 Seater-Antarctic Narrow Chocolate.png',
  'KISS30B-O1026-FR':'KISS30B-O1026-FR-Isobel-3 Seater-Antarctic Narrow Chocolate.png',
  'KISS30B-O1116-FR':'KISS30B-O1116-FR-Isobel-3 Seater-Tasman Chocolate.png',
  'KISS30B-O1316-FR':'KISS30B-O1316-FR-Isobel-3 Seater-Capelo Cool Coconut.png',
  'KISS30B-O1326-FR':'KISS30B-O1326-FR-Isobel-3 Seater-Capelo Cool Coconut.png',
  'KISS30B-O1416-FR':'KISS30B-O1416-FR-Isobel-3 Seater-Capelo Snow Drop.png',
  'KISS30B-O1426-FR':'KISS30B-O1426-FR-Isobel-3 Seater-Capelo Snow Drop.png',
  'KISS30B-O1716-FR':'KISS30B-O1716-FR-Isobel-3 Seater-Capelo Inkspot.png',
  'KISS30B-O1726-FR':'KISS30B-O1726-FR-Isobel-3 Seater-Capelo Inkspot.png',
  'KISS30B-O1826-FR':'KISS30B-O1826-FR-Isobel-3 Seater-Columbus Evergreen.png',
  'KISS30B-O1916-FR':'KISS30B-O1916-FR-Isobel-3 Seater-Columbus Marigold.png',
  'KISS30B-O1926-FR':'KISS30B-O1926-FR-Isobel-3 Seater-Columbus Marigold.png',
  'KISS30B-O2026-FR':'KISS30B-O2026-FR-Isobel-3 Seater-Columbus Potting Moss.png',
  'KISS40B-A0116-FR':'KISS40B-A0116-FR-Isobel-4 Seater-Wildwood Duck Egg.png',
  'KISS40B-A0216-FR':'KISS40B-A0216-FR-Isobel-4 Seater-Wildwood Ivory.png',
  'KISS40B-A0716-RE':'KISS40B-A0716-RE-Isobel-4 Seater-Midsummer Faded Blue.jpg',
  'KISS40B-A0916-FR':'KISS40B-A0916-FR-Isobel-4 Seater-Pelham Clementine.png',
  'KISS40B-A1016-FR':'KISS40B-A1016-FR-Isobel-4 Seater-Pelham Moss.png',
  'KISS40B-A1116-FR':'KISS40B-A1116-FR-Isobel-4 Seater-Pelham Denim.png',
  'KISS40B-A1216-FR':'KISS40B-A1216-FR-Isobel-4 Seater-Pelham Peacock.png',
  'KISS40B-B0316-FR':'KISS40B-B0316-FR-Isobel-4 Seater-Beatrice Midnight.png',
  'KISS40B-B0326-FR':'KISS40B-B0326-FR-Isobel-4 Seater-Beatrice Midnight.png',
  'KISS40B-G0416-FR':'KISS40B-G0416-FR-Isobel-4 Seater-Magnolia Cream Blue.png',
  'KISS40B-G0616-FR':'KISS40B-G0616-FR-Isobel-4 Seater-Little Magnolia Espresso.png',
  'KISS40B-G0626-FR':'KISS40B-G0626-FR-Isobel-4 Seater-Little Magnolia Espresso.png',
  'KISS40B-G0726-FR':'KISS40B-G0726-FR-Isobel-4 Seater-Little Magnolia Emerald.png',
  'KISS40B-L0916-FR':'KISS40B-L0916-FR-Isobel-4 Seater-Omega Carnelian.png',
  'KISS40B-L1316-FR':'KISS40B-L1316-FR-Isobel-4 Seater-Omega Winter Moss.png',
  'KISS40B-O0216-FR':'KISS40B-O0216-FR-Isobel-4 Seater-Tasman Petunia.png',
  'KISS40B-O0426-FR':'KISS40B-O0426-FR-Isobel-4 Seater-Bespoke Caramel.png',
  'KISS40B-O0616-FR':'KISS40B-O0616-FR-Isobel-4 Seater-Tasman Garden Grey.png',
  'KISS40B-O0716-FR':'KISS40B-O0716-FR-Isobel-4 Seater-Tasman Dandelion.png',
  'KISS40B-O1016-FR':'KISS40B-O1016-FR-Isobel-4 Seater-Antarctic Narrow Chocolate.png',
  'KISS40B-O1026-FR':'KISS40B-O1026-FR-Isobel-4 Seater-Antarctic Narrow Chocolate.png',
  'KISS40B-O1116-FR':'KISS40B-O1116-FR-Isobel-4 Seater-Tasman Chocolate.png',
  'KISS40B-O1316-FR':'KISS40B-O1316-FR-Isobel-4 Seater-Capelo Cool Coconut.png',
  'KISS40B-O1326-FR':'KISS40B-O1326-FR-Isobel-4 Seater-Capelo Cool Coconut.png',
  'KISS40B-O1416-FR':'KISS40B-O1416-FR-Isobel-4 Seater-Capelo Snow Drop.png',
  'KISS40B-O1426-FR':'KISS40B-O1426-FR-Isobel-4 Seater-Capelo Snow Drop.png',
  'KISS40B-O1716-FR':'KISS40B-O1716-FR-Isobel-4 Seater-Capelo Inkspot.png',
  'KISS40B-O1726-FR':'KISS40B-O1726-FR-Isobel-4 Seater-Capelo Inkspot.png',
  'KISS40B-O1826-FR':'KISS40B-O1826-FR-Isobel-4 Seater-Columbus Evergreen.png',
  'KISS40B-O1916-FR':'KISS40B-O1916-FR-Isobel-4 Seater-Columbus Marigold.png',
  'KISS40B-O1926-FR':'KISS40B-O1926-FR-Isobel-4 Seater-Columbus Marigold.png',
  'KISS40B-O2026-FR':'KISS40B-O2026-FR-Isobel-4 Seater-Columbus Potting Moss.png',
  'KSAS15B-B0122-FR':'KSAS15B-B0122-FR-Salthrop-Loveseat-Beatrice Barley.png',
  'KSAS15B-B0122-SI':'KSAS15B-B0122-SI-Salthrop-Loveseat-Beatrice Barley.png',
  'KSAS15B-B0222-FR':'KSAS15B-B0222-FR-Salthrop-Loveseat-Beatrice Camelia.png',
  'KSAS15B-B0222-SI':'KSAS15B-B0222-SI-Salthrop-Loveseat-Beatrice Camelia.png',
  'KSAS15B-B0322-FR':'KSAS15B-B0322-FR-Salthrop-Loveseat-Beatrice Midnight.png',
  'KSAS15B-B0322-SI':'KSAS15B-B0322-SI-Salthrop-Loveseat-Beatrice Midnight.png',
  'KSAS15B-B0422-FR':'KSAS15B-B0422-FR-Salthrop-Loveseat-Beatrice Nutmeg.png',
  'KSAS15B-B0422-SI':'KSAS15B-B0422-SI-Salthrop-Loveseat-Beatrice Nutmeg.png',
  'KSAS15B-B0522-FR':'KSAS15B-B0522-FR-Salthrop-Loveseat-Beatrice Olive.png',
  'KSAS15B-B0522-SI':'KSAS15B-B0522-SI-Salthrop-Loveseat-Beatrice Olive.png',
  'KSAS15B-J0122-FR':'KSAS15B-J0122-FR-Salthrop-Loveseat-Boho Cloud.png',
  'KSAS15B-J0122-SI':'KSAS15B-J0122-SI-Salthrop-Loveseat-Boho Cloud.png',
  'KSAS15B-J0222-FR':'KSAS15B-J0222-FR-Salthrop-Loveseat-Boho Denim.png',
  'KSAS15B-J0222-SI':'KSAS15B-J0222-SI-Salthrop-Loveseat-Boho Denim.png',
  'KSAS15B-J0322-FR':'KSAS15B-J0322-FR-Salthrop-Loveseat-Boho Parchment.png',
  'KSAS15B-J0322-SI':'KSAS15B-J0322-SI-Salthrop-Loveseat-Boho Parchment.png',
  'KSAS15B-J0422-FR':'KSAS15B-J0422-FR-Salthrop-Loveseat-Bruges Navy.png',
  'KSAS15B-J0422-SI':'KSAS15B-J0422-SI-Salthrop-Loveseat-Bruges Navy.png',
  'KSAS15B-J0522-FR':'KSAS15B-J0522-FR-Salthrop-Loveseat-Bruges Sage.jpeg',
  'KSAS15B-J0522-SI':'KSAS15B-J0522-SI-Salthrop-Loveseat-Bruges Sage.png',
  'KSAS15B-J0622-FR':'KSAS15B-J0622-FR-Salthrop-Loveseat-Bruges Sand.png',
  'KSAS15B-J0622-SI':'KSAS15B-J0622-SI-Salthrop-Loveseat-Bruges Sand.png',
  'KSAS15B-J0722-FR':'KSAS15B-J0722-FR-Salthrop-Loveseat-Suzy Olive.png',
  'KSAS15B-J0722-SI':'KSAS15B-J0722-SI-Salthrop-Loveseat-Suzy Olive.png',
  'KSAS15B-J0822-FR':'KSAS15B-J0822-FR-Salthrop-Loveseat-Suzy Denim.png',
  'KSAS15B-J0822-SI':'KSAS15B-J0822-SI-Salthrop-Loveseat-Suzy Denim.png',
  'KSAS15B-J0922-FR':'KSAS15B-J0922-FR-Salthrop-Loveseat-Suzy Natural.png',
  'KSAS15B-J1022-SI':'KSAS15B-J1022-SI-Salthrop-Loveseat-Beauville Spring Green.png',
  'KSAS15B-J1122-FR':'KSAS15B-J1122-FR-Salthrop-Loveseat-Beauville Cornish Blue.jpeg',
  'KSAS15B-J1122-SI':'KSAS15B-J1122-SI-Salthrop-Loveseat-Beauville Cornish Blue.png',
  'KSAS15B-O0122-FR':'KSAS15B-O0122-FR-Salthrop-Loveseat-Bespoke Coastal Blue.png',
  'KSAS15B-O0122-SI':'KSAS15B-O0122-SI-Salthrop-Loveseat-Bespoke Coastal Blue.png',
  'KSAS15B-O0222-FR':'KSAS15B-O0222-FR-Salthrop-Loveseat-Tasman Petunia.png',
  'KSAS15B-O0222-SI':'KSAS15B-O0222-SI-Salthrop-Loveseat-Tasman Petunia.png',
  'KSAS15B-O0822-FR':'KSAS15B-O0822-FR-Salthrop-Loveseat-Tasman Spring Green.png',
  'KSAS15B-O0822-SI':'KSAS15B-O0822-SI-Salthrop-Loveseat-Tasman Spring Green.png',
  'KSAS15B-O0922-FR':'KSAS15B-O0922-FR-Salthrop-Loveseat-Tasman Cornish Blue.png',
  'KSAS15B-O0922-SI':'KSAS15B-O0922-SI-Salthrop-Loveseat-Tasman Cornish Blue.png',
  'KSAS15B-O2322-FR':'KSAS15B-O2322-FR-Salthrop-Loveseat-Pinstripe Natural.png',
  'KSAS15B-O2322-SI':'KSAS15B-O2322-SI-Salthrop-Loveseat-Pinstripe Natural.png',
  'KSAS15B-O2422-FR':'KSAS15B-O2422-FR-Salthrop-Loveseat-Pinstripe Petunia.png',
  'KSAS15B-O2422-SI':'KSAS15B-O2422-SI-Salthrop-Loveseat-Pinstripe Petunia.png',
  'KSAS15B-O2522-FR':'KSAS15B-O2522-FR-Salthrop-Loveseat-Pinstripe Nutmeg.png',
  'KSAS15B-O2522-SI':'KSAS15B-O2522-SI-Salthrop-Loveseat-Pinstripe Nutmeg.png',
  'KSAS15B-O2622-FR':'KSAS15B-O2622-FR-Salthrop-Loveseat-Tasman Natural.png',
  'KSAS15S-B0122-FR':'KSAS15S-B0122-FR-Salthrop-Loveseat-Beatrice Barley.png',
  'KSAS15S-B0122-SI':'KSAS15S-B0122-SI-Salthrop-Loveseat-Beatrice Barley.png',
  'KSAS15S-B0222-SI':'KSAS15S-B0222-SI-Salthrop-Loveseat-Beatrice Camelia.png',
  'KSAS15S-B0322-FR':'KSAS15S-B0322-FR-Salthrop-Loveseat-Beatrice Midnight.png',
  'KSAS15S-B0322-SI':'KSAS15S-B0322-SI-Salthrop-Loveseat-Beatrice Midnight.png',
  'KSAS15S-B0422-FR':'KSAS15S-B0422-FR-Salthrop-Loveseat-Beatrice Nutmeg.png',
  'KSAS15S-B0422-SI':'KSAS15S-B0422-SI-Salthrop-Loveseat-Beatrice Nutmeg.png',
  'KSAS15S-B0522-FR':'KSAS15S-B0522-FR-Salthrop-Loveseat-Beatrice Olive.png',
  'KSAS15S-B0522-SI':'KSAS15S-B0522-SI-Salthrop-Loveseat-Beatrice Olive.png',
  'KSAS15S-J0122-FR':'KSAS15S-J0122-FR-Salthrop-Loveseat-Boho Cloud.png',
  'KSAS15S-J0122-SI':'KSAS15S-J0122-SI-Salthrop-Loveseat-Boho Cloud.png',
  'KSAS15S-J0222-FR':'KSAS15S-J0222-FR-Salthrop-Loveseat-Boho Denim.png',
  'KSAS15S-J0222-SI':'KSAS15S-J0222-SI-Salthrop-Loveseat-Boho Denim.png',
  'KSAS15S-J0322-FR':'KSAS15S-J0322-FR-Salthrop-Loveseat-Boho Parchment.png',
  'KSAS15S-J0322-SI':'KSAS15S-J0322-SI-Salthrop-Loveseat-Boho Parchment.png',
  'KSAS15S-J0422-FR':'KSAS15S-J0422-FR-Salthrop-Loveseat-Bruges Navy.jpg',
  'KSAS15S-J0422-SI':'KSAS15S-J0422-SI-Salthrop-Loveseat-Bruges Navy.jpg',
  'KSAS15S-J0522-FR':'KSAS15S-J0522-FR-Salthrop-Loveseat-Bruges Sage.jpg',
  'KSAS15S-J0522-SI':'KSAS15S-J0522-SI-Salthrop-Loveseat-Bruges Sage.jpg',
  'KSAS15S-J0622-FR':'KSAS15S-J0622-FR-Salthrop-Loveseat-Bruges Sand.jpg',
  'KSAS15S-J0622-SI':'KSAS15S-J0622-SI-Salthrop-Loveseat-Bruges Sand.jpg',
  'KSAS15S-J0722-FR':'KSAS15S-J0722-FR-Salthrop-Loveseat-Suzy Olive.jpg',
  'KSAS15S-J0722-SI':'KSAS15S-J0722-SI-Salthrop-Loveseat-Suzy Olive.jpg',
  'KSAS15S-J0822-FR':'KSAS15S-J0822-FR-Salthrop-Loveseat-Suzy Denim.jpg',
  'KSAS15S-J0822-SI':'KSAS15S-J0822-SI-Salthrop-Loveseat-Suzy Denim.jpg',
  'KSAS15S-J0922-FR':'KSAS15S-J0922-FR-Salthrop-Loveseat-Suzy Natural.jpg',
  'KSAS15S-J0922-SI':'KSAS15S-J0922-SI-Salthrop-Loveseat-Suzy Natural.png',
  'KSAS15S-J1022-FR':'KSAS15S-J1022-FR-Salthrop-Loveseat-Beauville Spring Green.png',
  'KSAS15S-J1022-SI':'KSAS15S-J1022-SI-Salthrop-Loveseat-Beauville Spring Green.jpg',
  'KSAS15S-J1122-FR':'KSAS15S-J1122-FR-Salthrop-Loveseat-Beauville Cornish Blue.jpg',
  'KSAS15S-J1122-SI':'KSAS15S-J1122-SI-Salthrop-Loveseat-Beauville Cornish Blue.jpg',
  'KSAS15S-O0122-FR':'KSAS15S-O0122-FR-Salthrop-Loveseat-Bespoke Coastal Blue.png',
  'KSAS15S-O0122-SI':'KSAS15S-O0122-SI-Salthrop-Loveseat-Bespoke Coastal Blue.png',
  'KSAS15S-O0222-FR':'KSAS15S-O0222-FR-Salthrop-Loveseat-Tasman Petunia.png',
  'KSAS15S-O0222-SI':'KSAS15S-O0222-SI-Salthrop-Loveseat-Tasman Petunia.png',
  'KSAS15S-O0822-FR':'KSAS15S-O0822-FR-Salthrop-Loveseat-Tasman Spring Green.png',
  'KSAS15S-O0822-SI':'KSAS15S-O0822-SI-Salthrop-Loveseat-Tasman Spring Green.png',
  'KSAS15S-O0922-SI':'KSAS15S-O0922-SI-Salthrop-Loveseat-Tasman Cornish Blue.png',
  'KSAS15S-O2322-FR':'KSAS15S-O2322-FR-Salthrop-Loveseat-Pinstripe Natural.jpg',
  'KSAS15S-O2322-SI':'KSAS15S-O2322-SI-Salthrop-Loveseat-Pinstripe Natural.jpg',
  'KSAS15S-O2422-FR':'KSAS15S-O2422-FR-Salthrop-Loveseat-Pinstripe Petunia.jpg',
  'KSAS15S-O2422-SI':'KSAS15S-O2422-SI-Salthrop-Loveseat-Pinstripe Petunia.jpg',
  'KSAS15S-O2522-FR':'KSAS15S-O2522-FR-Salthrop-Loveseat-Pinstripe Nutmeg.jpg',
  'KSAS15S-O2522-SI':'KSAS15S-O2522-SI-Salthrop-Loveseat-Pinstripe Nutmeg.jpg',
  'KSAS15S-O2622-FR':'KSAS15S-O2622-FR-Salthrop-Loveseat-Tasman Natural.jpg',
  'KSAS15S-O2622-SI':'KSAS15S-O2622-SI-Salthrop-Loveseat-Tasman Natural.png',
  'KSAS20B-B0122-FR':'KSAS20B-B0122-FR-Salthrop-2 Seater-Beatrice Barley.png',
  'KSAS20B-B0122-SI':'KSAS20B-B0122-SI-Salthrop-2 Seater-Beatrice Barley.png',
  'KSAS20B-B0222-FR':'KSAS20B-B0222-FR-Salthrop-2 Seater-Beatrice Camelia.png',
  'KSAS20B-B0222-SI':'KSAS20B-B0222-SI-Salthrop-2 Seater-Beatrice Camelia.png',
  'KSAS20B-B0322-FR':'KSAS20B-B0322-FR-Salthrop-2 Seater-Beatrice Midnight.png',
  'KSAS20B-B0322-SI':'KSAS20B-B0322-SI-Salthrop-2 Seater-Beatrice Midnight.png',
  'KSAS20B-B0422-FR':'KSAS20B-B0422-FR-Salthrop-2 Seater-Beatrice Nutmeg.png',
  'KSAS20B-B0422-SI':'KSAS20B-B0422-SI-Salthrop-2 Seater-Beatrice Nutmeg.png',
  'KSAS20B-B0522-FR':'KSAS20B-B0522-FR-Salthrop-2 Seater-Beatrice Olive.png',
  'KSAS20B-B0522-SI':'KSAS20B-B0522-SI-Salthrop-2 Seater-Beatrice Olive.png',
  'KSAS20B-J0122-FR':'KSAS20B-J0122-FR-Salthrop-2 Seater-Boho Cloud.png',
  'KSAS20B-J0122-SI':'KSAS20B-J0122-SI-Salthrop-2 Seater-Boho Cloud.png',
  'KSAS20B-J0222-FR':'KSAS20B-J0222-FR-Salthrop-2 Seater-Boho Denim.png',
  'KSAS20B-J0222-SI':'KSAS20B-J0222-SI-Salthrop-2 Seater-Boho Denim.png',
  'KSAS20B-J0322-FR':'KSAS20B-J0322-FR-Salthrop-2 Seater-Boho Parchment.png',
  'KSAS20B-J0322-SI':'KSAS20B-J0322-SI-Salthrop-2 Seater-Boho Parchment.png',
  'KSAS20B-J0422-FR':'KSAS20B-J0422-FR-Salthrop-2 Seater-Bruges Navy.png',
  'KSAS20B-J0422-SI':'KSAS20B-J0422-SI-Salthrop-2 Seater-Bruges Navy.png',
  'KSAS20B-J0522-FR':'KSAS20B-J0522-FR-Salthrop-2 Seater-Bruges Sage.png',
  'KSAS20B-J0522-SI':'KSAS20B-J0522-SI-Salthrop-2 Seater-Bruges Sage.png',
  'KSAS20B-J0622-FR':'KSAS20B-J0622-FR-Salthrop-2 Seater-Bruges Sand.png',
  'KSAS20B-J0622-SI':'KSAS20B-J0622-SI-Salthrop-2 Seater-Bruges Sand.png',
  'KSAS20B-J0722-SI':'KSAS20B-J0722-SI-Salthrop-2 Seater-Suzy Olive.png',
  'KSAS20B-J0822-SI':'KSAS20B-J0822-SI-Salthrop-2 Seater-Suzy Denim.png',
  'KSAS20B-J0922-SI':'KSAS20B-J0922-SI-Salthrop-2 Seater-Suzy Natural.png',
  'KSAS20B-J1022-FR':'KSAS20B-J1022-FR-Salthrop-2 Seater-Beauville Spring Green.png',
  'KSAS20B-J1022-SI':'KSAS20B-J1022-SI-Salthrop-2 Seater-Beauville Spring Green.png',
  'KSAS20B-J1122-FR':'KSAS20B-J1122-FR-Salthrop-2 Seater-Beauville Cornish Blue.png',
  'KSAS20B-J1122-SI':'KSAS20B-J1122-SI-Salthrop-2 Seater-Beauville Cornish Blue.png',
  'KSAS20B-O0122-FR':'KSAS20B-O0122-FR-Salthrop-2 Seater-Bespoke Coastal Blue.png',
  'KSAS20B-O0122-SI':'KSAS20B-O0122-SI-Salthrop-2 Seater-Bespoke Coastal Blue.png',
  'KSAS20B-O0222-FR':'KSAS20B-O0222-FR-Salthrop-2 Seater-Tasman Petunia.png',
  'KSAS20B-O0222-SI':'KSAS20B-O0222-SI-Salthrop-2 Seater-Tasman Petunia.png',
  'KSAS20B-O0822-FR':'KSAS20B-O0822-FR-Salthrop-2 Seater-Tasman Spring Green.png',
  'KSAS20B-O0822-SI':'KSAS20B-O0822-SI-Salthrop-2 Seater-Tasman Spring Green.png',
  'KSAS20B-O0922-FR':'KSAS20B-O0922-FR-Salthrop-2 Seater-Tasman Cornish Blue.png',
  'KSAS20B-O0922-SI':'KSAS20B-O0922-SI-Salthrop-2 Seater-Tasman Cornish Blue.png',
  'KSAS20B-O2322-FR':'KSAS20B-O2322-FR-Salthrop-2 Seater-Pinstripe Natural.png',
  'KSAS20B-O2322-SI':'KSAS20B-O2322-SI-Salthrop-2 Seater-Pinstripe Natural.png',
  'KSAS20B-O2422-FR':'KSAS20B-O2422-FR-Salthrop-2 Seater-Pinstripe Petunia.png',
  'KSAS20B-O2422-SI':'KSAS20B-O2422-SI-Salthrop-2 Seater-Pinstripe Petunia.png',
  'KSAS20B-O2522-FR':'KSAS20B-O2522-FR-Salthrop-2 Seater-Pinstripe Nutmeg.png',
  'KSAS20B-O2522-SI':'KSAS20B-O2522-SI-Salthrop-2 Seater-Pinstripe Nutmeg.png',
  'KSAS20B-O2622-FR':'KSAS20B-O2622-FR-Salthrop-2 Seater-Tasman Natural.png',
  'KSAS20B-O2622-SI':'KSAS20B-O2622-SI-Salthrop-2 Seater-Tasman Natural.png',
  'KSAS20S-B0122-FR':'KSAS20S-B0122-FR-Salthrop-2 Seater-Beatrice Barley.png',
  'KSAS20S-B0122-SI':'KSAS20S-B0122-SI-Salthrop-2 Seater-Beatrice Barley.png',
  'KSAS20S-B0222-FR':'KSAS20S-B0222-FR-Salthrop-2 Seater-Beatrice Camelia.png',
  'KSAS20S-B0222-SI':'KSAS20S-B0222-SI-Salthrop-2 Seater-Beatrice Camelia.png',
  'KSAS20S-B0322-FR':'KSAS20S-B0322-FR-Salthrop-2 Seater-Beatrice Midnight.png',
  'KSAS20S-B0322-SI':'KSAS20S-B0322-SI-Salthrop-2 Seater-Beatrice Midnight.png',
  'KSAS20S-B0422-FR':'KSAS20S-B0422-FR-Salthrop-2 Seater-Beatrice Nutmeg.png',
  'KSAS20S-B0422-SI':'KSAS20S-B0422-SI-Salthrop-2 Seater-Beatrice Nutmeg.png',
  'KSAS20S-B0522-FR':'KSAS20S-B0522-FR-Salthrop-2 Seater-Beatrice Olive.png',
  'KSAS20S-B0522-SI':'KSAS20S-B0522-SI-Salthrop-2 Seater-Beatrice Olive.png',
  'KSAS20S-J0122-FR':'KSAS20S-J0122-FR-Salthrop-2 Seater-Boho Cloud.png',
  'KSAS20S-J0122-SI':'KSAS20S-J0122-SI-Salthrop-2 Seater-Boho Cloud.png',
  'KSAS20S-J0222-FR':'KSAS20S-J0222-FR-Salthrop-2 Seater-Boho Denim.png',
  'KSAS20S-J0222-SI':'KSAS20S-J0222-SI-Salthrop-2 Seater-Boho Denim.png',
  'KSAS20S-J0322-FR':'KSAS20S-J0322-FR-Salthrop-2 Seater-Boho Parchment.png',
  'KSAS20S-J0322-SI':'KSAS20S-J0322-SI-Salthrop-2 Seater-Boho Parchment.png',
  'KSAS20S-J0422-FR':'KSAS20S-J0422-FR-Salthrop-2 Seater-Bruges Navy.jpg',
  'KSAS20S-J0422-SI':'KSAS20S-J0422-SI-Salthrop-2 Seater-Bruges Navy.jpg',
  'KSAS20S-J0522-FR':'KSAS20S-J0522-FR-Salthrop-2 Seater-Bruges Sage.jpg',
  'KSAS20S-J0522-SI':'KSAS20S-J0522-SI-Salthrop-2 Seater-Bruges Sage.jpg',
  'KSAS20S-J0622-FR':'KSAS20S-J0622-FR-Salthrop-2 Seater-Bruges Sand.jpg',
  'KSAS20S-J0622-SI':'KSAS20S-J0622-SI-Salthrop-2 Seater-Bruges Sand.jpg',
  'KSAS20S-J0722-FR':'KSAS20S-J0722-FR-Salthrop-2 Seater-Suzy Olive.png',
  'KSAS20S-J0722-SI':'KSAS20S-J0722-SI-Salthrop-2 Seater-Suzy Olive.jpg',
  'KSAS20S-J0822-FR':'KSAS20S-J0822-FR-Salthrop-2 Seater-Suzy Denim.jpg',
  'KSAS20S-J0822-SI':'KSAS20S-J0822-SI-Salthrop-2 Seater-Suzy Denim.jpg',
  'KSAS20S-J0922-FR':'KSAS20S-J0922-FR-Salthrop-2 Seater-Suzy Natural.png',
  'KSAS20S-J0922-SI':'KSAS20S-J0922-SI-Salthrop-2 Seater-Suzy Natural.jpg',
  'KSAS20S-J1022-FR':'KSAS20S-J1022-FR-Salthrop-2 Seater-Beauville Spring Green.jpg',
  'KSAS20S-J1022-SI':'KSAS20S-J1022-SI-Salthrop-2 Seater-Beauville Spring Green.jpg',
  'KSAS20S-J1122-FR':'KSAS20S-J1122-FR-Salthrop-2 Seater-Beauville Cornish Blue.jpg',
  'KSAS20S-J1122-SI':'KSAS20S-J1122-SI-Salthrop-2 Seater-Beauville Cornish Blue.jpg',
  'KSAS20S-O0122-FR':'KSAS20S-O0122-FR-Salthrop-2 Seater-Bespoke Coastal Blue.png',
  'KSAS20S-O0122-SI':'KSAS20S-O0122-SI-Salthrop-2 Seater-Bespoke Coastal Blue.png',
  'KSAS20S-O0222-FR':'KSAS20S-O0222-FR-Salthrop-2 Seater-Tasman Petunia.png',
  'KSAS20S-O0222-SI':'KSAS20S-O0222-SI-Salthrop-2 Seater-Tasman Petunia.png',
  'KSAS20S-O0822-FR':'KSAS20S-O0822-FR-Salthrop-2 Seater-Tasman Spring Green.png',
  'KSAS20S-O0822-SI':'KSAS20S-O0822-SI-Salthrop-2 Seater-Tasman Spring Green.png',
  'KSAS20S-O0922-FR':'KSAS20S-O0922-FR-Salthrop-2 Seater-Tasman Cornish Blue.png',
  'KSAS20S-O0922-SI':'KSAS20S-O0922-SI-Salthrop-2 Seater-Tasman Cornish Blue.png',
  'KSAS20S-O2322-FR':'KSAS20S-O2322-FR-Salthrop-2 Seater-Pinstripe Natural.jpg',
  'KSAS20S-O2322-SI':'KSAS20S-O2322-SI-Salthrop-2 Seater-Pinstripe Natural.jpg',
  'KSAS20S-O2422-FR':'KSAS20S-O2422-FR-Salthrop-2 Seater-Pinstripe Petunia.jpg',
  'KSAS20S-O2422-SI':'KSAS20S-O2422-SI-Salthrop-2 Seater-Pinstripe Petunia.jpg',
  'KSAS20S-O2522-FR':'KSAS20S-O2522-FR-Salthrop-2 Seater-Pinstripe Nutmeg.jpg',
  'KSAS20S-O2522-SI':'KSAS20S-O2522-SI-Salthrop-2 Seater-Pinstripe Nutmeg.jpg',
  'KSAS20S-O2622-FR':'KSAS20S-O2622-FR-Salthrop-2 Seater-Tasman Natural.jpg',
  'KSAS20S-O2622-SI':'KSAS20S-O2622-SI-Salthrop-2 Seater-Tasman Natural.jpg',
  'KSAS30B-B0122-FR':'KSAS30B-B0122-FR-Salthrop-3 Seater-Beatrice Barley.png',
  'KSAS30B-B0122-SI':'KSAS30B-B0122-SI-Salthrop-3 Seater-Beatrice Barley.png',
  'KSAS30B-B0222-FR':'KSAS30B-B0222-FR-Salthrop-3 Seater-Beatrice Camelia.png',
  'KSAS30B-B0222-SI':'KSAS30B-B0222-SI-Salthrop-3 Seater-Beatrice Camelia.png',
  'KSAS30B-B0322-FR':'KSAS30B-B0322-FR-Salthrop-3 Seater-Beatrice Midnight.png',
  'KSAS30B-B0322-SI':'KSAS30B-B0322-SI-Salthrop-3 Seater-Beatrice Midnight.png',
  'KSAS30B-B0422-FR':'KSAS30B-B0422-FR-Salthrop-3 Seater-Beatrice Nutmeg.png',
  'KSAS30B-B0422-SI':'KSAS30B-B0422-SI-Salthrop-3 Seater-Beatrice Nutmeg.png',
  'KSAS30B-B0522-FR':'KSAS30B-B0522-FR-Salthrop-3 Seater-Beatrice Olive.png',
  'KSAS30B-B0522-SI':'KSAS30B-B0522-SI-Salthrop-3 Seater-Beatrice Olive.png',
  'KSAS30B-J0122-FR':'KSAS30B-J0122-FR-Salthrop-3 Seater-Boho Cloud.png',
  'KSAS30B-J0122-SI':'KSAS30B-J0122-SI-Salthrop-3 Seater-Boho Cloud.png',
  'KSAS30B-J0222-FR':'KSAS30B-J0222-FR-Salthrop-3 Seater-Boho Denim.png',
  'KSAS30B-J0222-SI':'KSAS30B-J0222-SI-Salthrop-3 Seater-Boho Denim.png',
  'KSAS30B-J0322-FR':'KSAS30B-J0322-FR-Salthrop-3 Seater-Boho Parchment.png',
  'KSAS30B-J0322-SI':'KSAS30B-J0322-SI-Salthrop-3 Seater-Boho Parchment.png',
  'KSAS30B-J0422-FR':'KSAS30B-J0422-FR-Salthrop-3 Seater-Bruges Navy.png',
  'KSAS30B-J0422-SI':'KSAS30B-J0422-SI-Salthrop-3 Seater-Bruges Navy.png',
  'KSAS30B-J0522-FR':'KSAS30B-J0522-FR-Salthrop-3 Seater-Bruges Sage.png',
  'KSAS30B-J0522-SI':'KSAS30B-J0522-SI-Salthrop-3 Seater-Bruges Sage.png',
  'KSAS30B-J0622-FR':'KSAS30B-J0622-FR-Salthrop-3 Seater-Bruges Sand.png',
  'KSAS30B-J0622-SI':'KSAS30B-J0622-SI-Salthrop-3 Seater-Bruges Sand.png',
  'KSAS30B-J0722-FR':'KSAS30B-J0722-FR-Salthrop-3 Seater-Suzy Olive.png',
  'KSAS30B-J0722-SI':'KSAS30B-J0722-SI-Salthrop-3 Seater-Suzy Olive.png',
  'KSAS30B-J0822-FR':'KSAS30B-J0822-FR-Salthrop-3 Seater-Suzy Denim.png',
  'KSAS30B-J0822-SI':'KSAS30B-J0822-SI-Salthrop-3 Seater-Suzy Denim.png',
  'KSAS30B-J0922-FR':'KSAS30B-J0922-FR-Salthrop-3 Seater-Suzy Natural.png',
  'KSAS30B-J0922-SI':'KSAS30B-J0922-SI-Salthrop-3 Seater-Suzy Natural.png',
  'KSAS30B-J1022-FR':'KSAS30B-J1022-FR-Salthrop-3 Seater-Beauville Spring Green.png',
  'KSAS30B-J1022-SI':'KSAS30B-J1022-SI-Salthrop-3 Seater-Beauville Spring Green.png',
  'KSAS30B-J1122-FR':'KSAS30B-J1122-FR-Salthrop-3 Seater-Beauville Cornish Blue.png',
  'KSAS30B-J1122-SI':'KSAS30B-J1122-SI-Salthrop-3 Seater-Beauville Cornish Blue.png',
  'KSAS30B-O0122-FR':'KSAS30B-O0122-FR-Salthrop-3 Seater-Bespoke Coastal Blue.png',
  'KSAS30B-O0122-SI':'KSAS30B-O0122-SI-Salthrop-3 Seater-Bespoke Coastal Blue.png',
  'KSAS30B-O0222-FR':'KSAS30B-O0222-FR-Salthrop-3 Seater-Tasman Petunia.png',
  'KSAS30B-O0222-SI':'KSAS30B-O0222-SI-Salthrop-3 Seater-Tasman Petunia.png',
  'KSAS30B-O0822-FR':'KSAS30B-O0822-FR-Salthrop-3 Seater-Tasman Spring Green.png',
  'KSAS30B-O0822-SI':'KSAS30B-O0822-SI-Salthrop-3 Seater-Tasman Spring Green.png',
  'KSAS30B-O0922-FR':'KSAS30B-O0922-FR-Salthrop-3 Seater-Tasman Cornish Blue.png',
  'KSAS30B-O0922-SI':'KSAS30B-O0922-SI-Salthrop-3 Seater-Tasman Cornish Blue.png',
  'KSAS30B-O2322-FR':'KSAS30B-O2322-FR-Salthrop-3 Seater-Pinstripe Natural.png',
  'KSAS30B-O2322-SI':'KSAS30B-O2322-SI-Salthrop-3 Seater-Pinstripe Natural.png',
  'KSAS30B-O2422-FR':'KSAS30B-O2422-FR-Salthrop-3 Seater-Pinstripe Petunia.png',
  'KSAS30B-O2422-SI':'KSAS30B-O2422-SI-Salthrop-3 Seater-Pinstripe Petunia.png',
  'KSAS30B-O2522-FR':'KSAS30B-O2522-FR-Salthrop-3 Seater-Pinstripe Nutmeg.png',
  'KSAS30B-O2522-SI':'KSAS30B-O2522-SI-Salthrop-3 Seater-Pinstripe Nutmeg.png',
  'KSAS30B-O2622-FR':'KSAS30B-O2622-FR-Salthrop-3 Seater-Tasman Natural.png',
  'KSAS30B-O2622-SI':'KSAS30B-O2622-SI-Salthrop-3 Seater-Tasman Natural.png',
  'KSAS30S-B0122-FR':'KSAS30S-B0122-FR-Salthrop-3 Seater-Beatrice Barley.png',
  'KSAS30S-B0122-SI':'KSAS30S-B0122-SI-Salthrop-3 Seater-Beatrice Barley.png',
  'KSAS30S-B0222-FR':'KSAS30S-B0222-FR-Salthrop-3 Seater-Beatrice Camelia.png',
  'KSAS30S-B0222-SI':'KSAS30S-B0222-SI-Salthrop-3 Seater-Beatrice Camelia.png',
  'KSAS30S-B0322-FR':'KSAS30S-B0322-FR-Salthrop-3 Seater-Beatrice Midnight.png',
  'KSAS30S-B0322-SI':'KSAS30S-B0322-SI-Salthrop-3 Seater-Beatrice Midnight.png',
  'KSAS30S-B0422-FR':'KSAS30S-B0422-FR-Salthrop-3 Seater-Beatrice Nutmeg.png',
  'KSAS30S-B0422-SI':'KSAS30S-B0422-SI-Salthrop-3 Seater-Beatrice Nutmeg.png',
  'KSAS30S-B0522-FR':'KSAS30S-B0522-FR-Salthrop-3 Seater-Beatrice Olive.png',
  'KSAS30S-B0522-SI':'KSAS30S-B0522-SI-Salthrop-3 Seater-Beatrice Olive.png',
  'KSAS30S-J0122-FR':'KSAS30S-J0122-FR-Salthrop-3 Seater-Boho Cloud.png',
  'KSAS30S-J0122-SI':'KSAS30S-J0122-SI-Salthrop-3 Seater-Boho Cloud.png',
  'KSAS30S-J0222-FR':'KSAS30S-J0222-FR-Salthrop-3 Seater-Boho Denim.png',
  'KSAS30S-J0222-SI':'KSAS30S-J0222-SI-Salthrop-3 Seater-Boho Denim.png',
  'KSAS30S-J0322-FR':'KSAS30S-J0322-FR-Salthrop-3 Seater-Boho Parchment.png',
  'KSAS30S-J0322-SI':'KSAS30S-J0322-SI-Salthrop-3 Seater-Boho Parchment.png',
  'KSAS30S-J0422-FR':'KSAS30S-J0422-FR-Salthrop-3 Seater-Bruges Navy.jpg',
  'KSAS30S-J0422-SI':'KSAS30S-J0422-SI-Salthrop-3 Seater-Bruges Navy.jpg',
  'KSAS30S-J0522-FR':'KSAS30S-J0522-FR-Salthrop-3 Seater-Bruges Sage.jpg',
  'KSAS30S-J0522-SI':'KSAS30S-J0522-SI-Salthrop-3 Seater-Bruges Sage.jpg',
  'KSAS30S-J0622-FR':'KSAS30S-J0622-FR-Salthrop-3 Seater-Bruges Sand.jpg',
  'KSAS30S-J0622-SI':'KSAS30S-J0622-SI-Salthrop-3 Seater-Bruges Sand.jpg',
  'KSAS30S-J0722-FR':'KSAS30S-J0722-FR-Salthrop-3 Seater-Suzy Olive.jpg',
  'KSAS30S-J0722-SI':'KSAS30S-J0722-SI-Salthrop-3 Seater-Suzy Olive.jpg',
  'KSAS30S-J0822-FR':'KSAS30S-J0822-FR-Salthrop-3 Seater-Suzy Denim.jpg',
  'KSAS30S-J0822-SI':'KSAS30S-J0822-SI-Salthrop-3 Seater-Suzy Denim.jpg',
  'KSAS30S-J0922-FR':'KSAS30S-J0922-FR-Salthrop-3 Seater-Suzy Natural.jpg',
  'KSAS30S-J0922-SI':'KSAS30S-J0922-SI-Salthrop-3 Seater-Suzy Natural.jpg',
  'KSAS30S-J1022-FR':'KSAS30S-J1022-FR-Salthrop-3 Seater-Beauville Spring Green.jpg',
  'KSAS30S-J1022-SI':'KSAS30S-J1022-SI-Salthrop-3 Seater-Beauville Spring Green.jpg',
  'KSAS30S-J1122-FR':'KSAS30S-J1122-FR-Salthrop-3 Seater-Beauville Cornish Blue.jpg',
  'KSAS30S-J1122-SI':'KSAS30S-J1122-SI-Salthrop-3 Seater-Beauville Cornish Blue.jpg',
  'KSAS30S-O0122-FR':'KSAS30S-O0122-FR-Salthrop-3 Seater-Bespoke Coastal Blue.png',
  'KSAS30S-O0122-SI':'KSAS30S-O0122-SI-Salthrop-3 Seater-Bespoke Coastal Blue.png',
  'KSAS30S-O0222-FR':'KSAS30S-O0222-FR-Salthrop-3 Seater-Tasman Petunia.png',
  'KSAS30S-O0222-SI':'KSAS30S-O0222-SI-Salthrop-3 Seater-Tasman Petunia.png',
  'KSAS30S-O0822-FR':'KSAS30S-O0822-FR-Salthrop-3 Seater-Tasman Spring Green.png',
  'KSAS30S-O0822-SI':'KSAS30S-O0822-SI-Salthrop-3 Seater-Tasman Spring Green.png',
  'KSAS30S-O0922-FR':'KSAS30S-O0922-FR-Salthrop-3 Seater-Tasman Cornish Blue.png',
  'KSAS30S-O0922-SI':'KSAS30S-O0922-SI-Salthrop-3 Seater-Tasman Cornish Blue.png',
  'KSAS30S-O2322-FR':'KSAS30S-O2322-FR-Salthrop-3 Seater-Pinstripe Natural.jpg',
  'KSAS30S-O2322-SI':'KSAS30S-O2322-SI-Salthrop-3 Seater-Pinstripe Natural.jpg',
  'KSAS30S-O2422-FR':'KSAS30S-O2422-FR-Salthrop-3 Seater-Pinstripe Petunia.jpg',
  'KSAS30S-O2422-SI':'KSAS30S-O2422-SI-Salthrop-3 Seater-Pinstripe Petunia.jpg',
  'KSAS30S-O2522-FR':'KSAS30S-O2522-FR-Salthrop-3 Seater-Pinstripe Nutmeg.jpg',
  'KSAS30S-O2522-SI':'KSAS30S-O2522-SI-Salthrop-3 Seater-Pinstripe Nutmeg.jpg',
  'KSAS30S-O2622-FR':'KSAS30S-O2622-FR-Salthrop-3 Seater-Tasman Natural.jpg',
  'KSAS30S-O2622-SI':'KSAS30S-O2622-SI-Salthrop-3 Seater-Tasman Natural.jpg',
  'KSOS10F-A0116-FR':'KSOS10F-A0116-FR-Sophia-Armchair-Wildwood Duck Egg.png',
  'KSOS10F-A0216-FR':'KSOS10F-A0216-FR-Sophia-Armchair-Wildwood Ivory.png',
  'KSOS10F-A0316-FR':'KSOS10F-A0316-FR-Sophia-Armchair-Wildwood Twig.png',
  'KSOS10F-A0416-FR':'KSOS10F-A0416-FR-Sophia-Armchair-Peony Summer Sky.png',
  'KSOS10F-A0516-FR':'KSOS10F-A0516-FR-Sophia-Armchair-Midsummer Sky.png',
  'KSOS10F-A0616-FR':'KSOS10F-A0616-FR-Sophia-Armchair-Midsummer Stone.png',
  'KSOS10F-A0716-FR':'KSOS10F-A0716-FR-Sophia-Armchair-Midsummer Faded Blue.jpg',
  'KSOS10F-A0816-FR':'KSOS10F-A0816-FR-Sophia-Armchair-Otter Denim.png',
  'KSOS10F-A091-FR':'KSOS10F-A091-FR-Sophia-Armchair-Pelham Clementine.png',
  'KSOS10F-A1116-FR':'KSOS10F-A1116-FR-Sophia-Armchair-Pelham Denim.png',
  'KSOS10F-A121-FR':'KSOS10F-A121-FR-Sophia-Armchair-Pelham Peacock.png',
  'KSOS10F-A1316-FR':'KSOS10F-A1316-FR-Sophia-Armchair-Las Salinas Las Salinas 4.png',
  'KSOS10F-B011-FR':'KSOS10F-B011-FR-Sophia-Armchair-Beatrice Barley.png',
  'KSOS10F-B0216-FR':'KSOS10F-B0216-FR-Sophia-Armchair-Beatrice Camelia.png',
  'KSOS10F-B0316-FR':'KSOS10F-B0316-FR-Sophia-Armchair-Beatrice Midnight.png',
  'KSOS10F-B051-FR':'KSOS10F-B051-FR-Sophia-Armchair-Beatrice Olive.png',
  'KSOS10F-B0616-FR':'KSOS10F-B0616-FR-Sophia-Armchair-Froisse Cerulean.png',
  'KSOS10F-B0716-FR':'KSOS10F-B0716-FR-Sophia-Armchair-Froisse Chalk.png',
  'KSOS10F-B0816-FR':'KSOS10F-B0816-FR-Sophia-Armchair-Froisse Hemp.png',
  'KSOS10F-B1216-FR':'KSOS10F-B1216-FR-Sophia-Armchair-Froisse Putty.png',
  'KSOS10F-D011-FR':'KSOS10F-D011-FR-Sophia-Armchair-Fuchsia.png',
  'KSOS10F-D031-FR':'KSOS10F-D031-FR-Sophia-Armchair-Alchemilla.png',
  'KSOS10F-D051-FR':'KSOS10F-D051-FR-Sophia-Armchair-Grass.png',
  'KSOS10F-D0616-FR':'KSOS10F-D0616-FR-Sophia-Armchair-Brera Lino Cerise.png',
  'KSOS10F-D061-FR':'KSOS10F-D061-FR-Sophia-Armchair-Designers Guild - Cerise.png',
  'KSOS10F-G0116-FR':'KSOS10F-G0116-FR-Sophia-Armchair-Nympheus Teal green.png',
  'KSOS10F-G0216-FR':'KSOS10F-G0216-FR-Sophia-Armchair-Nympheus Stone pistachio.png',
  'KSOS10F-G0316-FR':'KSOS10F-G0316-FR-Sophia-Armchair-Nympheus Aqua teal.png',
  'KSOS10F-G0416-FR':'KSOS10F-G0416-FR-Sophia-Armchair-Magnolia Cream Blue.png',
  'KSOS10F-G0516-FR':'KSOS10F-G0516-FR-Sophia-Armchair-Little Magnolia Pink orange.png',
  'KSOS10F-G0616-FR':'KSOS10F-G0616-FR-Sophia-Armchair-Little Magnolia Espresso.png',
  'KSOS10F-G0716-FR':'KSOS10F-G0716-FR-Sophia-Armchair-Little Magnolia Emerald.png',
  'KSOS10F-J0116-FR':'KSOS10F-J0116-FR-Sophia-Armchair-Boho Cloud.png',
  'KSOS10F-J021-FR':'KSOS10F-J021-FR-Sophia-Armchair-Boho Denim.png',
  'KSOS10F-J0316-FR':'KSOS10F-J0316-FR-Sophia-Armchair-Boho Parchment.png',
  'KSOS10F-L0116-FR':'KSOS10F-L0116-FR-Sophia-Armchair-English Garden - Kitty Spring Green.png',
  'KSOS10F-L0216-FR':'KSOS10F-L0216-FR-Sophia-Armchair-English Garden - Kitty Blue Green.png',
  'KSOS10F-L0316-FR':'KSOS10F-L0316-FR-Sophia-Armchair-English Garden - Kitty Indian Summer.png',
  'KSOS10F-L0416-FR':'KSOS10F-L0416-FR-Sophia-Armchair-English Garden - Albertine Grey Skies.png',
  'KSOS10F-L0516-FR':'KSOS10F-L0516-FR-Sophia-Armchair-English Garden - Albertine Classic Rose.png',
  'KSOS10F-L0616-FR':'KSOS10F-L0616-FR-Sophia-Armchair-English Garden - Albertine Coral Orange.png',
  'KSOS10F-L0716-FR':'KSOS10F-L0716-FR-Sophia-Armchair-Belleville - Miji Juniper.png',
  'KSOS10F-L091-FR':'KSOS10F-L091-FR-Sophia-Armchair-Carnelian.png',
  'KSOS10F-L111-FR':'KSOS10F-L111-FR-Sophia-Armchair-Lagoon.png',
  'KSOS10F-L121-FR':'KSOS10F-L121-FR-Sophia-Armchair-Rosewood.png',
  'KSOS10F-L141-FR':'KSOS10F-L141-FR-Sophia-Armchair-Pine.png',
  'KSOS10F-L171-FR':'KSOS10F-L171-FR-Sophia-Armchair-Parakeet.png',
  'KSOS10F-L2016-FR':'KSOS10F-L2016-FR-Sophia-Armchair-Elba Midnight.png',
  'KSOS10F-L2116-FR':'KSOS10F-L2116-FR-Sophia-Armchair-Elba Sage.png',
  'KSOS10F-L211-FR':'KSOS10F-L211-FR-Sophia-Armchair-Sage.png',
  'KSOS10F-O0116-FR':'KSOS10F-O0116-FR-Sophia-Armchair-Bespoke Coastal Blue.png',
  'KSOS10F-O0216-FR':'KSOS10F-O0216-FR-Sophia-Armchair-Tasman Petunia.png',
  'KSOS10F-O0316-FR':'KSOS10F-O0316-FR-Sophia-Armchair-Bespoke Woodland.png',
  'KSOS10F-O0516-FR':'KSOS10F-O0516-FR-Sophia-Armchair-Tasman Sea Holly.png',
  'KSOS10F-O0616-FR':'KSOS10F-O0616-FR-Sophia-Armchair-Tasman Garden Grey.png',
  'KSOS10F-O0716-FR':'KSOS10F-O0716-FR-Sophia-Armchair-Tasman Dandelion.png',
  'KSOS10F-O0816-FR':'KSOS10F-O0816-FR-Sophia-Armchair-Tasman Spring Green.png',
  'KSOS10F-O081-FR':'KSOS10F-O081-FR-Sophia-Armchair-Spring Green Stripe.png',
  'KSOS10F-O0916-FR':'KSOS10F-O0916-FR-Sophia-Armchair-Tasman Cornish Blue.png',
  'KSOS10F-O1016-FR':'KSOS10F-O1016-FR-Sophia-Armchair-Antarctic Narrow Chocolate.png',
  'KSOS10F-O1116-FR':'KSOS10F-O1116-FR-Sophia-Armchair-Tasman Chocolate.png',
  'KSOS10F-O1316-FR':'KSOS10F-O1316-FR-Sophia-Armchair-Capelo Cool Coconut.png',
  'KSOS10F-O1416-FR':'KSOS10F-O1416-FR-Sophia-Armchair-Capelo Snow Drop.png',
  'KSOS10F-O1516-FR':'KSOS10F-O1516-FR-Sophia-Armchair-Capelo Sea Salt.png',
  'KSOS10F-O1616-FR':'KSOS10F-O1616-FR-Sophia-Armchair-Capelo Rosedale.png',
  'KSOS10F-O1716-FR':'KSOS10F-O1716-FR-Sophia-Armchair-Capelo Inkspot.png',
  'KSOS10F-O1816-FR':'KSOS10F-O1816-FR-Sophia-Armchair-Columbus Evergreen.png',
  'KSOS10F-O1916-FR':'KSOS10F-O1916-FR-Sophia-Armchair-Columbus Marigold.png',
  'KSOS10F-O2016-FR':'KSOS10F-O2016-FR-Sophia-Armchair-Columbus Potting Moss.png',
  'KSOS10F-O2116-FR':'KSOS10F-O2116-FR-Sophia-Armchair-Columbus Roselette.png',
  'KSOS10F-O2216-FR':'KSOS10F-O2216-FR-Sophia-Armchair-Columbus Sunflower.png',
  'KSOS20F-A0216-FR':'KSOS20F-A0216-FR-Sophia-2 Seater-Wildwood Ivory.png',
  'KSOS20F-A0316-FR':'KSOS20F-A0316-FR-Sophia-2 Seater-Wildwood Twig.png',
  'KSOS20F-A0416-FR':'KSOS20F-A0416-FR-Sophia-2 Seater-Peony Summer Sky.png',
  'KSOS20F-A0516-FR':'KSOS20F-A0516-FR-Sophia-2 Seater-Midsummer Sky.png',
  'KSOS20F-A0616-FR':'KSOS20F-A0616-FR-Sophia-2 Seater-Midsummer Stone.png',
  'KSOS20F-A0716-FR':'KSOS20F-A0716-FR-Sophia-2 Seater-Midsummer Faded Blue.jpg',
  'KSOS20F-A0816-FR':'KSOS20F-A0816-FR-Sophia-2 Seater-Otter Denim.png',
  'KSOS20F-A1016-FR':'KSOS20F-A1016-FR-Sophia-2 Seater-Pelham Moss.png',
  'KSOS20F-A1116-FR':'KSOS20F-A1116-FR-Sophia-2 Seater-Pelham Denim.png',
  'KSOS20F-A1316-FR':'KSOS20F-A1316-FR-Sophia-2 Seater-Las Salinas Las Salinas 4.png',
  'KSOS20F-B0116-FR':'KSOS20F-B0116-FR-Sophia-2 Seater-Beatrice Barley.png',
  'KSOS20F-B0216-FR':'KSOS20F-B0216-FR-Sophia-2 Seater-Beatrice Camelia.png',
  'KSOS20F-B0316-FR':'KSOS20F-B0316-FR-Sophia-2 Seater-Beatrice Midnight.png',
  'KSOS20F-B0616-FR':'KSOS20F-B0616-FR-Sophia-2 Seater-Froisse Cerulean.png',
  'KSOS20F-B0816-FR':'KSOS20F-B0816-FR-Sophia-2 Seater-Froisse Hemp.png',
  'KSOS20F-B1216-FR':'KSOS20F-B1216-FR-Sophia-2 Seater-Froisse Putty.png',
  'KSOS20F-D0516-FR':'KSOS20F-D0516-FR-Sophia-2 Seater-Varese Grass.png',
  'KSOS20F-D0716-FR':'KSOS20F-D0716-FR-Sophia-2 Seater-Brera Lino Chalk.png',
  'KSOS20F-G0116-FR':'KSOS20F-G0116-FR-Sophia-2 Seater-Nympheus Teal green.png',
  'KSOS20F-G0216-FR':'KSOS20F-G0216-FR-Sophia-2 Seater-Nympheus Stone pistachio.png',
  'KSOS20F-G0316-FR':'KSOS20F-G0316-FR-Sophia-2 Seater-Nympheus Aqua teal.png',
  'KSOS20F-G0416-FR':'KSOS20F-G0416-FR-Sophia-2 Seater-Magnolia Cream Blue.png',
  'KSOS20F-G0416-SI':'KSOS20F-G0416-SI-Sophia-2 Seater-Magnolia Cream Blue.png',
  'KSOS20F-G0516-FR':'KSOS20F-G0516-FR-Sophia-2 Seater-Little Magnolia Pink orange.png',
  'KSOS20F-G0616-FR':'KSOS20F-G0616-FR-Sophia-2 Seater-Little Magnolia Espresso.png',
  'KSOS20F-G0716-FR':'KSOS20F-G0716-FR-Sophia-2 Seater-Little Magnolia Emerald.png',
  'KSOS20F-J0116-FR':'KSOS20F-J0116-FR-Sophia-2 Seater-Boho Cloud.png',
  'KSOS20F-J0316-FR':'KSOS20F-J0316-FR-Sophia-2 Seater-Boho Parchment.png',
  'KSOS20F-L0116-FR':'KSOS20F-L0116-FR-Sophia-2 Seater-English Garden - Kitty Spring Green.png',
  'KSOS20F-L0216-FR':'KSOS20F-L0216-FR-Sophia-2 Seater-English Garden - Kitty Blue Green.png',
  'KSOS20F-L0316-FR':'KSOS20F-L0316-FR-Sophia-2 Seater-English Garden - Kitty Indian Summer.png',
  'KSOS20F-L0416-FR':'KSOS20F-L0416-FR-Sophia-2 Seater-English Garden - Albertine Grey Skies.png',
  'KSOS20F-L0516-FR':'KSOS20F-L0516-FR-Sophia-2 Seater-English Garden - Albertine Classic Rose.png',
  'KSOS20F-L0616-FR':'KSOS20F-L0616-FR-Sophia-2 Seater-English Garden - Albertine Coral Orange.png',
  'KSOS20F-L0716-FR':'KSOS20F-L0716-FR-Sophia-2 Seater-Belleville - Miji Juniper.png',
  'KSOS20F-L0916-FR':'KSOS20F-L0916-FR-Sophia-2 Seater-Omega Carnelian.png',
  'KSOS20F-L2016-FR':'KSOS20F-L2016-FR-Sophia-2 Seater-Elba Midnight.png',
  'KSOS20F-O0116-FR':'KSOS20F-O0116-FR-Sophia-2 Seater-Bespoke Coastal Blue.png',
  'KSOS20F-O0216-FR':'KSOS20F-O0216-FR-Sophia-2 Seater-Tasman Petunia.png',
  'KSOS20F-O0316-FR':'KSOS20F-O0316-FR-Sophia-2 Seater-Bespoke Woodland.png',
  'KSOS20F-O0416-FR':'KSOS20F-O0416-FR-Sophia-2 Seater-Bespoke Caramel.png',
  'KSOS20F-O0516-FR':'KSOS20F-O0516-FR-Sophia-2 Seater-Tasman Sea Holly.png',
  'KSOS20F-O0616-FR':'KSOS20F-O0616-FR-Sophia-2 Seater-Tasman Garden Grey.png',
  'KSOS20F-O0716-FR':'KSOS20F-O0716-FR-Sophia-2 Seater-Tasman Dandelion.png',
  'KSOS20F-O0816-FR':'KSOS20F-O0816-FR-Sophia-2 Seater-Tasman Spring Green.png',
  'KSOS20F-O0916-FR':'KSOS20F-O0916-FR-Sophia-2 Seater-Tasman Cornish Blue.png',
  'KSOS20F-O1116-FR':'KSOS20F-O1116-FR-Sophia-2 Seater-Tasman Chocolate.png',
  'KSOS20F-O1316-FR':'KSOS20F-O1316-FR-Sophia-2 Seater-Capelo Cool Coconut.png',
  'KSOS20F-O1416-FR':'KSOS20F-O1416-FR-Sophia-2 Seater-Capelo Snow Drop.png',
  'KSOS20F-O1516-FR':'KSOS20F-O1516-FR-Sophia-2 Seater-Capelo Sea Salt.png',
  'KSOS20F-O1616-FR':'KSOS20F-O1616-FR-Sophia-2 Seater-Capelo Rosedale.png',
  'KSOS20F-O1716-FR':'KSOS20F-O1716-FR-Sophia-2 Seater-Capelo Inkspot.png',
  'KSOS20F-O1816-FR':'KSOS20F-O1816-FR-Sophia-2 Seater-Columbus Evergreen.png',
  'KSOS20F-O1916-FR':'KSOS20F-O1916-FR-Sophia-2 Seater-Columbus Marigold.png',
  'KSOS20F-O2016-FR':'KSOS20F-O2016-FR-Sophia-2 Seater-Columbus Potting Moss.png',
  'KSOS20F-O2116-FR':'KSOS20F-O2116-FR-Sophia-2 Seater-Columbus Roselette.png',
  'KSOS20F-O2216-FR':'KSOS20F-O2216-FR-Sophia-2 Seater-Columbus Sunflower.png',
  'KSOS30F-A0116-FR':'KSOS30F-A0116-FR-Sophia-3 Seater-Wildwood Duck Egg.png',
  'KSOS30F-A0216-FR':'KSOS30F-A0216-FR-Sophia-3 Seater-Wildwood Ivory.png',
  'KSOS30F-A0716-FR':'KSOS30F-A0716-FR-Sophia-3 Seater-Midsummer Faded Blue.jpg',
  'KSOS30F-B1216-FR':'KSOS30F-B1216-FR-Sophia-3 Seater-Froisse Putty.png',
  'KSOS30F-O1216-FR':'KSOS30F-O1216-FR-Sophia-3 Seater-Bespoke Blossom.png',
  'KSOS30F-O1416-FR':'KSOS30F-O1416-FR-Sophia-3 Seater-Capelo Snow Drop.png',
  'KSOS30F-O1716-FR':'KSOS30F-O1716-FR-Sophia-3 Seater-Capelo Inkspot.png',
  'KSOS30F-O1916-FR':'KSOS30F-O1916-FR-Sophia-3 Seater-Columbus Marigold.png',
  /* Added 15 Oct 2026: Cocobella sectional renders confirmed on the CDN
     but missing from the generated manifest. A full regenerate will
     include them anyway. */
  'KCBMLAK-B0121-RHF':'KCBMLAK-B0121-RHF-Cocobella-2x3 Sectional-Beatrice Barley.png',
  'KCBMLAK-B0221-RHF':'KCBMLAK-B0221-RHF-Cocobella-2x3 Sectional-Beatrice Camelia.png',
  'KCBMLAK-B0321-RHF':'KCBMLAK-B0321-RHF-Cocobella-2x3 Sectional-Beatrice Midnight.png',
  'KCBMLAK-B0421-RHF':'KCBMLAK-B0421-RHF-Cocobella-2x3 Sectional-Beatrice Nutmeg.png',
  'KCBMLAK-B0521-RHF':'KCBMLAK-B0521-RHF-Cocobella-2x3 Sectional-Beatrice Olive.png',
  'KCBMLAK-J0121-RHF':'KCBMLAK-J0121-RHF-Cocobella-2x3 Sectional-Boho Cloud.png',
  'KCBMLAK-J0221-RHF':'KCBMLAK-J0221-RHF-Cocobella-2x3 Sectional-Boho Denim.png',
  'KCBMLAK-J0321-RHF':'KCBMLAK-J0321-RHF-Cocobella-2x3 Sectional-Boho Parchment.png',
  'KCBMLAK-O0121-RHF':'KCBMLAK-O0121-RHF-Cocobella-2x3 Sectional-Bespoke Coastal Blue.png',
  'KCBMLAK-O0221-RHF':'KCBMLAK-O0221-RHF-Cocobella-2x3 Sectional-Tasman Petunia.png',
  'KCBMLAK-O0821-RHF':'KCBMLAK-O0821-RHF-Cocobella-2x3 Sectional-Tasman Spring Green.png',
  'KCBMLAK-O0921-RHF':'KCBMLAK-O0921-RHF-Cocobella-2x3 Sectional-Tasman Cornish Blue.png',
  'KCBS25K-J0721-FR':'KCBS25K-J0721-FR-Cocobella-2.5 Seater-Suzy Olive.png',
  'KCBS30K-J0821-FR':'KCBS30K-J0821-FR-Cocobella-3 Seater-Suzy Denim.png',
  /* Added 30 Oct 2026: Salthrop renders on the CDN but missing from the
     generated manifest. */
  'KSAS15B-J0922-SI':'KSAS15B-J0922-SI-Salthrop-Loveseat-Suzy Natural.png',
  'KSAS15B-J1022-FR':'KSAS15B-J1022-FR-Salthrop-Loveseat-Beauville Spring Green.png',
  'KSAS15B-O2622-SI':'KSAS15B-O2622-SI-Salthrop-Loveseat-Tasman Natural.png',
  'KSAS20B-J0722-FR':'KSAS20B-J0722-FR-Salthrop-2 Seater-Suzy Olive.png',
  'KSAS20B-J0822-FR':'KSAS20B-J0822-FR-Salthrop-2 Seater-Suzy Denim.png',
  'KSAS20B-J0922-FR':'KSAS20B-J0922-FR-Salthrop-2 Seater-Suzy Natural.png'
};
